/** VERSION: 1.8.51.**/
/** Please don't modify or unzip this content. It will be updated regularly **/
var BoostPFS = (function (t) {
    function e(e) {
        for (var n, a, l = e[0], s = e[1], c = e[2], p = 0, f = []; p < l.length; p++) (a = l[p]), Object.prototype.hasOwnProperty.call(i, a) && i[a] && f.push(i[a][0]), (i[a] = 0);
        for (n in s) Object.prototype.hasOwnProperty.call(s, n) && (t[n] = s[n]);
        for (u && u(e); f.length; ) f.shift()();
        return o.push.apply(o, c || []), r();
    }
    function r() {
        for (var t, e = 0; e < o.length; e++) {
            for (var r = o[e], n = !0, l = 1; l < r.length; l++) {
                var s = r[l];
                0 !== i[s] && (n = !1);
            }
            n && (o.splice(e--, 1), (t = a((a.s = r[0]))));
        }
        return t;
    }
    var n = {},
        i = { 0: 0 },
        o = [];
    function a(e) {
        if (n[e]) return n[e].exports;
        var r = (n[e] = { i: e, l: !1, exports: {} });
        return t[e].call(r.exports, r, r.exports, a), (r.l = !0), r.exports;
    }
    (a.m = t),
        (a.c = n),
        (a.d = function (t, e, r) {
            a.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r });
        }),
        (a.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (a.t = function (t, e) {
            if ((1 & e && (t = a(t)), 8 & e)) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if ((a.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t))
                for (var n in t)
                    a.d(
                        r,
                        n,
                        function (e) {
                            return t[e];
                        }.bind(null, n)
                    );
            return r;
        }),
        (a.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t.default;
                      }
                    : function () {
                          return t;
                      };
            return a.d(e, "a", e), e;
        }),
        (a.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (a.p = "");
    var l = (window.webpackJsonpBoostPFS = window.webpackJsonpBoostPFS || []),
        s = l.push.bind(l);
    (l.push = e), (l = l.slice());
    for (var c = 0; c < l.length; c++) e(l[c]);
    var u = s;
    return o.push([191, 1]), r();
})({
    0: function (t, e, r) {
        "use strict";
        r(25), r(26), r(86), r(41), r(27), r(9), r(28), r(173), r(101), r(118), r(48), r(24), r(33), r(37), r(44), r(58), r(153), r(69), r(102), r(51), r(87), r(17), r(43), r(70), r(88), r(30), r(14), r(15), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(2),
            a = r(3),
            l = r(4),
            s = r(5),
            c = {
                isFullWidthMobile: function () {
                    return k.isMobile() && "style1" == o.a.getSettingValue("search.suggestionMobileStyle");
                },
                isStyle2: function () {
                    return !k.isMobile() && "style2" === o.a.getSettingValue("search.suggestionStyle");
                },
                isStyle3: function () {
                    return (!k.isMobile() && "style3" === o.a.getSettingValue("search.suggestionStyle")) || "2-overlay-fullwidth" === o.a.getSettingValue("search.suggestionColumn");
                },
                getListSuggestionType: function () {
                    var t = o.a.getSettingValue("search.suggestionBlocks"),
                        e = [];
                    return (
                        t.forEach(function (t) {
                            ["products", "suggestions", "collections", "pages"].includes(t.type) && "active" == t.status && e.push(t.type);
                        }),
                        4 == e.length ? [] : e
                    );
                },
            },
            u = {
                checkExistFilterOptionParam: function () {
                    for (var t in Globals.queryParams) if (t.indexOf("pf_") > -1) return !0;
                    return !1;
                },
                encodeURIParamValue: function (t) {
                    return encodeURIComponent(t).replace(/&/g, "%26").replace(/'/g, "%27").replace(/\*/g, "%2A");
                },
                showFilterTree: function () {
                    i()("." + l.a.filterTree).css({ display: "" }),
                        i()(".boost-pfs-filter-tree-mobile-button").css({ display: "" }),
                        i()(".boost-pfs-filter-left-col").css({ display: "" }),
                        i()(".boost-pfs-filter-right-col, .boost-pfs-filter-right").css({ width: "" }),
                        i()(".boost-pfs-filter-tree-desktop-button").css({ display: "" }),
                        i()(".boost-pfs-filter-in-collection-search-hide").css({ display: "" }),
                        i()(".boost-pfs-filter-tree-h-wrapper").css({ display: "" });
                },
                hideFilterTree: function () {
                    i()("." + l.a.filterTree).css({ display: "none" }),
                        i()(".boost-pfs-filter-tree-mobile-button").css({ display: "none" }),
                        i()(".boost-pfs-filter-left-col").css({ display: "none" }),
                        i()(".boost-pfs-filter-right-col, .boost-pfs-filter-right").css({ width: "100%" }),
                        i()(".boost-pfs-filter-tree-desktop-button").css({ display: "none" }),
                        i()(".boost-pfs-filter-in-collection-search-hide").css({ display: "none" }),
                        i()(".boost-pfs-filter-tree-h-wrapper").css({ display: "none" });
                },
            },
            p = (r(207), r(7));
        function f(t) {
            return (f =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        var h = function () {
                return o.a.getSettingValue("general.paginationTypeAdvanced");
            },
            y = function () {
                return "load_more" == o.a.getSettingValue("general.paginationType");
            },
            d = function () {
                return "infinite" == o.a.getSettingValue("general.paginationType");
            },
            m = {
                getSortingList: function () {
                    var t = o.a.getSettingValue("general.sortingList"),
                        e = o.a.getSettingValue("general.customSortingList");
                    if ("" != e) for (var r = (t = e.trim().split("|")).length - 1; r >= 0; r--) "" == t[r] && t.splice(r, 1);
                    var n = o.a.getSettingValue("general.extraSortingList");
                    if ((n && (t = t.concat(n.split("|"))), k.isSearchPage())) {
                        var i = k.findIndexArray("manual", t);
                        i >= 0 && t.splice(i, 1);
                    } else if (!k.isCollectionPage() || (k.isCollectionPage() && !o.a.getSettingValue("general.enableCollectionSearch"))) {
                        var a = k.findIndexArray("relevance", t);
                        a >= 0 && t.splice(a, 1);
                    }
                    for (var l = {}, s = 0; s < t.length; s++) {
                        var c = p.a.sortingList[t[s]];
                        if (n.length > 0 && n.indexOf(t[s]) > -1) {
                            var u = t[s].replace(/-/g, "_");
                            c = p.a[u];
                        }
                        if (((l[t[s]] = c), p.a.sortByOptions)) {
                            var f = p.a.sortByOptions[t[s]];
                            f && f.length > 0 && (l[t[s]] = f);
                        }
                    }
                    return l;
                },
                getDefaultSorting: function (t) {
                    var e = o.a.getSettingValue("default_sort_order"),
                        r = "";
                    return (
                        void 0 === t && (t = k.isSearchPage() ? "search" : k.isCollectionPage() ? boostPFSConfig.general.collection_id : void 0),
                        "object" == f(e) && void 0 !== t && ((r = e[(t = t.toString())]) || (r = "search" == t ? "relevance" : e.all)),
                        r
                    );
                },
                getProductMetafield: function (t, e, r) {
                    if (t.hasOwnProperty("metafields")) {
                        var n = t.metafields.filter(function (t) {
                            return t.namespace == e && t.key == r;
                        });
                        if (void 0 !== n[0]) return n[0].value;
                    }
                    return null;
                },
                isAdvancedPaginationType: h,
                buildProductItemUrl: function (t, e) {
                    var r = k.getWindowLocation().search.substring(1),
                        n = window.location.pathname,
                        i = n.split("/"),
                        a = "",
                        l = Shopify && Shopify.routes && void 0 !== Shopify.routes.root;
                    o.a.getSettingValue("general.useShopifyRouteForMultiLanguageURL") && l
                        ? (a = Shopify.routes.root.replace(/\/$/, ""))
                        : i.indexOf(boostPFSAppConfig.general.current_locale) > -1 && (a = "/" + boostPFSAppConfig.general.current_locale);
                    var s = "object" === f(t) && t.hasOwnProperty("handle") ? t.handle : t;
                    if ((e = void 0 !== e ? e : o.a.getSettingValue("general.addCollectionToProductUrl"))) {
                        if ("/" == n || k.isSearchPage() || k.isVendorPage() || k.isTypePage()) return (c = a + "/collections/all/products/") + s;
                        if (k.isTagPage()) {
                            var c = a + "/collections/",
                                u = i.indexOf("collections") + 1;
                            return i.length >= 4 ? c + i[u] + "/products/" + s : "/collections/all/products/" + s;
                        }
                        if (r.indexOf("cache:") > -1) {
                            var p = "all",
                                h = r.split("&")[0].split("?")[0].split("collections/");
                            return h.length > 1 && (p = h[1].indexOf("/") > -1 ? h[1].split("/")[0] : h[1]), "/collections/" + (p = p.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, "")) + "/products/" + s;
                        }
                        (u = i.indexOf("collections") + 1), (c = a + "/collections/");
                        return void 0 !== i[2] ? c + i[u] + "/products/" + s : window.location.pathname + "/products/" + s;
                    }
                    return a + "/products/" + s;
                },
                buildProductItemUrlWithVariant: function (t) {
                    var e = t.split_product && t.variants ? "?variant=" + t.variants[0].id : "";
                    return k.buildProductItemUrl(t, !1) + e;
                },
                buildProductItemVendorUrl: function (t) {
                    return window.location.protocol + "//" + window.location.hostname + "/collections/vendors?q=" + u.encodeURIParamValue(t);
                },
                removePageParamFromUrl: function (t) {
                    if (a.a.queryParams.hasOwnProperty("page")) {
                        var e = a.a.queryParams.page && !isNaN(a.a.queryParams.page) ? a.a.queryParams.page : 1;
                        t = t
                            .replace("&page=" + e, "")
                            .replace("?page=" + e + "&", "?")
                            .replace("?page=" + e, "");
                    }
                    return k.isBadUrl(t) ? "" : t;
                },
                removeCollectionScopeParamFromUrl: function (t) {
                    if (a.a.queryParams.hasOwnProperty("collection_scope")) {
                        var e = a.a.queryParams.collection_scope && !isNaN(a.a.queryParams.collection_scope) ? a.a.queryParams.collection_scope : 0;
                        t = t.replace("&collection_scope=" + e, "");
                    }
                    return k.isBadUrl(t) ? "" : t;
                },
                buildToolbarLink: function (t, e, r) {
                    var n = window.location.origin + window.location.pathname;
                    switch (t) {
                        case "page":
                        case "limit":
                        case "sort":
                        case "display":
                            if ("page" == t && 1 == r) break;
                            n += "?" + t + "=" + r;
                    }
                    return n;
                },
                isDefaultPaginationType: function () {
                    return "default" == o.a.getSettingValue("general.paginationType");
                },
                isLoadMorePaginationType: y,
                isInfiniteLoadingPaginationType: d,
                isLoadPreviousPagePaginationType: function () {
                    return (y() || d()) && h() && o.a.getSettingValue("general.activeLoadPreviousPage");
                },
                isNoFilterResult: function (t, e) {
                    return t <= 0 && !("init" === e && o.a.getSettingValue("general.productAndVariantAvailable") && o.a.getSettingValue("general.availableAfterFiltering"));
                },
                compileShopifyProductVariables: function (t, e) {
                    return (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/{{product.title}}/g, t.title)).replace(/{{product.vendor}}/g, t.vendor)).replace(
                        /{{product.url}}/g,
                        k.buildProductItemUrl(t)
                    )).replace(/{{product.available}}/g, t.available)).replace(/{{product.compare_at_price}}/g, k.formatMoney(t.compare_at_price_min))).replace(
                        /{{product.compare_at_price_min}}/g,
                        k.formatMoney(t.compare_at_price_min)
                    )).replace(/{{product.compare_at_price_max}}/g, k.formatMoney(t.compare_at_price_max))).replace(/{{product.description}}/g, void 0 !== t.body_html && null != t.body_html ? t.body_html : "")).replace(
                        /{{product.handle}}/g,
                        t.handle
                    )).replace(/{{product.id}}/g, t.id)).replace(/{{product.price}}/g, k.formatMoney(t.price_min))).replace(/{{product.price_max}}/g, k.formatMoney(t.price_max))).replace(
                        /{{product.price_min}}/g,
                        k.formatMoney(t.price_min)
                    )).replace(/{{product.template_suffix}}/g, void 0 !== t.template_suffix && null != t.template_suffix ? t.template_suffix : "")).replace(
                        /{{product.percent_sale_min}}/g,
                        t.percent_sale_min > 0 ? t.percent_sale_min : ""
                    )).replace(/{{product.type}}/g, t.product_type)).replace(/{{product.sku}}/g, void 0 !== t.skus && null != t.skus && t.skus.length > 0 ? t.skus[0] : ""));
                },
                compileShopifyProductMetafield: function (t, e) {
                    if (-1 != e.indexOf("product.metafields")) {
                        var r = e.match(/\{\{product.metafields(.*?)\}\}/g),
                            n = 0,
                            i = "",
                            o = "",
                            a = "",
                            l = "";
                        if (r.length > 0) {
                            n = r.length;
                            for (var s = 0; s < n; s++) 4 == (o = r[s].replace(/\{\{/g, "").replace(/\}\}/g, "").split(".")).length && ((i = o[2]), (a = o[3]), (l = k.getProductMetafield(t, i, a) || ""), (e = e.replaceAll(r[s], l)));
                        }
                    }
                    return e;
                },
            };
        function g(t) {
            return (g =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        var b = function (t, e) {
                t || (t = boostPFSConfig.general.no_image_url);
                e = void 0 !== e ? e : "large";
                for (var r = o.a.getSettingValue("general.imageExtension"), n = 0; n < r.length; n++) t = t.replace("." + r[n] + "?", "_" + e + "." + r[n] + "?");
                return t;
            },
            v = function () {
                return i()("<p>" + boostPFSConfig.shop.money_format + "</p>")
                    .text()
                    .replace(/{{[^}]*}}/g, "");
            },
            S = null,
            O = function () {
                return C.getWindowLocation().href.includes("webcache.googleusercontent.com") ? C.getWindowLocation().search.indexOf("search?") > -1 : window.location.pathname.indexOf("/search") > -1;
            },
            P = function (t, e) {
                e || (e = C.getWindowLocation().href), (t = t.replace(/[\[\]]/g, "\\$&"));
                var r = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
                return r ? (r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "") : null;
            },
            T = function (t) {
                for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
                return JSON.stringify(t) === JSON.stringify({});
            },
            w = function (t, e, r, n) {
                if (null != r) {
                    for (var i = 0; i < e.length; i++) if ((void 0 !== n && 0 == n && ((e[i][r] = e[i][r].toLowerCase()), (t = t.toLowerCase())), e[i][r] == t)) return i;
                } else for (i = 0; i < e.length; i++) if ((void 0 !== n && 0 == n && ((e[i] = e[i].toLowerCase()), (t = t.toLowerCase())), e[i] == t)) return i;
                return -1;
            },
            _ = function (t) {
                if (t && "string" == typeof t) {
                    var e = t.replace(/<.*?>/g, "");
                    return (
                        (e = e
                            .replace(/&amp;/g, "&")
                            .replace(/&lt;/g, "<")
                            .replace(/&gt;/g, ">")
                            .replace(/&quot;/g, '"')
                            .replace(/&#x27;/g, "'")
                            .replace(/&#36;/g, "$")
                            .replace(/&#x2F;/g, "/")
                            .replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/"/g, "&quot;")
                            .replace(/'/g, "&#x27;")
                            .replace(/\$/g, "&#36;")
                            .replace(/\//g, "&#x2F;")),
                        e
                    );
                }
                return void 0 === t || "undefined" == t ? "" : t;
            },
            C = {
                escape: function (t, e) {
                    return (
                        (e = e ? "&#13;" : "\n"),
                        ("" + t)
                            .replace(/&/g, "&amp;")
                            .replace(/'/g, "&apos;")
                            .replace(/"/g, "&quot;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/\r\n/g, e)
                            .replace(/[\r\n]/g, e)
                    );
                },
                unescape: function (t) {
                    return ("" + t)
                        .replace(/&amp;/g, "&")
                        .replace(/&lt;/g, "<")
                        .replace(/&gt;/g, ">")
                        .replace(/&quot;/g, '"')
                        .replace(/&#x27;/g, "'")
                        .replace(/&#36;/g, "$")
                        .replace(/&#x2F;/g, "/");
                },
                findIndexArray: w,
                getParam: P,
                getSearchTerm: function () {
                    return C.stripHtml(P(a.a.searchTermKey));
                },
                getValueInObjectArray: function (t, e, r, n) {
                    void 0 === r && (r = "key"), void 0 === n && (n = "values");
                    var i = w(t, e, r);
                    return i > -1 && e[i].hasOwnProperty(n) ? e[i][n] : "";
                },
                getFilePath: function (t, e, r) {
                    (e = void 0 !== e ? e : "png"), (r = void 0 !== r ? r : "");
                    var n = a.a.fileUrl.split("?")[0];
                    return (n += t + "." + e + (r ? "?v=" + r : ""));
                },
                getNumberDecimals: function (t) {
                    var e = t.toString().split(".");
                    return e.length > 1 ? e[1].length : 0;
                },
                isMobile: function () {
                    return (
                        S ||
                            ((S = i()(window).width()),
                            i()(window).on("resize", function () {
                                S = i()(window).width();
                            })),
                        S <= o.a.getSettingValue("general.breakpointMobile")
                    );
                },
                isMobileDevice: function () {
                    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                },
                isTablet: function () {
                    return (
                        S ||
                            ((S = i()(window).width()),
                            i()(window).on("resize", function () {
                                S = i()(window).width();
                            })),
                        S <= o.a.getSettingValue("general.breakpointTablet") && S > o.a.getSettingValue("general.breakpointMobile")
                    );
                },
                isiOS: function () {
                    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                },
                isSafari: function () {
                    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                },
                isBackButton: function () {
                    return window.performance && window.performance.navigation && 2 == window.performance.navigation.type;
                },
                isCartPage: function () {
                    return window.location.pathname.indexOf("/cart") > -1;
                },
                isProductPage: function () {
                    return window.location.pathname.indexOf("/products") > -1;
                },
                isCollectionPage: function () {
                    return window.location.pathname.includes("/collections");
                },
                isSearchPage: O,
                isVendorPage: function () {
                    return window.location.pathname.indexOf("/collections/vendors") > -1;
                },
                isTagPage: function () {
                    return void 0 !== a.a.currentTags && null !== a.a.currentTags && a.a.currentTags.length > 0;
                },
                isTypePage: function () {
                    return window.location.pathname.indexOf("/collections/types") > -1;
                },
                isGLHMobile: function () {
                    return navigator && navigator.userAgent && navigator.userAgent.includes(atob("TGlnaHRob3VzZQ==")) && C.isMobile() && !C.isSearchPage();
                },
                mergeObject: function t(e, r) {
                    for (var n in r)
                        try {
                            e[n] = r[n].constructor == Object ? (T(r[n]) ? e[n] || {} : t(e[n], r[n])) : r[n];
                        } catch (t) {
                            e[n] = r[n];
                        }
                    return e;
                },
                optimizeImage: b,
                getFeaturedImage: function (t, e) {
                    e = void 0 !== e ? e : "large";
                    var r = b(boostPFSConfig.general.no_image_url, e);
                    return t.length > 0 && (r = "object" === g(t[0]) ? b(t[0].src, e) : b(t[0], e)), r;
                },
                getFilterTagImage: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                        n = e.widthUrl,
                        i = void 0 === n ? 530 : n,
                        o = r.width,
                        a = void 0 === o ? i : o,
                        l = r.widths,
                        s = void 0 === l ? "352, 832, 1200, 1920" : l,
                        c = r.sizes,
                        u = void 0 === c ? "" : c,
                        p = r.srcset,
                        f = void 0 === p ? "" : p,
                        h = r.alt,
                        y = void 0 === h ? "" : h,
                        d = r.classes,
                        m = void 0 === d ? "" : d,
                        g = r.loading,
                        b = void 0 === g ? "" : g,
                        v = "";
                    if (!t || "string" != typeof t) return v;
                    if (
                        ((v += "<img "),
                        (v += 'src="'.concat(C.optimizeImage(t, i), "&amp;width=").concat(i, '" ')),
                        "string" == typeof y && "nil" != y && (v += 'alt="'.concat(y, '" ')),
                        m && "string" == typeof m && "nil" != m && (v += "class=".concat(m, " ")),
                        a && "nil" != a && (v += 'width="'.concat(a, '" ')),
                        !b || "string" != typeof b || ("eager" !== b && "lazy" !== b) || (v += 'loading="'.concat(b, '" ')),
                        "nil" !== f && s && "string" == typeof s)
                    ) {
                        v += 'srcset="';
                        var S = s.split(", ");
                        Array.isArray(S) &&
                            S.length > 0 &&
                            (S.forEach(function (e, r) {
                                (v += "".concat(C.optimizeImage(t, e + "x"), " ").concat(e, "w")), r < S.length - 1 && (v += ", ");
                            }),
                            (v += '" '));
                    }
                    return u && "string" == typeof u && (v += 'sizes="'.concat(u, '"')), (v += "/>");
                },
                slugify: function (t) {
                    if (null == t || "object" == g(t)) return "";
                    if ("string" != typeof t) {
                        if ("function" != typeof t.toString) return "";
                        t = t.toString();
                    }
                    t = t.toLowerCase();
                    for (var e = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;", r = 0, n = e.length; r < n; r++) t = t.replace(new RegExp(e.charAt(r), "g"), "aaaaaeeeeeiiiiiooooouuuuunc--_---".charAt(r));
                    for (var i = "ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž".length, o = 0; o < i; o++) t = t.replace(new RegExp("ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž".charAt(o), "g"), "AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz".charAt(o));
                    for (var a = ["AE", "ae", "O", "o", "A", "a"], l = "ÆæØøÅå".length, s = 0; s < l; s++) t = t.replace(new RegExp("ÆæØøÅå".charAt(s), "g"), a[s]);
                    return (t = t.replace(/'/g, "").replace(/"/g, ""))
                        .replace(/[\s\/]+/g, "-")
                        .replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, "-")
                        .replace(/\-\-+/g, "-")
                        .replace(/^-+/, "")
                        .replace(/-+$/, "");
                },
                capitalize: function (t, e, r) {
                    r = void 0 !== r && r;
                    return (
                        (e = void 0 !== e && e) && (t = t.toLowerCase()),
                        r
                            ? t.charAt(0).toUpperCase() + t.slice(1)
                            : t.replace(/(?:^|\s)\S/g, function (t) {
                                  return t.toUpperCase();
                              })
                    );
                },
                textify: function (t, e) {
                    e = void 0 !== e ? e : "-";
                    for (var r = t.split(e), n = "", i = 0; i < r.length; i++) (n += r[i].charAt(0).toUpperCase() + r[i].slice(1)), i < r.length - 1 && (n += " ");
                    return n;
                },
                stripHtml: _,
                stripScriptTag: function (t) {
                    if (t) return t.replace(/<script[^>]*>.*?<\/script>/gi, "");
                },
                truncateByWord: function (t, e, r) {
                    return void 0 === r && (r = "..."), (t = t.split(" ").length > e ? t.split(" ").splice(0, e).join(" ") + r : t.split(" ").splice(0, e).join(" "));
                },
                removeDecimal: function (t, e) {
                    e = void 0 !== e ? e : o.a.getSettingValue("general.decimalDelimiter");
                    var r = new RegExp("(\\" + e + "\\d+)+", "gi");
                    return t.replace(r, "");
                },
                formatMoney: function (t, e, r) {
                    if ((void 0 === e && (e = a.a.moneyFormat), ("money_with_currency" == e || o.a.getSettingValue("general.moneyFormatWithCurrency")) && (e = a.a.moneyFormatWithCurrency), void 0 === r)) r = !1;
                    "string" == typeof t && (t = t.replace(".", ""));
                    var n = "",
                        i = /\{\{\s*(\w+)\s*\}\}/,
                        l = e || "${{amount}}";
                    function s(t, e) {
                        return void 0 === t ? e : t;
                    }
                    function c(t, e, n, i) {
                        if (((e = s(e, 2)), (n = s(n, ",")), (i = s(i, ".")), isNaN(t) || null == t)) return 0;
                        var o = (t = parseFloat(t).toFixed(e)).split("."),
                            a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
                            l = o[1] ? i + o[1] : "";
                        return 1 == r ? (a + l).replace(/((\,00)|(\.00))$/g, "") : a + l;
                    }
                    var u = l.match(i);
                    switch (u && u.length > 1 ? u[1] : "") {
                        case "amount":
                            n = c(t, 2);
                            break;
                        case "amount_no_decimals":
                            n = c(t, 0);
                            break;
                        case "amount_with_comma_separator":
                            n = c(t, 2, ".", ",");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            n = c(t, 0, ".", ",");
                            break;
                        case "amount_with_space_separator_no_comma":
                            n = c(t, 2);
                            break;
                        case "amount_no_decimals_with_space_separator":
                            n = c(t, 0, " ", ".");
                            break;
                        default:
                            n = c(t, 2);
                    }
                    return (l = l.replace(i, n)), o.a.getSettingValue("general.enable3rdCurrencySupport") ? C.moneyWrapper(l) : l;
                },
                moneyWrapper: function (t) {
                    return '<span class="money">{{money}}</span>'.replace(/{{money}}/g, _(t));
                },
                formatNumberWithSeparator: function (t, e, r, n, i) {
                    isNaN(t) && (t = 0), isNaN(e) && (e = 0), n || (n = "." == r ? "," : ".");
                    var o = (t = parseFloat(t).toFixed(e)).toString().split("."),
                        a = o[0],
                        l = o[1] ? o[1] : "";
                    return r && (a = a.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r)), n && l && (l = i && /0+/.test(l) ? "" : n + l), a + l;
                },
                getCurrency: v,
                removeCurrencySymbol: function (t) {
                    t = i()("<p>" + t + "</p>").text();
                    for (var e = v().split(" "), r = 0; r < e.length; r++) t = t.replace(e[r].trim(), "");
                    return t.trim();
                },
                isShopifyActiveCurrency: function () {
                    return "undefined" != typeof Shopify && Shopify.hasOwnProperty("currency") && Shopify.currency.hasOwnProperty("rate") && 1 != Shopify.currency.rate;
                },
                isEnableShopifyMultipleCurrencies: function () {
                    return o.a.hasOwnProperty("general") && o.a.general.hasOwnProperty("currencies") && o.a.general.currencies.length > 1 && C.isShopifyActiveCurrency();
                },
                isConvertCurrenciesOnFrontEnd: function () {
                    var t = o.a.getSettingValue("currencyRoundingRules");
                    return t && "object" == g(t);
                },
                roundedPrice: function (t) {
                    t = parseFloat(t).toFixed(2);
                    var e = boostPFSAppConfig.general.current_currency.toLowerCase().trim(),
                        r = o.a.getSettingValue("currencyRoundingRules"),
                        n = r && e && r.hasOwnProperty(e) ? r[e] : 0,
                        i = C.getRoundingRange(!0);
                    if (i) {
                        var a = parseFloat(n);
                        (t /= i), 1 == (a /= i) && (a = 0);
                        var l = Math.floor(t);
                        (t = (t - l).toFixed(2) > a ? l + 1 : l), (t *= i), 0 == a && (n = 0), (t += parseFloat(n));
                    }
                    return t;
                },
                getRoundingRange: function (t) {
                    void 0 === t && (t = !1);
                    var e = boostPFSAppConfig.general.current_currency.toLowerCase().trim(),
                        r = o.a.getSettingValue("currencyRoundingRules"),
                        n = r && e && r.hasOwnProperty(e) ? parseFloat(r[e]) : 0,
                        i = !1;
                    return (
                        n > 0 &&
                            -1 != [0.25, 0.5, 0.75, 0.9, 0.95, 0.99, 1, 25, 50, 75, 90, 95, 99, 100, 250, 500, 750, 900, 950, 999, 1e3].indexOf(n) &&
                            ((i = 0.99), n > 100 ? (i = 999) : n > 10 ? (i = 99) : n > 1 && (i = 9), t && (i = n > 1 ? i + 1 : i + 0.01)),
                        i
                    );
                },
                convertPriceBasedOnActiveCurrency: function (t, e) {
                    if ((void 0 === e && (e = !0), !t || 0 == t)) return t;
                    if (C.isEnableShopifyMultipleCurrencies()) {
                        var r = t * Shopify.currency.rate;
                        t = e ? C.roundedPrice(r) : r;
                    }
                    return parseFloat(t);
                },
                convertPriceBasedOnPresentmentPrice: function (t) {
                    var e = o.a.getSettingValue("general.currencies");
                    if (void 0 !== e && e.length > 1) {
                        var r = o.a.getSettingValue("general.current_currency").toLowerCase().trim();
                        ["price_min", "price_max", "compare_at_price_min", "compare_at_price_max"].forEach(function (e) {
                            var n = e + "_" + r;
                            void 0 !== t[n] && (t[e] = t[n]);
                        });
                    }
                },
                revertPriceToDefaultCurrency: function (t, e) {
                    if (!t || 0 == t) return t;
                    if (C.isEnableShopifyMultipleCurrencies()) {
                        if (((t = C.roundedPrice(t)), e)) {
                            var r = C.getRoundingRange();
                            r && (t -= r);
                        }
                        return (t /= Shopify.currency.rate).toFixed(8);
                    }
                    return t;
                },
                reBuildUrlBaseOnLocale: function (t) {
                    t = t.replace("https://", "").replace("http://", "");
                    var e = Shopify && Shopify.routes && void 0 !== Shopify.routes.root;
                    if (o.a.getSettingValue("general.useShopifyRouteForMultiLanguageURL") && e) return Shopify.routes.root.replace(/\/$/, "") + t;
                    var r = o.a.getSettingValue("general.current_locale"),
                        n = o.a.getSettingValue("general.published_locales"),
                        i = Object.keys(n);
                    if (i.indexOf(r) < 0 || 1 == n[r]) return t;
                    var a = t.split("/");
                    return a.length > 1 && i.length && r.length && (i.indexOf(a[1]) > -1 ? (a[1] = r) : a.splice(1, 0, r)), a.join("/");
                },
                getWindowLocation: function () {
                    for (var t = window.location.href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;"), e = [], r = 0; r < t.length; r++) e.push(t.charAt(r));
                    var n = e.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),
                        i = "",
                        o = n.replace(/#.*$/, "");
                    return o.split("?").length > 1 && (i = o.split("?")[1]).length > 0 && (i = "?" + i), { pathname: window.location.pathname, href: n, search: i };
                },
                setWindowLocation: function (t) {
                    window.location.href = t;
                },
                isBadUrl: function (t) {
                    try {
                        t || (t = C.getWindowLocation().search);
                        var e = decodeURIComponent(t).split("&"),
                            r = !1;
                        if (e.length > 0)
                            for (var n = 0; n < e.length; n++) {
                                var i = e[n];
                                if ((r = C.isBadSearchTerm(i))) break;
                            }
                        return r;
                    } catch (t) {
                        return !0;
                    }
                },
                isBadSearchTerm: function (t) {
                    if ("string" == typeof t) {
                        var e = new RegExp(
                                [
                                    "onabort",
                                    "popstate",
                                    "afterprint",
                                    "beforeprint",
                                    "beforeunload",
                                    "blur",
                                    "canplay",
                                    "canplaythrough",
                                    "change",
                                    "click",
                                    "contextmenu",
                                    "copy",
                                    "cut",
                                    "dblclick",
                                    "drag",
                                    "dragend",
                                    "dragenter",
                                    "dragleave",
                                    "dragover",
                                    "dragstart",
                                    "drop",
                                    "durationchange",
                                    "ended",
                                    "error",
                                    "focus",
                                    "focusin",
                                    "focusout",
                                    "fullscreenchange",
                                    "fullscreenerror",
                                    "hashchange",
                                    "input",
                                    "invalid",
                                    "keydown",
                                    "keypress",
                                    "keyup",
                                    "load",
                                    "loadeddata",
                                    "loadedmetadata",
                                    "loadstart",
                                    "mousedown",
                                    "mouseenter",
                                    "mouseleave",
                                    "mousemove",
                                    "mouseover",
                                    "mouseout",
                                    "mouseout",
                                    "mouseup",
                                    "offline",
                                    "online",
                                    "pagehide",
                                    "pageshow",
                                    "paste",
                                    "pause",
                                    "play",
                                    "playing",
                                    "progress",
                                    "ratechange",
                                    "resize",
                                    "reset",
                                    "scroll",
                                    "search",
                                    "seeked",
                                    "seeking",
                                    "select",
                                    "show",
                                    "stalled",
                                    "submit",
                                    "suspend",
                                    "timeupdate",
                                    "toggle",
                                    "touchcancel",
                                    "touchend",
                                    "touchmove",
                                    "touchstart",
                                    "unload",
                                    "volumechange",
                                    "waiting",
                                    "wheel",
                                ].join("=|on")
                            ),
                            r = (t.match(/</g) || []).length,
                            n = (t.match(/>/g) || []).length,
                            i = (t.match(/alert\(/g) || []).length,
                            o = (t.match(/console\.log\(/g) || []).length,
                            a = (t.match(/execCommand/g) || []).length,
                            l = (t.match(/document\.cookie/g) || []).length,
                            s = (t.match(/j.*a.*v.*a.*s.*c.*r.*i.*p.*t/g) || []).length,
                            c = e.test(t);
                        if ((r > 0 && n > 0) || r > 1 || n > 1 || i || o || a || l || s || c) return !0;
                    }
                    return !1;
                },
                debounce: function (t, e) {
                    var r;
                    return function () {
                        var n = this,
                            i = arguments,
                            o = function () {
                                t.apply(n, i);
                            };
                        clearTimeout(r), (r = setTimeout(o, e));
                    };
                },
                iterateObject: function (t, e) {
                    t &&
                        "object" == g(t) &&
                        Object.keys(t).forEach(function (r) {
                            "object" == g(t[r]) ? C.iterateObject(t[r]) : "function" == typeof e && (t[r] = e(t[r]));
                        });
                },
                sticky: function (t, e, r) {
                    if (null == t.attr("data-offset-top")) {
                        var n = t.offset().top;
                        t.attr("data-offset-top", n);
                    }
                    var a = function () {
                        var n = !!(t.hasClass(l.a.filterTreeVertical) || t.find(s.a.filterTreeVertical).length > 0),
                            a = t.outerWidth(),
                            c = n ? t[0].scrollHeight : t.outerHeight(),
                            u = window.innerHeight,
                            p = Number(t.attr("data-offset-top")),
                            f = i()(e).position().top + i()(e).outerHeight(),
                            h = i()(e).offset().top + i()(e).outerHeight(),
                            y = "boost-pfs-filter-tree" == t[0].classList[0] || "boost-pfs-filter-tree-h-wrapper" == t[0].classList[0] ? t[0].classList[0] + "-stick-body" : "boost-pfs-filter-tree-button-stick-wrapper-body",
                            d = i()(e).height() <= u + 100,
                            m = 0,
                            g = i()(r);
                        if (
                            (g.length > 0 &&
                                g.each(function (t, e) {
                                    var r = e.getBoundingClientRect();
                                    r.y >= 0 && r.height > 0
                                        ? (m += r.height)
                                        : i()(e)
                                              .children()
                                              .each(function (t, e) {
                                                  var r = e.getBoundingClientRect();
                                                  r.y >= 0 && r.height > 0 && (m += r.height);
                                              });
                                }),
                            (p -= m),
                            window.scrollY < p || h - p <= c || d)
                        )
                            t.removeClass("boost-pfs-filter-stick"),
                                t.removeClass("boost-pfs-filter-absolute"),
                                i()("body").removeClass("boost-pfs-filter-stick-body"),
                                i()("body").removeClass(y),
                                t.css({ position: "initial", width: "", maxHeight: "none", overflow: "visible", visibility: "visible" });
                        else if (window.scrollY + c <= h) {
                            t.addClass("boost-pfs-filter-stick"),
                                t.removeClass("boost-pfs-filter-absolute"),
                                i()("body").addClass("boost-pfs-filter-stick-body"),
                                i()("body").addClass(y),
                                t.css({ position: "fixed", width: n ? a : "", maxHeight: window.innerHeight - m + "px", overflow: n ? "auto" : "visible", visibility: "visible", top: m + "px" });
                            var b = o.a.getSettingValue("general.stickyChangeTopTimeout");
                            "number" != typeof b && (b = 0),
                                setTimeout(function () {
                                    t.css({ top: m + "px" });
                                }, b);
                        } else {
                            t.removeClass("boost-pfs-filter-stick"), t.addClass("boost-pfs-filter-absolute"), i()("body").removeClass("boost-pfs-filter-stick-body"), i()("body").removeClass(y);
                            var v = o.a.getSettingValue("general.stickyFixTopPos") ? f - p - c : f - c - m;
                            t.css({ position: "absolute", top: v + "px", width: n ? a : "", maxHeight: "none", visibility: n ? "visible" : "hidden" });
                        }
                    };
                    i()(window).off("scroll", a), i()(window).on("scroll", a), a();
                },
                addClassToBody: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    if (t && "string" == typeof t) {
                        var e = { enableApp: l.a.enableApp, enableFilter: l.a.enableFilter, enableInstantSearch: l.a.enableInstantSearch, variantsDisplay: l.a.variantsDisplay },
                            r = e[t];
                        r && i()("body").addClass(r);
                    }
                },
                InstantSearch: c,
                isFullWidthMobile: c.isFullWidthMobile,
                isStyle2: c.isStyle2,
                isStyle3: c.isStyle3,
                getListSuggestionType: c.getListSuggestionType,
                FilterTree: u,
                checkExistFilterOptionParam: u.checkExistFilterOptionParam,
                encodeURIParamValue: u.encodeURIParamValue,
                showFilterTree: u.showFilterTree,
                hideFilterTree: u.hideFilterTree,
                FilterResult: m,
                buildProductItemUrl: m.buildProductItemUrl,
                buildProductItemUrlWithVariant: m.buildProductItemUrlWithVariant,
                buildProductItemVendorUrl: m.buildProductItemVendorUrl,
                removePageParamFromUrl: m.removePageParamFromUrl,
                removeCollectionScopeParamFromUrl: m.removeCollectionScopeParamFromUrl,
                buildToolbarLink: m.buildToolbarLink,
                isDefaultPaginationType: m.isDefaultPaginationType,
                isLoadMorePaginationType: m.isLoadMorePaginationType,
                isInfiniteLoadingPaginationType: m.isInfiniteLoadingPaginationType,
                isLoadPreviousPagePaginationType: m.isLoadPreviousPagePaginationType,
                getSortingList: m.getSortingList,
                getDefaultSorting: m.getDefaultSorting,
                getProductMetafield: m.getProductMetafield,
                isNoFilterResult: m.isNoFilterResult,
                compileShopifyProductVariables: m.compileShopifyProductVariables,
                compileShopifyProductMetafield: m.compileShopifyProductMetafield,
            },
            k = (e.a = C);
    },
    10: function (t, e, r) {
        "use strict";
        r(33), r(88), r(27), r(9), r(28), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        function n(t) {
            return (n =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function i(t, e) {
            for (var r = 0; r < e.length; r++) {
                var i = e[r];
                (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    "value" in i && (i.writable = !0),
                    Object.defineProperty(
                        t,
                        ((o = i.key),
                        (a = void 0),
                        (a = (function (t, e) {
                            if ("object" !== n(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var i = r.call(t, e || "default");
                                if ("object" !== n(i)) return i;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(o, "string")),
                        "symbol" === n(a) ? a : String(a)),
                        i
                    );
            }
            var o, a;
        }
        var o = (function () {
            function t() {
                !(function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, t),
                    (this.isInit = !1),
                    (this.isRendered = !1),
                    (this.isBoundEvent = !1),
                    (this.children = []),
                    (this.parent = null),
                    (this.$element = null);
            }
            var e, r, n;
            return (
                (e = t),
                (r = [
                    {
                        key: "refresh",
                        value: function () {
                            this._callAllInit(), this._callAllRender(), this._callAllBindEvents();
                        },
                    },
                    { key: "beforeInit", value: function () {} },
                    { key: "init", value: function () {} },
                    { key: "afterInit", value: function () {} },
                    {
                        key: "isLoopThroughChild",
                        value: function () {
                            return !0;
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return !0;
                        },
                    },
                    { key: "beforeRender", value: function () {} },
                    { key: "render", value: function () {} },
                    { key: "afterRender", value: function () {} },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !0;
                        },
                    },
                    { key: "beforeBindEvents", value: function () {} },
                    { key: "bindEvents", value: function () {} },
                    { key: "afterBindEvents", value: function () {} },
                    {
                        key: "addComponent",
                        value: function (t) {
                            (t.parent = this), this.children.push(t);
                        },
                    },
                    {
                        key: "removeComponent",
                        value: function (t) {
                            if (this.children && this.children.length > 0) {
                                var e = this.children.indexOf(t);
                                -1 !== e && this.children.splice(e, 1);
                            }
                        },
                    },
                    {
                        key: "_callAllInit",
                        value: function () {
                            this.isInit || (this.beforeInit(), this.init()),
                                this.children &&
                                    this.children.length > 0 &&
                                    this.isLoopThroughChild() &&
                                    this.children.forEach(function (t) {
                                        t._callAllInit();
                                    }),
                                this.isInit || (this.afterInit(), (this.isInit = !0));
                        },
                    },
                    {
                        key: "_callAllRender",
                        value: function () {
                            this.isRender() && this.beforeRender(),
                                this.children &&
                                    this.children.length > 0 &&
                                    this.isLoopThroughChild() &&
                                    this.children.forEach(function (t) {
                                        t._callAllRender();
                                    }),
                                this.isRender() && (this.render(), this.afterRender(), (this.isRendered = !0));
                        },
                    },
                    {
                        key: "_callAllBindEvents",
                        value: function () {
                            this.isBindEvents() && this.beforeBindEvents(),
                                this.children &&
                                    this.children.length > 0 &&
                                    this.isLoopThroughChild() &&
                                    this.children.forEach(function (t) {
                                        t._callAllBindEvents();
                                    }),
                                this.isBindEvents() && (this.bindEvents(), this.afterBindEvents(), (this.isBoundEvent = !0));
                        },
                    },
                ]) && i(e.prototype, r),
                n && i(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                t
            );
        })();
        e.a = o;
    },
    103: function (t, e, r) {
        "use strict";
        r(9), r(48), r(24), r(27), r(28), r(11), r(12), r(25), r(26);
        var n = r(3),
            i = r(0),
            o = function () {
                "string" != typeof n.a.currentTerm && (n.a.currentTerm = i.a.stripHtml(n.a.currentTerm.toString())), (n.a.currentTerm = i.a.stripHtml(n.a.currentTerm.trim()));
                var t = "";
                n.a.suggestionCache.hasOwnProperty(i.a.unescape(n.a.currentTerm)) &&
                    n.a.suggestionCache[i.a.unescape(n.a.currentTerm)].forEach(function (e) {
                        "redirect" == e.key && e.values && (t = (t = (t = e.values).replace("https://" + n.a.shopDomain, "")).replace("http://" + n.a.shopDomain, ""));
                    });
                return t;
            },
            a = {
                getSearchRedirectUrl: o,
                checkForSearchRedirect: function (t) {
                    if (t.data("search-submit")) {
                        t.removeAttr("data-search-submit");
                        var e = o();
                        e ? i.a.setWindowLocation(e) : t.closest("form").trigger("submit", [!0]);
                    }
                },
            };
        e.a = a;
    },
    123: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(30), r(9), r(27), r(28), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(10),
            a = r(4),
            l = r(124),
            s = r(91),
            c = r(125),
            u = r(126),
            p = r(23),
            f = r(127),
            h = r(2),
            y = r(0),
            d = r(7);
        function m(t) {
            return (m =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function g(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== m(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== m(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === m(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function b(t, e) {
            return (b = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function v(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = O(t);
                if (e) {
                    var i = O(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return S(this, r);
            };
        }
        function S(t, e) {
            if (e && ("object" === m(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function O(t) {
            return (O = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var P = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && b(t, e);
            })(m, t);
            var e,
                r,
                n,
                o = v(m);
            function m(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, m),
                    ((e = o.call(this)).type = t.type),
                    (e.status = t.status),
                    (e.maxSuggesionItems = t.number),
                    (e.label = y.a.stripHtml(t.label)),
                    (e.isShow = !1),
                    (e.isShowDYM = !1),
                    e.type && e.type === p.a.ResultType.PRODUCTS && (e.blockDym = new f.a()),
                    (e.settings = { suggesionMaxItems: h.a.getSettingValue("search.suggesionMaxItems") }),
                    e
                );
            }
            return (
                (e = m),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            switch (this.type) {
                                case p.a.ResultType.SUGGESTIONS:
                                case p.a.ResultType.DEFAULT_SUGGESTIONS:
                                case p.a.ResultType.RECENT_SEARCHES:
                                case p.a.ResultType.NO_RESULT_SUGGESTIONS:
                                    this.maxSuggesionItems = this.settings.suggesionMaxItems;
                                    for (var t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new l.a());
                                    break;
                                case p.a.ResultType.PRODUCTS:
                                case p.a.ResultType.DEFAULT_PRODUCTS:
                                case p.a.ResultType.NO_RESULT_PRODUCTS:
                                    for (this.maxSuggesionItems = this.settings.suggesionMaxItems, t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new s.a());
                                    break;
                                case p.a.ResultType.COLLECTIONS:
                                    for (t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new c.a());
                                    break;
                                case p.a.ResultType.PAGES:
                                    for (t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new u.a());
                            }
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case "dym":
                                    return '\n\t\t\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.searchSuggestionGroup}}" data-group="{{type}}" aria-label="{{label}}">\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}">{{label}}</li>\n\t\t\t\t\t\t\t{{resultItems}}\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            if (!(("active" == this.status && this.isShow) || this._isShowDYM())) return "";
                            var t;
                            switch (this.type) {
                                case p.a.ResultType.SUGGESTIONS:
                                    t = h.a.getSettingValue("label.suggestion.instantSearchSuggestionsLabel");
                                    break;
                                case p.a.ResultType.COLLECTIONS:
                                    t = h.a.getSettingValue("label.suggestion.instantSearchCollectionsLabel");
                                    break;
                                case p.a.ResultType.PRODUCTS:
                                    t = h.a.getSettingValue("label.suggestion.instantSearchProductsLabel");
                                    break;
                                case p.a.ResultType.PAGES:
                                    t = h.a.getSettingValue("label.suggestion.instantSearchPagesLabel");
                                    break;
                                case p.a.ResultType.NO_RESULT_SUGGESTIONS:
                                    t = d.a.suggestion.noSearchResultSearchTermLabel;
                                    break;
                                case p.a.ResultType.NO_RESULT_PRODUCTS:
                                    t = d.a.suggestion.noSearchResultProductsLabel;
                                    break;
                                case p.a.ResultType.RECENT_SEARCHES:
                                    t = d.a.suggestion.searchBoxOnclickRecentSearchLabel;
                                    break;
                                case p.a.ResultType.DEFAULT_SUGGESTIONS:
                                    t = d.a.suggestion.searchBoxOnclickSearchTermLabel;
                                    break;
                                case p.a.ResultType.DEFAULT_PRODUCTS:
                                    t = d.a.suggestion.searchBoxOnclickProductsLabel;
                                    break;
                                default:
                                    t = this.label;
                            }
                            return (
                                t || (t = this.label),
                                this.getTemplate()
                                    .replace(/{{type}}/g, this.type)
                                    .replace(/{{label}}/g, y.a.stripHtml(t))
                                    .replace(/{{class.searchSuggestionHeader}}/g, a.a.searchSuggestionHeader)
                                    .replace(/{{class.searchSuggestionGroup}}/g, a.a.searchSuggestionGroup)
                                    .replace(/{{resultItems}}/g, "")
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            (this.$element = i()(this.compileTemplate())),
                                this.type &&
                                    this.type === p.a.ResultType.PRODUCTS &&
                                    (this.blockDym.render(),
                                    this.blockDym.bindEvents(),
                                    this.blockDym.$element &&
                                        ((this.$element = i()(this.compileTemplate())),
                                        "style1" == h.a.getSettingValue("search.suggestionStyle") || y.a.isMobile()
                                            ? this.parent.$instantSearchResult.prepend(this.blockDym.$element)
                                            : this.$element.find(" ul").prepend(this.blockDym.$element))),
                                this.children.forEach(function (e) {
                                    e.$element && t.$element.find(" ul").append(e.$element);
                                });
                        },
                    },
                    {
                        key: "_isShowDYM",
                        value: function () {
                            return this.isShowDYM && this.type == p.a.ResultType.PRODUCTS;
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            (this.data = t),
                                (this.isAllEmpty = e),
                                this.children.forEach(function (e, r) {
                                    t && t.length > r ? e.setData(t[r]) : e.setData(null);
                                }),
                                this.blockDym && (this.blockDym.setData(this.parent.data), (this.isShowDYM = this.blockDym.isShow)),
                                (this.isShow = t && t.length > 0);
                        },
                    },
                ]) && g(e.prototype, r),
                n && g(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                m
            );
        })(o.a);
        e.a = P;
    },
    124: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(0),
            a = r(3),
            l = r(4),
            s = r(46),
            c = r(62),
            u = r(23);
        function p(t) {
            return (p =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function f(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== p(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== p(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === p(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function h(t, e) {
            return (h = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function y(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = m(t);
                if (e) {
                    var i = m(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return d(this, r);
            };
        }
        function d(t, e) {
            if (e && ("object" === p(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function m(t) {
            return (m = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var g = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && h(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = y(p);
            function p() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((t = c.call(this)).data = ""),
                    t
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedData}}" role="option">\n\t\t\t\t<a tabindex="-1" href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            if (!this.isShow) return "";
                            var t = o.a.stripHtml(a.a.currentTerm),
                                e = this.data;
                            return (
                                this.parent.type == u.a.ResultType.SUGGESTIONS && (e = this._highlightSuggestionResult(this.data, t)),
                                this.getTemplate()
                                    .replace(/{{escapedBlockType}}/g, o.a.stripHtml(this.parent.type))
                                    .replace(/{{escapedData}}/g, o.a.stripHtml(this.data))
                                    .replace(/{{class.searchSuggestionItem}}/g, l.a.searchSuggestionItem)
                                    .replace(/{{class.searchUiAutocompleteItem}}/g, l.a.searchUiAutocompleteItem)
                                    .replace(/{{searchLink}}/g, this.searchLink)
                                    .replace(/{{highlightedSuggestionResult}}/g, e)
                            );
                        },
                    },
                    {
                        key: "checkForRedirectData",
                        value: function () {
                            var t = this.parent.parent;
                            if (t.hasRedirectData && t.redirectData && t.searchQuery == this.data) return t.redirectData;
                            var e = o.a.getValueInObjectArray(u.a.ResultType.SUGGESTIONS_REDIRECT, t.data);
                            return e && e[this.data] ? e[this.data] : "";
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.data ? ((this.$element = i()(this.compileTemplate())), this.$element.attr("data-title", o.a.stripHtml(this.data))) : (this.$element = null);
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && !this.redirectLink && this.$element.on("click", this.saveRecentSearch.bind(this));
                        },
                    },
                    {
                        key: "saveRecentSearch",
                        value: function () {
                            s.a.setOnClickRecentSearches(this.data);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            (this.data = t),
                                (this.isShow = !!this.data),
                                (this.redirectLink = this.checkForRedirectData()),
                                this.redirectLink ? (this.searchLink = this.redirectLink) : (this.searchLink = o.a.reBuildUrlBaseOnLocale("/search?" + a.a.searchTermKey + "=" + o.a.encodeURIParamValue(this.data)));
                        },
                    },
                ]) && f(e.prototype, r),
                n && f(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(c.a);
        e.a = g;
    },
    125: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(0),
            a = r(3),
            l = r(4);
        function s(t) {
            return (s =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function c(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== s(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== s(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === s(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function u(t, e) {
            return (u = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function p(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = h(t);
                if (e) {
                    var i = h(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return f(this, r);
            };
        }
        function f(t, e) {
            if (e && ("object" === s(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function h(t) {
            return (h = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var y = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && u(t, e);
            })(f, t);
            var e,
                r,
                n,
                s = p(f);
            function f() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, f),
                    ((t = s.call(this)).data = ""),
                    t
                );
            }
            return (
                (e = f),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">\n\t\t\t\t<a tabindex="-1" href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            if (!this.isShow) return "";
                            this.searchTerm = o.a.stripHtml(a.a.currentTerm);
                            var t = o.a.reBuildUrlBaseOnLocale("/collections/" + this.data.handle),
                                e = this._highlightSuggestionResult(this.data.title, this.searchTerm);
                            return this.getTemplate()
                                .replace(/{{escapedBlockType}}/g, o.a.stripHtml(this.parent.type))
                                .replace(/{{escapedDataTitle}}/g, o.a.stripHtml(this.data.title))
                                .replace(/{{escapedDataId}}/g, o.a.stripHtml(this.data.id))
                                .replace(/{{class.searchSuggestionItem}}/g, l.a.searchSuggestionItem)
                                .replace(/{{class.searchUiAutocompleteItem}}/g, l.a.searchUiAutocompleteItem)
                                .replace(/{{searchLink}}/g, t)
                                .replace(/{{highlightedSuggestionResult}}/g, e);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.data ? ((this.$element = i()(this.compileTemplate())), this.$element.attr("data-title", o.a.stripHtml(this.data.title))) : (this.$element = null);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            (this.data = t), (this.isShow = !!this.data);
                        },
                    },
                ]) && c(e.prototype, r),
                n && c(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                f
            );
        })(r(62).a);
        e.a = y;
    },
    126: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(0),
            a = r(3),
            l = r(4);
        function s(t) {
            return (s =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function c(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== s(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== s(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === s(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function u(t, e) {
            return (u = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function p(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = h(t);
                if (e) {
                    var i = h(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return f(this, r);
            };
        }
        function f(t, e) {
            if (e && ("object" === s(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function h(t) {
            return (h = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var y = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && u(t, e);
            })(f, t);
            var e,
                r,
                n,
                s = p(f);
            function f() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, f),
                    ((t = s.call(this)).data = ""),
                    t
                );
            }
            return (
                (e = f),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">\n\t\t\t\t<a tabindex="-1" href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            if (!this.isShow) return "";
                            var t = o.a.stripHtml(a.a.currentTerm),
                                e = o.a.reBuildUrlBaseOnLocale(this.data.url),
                                r = this._highlightSuggestionResult(this.data.title, t);
                            return this.getTemplate()
                                .replace(/{{escapedBlockType}}/g, o.a.stripHtml(this.parent.type))
                                .replace(/{{escapedDataTitle}}/g, o.a.stripHtml(this.data.title))
                                .replace(/{{class.searchSuggestionItem}}/g, l.a.searchSuggestionItem)
                                .replace(/{{class.searchUiAutocompleteItem}}/g, l.a.searchUiAutocompleteItem)
                                .replace(/{{searchLink}}/g, e)
                                .replace(/{{highlightedSuggestionResult}}/g, r);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.data ? ((this.$element = i()(this.compileTemplate())), this.$element.attr("data-title", o.a.stripHtml(this.data.title))) : (this.$element = null);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            (this.data = t), (this.isShow = !!this.data);
                        },
                    },
                ]) && c(e.prototype, r),
                n && c(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                f
            );
        })(r(62).a);
        e.a = y;
    },
    127: function (t, e, r) {
        "use strict";
        r(24), r(27), r(9), r(28), r(25), r(26), r(30), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(10),
            a = r(4),
            l = r(0),
            s = r(23),
            c = r(3),
            u = r(7),
            p = r(46);
        function f(t) {
            return (f =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function h(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== f(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== f(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === f(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function y(t, e) {
            return (y = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function d(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = g(t);
                if (e) {
                    var i = g(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return m(this, r);
            };
        }
        function m(t, e) {
            if (e && ("object" === f(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function g(t) {
            return (g = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var b = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && y(t, e);
            })(f, t);
            var e,
                r,
                n,
                o = d(f);
            function f() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, f),
                    ((t = o.call(this)).data = ""),
                    (t.$element = null),
                    t
                );
            }
            return (
                (e = f),
                (n = [
                    {
                        key: "tempType",
                        get: function () {
                            return { LINK: "link", SEPARATOR: "separator", STRONG: "strong", P: "p" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case f.tempType.LINK:
                                    return '\n\t\t\t\t\t<a class="{{class.searchSuggestion}}-dym-suggest-query" href="{{url}}">{{content}}</a>\n\t\t\t\t'.trim();
                                case f.tempType.SEPARATOR:
                                    return '\n\t\t\t\t\t<span class="{{class.searchSuggestion}}-dym-suggest-query-separator">&nbsp</span>\n\t\t\t\t'.trim();
                                case f.tempType.STRONG:
                                    return "\n\t\t\t\t\t<strong>{{content}}</strong>\n\t\t\t\t".trim();
                                case f.tempType.P:
                                    return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-{{classType}}">{{content}}</p>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = this;
                            if (this.isShow) {
                                var e = "";
                                "" != this.dymList &&
                                    this.dymList.length > 0 &&
                                    this.dymList.forEach(function (r, n) {
                                        var i = "/search?" + c.a.searchTermKey + "=" + l.a.encodeURIParamValue(r);
                                        (e += t
                                            .getTemplate(f.tempType.LINK)
                                            .replace(/{{url}}/g, i)
                                            .replace(/{{content}}/g, r)),
                                            n < t.dymList.length - 1 && (e += t.getTemplate(f.tempType.SEPARATOR));
                                    });
                                var r = "";
                                if (this.suggestQuery != l.a.stripHtml(c.a.currentTerm)) {
                                    if (0 == this.totalProduct) {
                                        var n = this.getTemplate(f.tempType.STRONG).replace(/{{content}}/g, l.a.stripHtml(c.a.currentTerm)),
                                            i = u.a.error.noSuggestionProducts.replace(/{{ terms }}/g, n) + " ";
                                        r += this.getTemplate(f.tempType.P)
                                            .replace(/{{content}}/g, i)
                                            .replace(/{{classType}}/g, "dym-notfound");
                                    }
                                    if ("" != this.suggestQuery) {
                                        var o = this.getTemplate(f.tempType.STRONG).replace(/{{content}}/g, this.suggestQuery),
                                            s = this.getTemplate(f.tempType.STRONG).replace(/{{content}}/g, this.totalProductFromSuggestedQuery ? this.totalProductFromSuggestedQuery : ""),
                                            p = u.a.suggestion.suggestQuery.replace(/{{ count }}/g, s).replace(/{{ terms }}/g, o);
                                        r += this.getTemplate(f.tempType.P)
                                            .replace(/{{content}}/g, p)
                                            .replace(/{{classType}}/g, "dym-showing-result-for");
                                    }
                                    "" != e &&
                                        (r += this.getTemplate(f.tempType.P)
                                            .replace(/{{content}}/g, u.a.suggestion.didYouMean.replace(/{{ terms }}/g, e))
                                            .replace(/{{classType}}/g, "dym-suggest-query-list"));
                                }
                                return this.getTemplate()
                                    .replace(/{{dymContent}}/g, r)
                                    .replace(/{{class.searchSuggestion}}/g, a.a.searchSuggestion)
                                    .replace(/{{class.searchSuggestionItem}}/g, a.a.searchSuggestionItem);
                            }
                            return "";
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.isShow ? (this.$element = i()(this.compileTemplate())) : (this.$element = null);
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$element.find("a").on("click", this.saveRecentSearch.bind(this));
                        },
                    },
                    {
                        key: "saveRecentSearch",
                        value: function (t) {
                            if (t && t.target) {
                                var e = i()(t.target).text();
                                e && p.a.setOnClickRecentSearches(e);
                            }
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            (this.data = t),
                                (this.isShow = !1),
                                t &&
                                    (l.a.getValueInObjectArray(s.a.ResultType.LOCAL_CACHE, this.data)
                                        ? ((this.totalProduct = l.a.getValueInObjectArray(s.a.ResultType.TOTAL_PRODUCT, this.data)),
                                          (this.totalProductFromSuggestedQuery = l.a.getValueInObjectArray(s.a.ResultType.SUGGEST_TOTAL_PRODUCT, this.data)),
                                          (this.dymList = l.a.getValueInObjectArray(s.a.ResultType.DID_YOU_MEAN, this.data)),
                                          (this.suggestQuery = l.a.getValueInObjectArray(s.a.ResultType.SUGGEST_QUERY, this.data)),
                                          (this.isShow = this.totalProductFromSuggestedQuery > 0))
                                        : l.a.getValueInObjectArray(s.a.ResultType.PREV_QUERY, this.data)
                                        ? ((this.totalProduct = l.a.getValueInObjectArray(s.a.ResultType.PREV_TOTAL_PRODUCT, this.data)),
                                          (this.totalProductFromSuggestedQuery = l.a.getValueInObjectArray(s.a.ResultType.TOTAL_PRODUCT, this.data)),
                                          (this.isShow = this.totalProductFromSuggestedQuery > 0))
                                        : ((this.totalProduct = l.a.getValueInObjectArray(s.a.ResultType.TOTAL_PRODUCT, this.data)),
                                          (this.totalProductFromSuggestedQuery = 0),
                                          (this.dymList = l.a.getValueInObjectArray(s.a.ResultType.DID_YOU_MEAN, this.data)),
                                          (this.suggestQuery = l.a.getValueInObjectArray(s.a.ResultType.SUGGEST_QUERY, this.data)),
                                          (this.isShow = (this.dymList && this.dymList.length > 0) || this.suggestQuery)));
                        },
                    },
                ]) && h(e.prototype, r),
                n && h(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                f
            );
        })(o.a);
        e.a = b;
    },
    128: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(10),
            a = r(4),
            l = r(0),
            s = r(3),
            c = r(2),
            u = r(7),
            p = r(23),
            f = r(46);
        function h(t) {
            return (h =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function y(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== h(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== h(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === h(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function d(t, e) {
            return (d = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function m(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = b(t);
                if (e) {
                    var i = b(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return g(this, r);
            };
        }
        function g(t, e) {
            if (e && ("object" === h(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function b(t) {
            return (b = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var v = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && d(t, e);
            })(h, t);
            var e,
                r,
                n,
                o = m(h);
            function h() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, h),
                    ((t = o.call(this)).data = ""),
                    (t.$element = null),
                    t
                );
            }
            return (
                (e = h),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.searchSuggestionHeader}}-view-all {{class.searchSuggestionHeader}}" data-group="view-all" aria-label="View All">\n\t\t\t\t<a href="{{viewAllUrl}}"><span>{{label.suggestion.viewAll}}{{iconViewAll}}</span></a>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = l.a.getValueInObjectArray("total_product", this.data),
                                e = l.a.getValueInObjectArray("suggest_total_product", this.data);
                            "" !== e && (t = e);
                            var r = c.a.getSettingValue("search.suggestionBlocks"),
                                n = l.a.getValueInObjectArray("products", r, "type", "number");
                            if (0 == t || t <= n) return "";
                            var i = c.a.getSettingValue("search.iconViewAll");
                            (this.viewAllTerm = l.a.getValueInObjectArray(p.a.ResultType.SUGGEST_QUERY, this.data)), this.viewAllTerm || (this.viewAllTerm = l.a.getValueInObjectArray(p.a.ResultType.QUERY, this.data));
                            var o = l.a.reBuildUrlBaseOnLocale("/search?" + s.a.searchTermKey + "=" + l.a.encodeURIParamValue(this.viewAllTerm));
                            return this.getTemplate()
                                .replace(/{{class.searchSuggestionHeader}}/g, a.a.searchSuggestionHeader)
                                .replace(/{{label.suggestion.viewAll}}/g, u.a.suggestion.viewAll)
                                .replace(/{{iconViewAll}}/g, i)
                                .replace(/{{ count }}/g, t)
                                .replace(/{{viewAllUrl}}/g, o);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element = i()(this.compileTemplate());
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$element.on("click", this.saveRecentSearch.bind(this));
                        },
                    },
                    {
                        key: "saveRecentSearch",
                        value: function (t) {
                            this.viewAllTerm && f.a.setOnClickRecentSearches(this.viewAllTerm);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            this.data = t || null;
                        },
                    },
                ]) && y(e.prototype, r),
                n && y(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                h
            );
        })(o.a);
        e.a = v;
    },
    129: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(10),
            a = r(4),
            l = r(2);
        function s(t) {
            return (s =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function c(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== s(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== s(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === s(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function u(t, e) {
            return (u = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function p(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = h(t);
                if (e) {
                    var i = h(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return f(this, r);
            };
        }
        function f(t, e) {
            if (e && ("object" === s(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function h(t) {
            return (h = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var y = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && u(t, e);
            })(s, t);
            var e,
                r,
                n,
                o = p(s);
            function s() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, s),
                    ((t = o.call(this)).$element = null),
                    t
                );
            }
            return (
                (e = s),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.searchSuggestionLoading}}">\n\t\t\t\t<ul>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div class="{{class.searchSuggestionLoading}}-img"></div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div class="{{class.searchSuggestionLoading}}-img"></div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div class="{{class.searchSuggestionLoading}}-img"></div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate().replace(/{{class.searchSuggestionLoading}}/g, a.a.searchSuggestionLoading);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return l.a.getSettingValue("search.showSuggestionLoading");
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element = i()(this.compileTemplate());
                        },
                    },
                ]) && c(e.prototype, r),
                n && c(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(o.a);
        e.a = y;
    },
    130: function (t, e, r) {
        "use strict";
        r(24), r(25), r(58), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(4),
            a = r(7),
            l = r(0),
            s = r(3),
            c = r(23),
            u = r(75);
        function p(t) {
            return (p =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function f(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== p(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== p(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === p(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function h(t, e) {
            return (h = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function y(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = m(t);
                if (e) {
                    var i = m(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return d(this, r);
            };
        }
        function d(t, e) {
            if (e && ("object" === p(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function m(t) {
            return (m = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var g = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && h(t, e);
            })(d, t);
            var e,
                r,
                n,
                p = y(d);
            function d() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, d),
                    ((t = p.call(this)).$element = null),
                    t
                );
            }
            return (
                (e = d),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.searchSuggestion}}-no-result" data-group="empty" data-label="No Results: {{searchTerm}}" data-value="{{searchTerm}}" aria-label="No Results">\n\t\t\t\t<p>{{noResultLabel}}</p>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = l.a.stripHtml(s.a.currentTerm),
                                e = this.isEmptyWithSuggestion ? a.a.search.resultEmptyWithSuggestion : a.a.error.noSuggestionResult;
                            return (
                                (e = e.replace(/{{ terms }}/g, "<strong>" + t + "</strong>")),
                                this.getTemplate()
                                    .replace(/{{class.searchSuggestion}}/g, o.a.searchSuggestion)
                                    .replace(/{{class.searchSuggestionItem}}/g, o.a.searchSuggestionItem)
                                    .replace(/{{searchTerm}}/g, t)
                                    .replace(/{{noResultLabel}}/g, e)
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.hasRedirect ? (this.$element = null) : (this.$element = i()(this.compileTemplate()));
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            var e = u.a.getNoResultData();
                            (this.isEmptyWithSuggestion = e && !e.isAllEmpty), t ? ((this.data = t), (this.hasRedirect = l.a.getValueInObjectArray(c.a.ResultType.REDIRECT, this.data))) : ((this.data = null), (this.hasRedirect = !1));
                        },
                    },
                ]) && f(e.prototype, r),
                n && f(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                d
            );
        })(r(10).a);
        e.a = g;
    },
    131: function (t, e, r) {
        "use strict";
        r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(0),
            a = r(2),
            l = r(4);
        r(23);
        function s(t) {
            return (s =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function c(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== s(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== s(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === s(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function u(t, e) {
            return (u = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function p(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = h(t);
                if (e) {
                    var i = h(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return f(this, r);
            };
        }
        function f(t, e) {
            if (e && ("object" === s(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function h(t) {
            return (h = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var y = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && u(t, e);
            })(f, t);
            var e,
                r,
                n,
                s = p(f);
            function f(t, e) {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, f),
                    s.call(this, t, e)
                );
            }
            return (
                (e = f),
                (n = [
                    {
                        key: "isActive",
                        value: function () {
                            return !o.a.isMobile() && "style2" === a.a.getSettingValue("search.suggestionStyle");
                        },
                    },
                ]),
                (r = [
                    {
                        key: "_applyFilterAutocompleteAppendElement",
                        value: function (t) {
                            this.appendToSelector = a.a.getSettingValue("search.suggestionStyle2MainContainerSelector");
                        },
                    },
                    {
                        key: "_renderWrapper",
                        value: function () {
                            var t = o.a.InstantSearch.isFullWidthMobile() ? l.a.searchSuggestionMobile : "";
                            "" !== t && this.$wrapper.addClass(t);
                            var e = this._setSuggestionPosition();
                            e.setSuggetionPosition(),
                                e.setSuggetionPopoverPosition(),
                                i()(window).resize(function () {
                                    e.setSuggetionPopoverPosition();
                                });
                        },
                    },
                ]) && c(e.prototype, r),
                n && c(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                f
            );
        })(r(90).a);
        e.a = y;
    },
    132: function (t, e, r) {
        "use strict";
        r(24), r(30), r(9), r(37), r(44), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(10),
            a = r(4),
            l = r(0),
            s = r(3),
            c = r(23),
            u = r(46);
        function p(t) {
            return (p =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function f(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== p(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== p(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === p(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function h(t, e) {
            return (h = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function y(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = m(t);
                if (e) {
                    var i = m(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return d(this, r);
            };
        }
        function d(t, e) {
            if (e && ("object" === p(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function m(t) {
            return (m = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var g = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && h(t, e);
            })(p, t);
            var e,
                r,
                n,
                o = y(p);
            function p(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((r = o.call(this)).id = t),
                    (r.$inputElement = e),
                    (r.$element = null),
                    (r.isOpen = !1),
                    (r.keyboardNavIndex = -1),
                    r
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            (this.searchInput = this.parent),
                                (this.searchResult = this.parent.instantSearchResult),
                                (this.appendTo = this.searchResult.selector.wrapper),
                                (this.minLength = Settings.getSettingValue("search.suggestionMinLength")),
                                (this.delay = Settings.getSettingValue("search.suggestionDelay"));
                            var t = Settings.getSettingValue("search.searchBoxOnclick"),
                                e = u.a.getOnClickRecentSearches();
                            this.enableOnClickSearchBox = !!(
                                (t && t.recentSearch && t.recentSearch.status && e.length > 0) ||
                                (t.searchTermSuggestion && t.searchTermSuggestion.status && t.searchTermSuggestion.data.length > 0) ||
                                (t.productSuggestion && t.productSuggestion.status && t.productSuggestion.data.length > 0)
                            );
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div tabindex="0" class="boost-pfs-search-suggestion" style="display: none;"></div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || ((this.$element = i()(this.getTemplate())), (this.searchResult.$instantSearchResult = this.$element));
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element &&
                                this.parent.instantSearchResult.$wrapper &&
                                this.$inputElement &&
                                ((this.currentTerm = l.a.stripHtml(this.$inputElement.val())),
                                this.searchResult.$wrapper.append(this.$element),
                                this.$inputElement.on("keydown", this._onKeyboardEnter.bind(this)),
                                this.$inputElement.on("keyup", this._onKeyboardNavigation.bind(this)),
                                this.$element.on("focus", this.searchInput.onFocusAutocomplete.bind(this.searchInput)),
                                this.$element.on("click", this.searchInput.onSelectAutocomplete.bind(this.searchInput)),
                                document.addEventListener("click", this._onClose.bind(this), !0),
                                this.$inputElement.on("click", this._onOpen.bind(this)),
                                this.$inputElement.on("keyup", l.a.debounce(this._onKeyUp.bind(this), this.delay)));
                        },
                    },
                    {
                        key: "_onOpen",
                        value: function (t) {
                            this._isXSSSearchTerm(t) ||
                                ((this.isOpen = !0),
                                (this.keyboardNavIndex = -1),
                                (this.$keyboardSelectedItem = null),
                                (this.currentTerm = l.a.stripHtml(this.$inputElement.val())),
                                this.$element.show(),
                                this.searchResult.$wrapper.addClass(a.a.searchSuggestionOpen),
                                this.searchInput.onOpenAutocomplete(),
                                this._source());
                        },
                    },
                    {
                        key: "_onClose",
                        value: function (t) {
                            if (!this._isXSSSearchTerm(t)) {
                                var e = !1;
                                if (this.isOpen && t && t.target) {
                                    var r = i()(t.target),
                                        n = r.closest("." + a.a.searchSuggestionWrapper).length > 0,
                                        o = r.closest("#" + this.$inputElement.id).length > 0,
                                        l = r.closest(".boost-pfs-search-btn").length > 0;
                                    n || o || l || (e = !0);
                                } else t || (e = !0);
                                e &&
                                    (this.$element.hide(),
                                    this.searchResult.$wrapper.removeClass(a.a.searchSuggestionOpen),
                                    this.searchInput.onCloseAutocomplete(),
                                    (this.isOpen = !1),
                                    (this.keyboardNavIndex = -1),
                                    (this.$keyboardSelectedItem = null));
                            }
                        },
                    },
                    {
                        key: "_onKeyUp",
                        value: function (t) {
                            if (!this._isXSSSearchTerm(t)) {
                                this.isOpen = !0;
                                var e = l.a.stripHtml(this.$inputElement.val().trim());
                                this.currentTerm != e && ((this.currentTerm = e), (this.currentEvent = t), this._source());
                            }
                        },
                    },
                    {
                        key: "_onKeyboardNavigation",
                        value: function (t) {
                            var e = this;
                            if (!this._isXSSSearchTerm(t) && this.isOpen && this.$element && t && t.key) {
                                var r = this.$element.find("." + a.a.searchSuggestionItem);
                                if (!(r.length <= 0)) {
                                    var n = this.$element.find("[data-group=view-all]"),
                                        o = r.length + n.length,
                                        c = !1;
                                    if (t.key.includes("Down") || t.key.includes("Up"))
                                        if (
                                            ((c = !0),
                                            t.key.includes("Up")
                                                ? (this.keyboardNavIndex--, this.keyboardNavIndex < -1 && (this.keyboardNavIndex = o - 1))
                                                : t.key.includes("Down") && (this.keyboardNavIndex++, this.keyboardNavIndex > o - 1 && (this.keyboardNavIndex = -1)),
                                            this.$inputElement.focus(),
                                            -1 == this.keyboardNavIndex)
                                        ) {
                                            this.$keyboardSelectedItem = null;
                                            var u = l.a.unescape(l.a.stripHtml(s.a.currentTerm));
                                            this.$inputElement.val(u), r.removeClass("selected");
                                        } else
                                            this.keyboardNavIndex > r.length - 1
                                                ? ((this.$keyboardSelectedItem = null), (u = l.a.unescape(l.a.stripHtml(s.a.currentTerm))), this.$inputElement.val(u), r.removeClass("selected"), n.addClass("selected"))
                                                : r.each(function (t, r) {
                                                      var o = i()(r);
                                                      if ((console.log(r), t == e.keyboardNavIndex)) {
                                                          var a = l.a.unescape(l.a.stripHtml(o.attr("data-title")));
                                                          e.$inputElement.val(a), o.addClass("selected"), n.removeClass("selected"), (e.$keyboardSelectedItem = o);
                                                      } else o.removeClass("selected");
                                                  });
                                    else (t.key.includes("Left") || t.key.includes("Right")) && -1 != this.keyboardNavIndex && (c = !0);
                                    c && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault());
                                }
                            }
                        },
                    },
                    {
                        key: "_onKeyboardEnter",
                        value: function (t) {
                            if (!this._isXSSSearchTerm() && this.isOpen && this.$element && t && t.key) {
                                var e = !1;
                                if ("Enter" == t.key || "Space" == t.key) {
                                    if (-1 != this.keyboardNavIndex && this.$keyboardSelectedItem) {
                                        var r = this.$keyboardSelectedItem.find("a").attr("href");
                                        r && !l.a.isBadUrl(r) && ((e = !0), (window.location.href = r));
                                    }
                                } else "Tab" == t.key ? document.activeElement && (document.activeElement.id != this.searchInput.id ? this._onClose() : this._onOpen()) : "Escape" == t.key && this._onClose();
                                e && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault());
                            }
                        },
                    },
                    {
                        key: "_source",
                        value: function () {
                            if (!this._isXSSSearchTerm())
                                if ((this.$element.html(""), (this.keyboardNavIndex = -1), (this.$keyboardSelectedItem = null), this.currentTerm.length > 0)) {
                                    var t = { term: this.currentTerm },
                                        e = this._response.bind(this);
                                    this.searchInput._bindAutoCompleteSource(t, e);
                                } else
                                    this.enableOnClickSearchBox
                                        ? this.showOnClickSuggestion()
                                        : (this.searchResult.$wrapper.hide(), this.searchResult.$wrapper.removeClass(a.a.searchSuggestionOpen), this.searchInput.$element.attr("aria-expanded", !1));
                        },
                    },
                    {
                        key: "_response",
                        value: function (t) {
                            if (!this._isXSSSearchTerm()) {
                                var e = l.a.stripHtml(this.$inputElement.val()),
                                    r = l.a.getValueInObjectArray(c.a.ResultType.EVENT_TYPE, t),
                                    n = l.a.getValueInObjectArray(c.a.ResultType.QUERY, t);
                                if ("suggest_dym" == r || ("" != e && "" != n)) {
                                    this.$element.html(""), (this.keyboardNavIndex = -1), (this.$keyboardSelectedItem = null);
                                    var i = t;
                                    s.a.suggestionCache.hasOwnProperty(s.a.currentTerm) && (i = s.a.suggestionCache[s.a.currentTerm]), this.searchInput._bindAutoCompleteRenderMenu(this.$element[0], i);
                                    var o = { content: t };
                                    this.searchInput._bindAutoCompleteResponse(this.currentEvent, o),
                                        0 == this.searchResult.$wrapper.find('[data-group]:not([data-group="view-all"]').length
                                            ? (this.searchResult.$wrapper.hide(), this.searchResult.$wrapper.removeClass(a.a.searchSuggestionOpen), this.searchInput.$element.attr("aria-expanded", !1))
                                            : (this.searchResult.$wrapper.show(), this.searchResult.$wrapper.addClass(a.a.searchSuggestionOpen), this.searchInput.$element.attr("aria-expanded", !0));
                                }
                            }
                        },
                    },
                    {
                        key: "showOnClickSuggestion",
                        value: function () {
                            if (!this._isXSSSearchTerm()) {
                                this.$element.html(""), (this.keyboardNavIndex = -1), (this.$keyboardSelectedItem = null);
                                var t = u.a.getOnClickData();
                                this.searchResult.setData(this.$element, t, !1),
                                    this.searchResult.refresh(),
                                    this.searchResult.$wrapper.show(),
                                    this.searchResult.$wrapper.addClass(a.a.searchSuggestionOpen),
                                    this.searchInput.$element.attr("aria-expanded", !0),
                                    0 == this.$element.find("." + a.a.searchSuggestionItem).length &&
                                        (this.searchResult.$wrapper.hide(), this.searchResult.$wrapper.removeClass(a.a.searchSuggestionOpen), this.searchInput.$element.attr("aria-expanded", !1));
                            }
                        },
                    },
                    {
                        key: "_isXSSSearchTerm",
                        value: function (t) {
                            var e = l.a.stripHtml(this.$inputElement.val());
                            return (
                                !!l.a.isBadSearchTerm(e) &&
                                ((this.isOpen = !1),
                                this.$element.html(""),
                                this.$element.hide(),
                                this.searchResult.$wrapper.removeClass(a.a.searchSuggestionOpen),
                                this.searchResult.$wrapper.hide(),
                                this.searchResult.$wrapper.removeClass(a.a.searchSuggestionOpen),
                                t && "function" == typeof t.stopPropagation && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault()),
                                !0)
                            );
                        },
                    },
                ]) && f(e.prototype, r),
                n && f(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(o.a);
        e.a = g;
    },
    191: function (t, e, r) {
        var n = r(65).default;
        (window.BoostPFSFilterCallback = r(8).default.BoostPFSFilterCallback), (window.BoostPFSInstantSearchCallback = r(89).default.BoostPFSInstantSearchCallback), (t.exports = n);
    },
    2: function (t, e, r) {
        "use strict";
        r(51), r(33), r(25), r(41);
        var n = r(0),
            i = {
                general: {
                    enableFilter: !0,
                    filterTreeEnableRenderPartially: !0,
                    filterTreeNumberResultEnable: !0,
                    filterTreeIcon:
                        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.49468 16.5416C5.70499 15.7268 6.44558 15.1238 7.3256 15.1238C8.20561 15.1238 8.9462 15.7268 9.15652 16.5416H19.3774C19.4435 16.5416 19.5088 16.5553 19.5692 16.5823C19.6255 16.6073 19.677 16.6437 19.7195 16.6881C19.7602 16.7307 19.7928 16.7813 19.815 16.8356C19.8353 16.8857 19.8471 16.9391 19.8495 16.993C19.8519 17.0445 19.8457 17.0965 19.8311 17.1466C19.8183 17.1905 19.7989 17.2326 19.7739 17.2714C19.7191 17.356 19.6368 17.4217 19.5423 17.4571C19.4908 17.4765 19.4355 17.4864 19.3802 17.4869H19.3774H9.15652C8.9462 18.3017 8.20561 18.9047 7.3256 18.9047C6.44558 18.9047 5.70499 18.3017 5.49468 17.4869H0.472634C0.417338 17.4869 0.362045 17.4774 0.310057 17.458C0.214588 17.4231 0.131409 17.3569 0.0761129 17.2714C0.0510641 17.2326 0.0316858 17.1905 0.0189251 17.1466C0.00427391 17.0965 -0.00187082 17.0445 0.000492274 16.993C0.00285536 16.9391 0.0146699 16.8857 0.0349925 16.8356C0.0572055 16.7813 0.0898142 16.7307 0.130459 16.6881C0.172995 16.6437 0.224507 16.6073 0.280749 16.5823C0.341244 16.5553 0.406468 16.5416 0.472634 16.5416H5.49468ZM7.3256 16.069C7.84737 16.069 8.27083 16.4925 8.27083 17.0143C8.27083 17.536 7.84737 17.9595 7.3256 17.9595C6.80383 17.9595 6.38036 17.536 6.38036 17.0143C6.38036 16.4925 6.80383 16.069 7.3256 16.069ZM13.0566 8.97974C13.2669 8.16495 14.0075 7.56189 14.8875 7.56189C15.7675 7.56189 16.5081 8.16495 16.7184 8.97974H19.3774C19.4435 8.97974 19.5088 8.99345 19.5692 9.02039C19.6255 9.04544 19.677 9.08183 19.7195 9.12626C19.7602 9.16879 19.7928 9.21937 19.815 9.27372C19.8353 9.32382 19.8471 9.37721 19.8495 9.43109C19.8519 9.4826 19.8457 9.5346 19.8311 9.5847C19.8183 9.62865 19.7989 9.67072 19.7739 9.70947C19.7191 9.79407 19.6368 9.85977 19.5423 9.89521C19.4908 9.91459 19.4355 9.92451 19.3802 9.92498H19.3774H16.7184C16.5081 10.7398 15.7675 11.3428 14.8875 11.3428C14.0075 11.3428 13.2669 10.7398 13.0566 9.92498H0.472634C0.406468 9.92498 0.341244 9.91128 0.280749 9.88434C0.224507 9.85929 0.172995 9.8229 0.130459 9.77847C0.0898142 9.73594 0.0572055 9.68536 0.0349925 9.63101C0.0146699 9.58091 0.00285536 9.52752 0.000492274 9.47364C-0.00187082 9.42212 0.00427391 9.37013 0.0189251 9.32003C0.0316858 9.27608 0.0510641 9.23401 0.0761129 9.19526C0.131409 9.10971 0.214588 9.04355 0.310057 9.00858C0.362045 8.9892 0.417338 8.97974 0.472634 8.97974H13.0566ZM14.8875 8.50713C15.4093 8.50713 15.8327 8.93059 15.8327 9.45236C15.8327 9.97413 15.4093 10.3976 14.8875 10.3976C14.3657 10.3976 13.9423 9.97413 13.9423 9.45236C13.9423 8.93059 14.3657 8.50713 14.8875 8.50713ZM2.42266 1.41785C2.63298 0.603061 3.37356 0 4.25358 0C5.13359 0 5.87418 0.603061 6.0845 1.41785H19.3774C19.4435 1.41785 19.5088 1.43156 19.5692 1.4585C19.6255 1.48355 19.677 1.51994 19.7195 1.56436C19.7602 1.6069 19.7928 1.65747 19.815 1.71182C19.8353 1.76192 19.8471 1.81533 19.8495 1.86921C19.8519 1.92072 19.8457 1.97271 19.8311 2.02281C19.8183 2.06676 19.7989 2.10883 19.7739 2.14758C19.7191 2.23218 19.6368 2.29787 19.5423 2.33331C19.4908 2.35269 19.4355 2.36262 19.3802 2.36309H19.3774H6.0845C5.87418 3.17788 5.13359 3.78095 4.25358 3.78095C3.37356 3.78095 2.63298 3.17788 2.42266 2.36309H0.472634C0.417338 2.36309 0.362045 2.35364 0.310057 2.33426C0.214588 2.29929 0.131409 2.23312 0.0761129 2.14758C0.0510641 2.10883 0.0316858 2.06676 0.0189251 2.02281C0.00427391 1.97271 -0.00187082 1.92072 0.000492274 1.86921C0.00285536 1.81533 0.0146699 1.76192 0.0349925 1.71182C0.0572055 1.65747 0.0898142 1.6069 0.130459 1.56436C0.172995 1.51994 0.224507 1.48355 0.280749 1.4585C0.341244 1.43156 0.406468 1.41785 0.472634 1.41785H2.42266ZM4.25358 0.945236C4.77535 0.945236 5.19882 1.3687 5.19882 1.89047C5.19882 2.41224 4.77535 2.83571 4.25358 2.83571C3.73181 2.83571 3.30834 2.41224 3.30834 1.89047C3.30834 1.3687 3.73181 0.945236 4.25358 0.945236Z" fill="#4A4B52"/></svg>',
                    filterTreeIconClose:
                        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.13062 8.00003L12.565 4.56563C12.8778 4.25283 12.8778 3.74723 12.565 3.43443C12.2522 3.12163 11.7466 3.12163 11.4338 3.43443L7.99942 6.86883L4.56502 3.43443C4.25222 3.12163 3.74662 3.12163 3.43382 3.43443C3.12102 3.74723 3.12102 4.25283 3.43382 4.56563L6.86822 8.00003L3.43382 11.4344C3.12102 11.7472 3.12102 12.2528 3.43382 12.5656C3.58982 12.7216 3.79462 12.8 3.99942 12.8C4.20422 12.8 4.40902 12.7216 4.56502 12.5656L7.99942 9.13123L11.4338 12.5656C11.5898 12.7216 11.7946 12.8 11.9994 12.8C12.2042 12.8 12.409 12.7216 12.565 12.5656C12.8778 12.2528 12.8778 11.7472 12.565 11.4344L9.13062 8.00003Z" fill="#222222"/><mask id="mask0_33:1711" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="10" height="10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.13062 8.00003L12.565 4.56563C12.8778 4.25283 12.8778 3.74723 12.565 3.43443C12.2522 3.12163 11.7466 3.12163 11.4338 3.43443L7.99942 6.86883L4.56502 3.43443C4.25222 3.12163 3.74662 3.12163 3.43382 3.43443C3.12102 3.74723 3.12102 4.25283 3.43382 4.56563L6.86822 8.00003L3.43382 11.4344C3.12102 11.7472 3.12102 12.2528 3.43382 12.5656C3.58982 12.7216 3.79462 12.8 3.99942 12.8C4.20422 12.8 4.40902 12.7216 4.56502 12.5656L7.99942 9.13123L11.4338 12.5656C11.5898 12.7216 11.7946 12.8 11.9994 12.8C12.2042 12.8 12.409 12.7216 12.565 12.5656C12.8778 12.2528 12.8778 11.7472 12.565 11.4344L9.13062 8.00003Z" fill="white"/></mask><g mask="url(#mask0_33:1711)"></g></svg>',
                    filterTreeMobileStyle: "style2",
                    filterTreeMobileStyleFullWidth: !1,
                    filterTreeMobileIcon: "",
                    filterTreeHorizontalStyle: "style1",
                    filterHorizontalColumn: "1",
                    filterHorizontalOptionsAlign: "left",
                    filterTreeVerticalStyle: "style-default",
                    stickyFilterOnDesktop: !1,
                    stickyFilterOnMobile: !1,
                    stickyProductHeightLimitParam: 300,
                    showRefineBy: !0,
                    separateRefineByFromFilter: !1,
                    refineByHorizontalPosition: "bottom",
                    changeMobileButtonLabel: !1,
                    breakpointMobile: "767",
                    breakpointTablet: "1199",
                    changeDesktopButtonLabel: !1,
                    changeDesktopButtonIcon: !0,
                    showLoading: !1,
                    showMobileLoading: !1,
                    showLoadMoreLoading: !0,
                    positionShowInfiniteLoading: 700,
                    activeScrollToTop: !1,
                    styleScrollToTop: "style1",
                    showSingleOption: !0,
                    showOutOfStockOption: !1,
                    showFilterOptionCount: !0,
                    requestInstantly: !1,
                    capitalizeFilterOptionValues: !0,
                    forceCapitalizeFilterOptionValues: !1,
                    capitalizeFirstLetterFilterOptionValues: !1,
                    collapseOnPCByDefault: !1,
                    collapseOnMobileByDefault: !1,
                    keepScrollState: !0,
                    keepToggleState: !0,
                    keepTabOpenState: !1,
                    activeFilterScrollbarPC: !0,
                    activeFilterScrollbarMobile: !0,
                    scrollFirstLoadLength: 24,
                    startViewMore: { list: 5, box: 3, swatch: 10 },
                    startViewMoreH: { list: 10, box: 20, swatch: 10 },
                    removePriceDecimal: !0,
                    rangeSliderMoneyFormat: "",
                    oneValueRangeSlider: !1,
                    rangeSlidersStyle3: [],
                    rangeSlidersSingleHandle: [],
                    advancedRangeSliders: [],
                    shortenPipsRange: !1,
                    formatPipsRange: [
                        { node: 1e3, symbol: "K", fix: 0, suffix: !1 },
                        { node: 1e6, symbol: "M", fix: 2, suffix: !1 },
                    ],
                    enable3rdCurrencySupport: !1,
                    imageExtension: ["jpg", "JPG", "png", "PNG", "jpeg", "JPEG", "gif", "GIF", "webp", "WEBP"],
                    swatchStyle: "",
                    swatchImageVersion: "1111111",
                    removePrefixFromSwatchFile: !0,
                    enableFilterOptionBoxStyle: !0,
                    filterOptionBoxCharWidth: 14,
                    openMultiLevelByDefault: [],
                    multiLevelCollectionSelectType: "single",
                    filterPrefixParam: "pf_",
                    limit: 16,
                    vendorParam: "pf_v_vendor",
                    typeParam: "pf_pt_product_type",
                    priceMode: "",
                    tagMode: "",
                    location: "",
                    urlScheme: 1,
                    isShortenUrlParam: !1,
                    shortenUrlParamList: [],
                    productAvailable: !1,
                    variantAvailable: !1,
                    availableAfterFiltering: !1,
                    loadProductFirst: !0,
                    loadProductFirstBestSelling: !1,
                    addCollectionToProductUrl: !0,
                    showVariantImageBasedOnSelectedFilter: "",
                    paginationType: "default",
                    paginationTypeAdvanced: !0,
                    activeLoadPreviousPage: !0,
                    loadPreviousType: "load_more",
                    sessionStorageCurrentPreviousPage: "boostPFSCurrentPreviousPage",
                    sessionStorageCurrentPage: "boostPFSCurrentPage",
                    sessionStorageCurrentNextPage: "boostPFSCurrentNextPage",
                    sessionStoragePreviousPageEvent: "boostPFSPreviousPageEvent",
                    enableKeepScrollbackPosition: !0,
                    keepScrollbackPositionType: "sessionStorage",
                    sessionStorageScrollbackPosition: "boostPFSScrollbackPostion",
                    sortingList: ["relevance", "best-selling", "manual", "price-ascending", "price-descending", "title-ascending", "title-descending", "created-descending", "created-ascending"],
                    customSortingList: "",
                    extraSortingList: "",
                    sortingAvailableFirst: !1,
                    showLimitList: "4,8,12,16",
                    defaultDisplay: "grid",
                    collageNumber: 3,
                    enableCollectionSearch: !0,
                    showVariantsAsProduct: !1,
                    enableVariantsDisplay: !1,
                    showPlaceholderProductList: !1,
                    placeholderImageRatio: 1.4,
                    placeholderProductGridItemClass: "",
                    placeholderProductPerRow: 3,
                    loadProductFromLiquid: !1,
                    loadProductFromLiquidType: "ajax",
                    otpProductItemClass: "",
                    enableAjaxCart: !0,
                    enableAjaxCartOnProductPage: !1,
                    ajaxCartStyle: "slide",
                    showAjaxCartOnAdd: !0,
                    autoCloseMiniCart: !1,
                    autoCloseMiniCartDuration: 2e3,
                    selectOptionInProductItem: !1,
                    selectOptionContainer: "",
                    icoQuickView:
                        '<svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-quick-view" transform="scale(0.03125 0.03125)"><path d="M1009.004 493.256c-2.256-2.82-56.254-69.828-143.786-137.492-51.696-39.962-104.462-71.87-156.832-94.834-66.48-29.152-132.556-43.932-196.386-43.932-63.832 0-129.904 14.782-196.386 43.932-52.37 22.962-105.136 54.87-156.834 94.834-87.53 67.666-141.528 134.674-143.784 137.494l-14.996 18.742 14.998 18.744c2.256 2.82 56.252 69.828 143.784 137.492 51.696 39.962 104.462 71.87 156.834 94.834 66.48 29.152 132.554 43.932 196.386 43.932 63.83 0 129.904-14.782 196.386-43.932 52.37-22.962 105.136-54.87 156.832-94.834 87.53-67.666 141.53-134.674 143.786-137.492l14.994-18.744-14.996-18.744zM827.402 621.624c-74.24 57.196-189.226 125.374-315.402 125.374-126.18 0-241.162-68.178-315.402-125.374-55.36-42.65-97.042-85.794-118.512-109.612 52.994-58.698 229.246-235.006 433.916-235.006 126.178 0 241.162 68.178 315.402 125.374 55.366 42.654 97.050 85.8 118.522 109.622-21.474 23.82-63.158 66.968-118.524 109.622z"></path><path d="M512 309.976c-111.396 0-202.024 90.63-202.024 202.024s90.63 202.024 202.024 202.024 202.026-90.628 202.026-202.024-90.63-202.024-202.026-202.024zM512 654.018c-78.308 0-142.018-63.71-142.018-142.018s63.71-142.018 142.018-142.018 142.018 63.71 142.018 142.018c0 78.308-63.71 142.018-142.018 142.018z"></path><path d="M512 419.322c-51.102 0-92.678 41.576-92.678 92.678s41.576 92.68 92.678 92.68 92.678-41.576 92.678-92.68c0-51.104-41.574-92.678-92.678-92.678zM512 544.672c-18.014 0-32.67-14.656-32.67-32.672s14.656-32.67 32.67-32.67 32.67 14.656 32.67 32.67c0.002 18.014-14.654 32.672-32.67 32.672z"></path></g></svg>',
                    icoQuickViewLink: '<svg width="40" height="40" viewBox="0 0 40 40"><use xlink:href="#boost-pfs-icon-quick-view"></use></svg>',
                    icoCart:
                        '<svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-cart" transform="scale(0.03125 0.03125)"><path d="M448.217 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256s102.256-45.879 102.256-102.256c0-56.379-45.857-102.256-102.256-102.256zM448.217 977.908c-31.312 0-56.807-25.472-56.807-56.807 0-31.312 25.495-56.807 56.807-56.807s56.807 25.495 56.807 56.807c0.003 31.335-25.472 56.807-56.807 56.807z"></path><path d="M768.66 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256 56.354 0 102.256-45.879 102.256-102.256 0-56.379-45.902-102.256-102.256-102.256zM768.66 977.908c-31.335 0-56.807-25.472-56.807-56.807 0-31.312 25.472-56.807 56.807-56.807 31.29 0 56.807 25.495 56.807 56.807 0.003 31.335-25.517 56.807-56.807 56.807z"></path><path d="M1019.164 259.373c-4.294-5.499-10.886-8.702-17.883-8.702h-768.3l-63.329-233.255c-0.137-0.5-0.5-0.886-0.682-1.364-0.5-1.476-1.25-2.773-2.046-4.090-0.749-1.25-1.431-2.477-2.385-3.545-0.931-1.068-2.021-1.865-3.159-2.726-1.182-0.909-2.317-1.795-3.659-2.454-1.25-0.637-2.591-0.953-3.975-1.364-1.476-0.431-2.907-0.794-4.476-0.909-0.545-0.022-1.001-0.319-1.568-0.319h-124.978c-12.543 0-22.724 10.181-22.724 22.724s10.181 22.724 22.724 22.724h107.595l63.239 232.959 113.572 460.078c2.499 10.156 11.612 17.293 22.065 17.293h558.448c10.452 0 19.543-7.112 22.065-17.293l113.617-460.282c1.7-6.796 0.154-13.955-4.162-19.476zM869.871 710.976h-522.865l-102.39-414.858h727.667l-102.413 414.858z"></path></g></svg>',
                    icoCartLink: '<svg width="40" height="40" viewBox="0 0 40 40"><use xlink:href="#boost-pfs-icon-cart"></use></svg>',
                    enableTrackingOrderRevenue: !0,
                    filterEverywhereCollectionId: 0,
                    filterEverywhereDefaultSorting: "best-selling",
                    filterEverywhereUrlScheme: 0,
                    enableSeo: !0,
                    boostCollection: "boost-all",
                    moneyFormatWithCurrency: !1,
                    useShopifyRouteForMultiLanguageURL: !0,
                    enableBackToOriginal: !0,
                },
                search: {
                    enableSearch: !0,
                    enableSuggestion: !0,
                    suggestionBlocks: [
                        { type: "suggestions", label: "Suggestions", status: "active", number: 3 },
                        { type: "collections", label: "Collections", status: "active", number: 2 },
                        { type: "pages", label: "Pages", status: "active", number: 2 },
                        { type: "products", label: "Products", status: "active", number: 6 },
                    ],
                    suggesionMaxItems: 10,
                    suggestionDymLimit: 2,
                    suggestionMinLength: 1,
                    suggestionPosition: "",
                    suggestionDelay: 50,
                    suggestionWidth: "auto",
                    suggestionTypes: [],
                    suggestionStyle: "style2",
                    suggestionColumn: "1",
                    suggestionProductPosition: "none",
                    suggestionProductItemPerRow: "1",
                    suggestionProductItemType: "list",
                    suggestionMaxHeight: "",
                    suggestionMaxWidth: "",
                    suggestionStyle2MainContainerSelector: "body",
                    suggestionStyle1ProductItemType: "list",
                    suggestionStyle1ProductPosition: "none",
                    suggestionStyle1ProductPerRow: "1",
                    suggestionStyle2ProductItemType: "list",
                    suggestionStyle2ProductPosition: "right",
                    suggestionStyle2ProductPerRow: 2,
                    suggestionStyle3ProductItemType: "list",
                    suggestionStyle3ProductPosition: "right",
                    suggestionStyle3ProductPerRow: 3,
                    suggestionMobileStyle: "style1",
                    showSuggestionLoading: !0,
                    showSuggestionProductVendor: !0,
                    showSuggestionProductPrice: !0,
                    showSuggestionProductSalePrice: !0,
                    showSuggestionProductImage: !0,
                    showSuggestionProductSku: !1,
                    showSearchBtnMobile: !1,
                    showSearchBtnStyle3: !0,
                    enableDefaultResult: !0,
                    enableFuzzy: !0,
                    productAvailable: !1,
                    removePriceDecimal: !1,
                    highlightSuggestionResult: !0,
                    openProductNewTab: !1,
                    suggestionMode: "prod",
                    termKey: "q",
                    skipFields: [],
                    reduceMinMatch: !1,
                    fullMinMatch: !1,
                    enablePlusCharacterSearch: !1,
                    collectionDescLimitCharacter: 264,
                    pageExcerptLimitCharacter: 264,
                    fontSizeSuggestionHeader: "",
                    bgSuggestionHeader: "",
                    colorSuggestionHeader: "",
                    enableFixHeadTitle: !0,
                    searchPanelList: ["products", "collections", "pages"],
                    searchPanelDefault: "products",
                    searchPanelBlocks: { products: { label: "Products", pageSize: 25, active: !0 }, collections: { label: "Collections", pageSize: 25, active: !1 }, pages: { label: "Pages", pageSize: 25, active: !1 } },
                    suggestionNoResult: { search_terms: { label: '"Popular suggestions', status: !0, data: [] }, products: { label: "Products", status: !0, data: [] } },
                    searchBoxOnclick: {
                        recentSearch: { label: "Recent searches", status: !1, number: 3 },
                        searchTermSuggestion: { label: "Popular searches", status: !1, data: [] },
                        productSuggestion: { label: "Trending products", status: !1, data: [] },
                    },
                    iconViewAll:
                        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.1657 7.43443L10.1657 3.43443C9.8529 3.12163 9.3473 3.12163 9.0345 3.43443C8.7217 3.74723 8.7217 4.25283 9.0345 4.56563L11.6689 7.20003H2.4001C1.9577 7.20003 1.6001 7.55843 1.6001 8.00003C1.6001 8.44163 1.9577 8.80003 2.4001 8.80003H11.6689L9.0345 11.4344C8.7217 11.7472 8.7217 12.2528 9.0345 12.5656C9.1905 12.7216 9.3953 12.8 9.6001 12.8C9.8049 12.8 10.0097 12.7216 10.1657 12.5656L14.1657 8.56563C14.4785 8.25283 14.4785 7.74723 14.1657 7.43443" fill="#5C5F62"/></svg>',
                },
                init: function () {
                    var t = i;
                    if (
                        ("undefined" != typeof boostPFSConfig && boostPFSConfig.hasOwnProperty("settings") && null !== boostPFSConfig.settings && (t = n.a.mergeObject(t, boostPFSConfig.settings)),
                        "undefined" != typeof boostPFSAppConfig && Object.keys(boostPFSAppConfig).length > 0 && (t = n.a.mergeObject(t, boostPFSAppConfig)),
                        "undefined" != typeof boostPFSThemeConfig && Object.keys(boostPFSThemeConfig).length > 0 && (t = n.a.mergeObject(t, boostPFSThemeConfig)),
                        "undefined" != typeof boostPFSFilterConfig && Object.keys(boostPFSFilterConfig).length > 0 && (t = n.a.mergeObject(t, boostPFSFilterConfig)),
                        "undefined" != typeof boostPFSInstantSearchConfig && Object.keys(boostPFSInstantSearchConfig).length > 0 && (t = n.a.mergeObject(t, boostPFSInstantSearchConfig)),
                        "undefined" != typeof Shopify &&
                            Shopify.hasOwnProperty("locale") &&
                            t.hasOwnProperty("label") &&
                            t.hasOwnProperty("labelTranslations") &&
                            void 0 !== t.labelTranslations &&
                            t.labelTranslations.hasOwnProperty(Shopify.locale))
                    ) {
                        var e = t.labelTranslations[Shopify.locale];
                        t.label = n.a.mergeObject(t.label || {}, e);
                    }
                    i = t;
                },
                getSettingValue: function (t) {
                    var e = "";
                    if (i.hasOwnProperty(t)) return i[t];
                    if (t.indexOf(".") > -1)
                        for (var r = t.split("."), n = 0; n < r.length; n++)
                            if ("" == e) {
                                if (!i.hasOwnProperty(r[n])) return "";
                                e = i[r[n]];
                            } else {
                                if (!e.hasOwnProperty(r[n])) return "";
                                e = e[r[n]];
                            }
                    return e;
                },
            };
        e.a = i;
    },
    23: function (t, e, r) {
        "use strict";
        e.a = {
            ResultType: {
                ALL_EMPTY: "all_empty",
                TOTAL_PRODUCT: "total_product",
                SUGGESTIONS: "suggestions",
                COLLECTIONS: "collections",
                PRODUCTS: "products",
                PAGES: "pages",
                DID_YOU_MEAN: "did_you_mean",
                REDIRECT: "redirect",
                SUGGESTIONS_REDIRECT: "suggestions_redirect",
                QUERY: "query",
                PREV_QUERY: "prev_query",
                SUGGEST_QUERY: "suggest_query",
                EVENT_TYPE: "event_type",
                PREV_TOTAL_PRODUCT: "prev_total_product",
                SUGGEST_TOTAL_PRODUCT: "suggest_total_product",
                LOCAL_CACHE: "local_cache",
                RECENT_SEARCHES: "recent_searches",
                DEFAULT_SUGGESTIONS: "default_suggestions",
                DEFAULT_PRODUCTS: "default_products",
                NO_RESULT_PRODUCTS: "no_result_products",
                NO_RESULT_SUGGESTIONS: "no_result_suggestions",
            },
            Mobile: { SuggestionType: { FULL_SCREEN: "style1", STYLE_2: "style2" } },
        };
    },
    3: function (t, e, r) {
        "use strict";
        r(71), r(24);
        var n = r(2),
            i = r(0),
            o = {
                prefix: "pf",
                queryParams: {},
                instantSearchQueryParams: {},
                internalClick: !1,
                imutableFilterTree: ["page", "sort", "limit", "display", "_", "tab"],
                otherParams: ["page", "sort", "limit", "display", "tab"],
                hasFilterOptionParam: !1,
                hasFilterByLocation: !1,
                scrollData: [],
                shopName: "",
                shopDomain: "",
                fileUrl: "",
                defaultCurrency: "",
                moneyFormat: "",
                moneyFormatWithCurrency: "",
                collectionId: "",
                collectionTags: "",
                currentTags: "",
                defaultSorting: "",
                swatchExtension: "",
                productAvailable: !0,
                variantAvailable: !0,
                loadProductFirst: !1,
                searchTermKey: "q",
                suggestionCache: {},
                currentTerm: "",
                inventoryBaseSelectedLocations: !1,
                hasIntegration: !1,
                init: function () {
                    var t = boostPFSConfig.shop,
                        e = boostPFSConfig.general;
                    (o.shopName = t.name),
                        (o.shopDomain = t.domain),
                        (o.defaultCurrency = t.currency),
                        (o.moneyFormat = t.money_format),
                        (o.moneyFormatWithCurrency = t.money_format_with_currency),
                        (o.fileUrl = e.file_url),
                        (o.collectionId = i.a.isCollectionPage() || i.a.isSearchPage() ? e.collection_id : null),
                        (o.collectionTags = e.collection_tags),
                        (o.collectionCount = e.collection_count),
                        (o.currentTags = e.current_tags),
                        (o.defaultSorting = e.default_sort_by.trim()),
                        (o.swatchExtension = e.swatch_extension),
                        (o.productAvailable = n.a.getSettingValue("general.productAvailable")),
                        (o.variantAvailable = n.a.getSettingValue("general.variantAvailable")),
                        n.a.getSettingValue("general.productAndVariantAvailable") && ((o.productAvailable = !0), (o.variantAvailable = !0)),
                        (o.loadProductFirst = n.a.getSettingValue("general.loadProductFirst")),
                        (o.searchTermKey = n.a.getSettingValue("search.termKey")),
                        (o.mobileStyle = n.a.getSettingValue("general.filterTreeMobileStyle")),
                        (o.suggestionTypes = n.a.getSettingValue("search.suggestionTypes"));
                },
            };
        e.a = o;
    },
    39: function (t, e, r) {
        "use strict";
        r(11), r(61), r(9), r(13), r(12), r(43), r(37), r(44), r(25), r(41), r(27), r(28), r(118), r(69), r(58), r(72), r(51), r(49), r(87), r(48), r(26);
        var n = r(1),
            i = r.n(n),
            o = r(0),
            a = r(3),
            l = r(2),
            s = r(8),
            c = r(65),
            u = {},
            p = {},
            f = window.location.pathname,
            h = document.title,
            y = "",
            d = new Map(),
            m = new Map(),
            g = {
                init: function () {
                    (y = o.a.getWindowLocation().href),
                        (p = {
                            page: 1,
                            limit: l.a.getSettingValue("general.limit"),
                            sort: o.a.isSearchPage() ? "relevance" : a.a.defaultSorting,
                            display: l.a.getSettingValue("general.defaultDisplay"),
                            tab: l.a.getSettingValue("general.searchPanelDefault"),
                        }),
                        window.addEventListener("popstate", g.onPopState),
                        g.initShortenUrl();
                },
                initShortenUrl: function () {
                    var t = l.a.getSettingValue("general.shortenUrlParamList");
                    l.a.getSettingValue("general.isShortenUrlParam") &&
                        Array.isArray(t) &&
                        t.forEach(function (t) {
                            if ("string" == typeof t) {
                                var e = t.match(/[^:]:[^:]/),
                                    r = 0;
                                if ((e && e.hasOwnProperty("index") && (r = e.index), !r)) return;
                                var n = t.slice(0, r + 1),
                                    i = t.slice(r + 2);
                                n && i && (d.set(n, i), m.set(i, n));
                            }
                        });
                },
                updateAddressBar: function () {
                    if (
                        0 != (o.a.isCollectionPage() || o.a.isSearchPage() ? l.a.getSettingValue("general.urlScheme") : l.a.getSettingValue("general.filterEverywhereUrlScheme")) &&
                        window.history &&
                        "function" == typeof window.history.pushState
                    ) {
                        var t = g.buildAddressBarUrl(),
                            e = JSON.parse(JSON.stringify(a.a.queryParams));
                        (a.a.queryParams = e),
                            l.a.getSettingValue("general.paginationType") == ProductPagination.Type.INFINITE && "page" == a.a.queryParams.event_type
                                ? history.replaceState({ param: a.a.queryParams }, h, t)
                                : history.pushState({ param: a.a.queryParams }, h, t),
                            (y = t);
                        var r = new Event("boost-pfs-change-address-bar");
                        window.dispatchEvent(r);
                    }
                },
                buildAddressBarUrl: function (t) {
                    var e = t || a.a.queryParams,
                        r = window.location.protocol + "//" + window.location.hostname + f,
                        n = o.a.getWindowLocation().search,
                        i = new URLSearchParams(n),
                        s = !1,
                        c = o.a.isCollectionPage() || o.a.isSearchPage() ? l.a.getSettingValue("general.urlScheme") : l.a.getSettingValue("general.filterEverywhereUrlScheme");
                    Object.keys(e).forEach(function (t) {
                        var r = e[t];
                        if (t.startsWith(a.a.prefix)) {
                            var n = d.get(t);
                            if ((n || (n = t), i.delete(n), Array.isArray(r))) {
                                switch (c) {
                                    case 0:
                                        break;
                                    case 2:
                                        i.set(n, r);
                                        break;
                                    case 1:
                                    default:
                                        r.forEach(function (t) {
                                            i.append(n, t);
                                        });
                                }
                                s = !0;
                            } else null != r && (i.set(n, r), (s = !0));
                        } else t == a.a.searchTermKey && "string" == typeof r ? (o.a.isCollectionPage() && "" === r ? i.delete(t) : i.set(t, r)) : a.a.otherParams.includes(t) && (r == p[t] || ("sort" == t && r == a.a.defaultSorting) ? i.delete(t) : i.set(t, r));
                    });
                    var u = [];
                    i.forEach(function (t, r) {
                        var n = m.get(r);
                        n || (n = r), (n.startsWith(a.a.prefix) || a.a.imutableFilterTree.includes(n) || n == a.a.searchTermKey) && (e.hasOwnProperty(n) || u.push(r));
                    }),
                        u.forEach(function (t) {
                            i.delete(t);
                        }),
                        (a.a.hasFilterOptionParam = s),
                        i.sort();
                    var h = r,
                        y = i.toString();
                    return y && (2 == c && (y = y.replace(/%2C/g, ",")), (h += "?" + y)), h;
                },
                setAddressBarPathAfterFilter: function (t) {
                    (f = "string" == typeof t && t.startsWith("/") ? t : window.location.pathname), (f = o.a.reBuildUrlBaseOnLocale(f));
                },
                setWindowTitleAfterFilter: function (t) {
                    h = "string" != typeof t || "" == t || t.includes("undefined") || t.includes("null") ? document.title : t;
                },
                getHistoryState: function () {
                    return u;
                },
                onPopState: function (t) {
                    u = t.state;
                    var e = c.default.instance.filter,
                        r = o.a.getWindowLocation().href,
                        n = (r.includes("#") || y.includes("#")) && r.split("#")[0] == y;
                    e &&
                        !n &&
                        (o.a.isSearchPage() &&
                            i()("." + Class.searchResultPanelItem).length > 0 &&
                            i()("." + Class.searchResultPanelItem)
                                .first()
                                .trigger("click"),
                        e.filterLoadingIcon.setShow(!0),
                        s.default.updateParamsFromUrl(),
                        s.default.getFilterData("history", e.setData.bind(e)));
                },
                shortParamsMap: d,
                longParamMap: m,
            };
        e.a = g;
    },
    4: function (t, e, r) {
        "use strict";
        e.a = {
            filterTree: "boost-pfs-filter-tree",
            filterTreeVertical: "boost-pfs-filter-tree-v",
            filterTreeHorizontal: "boost-pfs-filter-tree-h",
            filterTreeOpenBody: "boost-pfs-filter-tree-open-body",
            filterTreeMobileButton: "boost-pfs-filter-tree-mobile-button",
            filterTreeMobileOpen: "boost-pfs-filter-tree-mobile-open",
            filterTreeDesktopButton: "boost-pfs-filter-tree-desktop-button",
            filterTreeDesktopOpen: "boost-pfs-filter-tree-desktop-open",
            filterOptionsWrapper: "boost-pfs-filter-options-wrapper",
            filterOption: "boost-pfs-filter-option",
            filterOptionTitle: "boost-pfs-filter-option-title",
            filterOptionContent: "boost-pfs-filter-option-content",
            filterOptionContentInner: "boost-pfs-filter-option-content-inner",
            filterOptionItem: "boost-pfs-filter-option-item",
            filterOptionLabel: "boost-pfs-filter-option-label",
            filterOptionRange: "boost-pfs-filter-option-range",
            filterRefineByWrapper: "boost-pfs-filter-refine-by-wrapper",
            filterRefineBy: "boost-pfs-filter-refine-by",
            filterSelectedItems: "boost-pfs-filter-refine-by-items",
            filterSelectedItemsMobile: "boost-pfs-filter-refine-by-items-mobile",
            filterOptionHidden: "boost-pfs-filter-option-hidden",
            filterOptionOpenList: "boost-pfs-filter-option-open-list",
            filterOptionCloseList: "boost-pfs-filter-option-close-list",
            filterOptionItemList: "boost-pfs-filter-option-item-list",
            filterOptionItemListSingleList: "boost-pfs-filter-option-item-list-single-list",
            filterOptionItemListMultipleList: "boost-pfs-filter-option-item-list-multiple-list",
            filterOptionItemListBox: "boost-pfs-filter-option-item-list-box",
            filterOptionItemListSwatch: "boost-pfs-filter-option-item-list-swatch",
            filterOptionItemListRating: "boost-pfs-filter-option-item-list-rating",
            filterOptionItemListMultiLevelTag: "boost-pfs-filter-option-item-list-multi-level-tag",
            filterOptiontemListMultiLevelCollections: "boost-pfs-filter-option-item-list-multi-level-collections",
            filterOptionItemStar: "boost-pfs-filter-icon-star",
            filterOptionItemStarActive: "boost-pfs-filter-icon-star-active",
            filterHasViewMore: "boost-pfs-filter-has-view-more",
            filterOptionViewMore: "boost-pfs-filter-option-view-more-action",
            filterOptionViewLess: "boost-pfs-filter-option-view-less-action",
            filterOptionViewMoreList: "boost-pfs-filter-view-more-list-action",
            filterHasSearchBox: "boost-pfs-filter-has-searchbox",
            filterOptionShowSearchBox: "boost-pfs-filter-option-show-search-box",
            filterHasScrollbar: "boost-pfs-filter-has-scrollbar",
            filterNoScrollbar: "boost-pfs-filter-no-scrollbar",
            button: "boost-pfs-filter-button",
            clearButton: "boost-pfs-filter-clear",
            clearAllButton: "boost-pfs-filter-clear-all",
            applyButton: "boost-pfs-filter-apply-button",
            applyAllButton: "boost-pfs-filter-apply-all-button",
            closeFilterButton: "boost-pfs-filter-close",
            showResultFilterButton: "boost-pfs-filter-show-result",
            numberResult: "boost-pfs-filter-number-result",
            collectionHeader: "boost-pfs-filter-collection-header",
            collectionDescription: "boost-pfs-filter-collection-description",
            collectionImage: "boost-pfs-filter-collection-image",
            collectionHasImage: "boost-pfs-filter-collection-has-image",
            collectionNoImage: "boost-pfs-filter-collection-no-image",
            filterOptionTooltip: "boost-pfs-filter-option-tooltip",
            searchBox: "boost-pfs-search-box",
            searchResultHeader: "boost-pfs-search-result-header",
            searchResultNumber: "boost-pfs-search-result-number",
            searchResultPanels: "boost-pfs-search-result-panel-controls",
            searchResultPanelItem: "boost-pfs-search-result-panel-item",
            searchSuggestion: "boost-pfs-search-suggestion",
            searchSuggestionWrapper: "boost-pfs-search-suggestion-wrapper",
            searchSuggestionHeader: "boost-pfs-search-suggestion-header",
            searchSuggestionGroup: "boost-pfs-search-suggestion-group",
            searchSuggestionItem: "boost-pfs-search-suggestion-item",
            searchSuggestionMobile: "boost-pfs-search-suggestion-mobile",
            searchSuggestionLoading: "boost-pfs-search-suggestion-loading",
            searchSuggestionOpen: "boost-pfs-search-suggestion-open",
            searchSuggestionOpenBody: "boost-pfs-search-suggestion-open-body",
            searchSuggestionMobileOpen: "boost-pfs-search-suggestion-mobile-open",
            searchSuggestionStyle3Open: "boost-pfs-search-suggestion-style3-open",
            searchUiAutocompleteItem: "boost-pfs-ui-item",
            searchSuggestionBtnSubmitMobile: "boost-pfs-search-submit-mobile",
            searchSuggestionBtnCloseMobile: "boost-pfs-search-btn-close-suggestion",
            searchSuggestionBtnClearMobile: "boost-pfs-search-btn-clear-suggestion",
            searchSuggestionNoTabIndex: "boost-pfs-search-no-tabindex",
            searchSuggestionBtnSubmitStyle3: "boost-pfs-search-submit-style3",
            searchSuggestionBtnCloseStyle3: "boost-pfs-search-btn-close-suggestion",
            searchSuggestionBtnClearStyle3: "boost-pfs-search-btn-clear-suggestion",
            productLoadMore: "boost-pfs-filter-load-more",
            productWrapLoading: "boost-pfs-filter-product-loading",
            buttonLoadPreviousPageSelector: "boost-pfs-filter-btn-load-previous-page",
            buttonLoadPreviousPageWrapper: "boost-pfs-filter-btn-load-previous-page-wrapper",
            productDisplayType: "boost-pfs-filter-display",
            filterResultItem: "boost-pfs-search-result-list-item",
            filterSkeleton: "boost-pfs-filter-skeleton",
            filterProductSkeleton: "boost-pfs-filter-product-skeleton",
            filterSkeletonText: "boost-pfs-filter-skeleton-text",
            filterSkeletonButton: "boost-pfs-filter-skeleton-button",
            atcForm: "boost-pfs-addtocart-product-form",
            atcAvailable: "boost-pfs-addtocart-available",
            atcSelectOptions: "boost-pfs-addtocart-select-options",
            atcSoldOut: "boost-pfs-addtocart-sold-out",
            variantsDisplay: "boost-pfs-variants-display",
            adaWrapper: "boost-pfs-ada",
            mobileButtonOpen: "boost-pfs-filter-tree-mobile-button-open",
            desktopButtonOpen: "boost-pfs-filter-tree-desktop-button-open",
            mobileDetectiOS: "boost-pfs-filter-mobile-detect-ios",
            hidden: "boost-hidden",
            enableApp: "boost-pfs-enable-app",
            enableFilter: "boost-pfs-enable-filter",
            enableInstantSearch: "boost-pfs-enable-instant-search",
        };
    },
    42: function (t, e, r) {
        "use strict";
        r(51), r(24);
        var n = r(0),
            i = {
                getApiUrl: function (t) {
                    var e = boostPFSConfig.api.filterUrl;
                    switch (t) {
                        case "search":
                            e = boostPFSConfig.api.searchUrl;
                            break;
                        case "suggestion":
                            e = boostPFSConfig.api.suggestionUrl;
                            break;
                        case "analytics":
                            e = boostPFSConfig.api.analyticsUrl;
                            break;
                        case "filter":
                            e = boostPFSConfig.api.filterUrl;
                            break;
                        case "products":
                            e = boostPFSConfig.api.productsUrl;
                    }
                    return e;
                },
                setApiLocaleParams: function (t) {
                    return (
                        Settings.general.hasOwnProperty("published_locales") &&
                            Object.keys(Settings.general.published_locales).length >= 1 &&
                            void 0 !== Settings.general.current_locale &&
                            (t.locale = Settings.getSettingValue("general.current_locale")),
                        t
                    );
                },
                setShopifyMultiCurrencyParams: function (t) {
                    return (
                        n.a.isEnableShopifyMultipleCurrencies() &&
                            (n.a.isConvertCurrenciesOnFrontEnd() ||
                                (boostPFSConfig && boostPFSConfig.general && "string" == typeof boostPFSConfig.general.current_currency && (t.currency = boostPFSConfig.general.current_currency.toLowerCase().trim()),
                                Shopify && Shopify.country && "string" == typeof Shopify.country && (t.country = Shopify.country.toLowerCase().trim()))),
                        t
                    );
                },
            };
        e.a = i;
    },
    45: function (t, e, r) {
        "use strict";
        r(25), r(26), r(24), r(51), r(30), r(9), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(2),
            a = r(0),
            l = r(3),
            s = r(4),
            c = r(7),
            u = r(10),
            p = r(89),
            f = r(80),
            h = r(103),
            y = r(132),
            d = r(46);
        function m(t) {
            return (m =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function g(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== m(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== m(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === m(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function b(t, e) {
            return (b = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function v(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = O(t);
                if (e) {
                    var i = O(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return S(this, r);
            };
        }
        function S(t, e) {
            if (e && ("object" === m(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function O(t) {
            return (O = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var P = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && b(t, e);
                })(m, t);
                var e,
                    r,
                    n,
                    u = v(m);
                function m(t, e) {
                    var r;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, m),
                        ((r = u.call(this)).id = t),
                        (r.autocomplete = null),
                        (r.instantSearchResult = null),
                        (r.isRendered = !1),
                        (r.isBoundEvents = !1),
                        (r.$element = e || i()("#" + r.id)),
                        (r.$searchForm = r.$element.closest("form")),
                        (r.$uiMenuElement = null),
                        r
                    );
                }
                return (
                    (e = m),
                    (n = [
                        {
                            key: "disableInstantSearch",
                            value: function () {
                                (T = !0), i()("." + s.a.searchSuggestionWrapper).css({ visibility: "hidden", opacity: 0, display: "none" });
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                (this.instantSearchResult = f.a.instantSearchResult(this.id, this.$element)),
                                    this.addComponent(this.instantSearchResult),
                                    (this.searchAutoComplete = new y.a(this.id, this.$element)),
                                    this.addComponent(this.searchAutoComplete);
                            },
                        },
                        {
                            key: "isRender",
                            value: function () {
                                return !this.isRendered;
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                var t = a.a.getParam(l.a.searchTermKey);
                                this.$element
                                    .val(t)
                                    .addClass(s.a.searchBox)
                                    .attr("autocomplete", "off")
                                    .attr("id", a.a.stripHtml(this.id))
                                    .attr("data-search-box", a.a.stripHtml(this.id))
                                    .attr("role", "combobox")
                                    .attr("placeholder", c.a.suggestion.searchBoxPlaceholder)
                                    .attr("aria-expanded", !1)
                                    .attr("aria-autocomplete", "list")
                                    .attr("aria-label", c.a.ada.searchAutoComplete)
                                    .attr("aria-owns", a.a.stripHtml(this.id.replace(s.a.searchBox, s.a.searchSuggestion)))
                                    .attr("data-already-init", !0),
                                    (this.isRendered = !0);
                            },
                        },
                        {
                            key: "isBindEvents",
                            value: function () {
                                return !this.isBoundEvents;
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                this.$element.on("click", this._onClickSearchBox.bind(this)).on("focus", this._onFocusSearchBox.bind(this)).on("keyup", this._onTypeSearchBoxEvent.bind(this)),
                                    this.$searchForm.length && this.$searchForm.on("submit", this._onSubmit.bind(this)),
                                    (this.isBoundEvents = !0);
                            },
                        },
                        {
                            key: "_bindAutoCompleteSource",
                            value: function (t, e) {
                                (window.suggestionCallback = e), (l.a.currentTerm = a.a.stripHtml(t.term));
                                var r = t.term.trim().replace(/\s+/g, " ");
                                if ("" != r) {
                                    var n = this.searchAutoComplete.$element;
                                    if ((this.instantSearchResult.setData(n, null, !0), this.instantSearchResult.refresh(), l.a.suggestionCache.hasOwnProperty(r))) return void window.suggestionCallback(l.a.suggestionCache[r]);
                                    (r = encodeURIComponent(r)), p.default.getSuggestionData(r, 0, "suggest");
                                }
                            },
                        },
                        {
                            key: "_bindAutoCompleteResponse",
                            value: function (t, e) {
                                var r = e.content,
                                    n = a.a.getValueInObjectArray("query", r),
                                    i = a.a.getValueInObjectArray("event_type", r),
                                    o = a.a.getValueInObjectArray("suggest_query", r),
                                    s = a.a.getValueInObjectArray("local_cache", r);
                                a.a.getValueInObjectArray("redirect", r),
                                    25 == Object.keys(l.a.suggestionCache).length && (l.a.suggestionCache = {}),
                                    l.a.suggestionCache.hasOwnProperty(n) || "suggest_dym" == i || (l.a.suggestionCache[n] = r),
                                    "" == o || "suggest" != i || s || p.default.getSuggestionData(o, 0, "suggest_dym", n),
                                    h.a.checkForSearchRedirect(this.$element);
                            },
                        },
                        {
                            key: "_bindAutoCompleteRenderMenu",
                            value: function (t, e) {
                                this.instantSearchResult.setData(i()(t), e, !1), this.instantSearchResult.refresh();
                            },
                        },
                        {
                            key: "_bindAutoCompleteResizeMenu",
                            value: function () {
                                this.customizeInstantSearch();
                            },
                        },
                        { key: "customizeInstantSearch", value: function () {} },
                        {
                            key: "onFocusAutocomplete",
                            value: function (t, e) {
                                return !(!e || !e.item || void 0 === e.item.label);
                            },
                        },
                        {
                            key: "onOpenAutocomplete",
                            value: function (t) {
                                var e = this;
                                a.a.isiOS() &&
                                    i()("." + s.a.searchSuggestionItem + " a")
                                        .on("touchstart", function () {
                                            e.isScrolling = !1;
                                        })
                                        .on("touchmove", function () {
                                            e.isScrolling = !0;
                                        })
                                        .on("touchend", function (t) {
                                            if (!e.isScrolling) {
                                                var r = i()(t.currentTarget).attr("href");
                                                a.a.isBadUrl(r) || (window.location.href = r);
                                            }
                                        }),
                                    a.a.InstantSearch.isFullWidthMobile() && !i()("body").hasClass(s.a.searchSuggestionMobileOpen) && i()("body").addClass(s.a.searchSuggestionMobileOpen),
                                    a.a.InstantSearch.isStyle3() && !i()("body").hasClass(s.a.searchSuggestionStyle3Open) && i()("body").addClass(s.a.searchSuggestionStyle3Open),
                                    this.instantSearchResult.$wrapper.hasClass(s.a.searchSuggestionOpen) || this.instantSearchResult.$wrapper.addClass(s.a.searchSuggestionOpen),
                                    i()("body").hasClass(s.a.searchSuggestionOpenBody) || i()("body").addClass(s.a.searchSuggestionOpenBody);
                            },
                        },
                        {
                            key: "onCloseAutocomplete",
                            value: function (t, e) {
                                this.instantSearchResult &&
                                    this.instantSearchResult.$instantSearchResult &&
                                    this.instantSearchResult.$wrapper &&
                                    ("test" == o.a.getSettingValue("search.suggestionMode") || a.a.InstantSearch.isFullWidthMobile()
                                        ? this.instantSearchResult.$instantSearchResult.show()
                                        : this.instantSearchResult.$instantSearchResult.siblings().hide(),
                                    a.a.isiOS() || this.instantSearchResult.$wrapper.removeClass(s.a.searchSuggestionOpen),
                                    i()("body").removeClass(s.a.searchSuggestionOpenBody));
                            },
                        },
                        {
                            key: "onSelectAutocomplete",
                            value: function (t) {
                                if (this.autocomplete) {
                                    var e = this.autocomplete.$element.find("." + s.a.searchSuggestionItem + ".selected");
                                    if (e.length) {
                                        var r = e.find("> a");
                                        if (r.length) {
                                            var n = r[0].attr("href");
                                            a.a.isBadUrl(n) || a.a.setWindowLocation(n);
                                        }
                                    }
                                    return !1;
                                }
                            },
                        },
                        { key: "_onClickSearchBox", value: function (t) {} },
                        { key: "_onFocusSearchBox", value: function (t) {} },
                        {
                            key: "_onTypeSearchBoxEvent",
                            value: function (t) {
                                l.a.currentTerm = a.a.stripHtml(t.target.value);
                            },
                        },
                        {
                            key: "_onSubmit",
                            value: function (t, e) {
                                if (!T && (void 0 === e && (e = this.isChangePage), (this.isChangePage = !1), !e)) {
                                    t.stopImmediatePropagation(),
                                        t.stopPropagation(),
                                        t.preventDefault(),
                                        (l.a.currentTerm = a.a.stripHtml(this.$element.val())),
                                        !l.a.currentTerm && t && t.target && (l.a.searchTerm = a.a.stripHtml(t.target.value));
                                    var r = h.a.getSearchRedirectUrl(),
                                        n = a.a.unescape(l.a.currentTerm);
                                    n = n.trim().replace(/\s+/g, " ");
                                    var i = l.a.suggestionCache.hasOwnProperty(n);
                                    d.a.setOnClickRecentSearches(n),
                                        i
                                            ? r && !a.a.isBadUrl(r)
                                                ? a.a.setWindowLocation(r)
                                                : ((this.isChangePage = !0), this.$searchForm[0].submit())
                                            : l.a.currentTerm
                                            ? this.$element.data("search-submit", !0)
                                            : ((this.isChangePage = !0), this.$searchForm[0].submit());
                                }
                            },
                        },
                    ]) && g(e.prototype, r),
                    n && g(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    m
                );
            })(u.a),
            T = !1;
        e.a = P;
    },
    46: function (t, e, r) {
        "use strict";
        r(24), r(33), r(88), r(69), r(27), r(9), r(28), r(11), r(13), r(12), r(72), r(48);
        var n = r(1),
            i = r.n(n),
            o = r(23),
            a = r(2),
            l = r(3),
            s = r(42),
            c = r(0),
            u = r(7),
            p = "boostPFSRecentSearches",
            f = null,
            h = {
                getOnClickBlockSettings: function () {
                    var t = {
                            type: o.a.ResultType.RECENT_SEARCHES,
                            label: u.a.suggestion.searchBoxOnClickRecentSearchLabel,
                            status: a.a.getSettingValue("search.searchBoxOnclick.recentSearch.status") ? "active" : "inactive",
                            number: a.a.getSettingValue("search.searchBoxOnclick.recentSearch.number"),
                        },
                        e = a.a.getSettingValue("search.searchBoxOnclick.searchTermSuggestion.data"),
                        r = {
                            type: o.a.ResultType.DEFAULT_SUGGESTIONS,
                            label: u.a.suggestion.searchBoxOnClickSearchTermLabel,
                            status: a.a.getSettingValue("search.searchBoxOnclick.searchTermSuggestion.status") ? "active" : "inactive",
                            number: e && e.length ? e.length : 0,
                        },
                        n = a.a.getSettingValue("search.searchBoxOnclick.productSuggestion.data");
                    return [
                        t,
                        r,
                        {
                            type: o.a.ResultType.DEFAULT_PRODUCTS,
                            label: u.a.suggestion.searchBoxOnClickProductsLabel,
                            status: a.a.getSettingValue("search.searchBoxOnclick.productSuggestion.status") ? "active" : "inactive",
                            number: n && n.length ? n.length : 0,
                        },
                    ];
                },
                getOnClickData: function () {
                    var t = a.a.getSettingValue("search.searchBoxOnclick");
                    if (f) return (f.recent_searches = h.getOnClickRecentSearches()), f;
                    var e = [];
                    return (
                        a.a.getSettingValue("search.searchBoxOnclick.recentSearch.status") && e.push({ key: o.a.ResultType.RECENT_SEARCHES, values: h.getOnClickRecentSearches() }),
                        a.a.getSettingValue("search.searchBoxOnclick.searchTermSuggestion.status") &&
                            e.push({ key: o.a.ResultType.DEFAULT_SUGGESTIONS, values: Array.isArray(t.searchTermSuggestion.data) ? t.searchTermSuggestion.data : [] }),
                        a.a.getSettingValue("search.searchBoxOnclick.productSuggestion.status") && h.getOnClickProducts(t.productSuggestion.data),
                        (f = e)
                    );
                },
                getOnClickRecentSearches: function (t) {
                    var e;
                    try {
                        e = JSON.parse(localStorage.getItem(p));
                    } catch (t) {
                        e = [];
                    }
                    if (Array.isArray(e)) {
                        if (!t) {
                            var r = a.a.getSettingValue("search.searchBoxOnclick.recentSearch.number");
                            r > 0 && (e = e.slice(0, r));
                        }
                    } else e = [];
                    var n = [];
                    return (
                        e.forEach(function (t) {
                            "" == t || c.a.isBadUrl(t) || n.push(t);
                        }),
                        n
                    );
                },
                setOnClickRecentSearches: function (t) {
                    if ("string" == typeof t && "" != t.trim() && !c.a.isBadUrl(t)) {
                        t = t.trim();
                        var e = h.getOnClickRecentSearches(!0),
                            r = e.indexOf(t);
                        r >= 0 ? (e.splice(r, 1), e.unshift(t)) : (e.unshift(t), (e = e.slice(0, 10)));
                        try {
                            localStorage.setItem(p, JSON.stringify(e));
                        } catch (t) {}
                    }
                },
                getOnClickProducts: function (t) {
                    if (Array.isArray(t) && 0 != t.length) {
                        var e = new URLSearchParams();
                        e.append("shop", l.a.shopDomain),
                            t.forEach(function (t) {
                                return e.append("ids", t);
                            });
                        var r = (e += "&locale=" + boostPFSAppConfig.general.current_locale).toString();
                        i.a.ajax({
                            method: "GET",
                            url: s.a.getApiUrl("products") + "?" + r,
                            dataType: "json",
                            success: function (t) {
                                f.push({ key: o.a.ResultType.DEFAULT_PRODUCTS, values: t });
                            },
                        });
                    }
                },
                onClickData: f,
            };
        e.a = h;
    },
    5: function (t, e, r) {
        "use strict";
        var n = {
            filterTree: ".boost-pfs-filter-tree",
            filterTreeVertical: ".boost-pfs-filter-tree-v",
            filterTreeHorizontal: ".boost-pfs-filter-tree-h",
            filterTreeHorizontalWrapper: ".boost-pfs-filter-tree-h-wrapper",
            filterTreeMobileButton: ".boost-pfs-filter-tree-mobile-button",
            filterTreeDesktopButton: ".boost-pfs-filter-tree-desktop-button",
            filterTreeWrapper: ".boost-pfs-filter-wrapper",
            stickyElementDesktop: ".boost-pfs-filter-tree",
            stickyElementMobile: ".boost-pfs-filter-tree-mobile-button",
            stickyFilterTreeDesktopButtonWrapper: ".boost-pfs-filter-tree-desktop-button-sticky-wrapper",
            stickyFilterTreeMobileButtonWrapper: ".boost-pfs-filter-tree-mobile-button-stick-wrapper",
            endStickyDesktop: ".boost-pfs-filter-products",
            endStickyMobile: ".boost-pfs-filter-products",
            avoidStickyHeader:
                "#shopify-section-announcement-bar, #shopify-section-header,.site-header--opening, .js-navigation, .js-mobile-header-wrapper, .mobile-nav-bar-wrapper, mobile_nav-fixed--true, .site-header--sticky, .site-header-wrapper .action-bar-wrapper",
            filterRefineByVertical: ".boost-pfs-filter-refine-by-wrapper-v",
            filterRefineByHorizontal: ".boost-pfs-filter-refine-by-wrapper-h",
            products: ".boost-pfs-filter-products",
            collections: ".boost-pfs-search-result-collections",
            pages: ".boost-pfs-search-result-pages",
            searchBoxMobile: "#boost-pfs-search-box-mobile",
            searchBoxStyle3: "#boost-pfs-search-box-style3",
            searchTopPanels: ".boost-pfs-search-result-panel-controls",
            searchCollectionPagination: ".boost-pfs-search-result-collection-pagination",
            searchPagePagination: ".boost-pfs-search-result-page-pagination",
            searchPanelsProductShow: ".boost-pfs-search-panel-product-show",
            searchPanelsCollectionShow: ".boost-pfs-search-panel-collection-show",
            searchPanelsPageShow: ".boost-pfs-search-panel-page-show",
            searchTotalResult: ".boost-pfs-search-total-result",
            searchNoResultJson: "#boost-pfs-instant-search-products-not-found-json",
            inCollectionSearch: ".boost-pfs-in-collection-search",
            topShowLimit: ".boost-pfs-filter-top-show-limit",
            topSorting: ".boost-pfs-filter-top-sorting",
            topDisplayType: ".boost-pfs-filter-top-display-type",
            pagination: ".boost-pfs-filter-bottom-pagination,.boost-pfs-filter-top-pagination",
            bottomPagination: ".boost-pfs-filter-bottom-pagination",
            loadMore: ".boost-pfs-filter-load-more",
            loadMoreButtonContainer: ".boost-pfs-filter-load-more-button-container",
            btnLoadPreviousPageWrapperSelector: ".boost-pfs-filter-btn-load-previous-page-wrapper",
            btnLoadPreviousPageSelector: ".boost-pfs-filter-btn-load-previous-page",
            loadMoreLoading: ".boost-pfs-filter-load-more-loading",
            topNotification: ".boost-pfs-filter-top-notification",
            breadcrumb: ".boost-pfs-filter-breadcrumb",
            scrollToTop: ".boost-pfs-filter-scroll-to-top",
            otpProductItem: "",
            otpButtons: "",
            otpTopCartWrapper: "#cart-icon-bubble",
            otpTopCartLink: 'header a[href="/cart"], a[href="/cart"].site-header__cart, .cart-page-link',
            otpTopCartCount: "#CartCount, .cart-count-bubble, .cart-count",
            otpTopCartSubtotal: "",
            productPageAtcButton: 'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]',
            productPageAtcForm: 'form[action="/cart/add"]',
            mostPopular: ".boost-pfs-most-popular",
            recentlyViewed: ".boost-pfs-recently-viewed",
            trackingProduct: ".boost-pfs-filter-products > *",
            trackingQuickView: ".boost-pfs-quickview-btn",
            trackingAddToCart: 'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]',
            trackingBuyNow: ".shopify-payment-button, #dynamic-checkout-cart",
            init: function () {
                var t = n;
                "undefined" != typeof boostPFSConfig && boostPFSConfig.hasOwnProperty("selector") && null !== boostPFSConfig.selector && (t = Utils.mergeObject(t, boostPFSConfig.selector)),
                    "undefined" != typeof boostPFSFilterConfig && boostPFSFilterConfig.hasOwnProperty("selector") && null !== boostPFSFilterConfig.selector && (t = Utils.mergeObject(t, boostPFSFilterConfig.selector)),
                    "undefined" != typeof boostPFSInstantSearchConfig &&
                        boostPFSInstantSearchConfig.hasOwnProperty("selector") &&
                        null !== boostPFSInstantSearchConfig.selector &&
                        (t = Utils.mergeObject(t, boostPFSInstantSearchConfig.selector)),
                    (n = t);
            },
        };
        e.a = n;
    },
    54: function (module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25),
            core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__),
            core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26),
            core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__),
            _helpers_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2),
            _helpers_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0),
            _helpers_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3),
            compileTemplate = function compileTemplate(itemHtml, data) {
                if ("undefined" != typeof boostPFSIntegrationTemplate && boostPFSIntegrationTemplate.hasOwnProperty("compileTemplate")) {
                    var _compileTemplate = "";
                    for (var i in boostPFSIntegrationTemplate.compileTemplate)
                        hascompileTemplate(i, !0) ? (_compileTemplate += boostPFSIntegrationCustomTemplate.compileTemplate[i]) : (_compileTemplate += boostPFSIntegrationTemplate.compileTemplate[i]);
                    try {
                        eval(_compileTemplate);
                    } catch (t) {
                        console.log("Error when parsing 3rd app template code");
                    }
                }
                return itemHtml;
            },
            call3rdAppFunction = function call3rdAppFunction(data) {
                if ("undefined" != typeof boostPFSIntegrationTemplate && boostPFSIntegrationTemplate.hasOwnProperty("call3rdFunction")) {
                    var call3rdFunction = "";
                    for (var i in boostPFSIntegrationTemplate.call3rdFunction)
                        hascompileTemplate(i, !0, "call3rdFunction") ? (call3rdFunction += boostPFSIntegrationCustomTemplate.call3rdFunction[i]) : (call3rdFunction += boostPFSIntegrationTemplate.call3rdFunction[i]);
                    try {
                        eval(call3rdFunction);
                    } catch (t) {
                        console.log("Error when parsing 3rd app integration code");
                    }
                }
            },
            hascompileTemplate = function (t, e) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "compileTemplate",
                    n = {};
                return (
                    !!_helpers_globals__WEBPACK_IMPORTED_MODULE_4__.a.hasIntegration ||
                    !(
                        void 0 === (n = e ? ("undefined" != typeof boostPFSIntegrationCustomTemplate ? boostPFSIntegrationCustomTemplate : {}) : "undefined" != typeof boostPFSIntegrationTemplate ? boostPFSIntegrationTemplate : {}) ||
                        !n.hasOwnProperty(r) ||
                        !n[r].hasOwnProperty(t) ||
                        "" === n[r][t]
                    )
                );
            },
            compileIntegrationTemplate = function (t, e) {
                return (e = e.replace(/{{itemReviews}}/g, ""));
            },
            call3rdIntegrationFunc = function (t) {},
            Integration = {
                compileTemplate: compileTemplate,
                call3rdAppFunction: call3rdAppFunction,
                hascompileTemplate: hascompileTemplate,
                compileIntegrationTemplate: compileIntegrationTemplate,
                call3rdIntegrationFunc: call3rdIntegrationFunc,
            };
        __webpack_exports__.a = Integration;
    },
    6: function (t, e, r) {
        "use strict";
        e.a = {
            Status: { ACTIVE: "active", DISABLED: "disabled" },
            FilterType: {
                COLLECTION: "collection",
                VENDOR: "vendor",
                PRODUCT_TYPE: "product_type",
                TITLE: "title",
                PRICE: "price",
                VARIANTS_PRICE: "variants_price",
                PERCENT_SALE: "percent_sale",
                REVIEW_RATINGS: "review_ratings",
                WEIGHT: "weight",
                STOCK: "stock",
                TAG: "tag",
                MULTI_LEVEL_TAG: "multi_level_tag",
                LOCATION: "location",
            },
            SelectType: { SINGLE: "single", MULTIPLE: "multiple" },
            DisplayType: { LIST: "list", BOX: "box", RANGE: "range", SWATCH: "swatch", RATING: "rating", SUB_CATEGORY: "sub_category", MULTI_LEVEL_COLLECTIONS: "multi_level_collections", MULTI_LEVEL_TAG: "multi_level_tag" },
            ValueType: { ALL: "all", SPECIFIC: "specific" },
            SortType: { KEY_ASCENDING: "key-asc", KEY_DESCENDING: "key-desc", DOC_COUNT_ASCENDING: "doc_count-asc", DOC_COUNT_DESCENDING: "doc_count-desc" },
            ShowMoreType: { NONE: "none", SCROLLBAR: "scrollbar", VIEWMORE: "viewmore", VIEWMORE_SCROLLBAR: "viewmore_scrollbar" },
        };
    },
    62: function (t, e, r) {
        "use strict";
        r(153), r(25), r(48), r(26), r(41), r(118), r(43), r(9), r(33), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(10),
            i = r(2);
        function o(t) {
            return (o =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function a(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function l(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (a = void 0),
                        (a = (function (t, e) {
                            if ("object" !== o(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== o(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === o(a) ? a : String(a)),
                        n
                    );
            }
            var i, a;
        }
        function s(t, e) {
            return (s = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function c(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = p(t);
                if (e) {
                    var i = p(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return u(this, r);
            };
        }
        function u(t, e) {
            if (e && ("object" === o(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function p(t) {
            return (p = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var f = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && s(t, e);
            })(u, t);
            var e,
                r,
                n,
                o = c(u);
            function u() {
                return a(this, u), o.apply(this, arguments);
            }
            return (
                (e = u),
                (r = [
                    {
                        key: "_highlightSuggestionResult",
                        value: function (t, e) {
                            if (i.a.getSettingValue("search.highlightSuggestionResult") && e && e.length > 1 && t) {
                                var r,
                                    n = function (t, e) {
                                        return new RegExp(t.replace(/([\(\)\{\}\[\]\.\+\-\=\\\/])/g, "\\$&"), e ? "g" : "ig");
                                    },
                                    o = e.split(" "),
                                    a = o.length;
                                for (r = 0; r < a; r++) {
                                    var l = n(o[r]),
                                        s = t.match(l);
                                    if (null !== s && s.length > 0) {
                                        var c,
                                            u = (s = s.filter(function (t, e) {
                                                return s.indexOf(t) == e && "" != t;
                                            })).length;
                                        for (c = 0; c < u; c++) s[c].length > 1 && ((l = n(s[c], !0)), (t = t.replace(l, "<b>" + s[c] + "</b>")));
                                    }
                                }
                            }
                            return t;
                        },
                    },
                ]) && l(e.prototype, r),
                n && l(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                u
            );
        })(n.a);
        e.a = f;
    },
    64: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(10),
            a = r(45),
            l = r(4),
            s = r(2),
            c = r(7),
            u = r(5),
            p = r(0),
            f = r(3);
        function h(t) {
            return (h =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function y(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== h(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== h(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === h(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function d(t, e) {
            return (d = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function m(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = b(t);
                if (e) {
                    var i = b(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return g(this, r);
            };
        }
        function g(t, e) {
            if (e && ("object" === h(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function b(t) {
            return (b = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var v = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && d(t, e);
            })(h, t);
            var e,
                r,
                n,
                o = m(h);
            function h() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, h),
                    ((t = o.call(this)).data = ""),
                    (t.isBoundEvents = !1),
                    (t.isOpen = !1),
                    (t.inputMobileId = u.a.searchBoxMobile.substr(1)),
                    (t.searchBox = null),
                    (t.selector = {
                        searchInput: u.a.searchBoxMobile,
                        clearButton: "." + l.a.searchSuggestionBtnClearMobile,
                        closebutton: "." + l.a.searchSuggestionBtnCloseMobile,
                        submitButton: "." + l.a.searchSuggestionBtnSubmitMobile,
                        topPanel: "." + l.a.searchSuggestion + "-mobile-top-panel",
                        overlay: "." + l.a.searchSuggestion + "-mobile-overlay",
                        searchInputs: 'input[name="' + s.a.getSettingValue("search.termKey") + '"]',
                    }),
                    t
                );
            }
            return (
                (e = h),
                (n = [
                    {
                        key: "tempType",
                        get: function () {
                            return { SEARCH_BTN: "search_btn", DEFAULT: "default" };
                        },
                    },
                    {
                        key: "isActive",
                        value: function () {
                            return !0;
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case h.tempType.SEARCH_BTN:
                                    return '\n\t\t\t\t\t<span class="{{class.searchSuggestionBtnSubmitMobile}}"><span>Submit</span></span>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-mobile-overlay"></div>\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-mobile-top-panel">\n\t\t\t\t\t\t<form action="/search" method="get">\n\t\t\t\t\t\t\t<button type="button" class="{{class.searchSuggestionBtnCloseMobile}}"><-</button>\n\t\t\t\t\t\t\t{{btnSearch}}\n\t\t\t\t\t\t\t<input role="textbox" type="text" name="{{searchTermKey}}" placeholder="{{searchBoxPlaceholder}}" id="{{searchId}}" />\n\t\t\t\t\t\t\t<button role="textbox" type="button" class="{{class.searchSuggestionBtnClearMobile}}">X</button>\n\t\t\t\t\t\t</form>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = "";
                            return (
                                s.a.getSettingValue("search.showSearchBtnMobile") && (t = this.getTemplate(h.tempType.SEARCH_BTN)),
                                this.getTemplate()
                                    .replace(/{{btnSearch}}/g, t)
                                    .replace(/{{searchTermKey}}/g, s.a.getSettingValue("search.termKey"))
                                    .replace(/{{searchBoxPlaceholder}}/g, c.a.suggestion.searchBoxPlaceholder)
                                    .replace(/{{searchId}}/g, this.inputMobileId)
                                    .replace(/{{class.searchSuggestion}}/g, l.a.searchSuggestion)
                                    .replace(/{{class.searchSuggestionBtnSubmitMobile}}/g, l.a.searchSuggestionBtnSubmitMobile)
                                    .replace(/{{class.searchSuggestionBtnCloseMobile}}/g, l.a.searchSuggestionBtnCloseMobile)
                                    .replace(/{{class.searchSuggestionBtnClearMobile}}/g, l.a.searchSuggestionBtnClearMobile)
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            i()("body").append(this.compileTemplate());
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvents;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            (this.$searchInput = i()(this.selector.searchInput)),
                                (this.$clearButtonElement = i()(this.selector.clearButton)),
                                (this.$closebuttonElement = i()(this.selector.closebutton)),
                                (this.$submitButtonElement = i()(this.selector.submitButton)),
                                (this.$topPanelElement = i()(this.selector.topPanel)),
                                (this.$overlayElement = i()(this.selector.overlay)),
                                (this.searchBox = new a.a(this.inputMobileId, this.$searchInput)),
                                this.searchBox.refresh(),
                                this.$closebuttonElement.on("click", this.closeInstantSearchMobile.bind(this, !0)),
                                this.$clearButtonElement.on("click", this.clearInstantSearchMobile.bind(this)),
                                (this.$searchInputs = i()(this.selector.searchInputs)),
                                this.$searchInputs.on("click", this._onClickSearchBox.bind(this)).on("focus", this._onFocusSearchBox.bind(this)).on("keyup", this._onTypeSearchBoxEvent.bind(this)),
                                this.$searchInput.on("focus", this._onFocusMobileInput.bind(this)),
                                this.$searchInput.on("keyup", this._onKeyupSearchBox.bind(this)),
                                (this.$targetInput = null),
                                (this.isBoundEvents = !0);
                        },
                    },
                    {
                        key: "_onClickSearchBox",
                        value: function (t) {
                            if (p.a.isFullWidthMobile()) {
                                var e = this.$targetInput && p.a.stripHtml(this.$targetInput.val());
                                e && this.$searchInputs.val(e),
                                    this.$searchInput &&
                                        (this.$searchInput.length > 0 && "" != p.a.stripHtml(this.$searchInput.val())
                                            ? this.openSuggestionMobile()
                                            : this.searchBox &&
                                              this.searchBox.searchAutoComplete &&
                                              this.searchBox.searchAutoComplete.enableOnClickSearchBox &&
                                              (this.openSuggestionMobile(), this.searchBox.searchAutoComplete.showOnClickSuggestion()));
                            }
                        },
                    },
                    {
                        key: "_onKeyupSearchBox",
                        value: function (t) {
                            var e;
                            this.$targetInput.val(p.a.stripHtml(null == t || null === (e = t.currentTarget) || void 0 === e ? void 0 : e.value));
                        },
                    },
                    {
                        key: "_onFocusSearchBox",
                        value: function (t) {
                            if (p.a.isFullWidthMobile()) {
                                var e = t && t.target ? t.target.id : "",
                                    r = this.$searchInput ? this.$searchInput.attr("id") : "";
                                "" != e && "" != r && e != r && ((this.$targetInput = i()("#" + e)), this.showSearchBoxMobile()), this.$searchInput.trigger("click");
                            }
                        },
                    },
                    {
                        key: "_onFocusMobileInput",
                        value: function (t) {
                            var e = this;
                            this.isReFocus
                                ? (t && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault()), (this.isReFocus = !1), this._onFocusSearchBox(t))
                                : setTimeout(function () {
                                      (document.activeElement && document.activeElement.id ? "#" + document.activeElement.id : "") != u.a.searchBoxMobile && ((e.isReFocus = !0), e.$searchInput.focus());
                                  }, 0);
                        },
                    },
                    {
                        key: "_onTypeSearchBoxEvent",
                        value: function (t) {
                            p.a.InstantSearch.isFullWidthMobile() &&
                                (this.searchBox.instantSearchResult.$wrapper.show(),
                                "" == p.a.stripHtml(t.target.value)
                                    ? (this.searchBox && this.searchBox.searchAutoComplete && this.searchBox.searchAutoComplete.enableOnClickSearchBox
                                          ? this.searchBox.searchAutoComplete.showOnClickSuggestion()
                                          : this.closeInstantSearchMobile(),
                                      this.$clearButtonElement.hide())
                                    : this.$clearButtonElement.show());
                        },
                    },
                    {
                        key: "showSearchBoxMobile",
                        value: function () {
                            var t = this;
                            (this.isOpen = !0),
                                this.onClickOutsideSuggestionMobileEvent(),
                                this.scrollSuggestionMobileEvent(),
                                "" == p.a.stripHtml(this.$searchInput.val()) ? this.$clearButtonElement.hide() : this.$clearButtonElement.show(),
                                this.$searchInput.is(":focus") ||
                                    (this.$topPanelElement.show(),
                                    this.$overlayElement.show(),
                                    i()('[tabindex="-1"]').removeAttr("tabindex").addClass(l.a.searchSuggestionNoTabIndex),
                                    p.a.isMobile() && i()("[data-open=true]").length > 0 && i()("[data-open=true]").attr("data-open", !1),
                                    setTimeout(function () {
                                        t.$searchInput.focus();
                                    }, 100),
                                    this.afterShowSearchBoxMobile());
                        },
                    },
                    {
                        key: "closeInstantSearchMobile",
                        value: function (t) {
                            this.searchBox.instantSearchResult.$wrapper.hide(),
                                (t = void 0 !== t && t) && (this.$topPanelElement.hide(), this.$overlayElement.hide()),
                                this._setValueAllSearchBoxes(),
                                $('body').removeClass('show-search'),
                                i()("." + l.a.searchSuggestionNoTabIndex).attr("tabindex", -1),
                                this.searchBox.instantSearchResult.$wrapper.hasClass(l.a.searchSuggestionOpen) && this.searchBox.instantSearchResult.$wrapper.removeClass(l.a.searchSuggestionOpen),
                                i()("body").hasClass(l.a.searchSuggestionMobileOpen) && i()("body").removeClass(l.a.searchSuggestionMobileOpen),
                                this.afterCloseInstantSearchMobile(t);
                        },
                    },
                    {
                        key: "clearInstantSearchMobile",
                        value: function () {
                            this.$clearButtonElement.hide(),
                                (f.a.currentTerm = ""),
                                this._setValueAllSearchBoxes(""),
                                this.searchBox && this.searchBox.searchAutoComplete && this.searchBox.searchAutoComplete.enableOnClickSearchBox ? this.searchBox.searchAutoComplete.showOnClickSuggestion() : this.closeInstantSearchMobile(),
                                this.$searchInput.focus();
                        },
                    },
                    { key: "afterCloseInstantSearchMobile", value: function (t) {} },
                    {
                        key: "_setValueAllSearchBoxes",
                        value: function (t) {
                            void 0 === t && (t = p.a.stripHtml(f.a.currentTerm)), (f.a.currentTerm = p.a.stripHtml(t)), this.$searchInputs.val(p.a.stripHtml(t));
                        },
                    },
                    {
                        key: "onClickOutsideSuggestionMobileEvent",
                        value: function () {
                            var t = this;
                            i()(document).on("touchstart", function (e) {
                                if (e.target) {
                                    var r = i()(e.target),
                                        n = r.closest("." + l.a.searchSuggestion + "-mobile-top-panel").length > 0,
                                        o = r.closest("." + l.a.searchSuggestionWrapper + " div").length > 0;
                                    n || o || t.closeInstantSearchMobile(!0);
                                }
                            });
                        },
                    },
                    {
                        key: "scrollSuggestionMobileEvent",
                        value: function () {
                            var t = this;
                            i()(document).on("touchmove", function (e) {
                                t.$searchInput.is(":focus") && t.$searchInput.blur();
                            });
                        },
                    },
                    { key: "afterShowSearchBoxMobile", value: function () {} },
                    {
                        key: "openSuggestionMobile",
                        value: function () {
                            this.beforeOpenSuggestionMobile(),
                                i()("body").hasClass(l.a.searchSuggestionMobileOpen) || i()("body").addClass(l.a.searchSuggestionMobileOpen),
                                this.showSearchBoxMobile(),
                                this.searchBox.instantSearchResult.$wrapper.show(),
                                this.afterOpenSuggestionMobile();
                        },
                    },
                    { key: "beforeOpenSuggestionMobile", value: function () {} },
                    { key: "afterOpenSuggestionMobile", value: function () {} },
                ]) && y(e.prototype, r),
                n && y(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                h
            );
        })(o.a);
        e.a = v;
    },
    65: function (t, e, r) {
        "use strict";
        r.r(e);
        r(25), r(58), r(43), r(9), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(2),
            a = r(7),
            l = r(3),
            s = r(5),
            c = r(39),
            u = (r(33), r(73), r(86), r(27), r(28), r(71), r(0)),
            p = r(45),
            f = r(64),
            h = r(81),
            y = r(91),
            d = (r(24), r(10)),
            m = r(54);
        function g(t) {
            return (g =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function b(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== g(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== g(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === g(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function v(t, e) {
            return (v = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function S(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = P(t);
                if (e) {
                    var i = P(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return O(this, r);
            };
        }
        function O(t, e) {
            if (e && ("object" === g(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function P(t) {
            return (P = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var T = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && v(t, e);
            })(p, t);
            var e,
                r,
                n,
                a = S(p);
            function p() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((t = a.call(this)).data = null),
                    (t.id = null),
                    (t.totalProduct = null),
                    (t.$element = null),
                    (t.$productList = i()(s.a.products)),
                    (t.settings = {
                        enableKeepScrollbackPosition: o.a.getSettingValue("general.enableKeepScrollbackPosition"),
                        keepScrollbackPositionType: o.a.getSettingValue("general.keepScrollbackPositionType"),
                        sessionStorageScrollbackPosition: o.a.getSettingValue("general.sessionStorageScrollbackPosition"),
                    }),
                    t
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            window.BoostOTP && BoostOTP.OTPButtons.init(this);
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return "";
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            if (!this.$element || 0 == this.$element.length)
                                if (this.parent.isRender()) {
                                    var t = this.compileTemplate();
                                    "function" == typeof u.a.compileShopifyProductVariables && (t = u.a.compileShopifyProductVariables(this.data, t)),
                                        "function" == typeof u.a.compileShopifyProductMetafield && (t = u.a.compileShopifyProductMetafield(this.data, t)),
                                        (t = m.a.compileTemplate(t, this.data)),
                                        (t = m.a.compileIntegrationTemplate(this.data, t)) && "string" == typeof t && (this.$element = i()(t.trim()));
                                } else {
                                    var e = o.a.getSettingValue("general.otpProductItemClass");
                                    this.$element = e ? this.$productList.children(e).eq(this.index) : this.$productList.children().eq(this.index);
                                }
                            if (this.$element) {
                                this.$element.attr("data-id", u.a.stripHtml(this.id));
                                var r = u.a.stripHtml(this.$element.attr("data-page")),
                                    n = l.a.queryParams.page && !isNaN(l.a.queryParams.page) ? l.a.queryParams.page : 1;
                                (r && !isNaN(r)) || this.$element.attr("data-page", u.a.stripHtml(n)), window.BoostOTP && BoostOTP.OTPButtons.render(this);
                            }
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            var t = u.a.isSearchPage() || u.a.isCollectionPage(),
                                e = u.a.isiOS() && o.a.getSettingValue("general.paginationType") == ProductPagination.Type.DEFAULT;
                            t && !e && this.settings.enableKeepScrollbackPosition && this._bindKeepScrollbackPositionEvent(), window.BoostOTP && BoostOTP.OTPButtons.bindEvents(this);
                        },
                    },
                    {
                        key: "_bindKeepScrollbackPositionEvent",
                        value: function () {
                            if (this.$element)
                                if (u.a.isMobileDevice()) {
                                    var t = !1;
                                    this.$element
                                        .on("touchstart", function () {
                                            t = !1;
                                        })
                                        .on("touchmove", function () {
                                            t = !0;
                                        })
                                        .on("touchend", this._onClickKeepPositionEvent.bind(this, t));
                                } else this.$element.on("click", this._onClickKeepPositionEvent.bind(this, !1));
                        },
                    },
                    {
                        key: "_onClickKeepPositionEvent",
                        value: function (t, e) {
                            if (!t && this.id) {
                                var r = JSON.parse(JSON.stringify(l.a.queryParams)),
                                    n = u.a.stripHtml(this.$element.attr("data-page"));
                                r.page = n && !isNaN(n) ? n : 1;
                                var i = c.a.buildAddressBarUrl(r),
                                    o = { productId: this.id, page: n, position: window.pageYOffset, offset: this.$element.offset().top - window.pageYOffset, url: i };
                                if ("sessionStorage" == this.settings.keepScrollbackPositionType) sessionStorage.setItem(this.settings.sessionStorageScrollbackPosition, JSON.stringify(o));
                                else {
                                    var a = c.a.getHistoryState();
                                    a && a.param && (o.param = a.param);
                                }
                                window.history.replaceState(o, document.title, i);
                            }
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            (this.data = t), (this.id = t.id), (this.index = e), (this.totalProduct = this.parent.totalProduct);
                        },
                    },
                ]) && b(e.prototype, r),
                n && b(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(d.a);
        function w(t) {
            return (w =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function _(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== w(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== w(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === w(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function C(t, e) {
            return (C = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function k(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = R(t);
                if (e) {
                    var i = R(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return E(this, r);
            };
        }
        function E(t, e) {
            if (e && ("object" === w(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function R(t) {
            return (R = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var I = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && C(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = k(o);
            function o() {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, o),
                    i.call(this)
                );
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            console.warn("Missing buildProductGridItem function in theme lib");
                        },
                    },
                ]) && _(e.prototype, r),
                n && _(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(T);
        function j(t) {
            return (j =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function L(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== j(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== j(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === j(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function B(t, e) {
            return (B = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function A(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = F(t);
                if (e) {
                    var i = F(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return x(this, r);
            };
        }
        function x(t, e) {
            if (e && ("object" === j(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function F(t) {
            return (F = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var $ = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && B(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = A(o);
            function o() {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, o),
                    i.call(this)
                );
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            console.warn("Missing buildProductListItem function in theme lib");
                        },
                    },
                ]) && L(e.prototype, r),
                n && L(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(T);
        function D(t) {
            return (D =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function M(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== D(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== D(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === D(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function V(t, e) {
            return (V = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function N(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = U(t);
                if (e) {
                    var i = U(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return H(this, r);
            };
        }
        function H(t, e) {
            if (e && ("object" === D(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function U(t) {
            return (U = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var W = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && V(t, e);
                })(o, t);
                var e,
                    r,
                    n,
                    i = N(o);
                function o() {
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, o),
                        i.call(this)
                    );
                }
                return (
                    (e = o),
                    (r = [
                        {
                            key: "compileTemplate",
                            value: function () {
                                console.warn("Missing buildProductCollageItem function in theme lib");
                            },
                        },
                    ]) && M(e.prototype, r),
                    n && M(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    o
                );
            })(T),
            q = (r(49), r(37), r(41), r(101), r(26), r(44), r(87), r(188), r(70), r(122), r(72), r(48), r(30), r(69), r(155), r(4));
        r(189);
        function G(t) {
            return (G =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function z(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== G(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== G(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === G(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function K(t, e) {
            return (K = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Y(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = J(t);
                if (e) {
                    var i = J(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Q(this, r);
            };
        }
        function Q(t, e) {
            if (e && ("object" === G(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function J(t) {
            return (J = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var X = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && K(t, e);
                })(l, t);
                var e,
                    r,
                    n,
                    a = Y(l);
                function l() {
                    var t;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, l),
                        ((t = a.call(this)).$element = i()(s.a.searchTopPanels)),
                        (t.data = null),
                        (t.panelItems = []),
                        (t.eventType = "init"),
                        (t.selector = {
                            products: s.a.products,
                            collections: s.a.collections,
                            pages: s.a.pages,
                            filterTree: s.a.filterTree,
                            filterTreeDesktopButton: s.a.filterTreeDesktopButton,
                            filterTreeMobileButton: s.a.filterTreeMobileButton,
                            pagination: s.a.pagination,
                            loadMore: s.a.loadMore,
                            btnLoadPreviousPageWrapperSelector: s.a.btnLoadPreviousPageWrapperSelector,
                            searchPanelsProductShow: s.a.searchPanelsProductShow,
                            searchPanelsCollectionShow: s.a.searchPanelsCollectionShow,
                            searchPanelsPageShow: s.a.searchPanelsPageShow,
                        }),
                        (t.settings = {
                            searchPanelDefault: o.a.getSettingValue("search.searchPanelDefault"),
                            searchPanelList: o.a.getSettingValue("search.searchPanelList"),
                            searchPanelBlocks: o.a.getSettingValue("search.searchPanelBlocks"),
                        }),
                        (t.isFetchedFilterData = !1),
                        t
                    );
                }
                return (
                    (e = l),
                    (n = [
                        {
                            key: "isPanelActive",
                            value: function (t) {
                                return !u.a.isSearchPage() || l.getPanelActive() == t;
                            },
                        },
                        {
                            key: "getPanelActive",
                            value: function () {
                                return Globals.hasOwnProperty("searchDisplay") && Object.values(at.Enum).indexOf(Globals.searchDisplay) > -1 ? Globals.searchDisplay : o.a.getSettingValue("search.searchPanelDefault");
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                var t = this;
                                (this.panelItems = []),
                                    this.settings.searchPanelList.forEach(function (e) {
                                        var r = t.settings.searchPanelBlocks[e],
                                            n = new at(r, e);
                                        t.addComponent(n), t.panelItems.push(n);
                                    });
                            },
                        },
                        {
                            key: "isRender",
                            value: function () {
                                return u.a.isSearchPage() && this.isFetchedFilterData;
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                var t = this,
                                    e = 0;
                                switch (
                                    (this.$element.empty(),
                                    this.panelItems.forEach(function (r) {
                                        t.$element.append(r.$element), r.isRendered && e++;
                                    }),
                                    l.getPanelActive())
                                ) {
                                    case at.Enum.COLLECTION:
                                        this.showPanelCollection();
                                        break;
                                    case at.Enum.PAGE:
                                        this.showPanelPage();
                                        break;
                                    default:
                                        this.showPanelProduct();
                                }
                                this.$element.addClass("boost-pfs-search-panel-items-" + e);
                            },
                        },
                        {
                            key: "hidePanelProduct",
                            value: function () {
                                i()(this.selector.products).addClass(q.a.hidden),
                                    i()(this.selector.filterTreeDesktopButton).addClass(q.a.hidden),
                                    i()(this.selector.filterTreeMobileButton).addClass(q.a.hidden),
                                    i()(this.selector.filterTree).addClass(q.a.hidden),
                                    i()(this.selector.pagination).addClass(q.a.hidden),
                                    i()(this.selector.loadMore).addClass(q.a.hidden),
                                    i()(this.selector.btnLoadPreviousPageWrapperSelector).addClass(q.a.hidden),
                                    i()(this.selector.searchPanelsProductShow).addClass(q.a.hidden);
                            },
                        },
                        {
                            key: "hidePanelCollection",
                            value: function () {
                                i()(this.selector.collections).parent().addClass(q.a.hidden), i()(this.selector.searchPanelsCollectionShow).addClass(q.a.hidden);
                            },
                        },
                        {
                            key: "hidePanelPage",
                            value: function () {
                                i()(this.selector.pages).parent().addClass(q.a.hidden), i()(this.selector.searchPanelsPageShow).addClass(q.a.hidden);
                            },
                        },
                        {
                            key: "showPanelProduct",
                            value: function () {
                                this.hidePanelCollection(),
                                    this.hidePanelPage(),
                                    i()(this.selector.products).removeClass(q.a.hidden),
                                    i()(this.selector.filterTree).removeClass(q.a.hidden),
                                    i()(this.selector.filterTreeDesktopButton).removeClass(q.a.hidden),
                                    i()(this.selector.filterTreeMobileButton).removeClass(q.a.hidden),
                                    i()(this.selector.pagination).removeClass(q.a.hidden),
                                    i()(this.selector.loadMore).removeClass(q.a.hidden),
                                    i()(this.selector.btnLoadPreviousPageWrapperSelector).removeClass(q.a.hidden),
                                    i()(this.selector.searchPanelsProductShow).removeClass(q.a.hidden);
                            },
                        },
                        {
                            key: "showPanelCollection",
                            value: function () {
                                this.hidePanelProduct(),
                                    this.hidePanelPage(),
                                    this.data.total_collection > 0 && (i()(this.selector.collections).parent().removeClass(q.a.hidden), i()(this.selector.searchPanelsCollectionShow).removeClass(q.a.hidden));
                            },
                        },
                        {
                            key: "showPanelPage",
                            value: function () {
                                this.hidePanelProduct(), this.hidePanelCollection(), this.data.total_page > 0 && (i()(this.selector.pages).parent().removeClass(q.a.hidden), i()(this.selector.searchPanelsPageShow).removeClass(q.a.hidden));
                            },
                        },
                        {
                            key: "setData",
                            value: function (t, e) {
                                (this.isFetchedFilterData = !0),
                                    t && (this.data = t),
                                    (this.eventType = e),
                                    this.panelItems.forEach(function (r) {
                                        r.setData(t, e);
                                    });
                            },
                        },
                    ]) && z(e.prototype, r),
                    n && z(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    l
                );
            })(d.a),
            Z = r(8);
        function tt(t) {
            return (tt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function et(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== tt(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== tt(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === tt(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function rt(t, e) {
            return (rt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function nt(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ot(t);
                if (e) {
                    var i = ot(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return it(this, r);
            };
        }
        function it(t, e) {
            if (e && ("object" === tt(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function ot(t) {
            return (ot = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var at = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && rt(t, e);
            })(s, t);
            var e,
                r,
                n,
                o = nt(s);
            function s(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, s),
                    ((r = o.call(this)).$element = null),
                    (r.data = t),
                    (r.type = e),
                    (r.eventType = "init"),
                    (r.isRenderPanelContent = !1),
                    (r.limit = 25),
                    (r.page = 1),
                    (r.active = t.active),
                    r.type == s.Enum.PRODUCT ? ((r.limit = Settings.getSettingValue("general.limit")), (r.page = l.a.queryParams.page)) : t.hasOwnProperty("pageSize") && (r.limit = parseInt(t.pageSize)),
                    r
                );
            }
            return (
                (e = s),
                (n = [
                    {
                        key: "Enum",
                        get: function () {
                            return { COLLECTION: "collections", PRODUCT: "products", PAGE: "pages" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.searchResultPanelItem}}">\n\t\t\t\t<button>{{panelItemLabel}} ({{panelItemCount}})</button>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{panelItemLabel}}/g, u.a.stripHtml(this.data.label))
                                .replace(/{{panelItemCount}}/g, u.a.stripHtml(this.totalResult))
                                .replace(/{{class.searchResultPanelItem}}/g, q.a.searchResultPanelItem);
                        },
                    },
                    {
                        key: "isActive",
                        value: function () {
                            return X.isPanelActive(this.type);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return this.type == s.Enum.PRODUCT || (this.active && this.totalResult && "init" == this.eventType);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            (this.$element = i()(this.compileTemplate())), this.isActive() && this.$element.addClass("boost-active");
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$element.on("click", this._onClickPanelItem.bind(this));
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            var r = 0,
                                n = "",
                                i = this.data.hasOwnProperty("label") ? this.data.label : "";
                            switch (this.type) {
                                case s.Enum.COLLECTION:
                                    (r = t.total_collection), (n = a.a.search.searchPanelCollection ? a.a.search.searchPanelCollection : i);
                                    break;
                                case s.Enum.PAGE:
                                    (r = t.total_page), (n = a.a.search.searchPanelPage ? a.a.search.searchPanelPage : i);
                                    break;
                                default:
                                    (r = t.total_product), (n = a.a.search.searchPanelProduct ? a.a.search.searchPanelProduct : i);
                            }
                            (this.eventType = e), (this.totalResult = r), (this.data.label = n), this.type == s.Enum.PRODUCT && (this.page = l.a.queryParams.page);
                        },
                    },
                    {
                        key: "_onClickPanelItem",
                        value: function (t) {
                            t.preventDefault(), (l.a.searchDisplay = this.type), Z.default.setParam("limit", this.limit), Z.default.setParam("page", this.page);
                            var e = this.parent,
                                r = e.parent.searchResultTotal;
                            switch (
                                (this.isRenderPanelContent || this.type === s.Enum.PRODUCT || Z.default.getFilterData("search", this._searchPanelCallback.bind(this)),
                                this.$element.addClass("boost-active"),
                                this.$element.siblings().removeClass("boost-active"),
                                this.type)
                            ) {
                                case s.Enum.COLLECTION:
                                    e.showPanelCollection();
                                    break;
                                case s.Enum.PAGE:
                                    e.showPanelPage();
                                    break;
                                default:
                                    e.showPanelProduct();
                            }
                            r.setData(this.totalResult, this.type), r.refresh(), (this.isRenderPanelContent = !0);
                        },
                    },
                    {
                        key: "_searchPanelCallback",
                        value: function (t) {
                            var e = this.parent.parent.collectionList,
                                r = this.parent.parent.collectionListPagination,
                                n = !!t.hasOwnProperty("total_collection") && t.total_collection;
                            l.a.searchDisplay === s.Enum.PAGE && ((e = this.parent.parent.pageList), (r = this.parent.parent.pageListPagination), (n = !!t.hasOwnProperty("total_page") && t.total_page)),
                                e.setData(t),
                                e.refresh(),
                                r.setData(t, n, this.limit, this.page),
                                r.refresh();
                        },
                    },
                ]) && et(e.prototype, r),
                n && et(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(d.a);
        function lt(t) {
            return (lt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function st(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== lt(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== lt(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === lt(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ct(t, e) {
            return (ct = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function ut(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ft(t);
                if (e) {
                    var i = ft(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return pt(this, r);
            };
        }
        function pt(t, e) {
            if (e && ("object" === lt(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function ft(t) {
            return (ft = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ht = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ct(t, e);
            })(l, t);
            var e,
                r,
                n,
                a = ut(l);
            function l() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((t = a.call(this)).data = null),
                    (t.totalProduct = null),
                    (t.paginationType = ""),
                    (t.$loadMore = i()(s.a.loadMore)),
                    (t.settings = { limit: o.a.getSettingValue("general.limit"), showLoading: o.a.getSettingValue("general.showLoading"), showLoadMoreLoading: o.a.getSettingValue("general.showLoadMoreLoading") }),
                    (t.settings.limit <= 0 || t.settings.limit > 70) && (t.settings.limit = 24),
                    t
                );
            }
            return (
                (e = l),
                (n = [
                    {
                        key: "Type",
                        get: function () {
                            return { DEFAULT: "default", LOAD_MORE: "load_more", INFINITE: "infinite" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "isRender",
                        value: function () {
                            return null !== this.data;
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            t && (this.data = t), (this.totalProduct = this.parent.totalProduct), (this.paginationType = o.a.getSettingValue("general.paginationType"));
                        },
                    },
                    {
                        key: "showLoading",
                        value: function () {
                            this.settings.showLoadMoreLoading && !1 === this.settings.showLoading && this.$loadMore.find(s.a.loadMoreLoading).show();
                        },
                    },
                    {
                        key: "hideLoading",
                        value: function () {
                            this.settings.showLoadMoreLoading && this.$loadMore.find(s.a.loadMoreLoading).hide();
                        },
                    },
                ]) && st(e.prototype, r),
                n && st(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(d.a);
        function yt(t, e) {
            var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
            if (!r) {
                if (
                    Array.isArray(t) ||
                    (r = (function (t, e) {
                        if (!t) return;
                        if ("string" == typeof t) return dt(t, e);
                        var r = Object.prototype.toString.call(t).slice(8, -1);
                        "Object" === r && t.constructor && (r = t.constructor.name);
                        if ("Map" === r || "Set" === r) return Array.from(t);
                        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dt(t, e);
                    })(t)) ||
                    (e && t && "number" == typeof t.length)
                ) {
                    r && (t = r);
                    var n = 0,
                        i = function () {};
                    return {
                        s: i,
                        n: function () {
                            return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
                        },
                        e: function (t) {
                            throw t;
                        },
                        f: i,
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var o,
                a = !0,
                l = !1;
            return {
                s: function () {
                    r = r.call(t);
                },
                n: function () {
                    var t = r.next();
                    return (a = t.done), t;
                },
                e: function (t) {
                    (l = !0), (o = t);
                },
                f: function () {
                    try {
                        a || null == r.return || r.return();
                    } finally {
                        if (l) throw o;
                    }
                },
            };
        }
        function dt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
        }
        function mt(t) {
            return (mt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function gt(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== mt(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== mt(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === mt(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function bt(t, e) {
            return (bt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function vt(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ot(t);
                if (e) {
                    var i = Ot(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return St(this, r);
            };
        }
        function St(t, e) {
            if (e && ("object" === mt(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ot(t) {
            return (Ot = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Pt = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && bt(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = vt(p);
            function p() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((t = c.call(this)).data = null),
                    (t.totalProduct = null),
                    (t.$element = i()(s.a.products)),
                    (t.settings = {
                        loadProductFromLiquid: o.a.getSettingValue("general.loadProductFromLiquid"),
                        loadProductFromLiquidType: o.a.getSettingValue("general.loadProductFromLiquidType"),
                        sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent"),
                        themeId: o.a.getSettingValue("general.theme_id"),
                        productAndVariantAvailable: o.a.getSettingValue("general.productAndVariantAvailable"),
                        sortingAvailableFirst: o.a.getSettingValue("general.sortingAvailableFirst"),
                        enableKeepScrollbackPosition: o.a.getSettingValue("general.enableKeepScrollbackPosition"),
                        keepScrollbackPositionType: o.a.getSettingValue("general.keepScrollbackPositionType"),
                        sessionStorageScrollbackPosition: o.a.getSettingValue("general.sessionStorageScrollbackPosition"),
                    }),
                    t
                );
            }
            return (
                (e = p),
                (n = [
                    {
                        key: "Enum",
                        get: function () {
                            return { itemStyle: { GRID: "grid", LIST: "list", COLLAGE: "collage" }, loadProductType: { JS: "js", AJAX: "ajax", SYNC: "sync" } };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "isRender",
                        value: function () {
                            var t = u.a.getDefaultSorting();
                            return (
                                null != this.data &&
                                X.isPanelActive(at.Enum.PRODUCT) &&
                                (!l.a.loadProductFirst ||
                                    !u.a.isCollectionPage() ||
                                    u.a.isVendorPage() ||
                                    u.a.isTagPage() ||
                                    u.a.isTypePage() ||
                                    ("" != t && t != o.a.getSettingValue("general.default_sort_by")) ||
                                    ("best-selling" === l.a.defaultSorting && !o.a.getSettingValue("general.loadProductFirstBestSelling")) ||
                                    l.a.defaultSorting.startsWith("extra") ||
                                    this.settings.productAndVariantAvailable ||
                                    this.settings.sortingAvailableFirst ||
                                    l.a.hasFilterByLocation ||
                                    (l.a.loadProductFirst && (l.a.hasFilterOptionParam || "init" != this.eventType)) ||
                                    o.a.getSettingValue("general.enableVariantsDisplay"))
                            );
                        },
                    },
                    {
                        key: "getNoResultTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-message"><p><em>{{content}}</em></p></div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getNoResultSearchTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-message result-empty-search">\n\t\t\t\t<p>{{content}}</p>\n\t\t\t\t<p><a href="{{link}}">{{label.seeAllProducts}}</a></p>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this._catchError(),
                                this.totalProduct > 0 &&
                                    (["incollection_search", "history"].includes(l.a.queryParams.event_type) && u.a.showFilterTree(), this.settings.loadProductFromLiquid ? this.buildProductListDataFromLiquid() : this.buildProductList()),
                                o.a.getSettingValue("mostPopular.mostPopularEnable") && i()(s.a.mostPopular).length > 0 && new MostPopular().refresh();
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            var t = u.a.isSearchPage() || u.a.isCollectionPage(),
                                e = u.a.isiOS() && o.a.getSettingValue("general.paginationType") == ht.Type.DEFAULT;
                            t && !e && this.settings.enableKeepScrollbackPosition && this._bindKeepScrollbackPositionEvent();
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            var e = this;
                            if (
                                ((this.data = t),
                                (this.totalProduct = this.parent.totalProduct),
                                this.prepareProductData(),
                                (this.eventType = this.parent.eventType),
                                (this.eventInfo = this.parent.eventInfo),
                                (this.children = []),
                                (this.productItems = []),
                                (this.ajaxPage = 0),
                                this.totalProduct > 0)
                            ) {
                                var r = this._getProductItemClass();
                                t.forEach(function (t, n) {
                                    var i = new r();
                                    e.addComponent(i), i.setData(t, n), e.productItems.push(i);
                                });
                            }
                        },
                    },
                    {
                        key: "_getProductItemClass",
                        value: function () {
                            switch (l.a.queryParams.display) {
                                case p.Enum.itemStyle.LIST:
                                    return $;
                                case p.Enum.itemStyle.COLLAGE:
                                    return W;
                                default:
                                    return I;
                            }
                        },
                    },
                    {
                        key: "buildProductListDataFromLiquid",
                        value: function () {
                            u.a.isDefaultPaginationType() || "page" != this.eventType || i()(window).off("scroll"),
                                this.settings.loadProductFromLiquidType == p.Enum.loadProductType.SYNC ? this._getProductListHtmlBySync() : this._getProductListHtmlByAjax();
                        },
                    },
                    {
                        key: "prepareProductData",
                        value: function () {
                            var t = this,
                                e = this.data;
                            return Array.isArray(e)
                                ? (e.forEach(function (e) {
                                      var r = [];
                                      e.options_with_values.forEach(function (t) {
                                          r.push(t.name);
                                      }),
                                          (e.options = r);
                                      var n = !0;
                                      if (e.variants && e.variants.length > 0) {
                                          var i = e.variants[0];
                                          i.hasOwnProperty("fulfillment_service") && "gift_card" == i.fulfillment_service && (n = !1);
                                      }
                                      u.a.isEnableShopifyMultipleCurrencies() &&
                                          (u.a.isConvertCurrenciesOnFrontEnd()
                                              ? ((e.price_min = u.a.convertPriceBasedOnActiveCurrency(e.price_min, n)),
                                                (e.price_max = u.a.convertPriceBasedOnActiveCurrency(e.price_max, n)),
                                                (e.compare_at_price_min = u.a.convertPriceBasedOnActiveCurrency(e.compare_at_price_min, n)),
                                                (e.compare_at_price_max = u.a.convertPriceBasedOnActiveCurrency(e.compare_at_price_max, n)))
                                              : u.a.convertPriceBasedOnPresentmentPrice(e)),
                                          e.variants.forEach(function (t) {
                                              var e = [],
                                                  r = t.merged_options;
                                              if (Array.isArray(r)) {
                                                  for (var i = 0; i < r.length; i++) {
                                                      var o = r[i].split(":");
                                                      (t["option" + (parseInt(i) + 1)] = o[1]), (t["option_" + o[0]] = o[1]), e.push(o[1]);
                                                  }
                                                  t.options = e;
                                              }
                                              if (null != t.compare_at_price) {
                                                  var a = parseFloat(t.compare_at_price);
                                                  (a = u.a.convertPriceBasedOnActiveCurrency(a, n)), (t.compare_at_price = a);
                                              }
                                              var l = parseFloat(t.price);
                                              (l = u.a.convertPriceBasedOnActiveCurrency(l, n)), (t.price = l);
                                          }),
                                          (e.description = e.body_html),
                                          (e.featured_image = Array.isArray(e.images) && e.images.length > 0 ? e.images[0] : boostPFSConfig.general.no_image_url),
                                          (e = t.showVariantImageBasedOnSelectedFilter(e));
                                  }),
                                  e)
                                : [];
                        },
                    },
                    {
                        key: "showVariantImageBasedOnSelectedFilter",
                        value: function (t) {
                            var e = o.a.getSettingValue("general.showVariantImageBasedOnSelectedFilter");
                            if (e && "string" == typeof e && Array.isArray(t.variants) && t.variants.length > 1 && l.a.queryParams && Array.isArray(l.a.queryParams[e]) && l.a.queryParams[e].length > 0)
                                for (var r = l.a.queryParams[e], n = 0; n < r.length; n++) {
                                    for (var i = !1, a = e.replace(l.a.prefix + "_opt_", "") + ":" + r[n], s = 0; s < t.variants.length; s++) {
                                        var c = t.variants[s];
                                        if ((i = Array.isArray(c.merged_options) && c.merged_options.includes(a) && c.image)) {
                                            (t.featured_image = c.image),
                                                Array.isArray(t.images_info) &&
                                                    t.images_info.sort(function (t, e) {
                                                        return e.src == c.image ? 1 : -1;
                                                    }),
                                                Array.isArray(t.images) &&
                                                    t.images.sort(function (t, e) {
                                                        return e == c.image ? 1 : -1;
                                                    });
                                            break;
                                        }
                                    }
                                    if (i) break;
                                }
                            return t;
                        },
                    },
                    {
                        key: "buildProductList",
                        value: function () {
                            var t = this,
                                e = [];
                            if (
                                (this.productItems.forEach(function (t) {
                                    e.push(t.$element);
                                }),
                                this.$element.removeAttr("data-boost-sort"),
                                (u.a.isDefaultPaginationType() || (!u.a.isDefaultPaginationType() && "page" != this.eventType)) && (this.$element.html(""), i()(window).off("scroll")),
                                u.a.isLoadPreviousPagePaginationType() && parseInt(window.sessionStorage.getItem(this.settings.sessionStoragePreviousPageEvent)))
                            ) {
                                var r = [];
                                e.forEach(function (t) {
                                    return r.push(t);
                                }),
                                    r.reverse(),
                                    r.forEach(function (e) {
                                        return t.$element.prepend(e);
                                    });
                            } else
                                e.forEach(function (e) {
                                    return t.$element.append(e);
                                });
                            m.a.call3rdAppFunction(this.data), m.a.call3rdIntegrationFunc(this.data), this.settings.loadProductFromLiquid && this.settings.loadProductFromLiquidType == p.Enum.loadProductType.AJAX && this.afterRender();
                        },
                    },
                    {
                        key: "buildExtrasProductListByAjax",
                        value: function (t, e, r, n, a, l) {
                            a || (a = 0), l || (l = []), (!n || n > 20) && (n = 20);
                            for (var s = n * a, c = Math.min(t.length, n * (a + 1)), u = [], p = s; p < c; p++) u.push(t[p].handle);
                            var f = u.join("+"),
                                h = window.location.pathname.split("/"),
                                y = "",
                                d = Shopify && Shopify.routes && void 0 !== Shopify.routes.root;
                            o.a.getSettingValue("general.useShopifyRouteForMultiLanguageURL") && d
                                ? (y = Shopify.routes.root.replace(/\/$/, ""))
                                : h.indexOf(boostPFSAppConfig.general.current_locale) > -1 && (y = "/" + boostPFSAppConfig.general.current_locale);
                            var m = y + "/collections/all/" + f + "?view=" + e;
                            i.a.ajax({
                                type: "GET",
                                url: m,
                                success: function (i) {
                                    this._onExtraProductListAjaxSuccess(t, e, r, n, a, i, l);
                                }.bind(this),
                            });
                        },
                    },
                    {
                        key: "_getProductListHtmlByAjax",
                        value: function () {
                            (this.isFetchedAjaxProductData = !1), this.$element.addClass(q.a.productWrapLoading);
                            for (var t = 20 * this.ajaxPage, e = Math.min(this.data.length, 20 * (this.ajaxPage + 1)), r = [], n = t; n < e; n++) r.push(this.data[n].handle);
                            var o = r.join("+");
                            i.a.ajax({ type: "GET", url: "/collections/all/" + o + "?view=boost-pfs-product-item", success: this._onProductListAjaxSuccess.bind(this) });
                        },
                    },
                    {
                        key: "_getProductListHtmlBySync",
                        value: function () {
                            var t = this.settings.themeId,
                                e = !1;
                            this.productItems.forEach(function (r, n) {
                                e || (r.data.html && r.data.html.value && t && t == r.data.html.theme_id ? ((r.data.html = r.data.html.value), r.refresh()) : (e = !0));
                            }),
                                e ? this._getProductListHtmlByAjax() : this.buildProductList();
                        },
                    },
                    {
                        key: "_onProductListAjaxSuccess",
                        value: function (t) {
                            var e = this,
                                r = [];
                            try {
                                /<\!--.*?-->/.test(t) && (t = t.replace(/<\!--.*?-->/g, "")), (r = JSON.parse(t).products);
                            } catch (t) {
                                return void console.warn("Could not parse json from collection.boost-pfs-product-item.liquid");
                            }
                            r.forEach(function (t) {
                                e.data.forEach(function (e, r) {
                                    e.id == t.id && (e.html = t.html.value);
                                });
                            });
                            for (var n = 20 * this.ajaxPage, i = n; i < n + r.length; i++)
                                this.productItems.forEach(function (t) {
                                    t.id == e.data[i].id
                                        ? (t.setData(e.data[i]), t.refresh())
                                        : e.productItems.forEach(function (t) {
                                              t.bindEvents();
                                          });
                                });
                            0 == this.ajaxPage && (u.a.isDefaultPaginationType() || "page" !== this.eventType) && this.$element.html(""),
                                this.buildProductList(),
                                20 * (this.ajaxPage + 1) < this.data.length
                                    ? (this.ajaxPage++, this._getProductListHtmlByAjax())
                                    : ((this.isFetchedAjaxProductData = !0), this.parent.pagination.refresh(), this.parent.productPlaceholder.refresh(), this.$element.removeClass(q.a.productWrapLoading));
                        },
                    },
                    {
                        key: "_onExtraProductListAjaxSuccess",
                        value: function (t, e, r, n, i, o, a) {
                            try {
                                /<\!--.*?-->/.test(o) && (o = o.replace(/<\!--.*?-->/g, "")), (a = a.concat(JSON.parse(o).products));
                            } catch (t) {
                                console.warn("Could not parse json from " + e + ": " + t.message);
                            }
                            n * i < t.length - 1 ? (i++, this.buildExtrasProductListByAjax(t, e, r, n, i, a)) : "function" == typeof r && r(a);
                        },
                    },
                    {
                        key: "_bindKeepScrollbackPositionEvent",
                        value: function () {
                            if ("init" == this.eventType || "history" == this.eventType) {
                                history.scrollRestoration = "manual";
                                var t = "sessionStorage" == this.settings.keepScrollbackPositionType ? this._getScrollDataFromSessionStorage() : this._getScrollDataFromHistory();
                                t && (this.parent._changeProductListGobackPreviousPositionStatus(!0), this._scrollBackToItem(t));
                            }
                        },
                    },
                    {
                        key: "_getScrollDataFromSessionStorage",
                        value: function () {
                            var t = {};
                            try {
                                t = JSON.parse(sessionStorage.getItem(this.settings.sessionStorageScrollbackPosition));
                            } catch (t) {}
                            return "object" != mt(t) && (t = {}), sessionStorage.removeItem(this.settings.sessionStorageScrollbackPosition), t;
                        },
                    },
                    {
                        key: "_getScrollDataFromHistory",
                        value: function () {
                            var t = null;
                            if (history && history.state && history.state.productId) {
                                t = history.state;
                                var e = new URL(u.a.getWindowLocation().href);
                                setTimeout(function () {
                                    window.history.replaceState("", document.title, e.toString().replace(/\+/g, "%20"));
                                }, 500);
                            }
                            return t;
                        },
                    },
                    {
                        key: "_scrollBackToItem",
                        value: function (t) {
                            if (t && t.hasOwnProperty("page") && t.hasOwnProperty("productId") && t.hasOwnProperty("position") && t.hasOwnProperty("url")) {
                                var e = JSON.parse(JSON.stringify(l.a.queryParams)),
                                    r = "string" == typeof t.url && 2 == t.url.split("?").length ? t.url.split("?")[1] : "",
                                    n = new URLSearchParams(r).get("page");
                                n && (e.page = n);
                                var i = Navigation.buildAddressBarUrl(e),
                                    a = o.a.getSettingValue("general.paginationType"),
                                    s = this.$element.find('[data-id="' + t.productId + '"]').first(),
                                    c = this;
                                if (!s.length || i != t.url) return void c.parent._changeProductListGobackPreviousPositionStatus(!1);
                                if (a == ht.Type.DEFAULT) window.scrollTo({ top: t.position, behavior: "smooth" });
                                else {
                                    var u = (s = this.$element.find('[data-id="' + t.productId + '"]').first()).offset().top - t.offset;
                                    window.scrollTo({ top: u, behavior: "smooth" }),
                                        window.IntersectionObserver
                                            ? new IntersectionObserver(function (t, e) {
                                                  var r,
                                                      n = yt(t);
                                                  try {
                                                      for (n.s(); !(r = n.n()).done; ) r.value.isIntersecting && (c.parent._changeProductListGobackPreviousPositionStatus(!1), e.disconnect());
                                                  } catch (t) {
                                                      n.e(t);
                                                  } finally {
                                                      n.f();
                                                  }
                                              }).observe(s[0])
                                            : setTimeout(function () {
                                                  c.parent._changeProductListGobackPreviousPositionStatus(!1);
                                              }, 500);
                                }
                            }
                        },
                    },
                    {
                        key: "_catchError",
                        value: function () {
                            if (u.a.isNoFilterResult(this.totalProduct, this.eventType)) {
                                var t = a.a.error.noProducts,
                                    e = "";
                                u.a.checkExistFilterOptionParam()
                                    ? ((t = a.a.error.noFilterResult), (e = this.getNoResultTemplate().replace(/{{content}}/g, t)))
                                    : u.a.isSearchPage()
                                    ? ((t = a.a.search.resultEmpty.replace(/{{ terms }}/g, "<strong>" + u.a.stripHtml(l.a.queryParams.q) + "</strong>").replace(/{{ breakline }}/g, "<br />")),
                                      (e = this.getNoResultSearchTemplate()
                                          .replace(/{{content}}/g, t)
                                          .replace(/{{link}}/g, "/collections/all")
                                          .replace(/{{label.seeAllProducts}}/g, a.a.search.seeAllProducts)))
                                    : ((t = a.a.error.noFilterResult), (e = this.getNoResultTemplate().replace(/{{content}}/g, t))),
                                    l.a.queryParams.incollection_search && u.a.hideFilterTree(),
                                    "" != e && this.$element.html(e);
                            }
                        },
                    },
                ]) && gt(e.prototype, r),
                n && gt(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(d.a);
        function Tt(t) {
            return (Tt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function wt(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Tt(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Tt(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Tt(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function _t(t, e) {
            return (_t = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ct(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Et(t);
                if (e) {
                    var i = Et(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return kt(this, r);
            };
        }
        function kt(t, e) {
            if (e && ("object" === Tt(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Et(t) {
            return (Et = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Rt = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && _t(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = Ct(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).$element = i()(s.a.pagination)),
                    (t.$buttomElement = i()(s.a.bottomPagination)),
                    (t.$productList = i()(s.a.products)),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            return "";
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return null !== this.data;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            i()(s.a.pagination).html(this.compileTemplate());
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element.show(), this.$element.find("a").off("click"), this.$element.find("a").on("click", this._onClickEvent.bind(this));
                        },
                    },
                    {
                        key: "_onClickEvent",
                        value: function (t) {
                            var e;
                            t.preventDefault(), (l.a.internalClick = !0);
                            try {
                                e = new URL(i()(t.currentTarget).attr("href"));
                            } catch (r) {
                                e = new URL("https://" + boostPFSConfig.shop.domain + i()(t.currentTarget).attr("href"));
                            }
                            var r = e && e.searchParams ? e.searchParams.get("page") : 1;
                            (r && !isNaN(r)) || (r = 1), Z.default.setParam("page", r), Z.default.applyFilter("page"), window.scrollTo({ top: this.$productList.offset().top - 50, behavior: "smooth" });
                        },
                    },
                ]) && wt(e.prototype, r),
                n && wt(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(ht);
        function It(t) {
            return (It =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function jt(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== It(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== It(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === It(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Lt(t, e) {
            return (Lt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Bt(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = xt(t);
                if (e) {
                    var i = xt(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return At(this, r);
            };
        }
        function At(t, e) {
            if (e && ("object" === It(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function xt(t) {
            return (xt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ft = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Lt(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = Bt(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).$element = i()(s.a.topDisplayType)),
                    (t.selector = { productDisplayTypeItem: "." + q.a.productDisplayType + "-item", productDisplayTypeGrid: "." + q.a.productDisplayType + "-grid", productDisplayTypeList: "." + q.a.productDisplayType + "-list" }),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    { key: "compileTemplate", value: function () {} },
                    {
                        key: "render",
                        value: function () {
                            this.$element.html(this.compileTemplate()),
                                this.$element.length &&
                                    (this.$element.find(this.selector.productDisplayTypeList).removeClass("active"),
                                    this.$element.find(this.selector.productDisplayTypeGrid).removeClass("active"),
                                    "list" == l.a.queryParams.display
                                        ? this.$element.find(this.selector.productDisplayTypeList).addClass("active")
                                        : "grid" == l.a.queryParams.display && this.$element.find(this.selector.productDisplayTypeGrid).addClass("active"));
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            i()(s.a.topDisplayType + " a").on("click", this._onClickEvent.bind(this));
                        },
                    },
                    {
                        key: "_onClickEvent",
                        value: function (t) {
                            t.preventDefault(), (l.a.internalClick = !0);
                            var e = i()(t.currentTarget);
                            e.siblings().removeClass("active"), e.addClass("active");
                            var r = u.a.stripHtml(e.data("display"));
                            if (r) Z.default.setParam("display", r);
                            else {
                                var n = window.location.href,
                                    o = new URL(n);
                                if (((o = o.hostname), -1 !== e.attr("href").indexOf(o))) var a = new URL(e.attr("href"));
                                else a = new URL("https://" + o + e.attr("href"));
                                (r = u.a.stripHtml(a.searchParams.get("display"))) && Z.default.setParam("display", r);
                            }
                            Z.default.applyFilter("display");
                        },
                    },
                ]) && jt(e.prototype, r),
                n && jt(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function $t(t) {
            return ($t =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Dt(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== $t(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== $t(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === $t(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Mt(t, e) {
            return (Mt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Vt(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ht(t);
                if (e) {
                    var i = Ht(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Nt(this, r);
            };
        }
        function Nt(t, e) {
            if (e && ("object" === $t(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ht(t) {
            return (Ht = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ut = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Mt(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = Vt(a);
            function a() {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    o.call(this)
                );
            }
            return (
                (e = a),
                (r = [
                    { key: "compileTemplate", value: function () {} },
                    {
                        key: "render",
                        value: function () {
                            i()(s.a.topSorting).html(this.compileTemplate());
                            var t = i()(s.a.topSorting + " select");
                            t.length && t.val(u.a.stripHtml(l.a.queryParams.sort));
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            i()(s.a.topSorting + " select").change(function (t) {
                                Z.default.setParam("sort", u.a.stripHtml(i()(this).val())), Z.default.setParam("page", 1), Z.default.applyFilter("sort");
                            });
                        },
                    },
                ]) && Dt(e.prototype, r),
                n && Dt(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function Wt(t) {
            return (Wt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function qt(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Wt(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Wt(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Wt(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Gt(t, e) {
            return (Gt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function zt(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Yt(t);
                if (e) {
                    var i = Yt(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Kt(this, r);
            };
        }
        function Kt(t, e) {
            if (e && ("object" === Wt(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Yt(t) {
            return (Yt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Qt = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Gt(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = zt(a);
            function a() {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    o.call(this)
                );
            }
            return (
                (e = a),
                (r = [
                    { key: "compileTemplate", value: function () {} },
                    {
                        key: "render",
                        value: function () {
                            i()(s.a.topShowLimit).html(this.compileTemplate());
                            var t = i()(s.a.topShowLimit + " select");
                            t.length && t.val(u.a.stripHtml(Globals.queryParams.limit));
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            i()(s.a.topShowLimit + " select").change(function (t) {
                                Z.default.setParam("limit", u.a.stripHtml(i()(this).val())), Z.default.setParam("page", 1), Z.default.applyFilter();
                            });
                        },
                    },
                ]) && qt(e.prototype, r),
                n && qt(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function Jt(t) {
            return (Jt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Xt(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Jt(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Jt(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Jt(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Zt(t, e) {
            return (Zt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function te(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = re(t);
                if (e) {
                    var i = re(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ee(this, r);
            };
        }
        function ee(t, e) {
            if (e && ("object" === Jt(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function re(t) {
            return (re = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ne = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Zt(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = te(p);
            function p() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((t = c.call(this)).searchValue = ""),
                    (t.selector = { clearButton: ".boost-pfs-in-collection-search-clear", searchInput: ".boost-pfs-in-collection-search-input", searchWrapper: ".boost-pfs-in-collection-search-wrapper" }),
                    t
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t<div class="boost-pfs-in-collection-search-wrapper">\n\t\t\t<input aria-label="{{placeholder}}" class="boost-pfs-in-collection-search-input" type="text" placeholder="{{placeholder}}">\n\t\t\t\t<button type="button" class="boost-pfs-in-collection-search-clear">\n\t\t\t\t\t<svg aria-hidden="true" width="15" height="16" viewBox="0 0 20 20">\n\t\t\t\t\t\t<path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="#222222"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</button>\n\t\t\t\t<button type="button" class="boost-pfs-in-collection-search-button">\n\t\t\t\t\t<svg aria-hidden="true" width="15" height="16" viewBox="0 0 15 16" fill="none">\n\t\t\t\t\t\t<path d="M14.4323 14.4001L10.4594 10.4801C12.1215 8.32012 11.9188 5.20012 9.93233 3.24012C7.74314 1.08012 4.17558 1.08012 1.94585 3.24012C-0.243342 5.40012 -0.243342 8.92012 1.94585 11.1201C2.9999 12.1601 4.41882 12.7601 5.91882 12.7601C7.13504 12.7601 8.31071 12.3601 9.28368 11.6401L13.2567 15.5601C13.4188 15.7201 13.6215 15.8001 13.8242 15.8001C14.0269 15.8001 14.2296 15.7201 14.3918 15.5601C14.7567 15.2001 14.7567 14.7201 14.4323 14.4001ZM5.95936 11.1201C4.90531 11.1201 3.89179 10.7201 3.12152 9.96012C1.54044 8.40012 1.54044 5.92012 3.12152 4.36012C3.89179 3.60012 4.94585 3.20012 5.95936 3.20012C6.97287 3.20012 8.02693 3.60012 8.7972 4.36012C10.3783 5.92012 10.3783 8.40012 8.7972 9.96012C8.02693 10.7201 7.01341 11.1201 5.95936 11.1201Z" fill="#222222"/>\n\t\t\t\t\t</svg>\t\n\t\t\t\t</button>\n\t\t</div>\n        '.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = a.a.inCollectionSearch;
                            return this.getTemplate().replace(/{{placeholder}}/g, t);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return o.a.getSettingValue("general.enableCollectionSearch") && u.a.isCollectionPage() && "incollection_search" !== this.parent.eventType;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            i()(this.selector.searchWrapper).length || (s.a.inCollectionSearch && i()(s.a.inCollectionSearch).length > 0 && i()(s.a.inCollectionSearch).html(this.compileTemplate()));
                            var t = i()(this.selector.searchInput);
                            t.length && ((this.searchValue = u.a.stripHtml(l.a.queryParams.q) || ""), t.val(this.searchValue), this.searchValue ? i()(this.selector.clearButton).show() : i()(this.selector.clearButton).hide());
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            i()(this.selector.searchInput).off("input"),
                                i()(this.selector.clearButton).off("click"),
                                i()(this.selector.searchInput).on("input", u.a.debounce(this.onTypeInCollectionSearch.bind(this), 300)),
                                i()(this.selector.clearButton).on("click", this.onClickClearButton.bind(this));
                        },
                    },
                    {
                        key: "onTypeInCollectionSearch",
                        value: function (t) {
                            this.setSearchValue(t), this.searchValue ? i()(this.selector.clearButton).show() : i()(this.selector.clearButton).hide(), this.applyApi();
                        },
                    },
                    {
                        key: "setSearchValue",
                        value: function (t) {
                            if (t && t.target) {
                                var e = u.a.stripHtml(t.target.value);
                                (e = "function" == typeof e.toString ? e.toLowerCase().trim() : ""), (this.searchValue = e);
                            } else this.searchValue = "";
                        },
                    },
                    {
                        key: "onClickClearButton",
                        value: function () {
                            i()(this.selector.searchInput).val(""), (this.searchValue = ""), i()(this.selector.clearButton).hide(), this.applyApi(), this.afterClear();
                        },
                    },
                    { key: "afterClear", value: function () {} },
                    {
                        key: "applyApi",
                        value: function () {
                            Z.default.setParam("q", this.searchValue), Z.default.setParam("page", 1), Z.default.applyFilter("incollection_search");
                        },
                    },
                ]) && Xt(e.prototype, r),
                n && Xt(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(d.a);
        function ie(t) {
            return (ie =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function oe(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ie(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ie(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ie(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ae(t, e) {
            return (ae = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function le(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ce(t);
                if (e) {
                    var i = ce(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return se(this, r);
            };
        }
        function se(t, e) {
            if (e && ("object" === ie(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function ce(t) {
            return (ce = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ue = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ae(t, e);
            })(c, t);
            var e,
                r,
                n,
                s = le(c);
            function c() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((t = s.call(this)).data = null),
                    (l.a.currentTerm = u.a.stripHtml(u.a.getSearchTerm())),
                    (t.$searchResultHeader = i()("." + q.a.searchResultHeader)),
                    (t.$searchResultNumber = i()("." + q.a.searchResultNumber)),
                    t
                );
            }
            return (
                (e = c),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            l.a.currentTerm && (this.searchTerm = u.a.stripHtml(l.a.currentTerm.trim()));
                        },
                    },
                    {
                        key: "compileSEOTitleTemplate",
                        value: function () {
                            var t = this.data.total_product <= 1 ? a.a.search.seoTitleOne : a.a.search.seoTitleOther;
                            return t && (t = t.replace(/{{ count }}/g, u.a.stripHtml(this.data.total_product)).replace(/{{ terms }}/g, u.a.stripHtml(this.searchTerm))), t;
                        },
                    },
                    {
                        key: "compileSearchResultHeader",
                        value: function () {
                            if (this.searchTerm) var t = a.a.search.resultHeader;
                            else t = a.a.search.generalTitle;
                            return t.replace(/{{ terms }}/g, u.a.stripHtml(this.searchTerm));
                        },
                    },
                    {
                        key: "compileSearchResultNumber",
                        value: function () {
                            var t = "";
                            return (
                                this.searchTerm && (t = a.a.search.resultNumber),
                                t.replace(/{{ count }}/g, "<strong>" + u.a.stripHtml(this.data.total_product) + "</strong>").replace(/{{ terms }}/g, "<strong>" + u.a.stripHtml(this.searchTerm) + "</strong>")
                            );
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return !!this.data;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this._buildSEOTitle(), this._buildSearchResultHeader(), this._buildSearchResultNumber();
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            t && (this.data = t);
                        },
                    },
                    {
                        key: "_buildSEOTitle",
                        value: function () {
                            if (this.searchTerm && "" !== this.searchTerm) {
                                var t = o.a.getSettingValue("search.enableFixHeadTitle"),
                                    e = this.compileSEOTitleTemplate();
                                document.title = t && e ? e.replace(/&quot;/g, '"') : document.title.replace(/[0-9]+/, u.a.stripHtml(this.data.total_product));
                            }
                        },
                    },
                    {
                        key: "_buildSearchResultHeader",
                        value: function () {
                            var t = this.compileSearchResultHeader();
                            this.$searchResultHeader.html(t);
                        },
                    },
                    {
                        key: "_buildSearchResultNumber",
                        value: function () {
                            var t = this.compileSearchResultNumber();
                            this.$searchResultNumber.html(t);
                        },
                    },
                ]) && oe(e.prototype, r),
                n && oe(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        function pe(t) {
            return (pe =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function fe(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function he(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== pe(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== pe(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === pe(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ye(t, e) {
            return (ye = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function de(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ge(t);
                if (e) {
                    var i = ge(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return me(this, r);
            };
        }
        function me(t, e) {
            if (e && ("object" === pe(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function ge(t) {
            return (ge = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var be = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ye(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = de(a);
            function a() {
                return fe(this, a), o.apply(this, arguments);
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            return "";
                        },
                    },
                    {
                        key: "buildBreadcrumb",
                        value: function () {
                            if (((this.collectionData = this.parent.collectionData), this.collectionData && this.collectionData.collection)) {
                                var t = i()(s.a.breadcrumb);
                                t.length && t.html(this.compileTemplate());
                            }
                        },
                    },
                ]) && he(e.prototype, r),
                n && he(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function ve(t) {
            return (ve =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Se(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ve(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ve(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ve(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Oe(t, e) {
            return (Oe = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Pe(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = we(t);
                if (e) {
                    var i = we(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Te(this, r);
            };
        }
        function Te(t, e) {
            if (e && ("object" === ve(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function we(t) {
            return (we = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var _e = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Oe(t, e);
            })(c, t);
            var e,
                r,
                n,
                s = Pe(c);
            function c() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((t = s.call(this)).data = null),
                    (t.defaultCollectionData = { collection: { description: "", handle: o.a.getSettingValue("general.collection_handle"), title: a.a.collectionAll } }),
                    (t.collectionData = {}),
                    (t.$collectionHeader = i()("." + q.a.collectionHeader)),
                    (t.$collectionDescription = i()("." + q.a.collectionDescription)),
                    (t.$collectionImage = i()("." + q.a.collectionImage)),
                    t
                );
            }
            return (
                (e = c),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            (this.breadcrumb = new be()), this.addComponent(this.breadcrumb);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return !!this.data && ("collection" == this.parent.eventType || "history" == this.parent.eventType);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = window.location.pathname;
                            if (t && "/" != t) {
                                if ("/collections/all" == t) this.collectionData = this.defaultCollectionData;
                                else if (u.a.isVendorPage() || u.a.isTypePage()) this.collectionData = { collection: { description: "", handle: "", title: u.a.stripHtml(u.a.getSearchTerm()) } };
                                else if (!u.a.isSearchPage()) {
                                    var e = u.a.getWindowLocation().href.split("?")[0] + "?view=desc";
                                    i.a.ajax({ method: "GET", url: e, dataType: "json", success: this._onGetCollectionDataSuccess.bind(this), error: this._onGetCollectionDataError.bind(this) });
                                }
                                this._buildPageInfo();
                            }
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            t && (this.data = t);
                        },
                    },
                    {
                        key: "_buildPageInfo",
                        value: function () {
                            this.breadcrumb && this.breadcrumb.buildBreadcrumb(), this.buildCollectionDetail(), this.buildDocumentInfo();
                        },
                    },
                    {
                        key: "buildCollectionDetail",
                        value: function () {
                            if (void 0 !== this.collectionData && this.collectionData.hasOwnProperty("collection")) {
                                var t = this.collectionData.collection,
                                    e = t.hasOwnProperty("title") && "" != t.title ? t.title : null,
                                    r = t.hasOwnProperty("description") && "" != t.description ? t.description : null,
                                    n = t.hasOwnProperty("image") && t.image && t.image.src ? t.image.src : null;
                                e ? this.$collectionHeader.html(u.a.stripHtml(e)).show() : this.$collectionHeader.hide(),
                                    r ? this.$collectionDescription.html(r).show() : this.$collectionDescription.hide(),
                                    n && !u.a.isBadUrl(n)
                                        ? this.$collectionImage
                                              .attr("src", n)
                                              .css("background-image", "url(" + n + ")")
                                              .removeClass(q.a.collectionNoImage)
                                              .addClass(q.a.collectionHasImage)
                                        : this.$collectionImage
                                              .attr("src", "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==")
                                              .css("background-image", "none")
                                              .removeClass(q.a.collectionHasImage)
                                              .addClass(q.a.collectionNoImage);
                            }
                        },
                    },
                    {
                        key: "buildDocumentInfo",
                        value: function () {
                            if (void 0 !== this.collectionData && this.collectionData.hasOwnProperty("collection")) {
                                var t = this.collectionData.collection.title + " - " + l.a.shopName;
                                document.title = t;
                            }
                        },
                    },
                    {
                        key: "_onGetCollectionDataSuccess",
                        value: function (t) {
                            (this.collectionData = t), this._buildPageInfo();
                        },
                    },
                    {
                        key: "_onGetCollectionDataError",
                        value: function () {
                            (this.collectionData = this.defaultCollectionData), this._buildPageInfo();
                        },
                    },
                ]) && Se(e.prototype, r),
                n && Se(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        function Ce(t) {
            return (Ce =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ke(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ce(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ce(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ce(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ee(t, e) {
            return (Ee = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Re(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = je(t);
                if (e) {
                    var i = je(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Ie(this, r);
            };
        }
        function Ie(t, e) {
            if (e && ("object" === Ce(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function je(t) {
            return (je = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Le = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ee(t, e);
            })(s, t);
            var e,
                r,
                n,
                a = Re(s);
            function s() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, s),
                    ((t = a.call(this)).selecor = { robots: 'meta[content="noindex,nofollow,nosnippet"]' }),
                    (t.currentCollection = boostPFSConfig.general.collection_handle),
                    (t.settings = { boostCollection: o.a.getSettingValue("general.boostCollection") }),
                    t
                );
            }
            return (
                (e = s),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<meta name="robots" content="noindex,nofollow,nosnippet">\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate();
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return (
                                o.a.getSettingValue("general.enableSeo") &&
                                !i()(this.selecor.robots).length &&
                                (0 == this.currentCollection.indexOf(this.settings.boostCollection) || u.a.checkExistFilterOptionParam() || (l.a.queryParams.q && !u.a.isSearchPage()))
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            i()("head").append(this.compileTemplate());
                        },
                    },
                ]) && ke(e.prototype, r),
                n && ke(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(d.a);
        function Be(t) {
            return (Be =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ae(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Be(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Be(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Be(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function xe(t, e) {
            return (xe = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Fe(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = De(t);
                if (e) {
                    var i = De(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return $e(this, r);
            };
        }
        function $e(t, e) {
            if (e && ("object" === Be(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function De(t) {
            return (De = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Me = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && xe(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = Fe(p);
            function p() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((t = c.call(this)).$loadMoreContainer = null),
                    (t.$defaultElement = i()(s.a.pagination)),
                    (t.$element = i()(s.a.loadMore)),
                    (t.selector = { loadMoreButton: "." + q.a.productLoadMore + "-button", loadMoreTotal: s.a.loadMore + "-total" }),
                    (t.settings.sessionStorageCurrentNextPage = o.a.getSettingValue("general.sessionStorageCurrentNextPage")),
                    (t.settings.sessionStoragePreviousPageEvent = o.a.getSettingValue("general.sessionStoragePreviousPageEvent")),
                    t
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case "total":
                                    return '\n\t\t\t\t\t<div class="{{class.productLoadMore}}-total">{{progressLabel}}</div>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t{{loadMoreProgress}}\n\t\t\t\t\t<div class="{{class.productLoadMore}}-button-container">\n\t\t\t\t\t\t<button aria-label="{{label.loadMore}}" class="{{class.productLoadMore}}-button">{{label.loadMore}}</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="{{class.productLoadMore}}-loading" style="display: none;">\n\t\t\t\t\t\t<div class="{{class.productLoadMore}}-icon"></div>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = this.compileTotalTemplate();
                            (l.a.queryParams.page && !isNaN(l.a.queryParams.page)) || (l.a.queryParams.page = 1);
                            var e = this.totalProduct - l.a.queryParams.page * l.a.queryParams.limit;
                            return (
                                (e = Math.min(e, l.a.queryParams.limit)),
                                this.getTemplate()
                                    .replace(/{{loadMoreProgress}}/g, t)
                                    .replace(/{{label.loadMore}}/g, a.a.loadMore)
                                    .replace(/{{class.productLoadMore}}/g, q.a.productLoadMore)
                                    .replace(/{{ amountProduct }}/g, e)
                            );
                        },
                    },
                    {
                        key: "compileTotalTemplate",
                        value: function () {
                            (l.a.queryParams.page && !isNaN(l.a.queryParams.page)) || (l.a.queryParams.page = 1),
                                (l.a.queryParams.limit && !isNaN(l.a.queryParams.limit)) || (l.a.queryParams.limit = 20),
                                u.a.isLoadPreviousPagePaginationType() && "page" == this.parent.eventType
                                    ? (this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage)))
                                    : (this.nextPage = l.a.queryParams.page);
                            var t = (this.nextPage - 1) * l.a.queryParams.limit + 1,
                                e = i()(s.a.products + " > *:not(script):not(style)").length;
                            e && (t -= e - l.a.queryParams.limit), (this.fromProduct = t);
                            var r = (this.nextPage - 1) * l.a.queryParams.limit + 1 + this.data.products.length - 1;
                            return (
                                (this.toProduct = r),
                                this.getTemplate("total")
                                    .replace(/{{progressLabel}}/g, a.a.loadMoreTotal)
                                    .replace(/{{ from }}/g, this.fromProduct)
                                    .replace(/{{ to }}/g, this.toProduct)
                                    .replace(/{{ total }}/g, this.totalProduct)
                                    .replace(/{{class.productLoadMore}}/g, q.a.productLoadMore)
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$defaultElement.empty();
                            var t = l.a.queryParams,
                                e = this.compileTemplate();
                            if ((this.$element.html(e), i()(s.a.loadMoreButtonContainer).length > 0)) {
                                var r = this.compileTotalTemplate();
                                i()(this.selector.loadMoreTotal).replaceWith(r);
                            }
                            (this.$loadMoreContainer = i()(s.a.loadMoreButtonContainer)), this.hideLoading();
                            var n = Math.ceil(this.totalProduct / t.limit);
                            parseInt(t.page) < n && this.toProduct < this.totalProduct ? (this.$element.show(), this.$loadMoreContainer.show()) : this.$element.hide();
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            u.a.isLoadPreviousPagePaginationType() ? (this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage))) : (this.nextPage = l.a.queryParams.page),
                                this.$element.find(this.selector.loadMoreButton).off("click").on("click", this._onClickEvent.bind(this));
                        },
                    },
                    {
                        key: "_onClickEvent",
                        value: function (t) {
                            if (
                                (t.preventDefault(),
                                this.$loadMoreContainer.hide(),
                                this.showLoading(),
                                this.nextPage++,
                                (l.a.internalClick = !0),
                                Z.default.setParam("limit", l.a.queryParams.limit),
                                Z.default.setParam("page", this.nextPage),
                                u.a.FilterResult.isAdvancedPaginationType())
                            )
                                u.a.isLoadPreviousPagePaginationType() &&
                                    (window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, this.nextPage), window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 0)),
                                    Z.default.applyFilter("page");
                            else {
                                var e = tp.instance.filter;
                                Z.default.getFilterData("page", e.setData.bind(e));
                            }
                        },
                    },
                ]) && Ae(e.prototype, r),
                n && Ae(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(ht);
        function Ve(t) {
            return (Ve =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ne(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ve(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ve(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ve(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function He(t, e) {
            return (He = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ue(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = qe(t);
                if (e) {
                    var i = qe(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return We(this, r);
            };
        }
        function We(t, e) {
            if (e && ("object" === Ve(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function qe(t) {
            return (qe = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ge = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && He(t, e);
            })(c, t);
            var e,
                r,
                n,
                a = Ue(c);
            function c() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((t = a.call(this)).$element = i()(s.a.bottomPagination)),
                    (t.settings.positionShowInfiniteLoading = o.a.getSettingValue("general.positionShowInfiniteLoading")),
                    (t.settings.sessionStorageCurrentNextPage = o.a.getSettingValue("general.sessionStorageCurrentNextPage")),
                    (t.settings.sessionStoragePreviousPageEvent = o.a.getSettingValue("general.sessionStoragePreviousPageEvent")),
                    t
                );
            }
            return (
                (e = c),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.productLoadMore}}-loading" style="display: none;">\n\t\t\t\t<div class="{{class.productLoadMore}}-icon"></div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate().replace(/{{class.productLoadMore}}/g, q.a.productLoadMore);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return null !== this.data && X.isPanelActive(at.Enum.PRODUCT);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            if ((this.$element.empty(), this.$element.show(), 0 == this.$loadMore.find(s.a.loadMoreLoading).length)) {
                                var t = this.compileTemplate();
                                this.$loadMore.prepend(t), this.$loadMore.show();
                            }
                            this.hideLoading();
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            u.a.isLoadPreviousPagePaginationType() ? (this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage))) : (this.nextPage = l.a.queryParams.page),
                                this.totalProduct > l.a.queryParams.limit * this.nextPage && ((this.scrolling = !1), (this.scrollToBottom = !1), this.$element.length > 0 && i()(window).on("scroll", this._onScrollEvent.bind(this)));
                        },
                    },
                    {
                        key: "_onScrollEvent",
                        value: function (t) {
                            if ((t.preventDefault(), t.stopPropagation(), i()(s.a.products).hasClass(q.a.productWrapLoading) || !X.isPanelActive(at.Enum.PRODUCT))) return !1;
                            this._isScrollToBottom() && this._loadMoreProducts();
                        },
                    },
                    {
                        key: "_isScrollToBottom",
                        value: function () {
                            var t = window.innerHeight * (window.innerHeight / i()(document).outerHeight()),
                                e = parseInt(this.$element.offset().top),
                                r = window.pageYOffset,
                                n = parseInt(r) + t + parseInt(this.settings.positionShowInfiniteLoading);
                            return r + window.innerHeight + t >= i()(document).outerHeight() - 100 && (this.scrollToBottom = !0), !this.scrolling && this.data.products.length > 0 && (n >= e || (n < e && this.scrollToBottom));
                        },
                    },
                    {
                        key: "_loadMoreProducts",
                        value: function () {
                            if (this.parent._productPaginationInfiniteShouldLoadmore()) {
                                this.showLoading(), (this.scrolling = !0), this.nextPage++;
                                var t = Math.ceil(this.totalProduct / l.a.queryParams.limit);
                                if (this.nextPage <= t)
                                    if (((l.a.internalClick = !0), Z.default.setParam("limit", l.a.queryParams.limit), Z.default.setParam("page", this.nextPage), u.a.FilterResult.isAdvancedPaginationType()))
                                        u.a.isLoadPreviousPagePaginationType() &&
                                            (window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, this.nextPage), window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 0)),
                                            Z.default.applyFilter("page");
                                    else {
                                        var e = tp.instance.filter;
                                        Z.default.getFilterData("page", e.setData.bind(e));
                                    }
                            }
                        },
                    },
                ]) && Ne(e.prototype, r),
                n && Ne(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(ht);
        function ze(t) {
            return (ze =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ke(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ze(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ze(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ze(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ye(t, e) {
            return (Ye = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Qe(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Xe(t);
                if (e) {
                    var i = Xe(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Je(this, r);
            };
        }
        function Je(t, e) {
            if (e && ("object" === ze(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Xe(t) {
            return (Xe = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ze = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ye(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = Qe(p);
            function p() {
                var t;
                !(function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, p),
                    ((t = c.call(this)).$wrapper = i()(s.a.btnLoadPreviousPageWrapperSelector)),
                    (t.$element = i()(s.a.btnLoadPreviousPageSelector)),
                    (t.$productList = i()(s.a.products)),
                    (t.settings.sessionStorageCurrentPreviousPage = o.a.getSettingValue("general.sessionStorageCurrentPreviousPage")),
                    (t.settings.sessionStorageCurrentPage = o.a.getSettingValue("general.sessionStorageCurrentPage")),
                    (t.settings.sessionStorageCurrentNextPage = o.a.getSettingValue("general.sessionStorageCurrentNextPage")),
                    (t.settings.sessionStoragePreviousPageEvent = o.a.getSettingValue("general.sessionStoragePreviousPageEvent"));
                var e = o.a.getSettingValue("general.loadPreviousType");
                return (t.settings.loadPreviousType = e || o.a.getSettingValue("general.paginationType")), (t.state = { isLoading: !1, lastScrollPos: window.scrollY }), t;
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            Z.default.addAfterApplyFilter(this.doneLoadPreviousPage.bind(this));
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.buttonLoadPreviousPageSelector}}">\n\t\t\t\t<span aria-label="{{label.loadPreviousPage}}" class="js-{{class.buttonLoadPreviousPageSelector}}">{{label.loadPreviousPage}}</span>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getWrapperTemplate",
                        value: function () {
                            return '<div class="{{class.buttonLoadPreviousPageWrapper}}"></div>'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{class.buttonLoadPreviousPageSelector}}/g, q.a.buttonLoadPreviousPageSelector)
                                .replace(/{{label.loadPreviousPage}}/g, a.a.loadPreviousPage);
                        },
                    },
                    {
                        key: "compileWrapperTemplate",
                        value: function () {
                            return this.getWrapperTemplate().replace(/{{class.buttonLoadPreviousPageWrapper}}/g, q.a.buttonLoadPreviousPageWrapper);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return this.data && u.a.isLoadPreviousPagePaginationType() && "page" != this.parent.eventType;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$wrapper.length || ((this.$wrapper = i()(this.compileWrapperTemplate())), this.$wrapper.insertBefore(this.$productList)),
                                this.$element.length || ((this.$element = i()(this.compileTemplate())), this.$wrapper.append(this.$element));
                            var t = Math.ceil(this.totalProduct / l.a.queryParams.limit),
                                e = l.a.queryParams.page,
                                r = t > 1 && e > 1;
                            window.sessionStorage.setItem(this.settings.sessionStorageCurrentPreviousPage, e),
                                window.sessionStorage.setItem(this.settings.sessionStorageCurrentPage, e),
                                window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, e),
                                window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 1),
                                r && this.settings.loadPreviousType == ht.Type.LOAD_MORE ? this.$wrapper.show() : (this.$wrapper.hide(), u.a.isiOS() && (this.state.isLoading = !1));
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return u.a.isLoadPreviousPagePaginationType();
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.settings.loadPreviousType == ht.Type.LOAD_MORE
                                ? (this.$element.off("click"), this.$element.on("click", this._onClickEvent.bind(this)))
                                : this.settings.loadPreviousType != ht.Type.INFINITE || this.isBoundEvent || i()(document).on("scroll", this._onScrollEvent.bind(this));
                        },
                    },
                    {
                        key: "_onClickEvent",
                        value: function (t) {
                            t && t.preventDefault(), this.loadPreviousPage();
                        },
                    },
                    {
                        key: "_onScrollEvent",
                        value: function (t) {
                            if (!this.state.isLoading) {
                                var e = window.scrollY,
                                    r = this.$productList.offset().top;
                                e < this.state.lastScrollPos && e < r + 100 ? ((this.state.isLoading = !0), this.loadPreviousPage()) : (this.state.lastScrollPos = e);
                            }
                        },
                    },
                    {
                        key: "loadPreviousPage",
                        value: function () {
                            var t = l.a.queryParams.page;
                            if (
                                (null !== window.sessionStorage.getItem(this.settings.sessionStorageCurrentPreviousPage)
                                    ? (this.currentPreviousPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentPreviousPage)))
                                    : (this.currentPreviousPage = t),
                                this.currentPreviousPage < 2)
                            )
                                return this.$wrapper.hide(), !1;
                            (l.a.internalClick = !0),
                                Z.default.setParam("limit", l.a.queryParams.limit),
                                this.currentPreviousPage--,
                                window.sessionStorage.setItem(this.settings.sessionStorageCurrentPreviousPage, this.currentPreviousPage),
                                window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 1),
                                Z.default.setParam("page", this.currentPreviousPage),
                                Z.default.applyFilter("page", "previous"),
                                this.currentPreviousPage < 2 && this.$wrapper.hide();
                        },
                    },
                    {
                        key: "doneLoadPreviousPage",
                        value: function (t, e, r) {
                            var n = this;
                            "page" == e &&
                                "previous" == r &&
                                this.settings.loadPreviousType == ht.Type.INFINITE &&
                                setTimeout(function () {
                                    var t = l.a.queryParams.page + 1,
                                        e = i()(s.a.products + ' [data-page="' + t + '"]');
                                    if (e.length > 0) {
                                        var r = parseInt(e.offset().top - 100);
                                        window.scrollTo(0, r);
                                    }
                                    n.state.isLoading = !1;
                                }, 200);
                        },
                    },
                ]) && Ke(e.prototype, r),
                n && Ke(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(ht);
        function tr(t) {
            return (tr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function er(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== tr(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== tr(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === tr(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function rr(t, e) {
            return (rr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function nr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = or(t);
                if (e) {
                    var i = or(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ir(this, r);
            };
        }
        function ir(t, e) {
            if (e && ("object" === tr(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function or(t) {
            return (or = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ar = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && rr(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = nr(a);
            function a(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    (r = o.call(this)),
                    t || (t = s.a.searchPagePagination),
                    (r.type = e),
                    (r.$element = i()(t)),
                    (r.$productList = i()(s.a.products)),
                    (r.filterResult = r.parent),
                    r
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "isRender",
                        value: function () {
                            return l.a.hasOwnProperty("searchDisplay") && l.a.searchDisplay === this.type;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element.html(this.compileTemplate());
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element.show(), this.$element.find("a").off("click"), this.$element.find("a").on("click", this._onClickEvent.bind(this));
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e, r, n) {
                            t && (this.data = t);
                            var i = this.parent.searchResultPanels.children,
                                o = this.type;
                            (this.panelItem = i.find(function (t) {
                                return t.type == o;
                            })),
                                (this.totalProduct = e),
                                (this.limit = r),
                                (this.page = n),
                                (this.paginationType = Settings.getSettingValue("general.paginationType"));
                        },
                    },
                    {
                        key: "_onClickEvent",
                        value: function (t) {
                            t.preventDefault(), (l.a.internalClick = !0);
                            var e = new URL(i()(t.currentTarget).attr("href")).searchParams.get("page");
                            (e && !isNaN(e)) || (e = 1),
                                Z.default.setParam("page", e),
                                Z.default.setParam("limit", this.limit),
                                Z.default.getFilterData("search", this.panelItem._searchPanelCallback.bind(this.panelItem)),
                                window.scrollTo({ top: this.$productList.offset().top - 50, behavior: "smooth" });
                        },
                    },
                ]) && er(e.prototype, r),
                n && er(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(Rt);
        function lr(t) {
            return (lr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function sr(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== lr(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== lr(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === lr(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function cr(t, e) {
            return (cr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function ur(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = fr(t);
                if (e) {
                    var i = fr(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return pr(this, r);
            };
        }
        function pr(t, e) {
            if (e && ("object" === lr(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function fr(t) {
            return (fr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var hr = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && cr(t, e);
            })(c, t);
            var e,
                r,
                n,
                a = ur(c);
            function c() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((t = a.call(this)).$productList = i()(s.a.products)),
                    (t.$element = []),
                    (t.isFetchedProductData = !1),
                    (t.settings = {
                        showPlaceholderProductList: o.a.getSettingValue("general.showPlaceholderProductList"),
                        placeholderImageRatio: o.a.getSettingValue("general.placeholderImageRatio"),
                        productGridClass: o.a.getSettingValue("custom.product_grid_class"),
                        placeholderProductGridItemClass: o.a.getSettingValue("general.placeholderProductGridItemClass"),
                        productsPerRow: o.a.getSettingValue("custom.products_per_row"),
                        placeholderProductPerRow: o.a.getSettingValue("general.placeholderProductPerRow"),
                        sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent"),
                    }),
                    t
                );
            }
            return (
                (e = c),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            (this.eventType = this.parent.eventType), Z.default.addBeforeApplyFilter(this.renderBeforeApplyFilter.bind(this));
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{wrapperClass}} {{class.filterProductSkeleton}}">\n\t\t\t\t<div class="{{class.filterProductSkeleton}}-image" style="padding-top: {{paddingTop}}%"></div>\n\t\t\t\t<div class="{{class.filterProductSkeleton}}-meta">\n\t\t\t\t\t<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}"></span>\n\t\t\t\t\t<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return void 0 !== l.a.queryParams.display && "grid" != l.a.queryParams.display && this.compileTemplateExtra ? this.compileTemplateExtra() : this.compileTemplateGridType();
                        },
                    },
                    {
                        key: "compileTemplateGridType",
                        value: function () {
                            var t = parseFloat(this.settings.placeholderImageRatio),
                                e = t > 0 ? t : 1.4,
                                r = "";
                            return (
                                "" == (r = this.settings.productGridClass && "" !== this.settings.productGridClass ? this.settings.productGridClass : this.settings.placeholderProductGridItemClass) &&
                                    (r = this.$productList.children().length > 0 ? u.a.stripHtml(this.$productList.children().first().attr("class")) : q.a.filterSkeleton + "-def-width"),
                                this.getTemplate()
                                    .replace(/{{class.filterProductSkeleton}}/g, q.a.filterProductSkeleton)
                                    .replace(/{{class.filterSkeleton}}/g, q.a.filterSkeleton)
                                    .replace(/{{class.filterSkeletonText}}/g, q.a.filterSkeletonText)
                                    .replace(/{{paddingTop}}/g, 100 * e)
                                    .replace(/{{wrapperClass}}/g, r)
                            );
                        },
                    },
                    {
                        key: "compileTemplateExtra",
                        value: function () {
                            return !1;
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            var t = u.a.getDefaultSorting();
                            return (
                                this.settings.showPlaceholderProductList &&
                                X.isPanelActive(at.Enum.PRODUCT) &&
                                (!l.a.loadProductFirst ||
                                    !u.a.isCollectionPage() ||
                                    u.a.isVendorPage() ||
                                    u.a.isTagPage() ||
                                    u.a.isTypePage() ||
                                    ("" != t && t != o.a.getSettingValue("general.default_sort_by")) ||
                                    ("best-selling" === l.a.defaultSorting && !o.a.getSettingValue("general.loadProductFirstBestSelling")) ||
                                    l.a.defaultSorting.startsWith("extra") ||
                                    o.a.getSettingValue("general.productAndVariantAvailable") ||
                                    o.a.getSettingValue("general.sortingAvailableFirst") ||
                                    l.a.hasFilterByLocation ||
                                    (l.a.loadProductFirst && (l.a.hasFilterOptionParam || "init" != this.eventType)) ||
                                    o.a.getSettingValue("general.enableVariantsDisplay"))
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this.settings.productsPerRow || this.settings.placeholderProductPerRow,
                                e = this.compileTemplate();
                            this.$element = [];
                            for (var r = 0; r < t; r++) this.$element.push(i()(e));
                            var n = this.parent.productList,
                                o = n.settings.loadProductFromLiquid && n.settings.loadProductFromLiquidType == ProductList.Enum.loadProductType.AJAX;
                            this.isFetchedProductData ? (o && !n.isFetchedAjaxProductData) || this.setHide() : this.setShow();
                        },
                    },
                    {
                        key: "renderBeforeApplyFilter",
                        value: function (t) {
                            (this.eventType = t), this.refresh();
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            t && this.isRender() && (this.isFetchedProductData = !0);
                        },
                    },
                    {
                        key: "setShow",
                        value: function () {
                            var t = this;
                            this.$productList.addClass(q.a.productWrapLoading),
                                this.$productList.css("min-height", this.$productList.height()),
                                (u.a.isDefaultPaginationType() || (!u.a.isDefaultPaginationType() && "page" !== this.eventType)) && this.$productList.html(""),
                                u.a.isLoadPreviousPagePaginationType() && parseInt(window.sessionStorage.getItem(this.settings.sessionStoragePreviousPageEvent))
                                    ? this.$element.forEach(function (e) {
                                          return t.$productList.prepend(e);
                                      })
                                    : this.$element.forEach(function (e) {
                                          return t.$productList.append(e);
                                      });
                        },
                    },
                    {
                        key: "setHide",
                        value: function () {
                            var t = this;
                            this.$productList.find("." + q.a.filterProductSkeleton).remove(),
                                setTimeout(function () {
                                    t.$productList.removeClass(q.a.productWrapLoading), t.$productList.css("min-height", 0);
                                }),
                                (this.isFetchedProductData = !1);
                        },
                    },
                ]) && sr(e.prototype, r),
                n && sr(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        function yr(t) {
            return (yr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function dr(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== yr(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== yr(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === yr(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function mr(t, e) {
            return (mr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function gr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = vr(t);
                if (e) {
                    var i = vr(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return br(this, r);
            };
        }
        function br(t, e) {
            if (e && ("object" === yr(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function vr(t) {
            return (vr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Sr = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && mr(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = gr(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).data = null),
                    (t.id = null),
                    (t.index = 0),
                    (t.$element = null),
                    (t.displayImage = !0),
                    (t.displayExcerpt = !1),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = this.data.hasOwnProperty("url") ? this.data.url : "#",
                                e = "",
                                r = "",
                                n = "";
                            if (
                                (this.displayImage &&
                                    (this.data.image && this.data.image.hasOwnProperty("src") && "" !== this.data.image.src && (r = u.a.optimizeImage(this.data.image.src, "200x")),
                                    r.length > 0 && (e = this.getTemplate(kr.Enum.tempType.IMAGE))),
                                this.displayExcerpt && this.data.body_html && "string" == typeof this.data.body_html)
                            ) {
                                var i = u.a.stripHtml(this.data.body_html);
                                i.length > 264 && (i = i.substr(0, Settings.getSettingValue("search.pageExcerptLimitCharacter")) + "..."), (n = this.getTemplate(kr.Enum.tempType.EXCERPT).replace(/{{itemExcerpt}}/g, i));
                            }
                            return this.getTemplate()
                                .replace(/{{itemThumbnail}}/g, e)
                                .replace(/{{itemThumbSrc}}/g, r)
                                .replace(/{{itemDesc}}/g, n)
                                .replace(/{{class.filterResultItem}}/g, q.a.filterResultItem)
                                .replace(/{{itemUrl}}/g, t)
                                .replace(/{{itemTitle}}/g, u.a.stripHtml(this.data.title));
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element = i()(this.compileTemplate());
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            (this.data = t),
                                (this.id = t.id),
                                (this.index = e),
                                (this.displayImage = this.parent.panelData.hasOwnProperty("displayImage") && this.parent.panelData.displayImage),
                                (this.displayExcerpt = this.parent.panelData.hasOwnProperty("displayExcerpt") && this.parent.panelData.displayExcerpt);
                        },
                    },
                ]) && dr(e.prototype, r),
                n && dr(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function Or(t) {
            return (Or =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Pr(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Or(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Or(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Or(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Tr(t, e) {
            return (Tr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function wr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Cr(t);
                if (e) {
                    var i = Cr(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return _r(this, r);
            };
        }
        function _r(t, e) {
            if (e && ("object" === Or(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Cr(t) {
            return (Cr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var kr = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Tr(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = wr(o);
            function o() {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, o),
                    i.call(this)
                );
            }
            return (
                (e = o),
                (n = [
                    {
                        key: "Enum",
                        get: function () {
                            return { tempType: { ITEM: "page_item", IMAGE: "image", EXCERPT: "excerpt" } };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case o.Enum.tempType.IMAGE:
                                    return '\n\t\t\t\t\t<div class="{{class.filterResultItem}}-image">\n\t\t\t\t\t\t<img src="{{itemThumbSrc}}" alt="{{itemTitle}}" />\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                case o.Enum.tempType.EXCERPT:
                                    return '\n\t\t\t\t\t<p class="{{class.filterResultItem}}-description">\n\t\t\t\t\t\t{{itemExcerpt}}\n\t\t\t\t\t</p>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.filterResultItem}} {{class.filterResultItem}}-page">\n\t\t\t\t\t\t<a href="{{itemUrl}}" aria-label="{{itemTitle}}" title="{{itemTitle}}">\n\t\t\t\t\t\t\t{{itemThumbnail}}\n\t\t\t\t\t\t\t<div class="{{class.filterResultItem}}-content">\n\t\t\t\t\t\t\t\t<div class="{{class.filterResultItem}}-title">{{itemTitle}}</div>\n\t\t\t\t\t\t\t\t{{itemDesc}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                ]) && Pr(e.prototype, r),
                n && Pr(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(Sr);
        function Er(t) {
            return (Er =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Rr(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Er(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Er(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Er(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ir(t, e) {
            return (Ir = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function jr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Br(t);
                if (e) {
                    var i = Br(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Lr(this, r);
            };
        }
        function Lr(t, e) {
            if (e && ("object" === Er(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Br(t) {
            return (Br = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ar = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ir(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = jr(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).data = null),
                    (t.id = null),
                    (t.index = 0),
                    (t.$element = null),
                    (t.displayImage = !0),
                    (t.displayDescription = !1),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = "/collections/" + this.data.handle,
                                e = "",
                                r = "",
                                n = "";
                            if (
                                (this.displayImage &&
                                    (this.data.image && this.data.image.hasOwnProperty("src") && "" !== this.data.image.src && (r = u.a.optimizeImage(this.data.image.src, "200x")),
                                    r.length > 0 && (e = this.getTemplate(Nr.Enum.tempType.IMAGE))),
                                this.displayDescription && this.data.body_html && "string" == typeof this.data.body_html)
                            ) {
                                var i = u.a.stripHtml(this.data.body_html);
                                i.length > 264 && (i = i.substr(0, Settings.getSettingValue("search.collectionDescLimitCharacter")) + "..."), (n = this.getTemplate(Nr.Enum.tempType.DESCRIPTION).replace(/{{itemDescription}}/g, i));
                            }
                            return this.getTemplate()
                                .replace(/{{itemThumbnail}}/g, e)
                                .replace(/{{itemThumbSrc}}/g, r)
                                .replace(/{{itemDesc}}/g, n)
                                .replace(/{{class.filterResultItem}}/g, q.a.filterResultItem)
                                .replace(/{{itemUrl}}/g, t)
                                .replace(/{{itemTitle}}/g, u.a.stripHtml(this.data.title));
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element = i()(this.compileTemplate());
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            (this.data = t),
                                (this.id = t.id),
                                (this.index = e),
                                (this.displayImage = this.parent.panelData.hasOwnProperty("displayImage") && this.parent.panelData.displayImage),
                                (this.displayDescription = this.parent.panelData.hasOwnProperty("displayDescription") && this.parent.panelData.displayDescription);
                        },
                    },
                ]) && Rr(e.prototype, r),
                n && Rr(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function xr(t) {
            return (xr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Fr(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== xr(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== xr(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === xr(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function $r(t, e) {
            return ($r = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Dr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Vr(t);
                if (e) {
                    var i = Vr(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Mr(this, r);
            };
        }
        function Mr(t, e) {
            if (e && ("object" === xr(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Vr(t) {
            return (Vr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Nr = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && $r(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = Dr(o);
            function o() {
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, o),
                    i.call(this)
                );
            }
            return (
                (e = o),
                (n = [
                    {
                        key: "Enum",
                        get: function () {
                            return { tempType: { ITEM: "collection_item", IMAGE: "image", DESCRIPTION: "description" } };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case o.Enum.tempType.IMAGE:
                                    return '\n\t\t\t\t\t<div class="{{class.filterResultItem}}-image">\n\t\t\t\t\t\t<img src="{{itemThumbSrc}}" alt="{{itemTitle}}" />\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                case o.Enum.tempType.DESCRIPTION:
                                    return '\n\t\t\t\t\t<p class="{{class.filterResultItem}}-description">\n\t\t\t\t\t\t{{itemDescription}}\n\t\t\t\t\t</p>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.filterResultItem}} {{class.filterResultItem}}-collection">\n\t\t\t\t\t\t<a href="{{itemUrl}}" aria-label="{{itemTitle}}" title="{{itemTitle}}">\n\t\t\t\t\t\t\t{{itemThumbnail}}\n\t\t\t\t\t\t\t<div class="{{class.filterResultItem}}-content">\n\t\t\t\t\t\t\t\t<div class="{{class.filterResultItem}}-title">{{itemTitle}}</div>\n\t\t\t\t\t\t\t\t{{itemDesc}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                ]) && Fr(e.prototype, r),
                n && Fr(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(Ar);
        function Hr(t) {
            return (Hr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ur(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Hr(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Hr(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Hr(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Wr(t, e) {
            return (Wr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function qr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = zr(t);
                if (e) {
                    var i = zr(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Gr(this, r);
            };
        }
        function Gr(t, e) {
            if (e && ("object" === Hr(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function zr(t) {
            return (zr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Kr = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Wr(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = qr(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).$element = i()(s.a.collections)),
                    (t.data = null),
                    (t.totalCollection = 0),
                    (t.settings = { searchPanelBlocks: Settings.getSettingValue("search.searchPanelBlocks") }),
                    (t.panelData = {}),
                    t.settings.searchPanelBlocks.hasOwnProperty(at.Enum.COLLECTION) && (t.panelData = t.settings.searchPanelBlocks[at.Enum.COLLECTION]),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "isRender",
                        value: function () {
                            return null != this.data && X.isPanelActive(at.Enum.COLLECTION);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this,
                                e = [];
                            this.collectionItems.forEach(function (t) {
                                e.push(t.$element);
                            }),
                                this.$element.html(""),
                                e.forEach(function (e) {
                                    return t.$element.append(e);
                                });
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            var e = this;
                            t &&
                                t.collections &&
                                t.collections.length &&
                                ((this.data = t.collections),
                                (this.totalCollection = t.total_collection ? t.total_collection : 0),
                                (this.collectionItems = []),
                                this.data.forEach(function (t, r) {
                                    var n = new Nr();
                                    e.addComponent(n), n.setData(t), e.collectionItems.push(n);
                                }));
                        },
                    },
                ]) && Ur(e.prototype, r),
                n && Ur(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function Yr(t) {
            return (Yr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Qr(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Yr(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Yr(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Yr(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Jr(t, e) {
            return (Jr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Xr(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = tn(t);
                if (e) {
                    var i = tn(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Zr(this, r);
            };
        }
        function Zr(t, e) {
            if (e && ("object" === Yr(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function tn(t) {
            return (tn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var en = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Jr(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = Xr(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).$element = i()(s.a.pages)),
                    (t.data = null),
                    (t.totalPage = 0),
                    (t.settings = { searchPanelBlocks: Settings.getSettingValue("search.searchPanelBlocks") }),
                    (t.panelData = {}),
                    t.settings.searchPanelBlocks.hasOwnProperty(at.Enum.PAGE) && (t.panelData = t.settings.searchPanelBlocks[at.Enum.PAGE]),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "isRender",
                        value: function () {
                            return null != this.data && X.isPanelActive(at.Enum.PAGE);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            this.$element.html(""),
                                this.pageItems.forEach(function (e) {
                                    t.$element.append(e.$element);
                                });
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            var e = this;
                            t &&
                                t.pages &&
                                t.pages.length &&
                                ((this.data = t.pages),
                                (this.totalPage = t.total_page ? t.total_page : 0),
                                (this.pageItems = []),
                                this.data.forEach(function (t, r) {
                                    var n = new kr();
                                    e.addComponent(n), n.setData(t), e.pageItems.push(n);
                                }));
                        },
                    },
                ]) && Qr(e.prototype, r),
                n && Qr(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function rn(t) {
            return (rn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function nn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== rn(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== rn(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === rn(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function on(t, e) {
            return (on = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function an(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = sn(t);
                if (e) {
                    var i = sn(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ln(this, r);
            };
        }
        function ln(t, e) {
            if (e && ("object" === rn(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function sn(t) {
            return (sn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var cn = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && on(t, e);
            })(l, t);
            var e,
                r,
                n,
                o = an(l);
            function l() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((t = o.call(this)).$element = i()(s.a.searchTotalResult)),
                    (t.total = 0),
                    (t.panalType = at.Enum.PRODUCT),
                    t
                );
            }
            return (
                (e = l),
                (r = [
                    {
                        key: "compileTemplate",
                        value: function () {
                            return (this.total > 1 ? a.a.search.searchTotalResults : a.a.search.searchTotalResult).replace(/{{ count }}/g, "<strong>" + u.a.stripHtml(this.total) + "</strong>");
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this.compileTemplate();
                            this.$element.html(t);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            "number" == typeof t && (this.total = t), e && (this.panalType = e);
                        },
                    },
                ]) && nn(e.prototype, r),
                n && nn(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(d.a);
        r(52), r(53);
        function un(t) {
            return (un =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function pn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== un(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== un(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === un(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function fn(t, e) {
            return (fn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function hn(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = dn(t);
                if (e) {
                    var i = dn(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return yn(this, r);
            };
        }
        function yn(t, e) {
            if (e && ("object" === un(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function dn(t) {
            return (dn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var mn = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && fn(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = hn(a);
            function a() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((t = o.call(this)).data = null),
                    (t.id = null),
                    (t.totalProduct = null),
                    (t.$element = null),
                    t
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            window.BoostOTP && BoostOTP.OTPButtons.init(this);
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            if ("function" == typeof ProductGridItem) {
                                var t = new ProductGridItem();
                                t.data = this.data;
                                var e = t.compileTemplate().trim();
                                return (e = m.a.compileTemplate(e, this.data)), (e = m.a.compileIntegrationTemplate(this.data, e));
                            }
                            console.warn("Missing buildProductGridItem function in theme lib");
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element ||
                                ((this.$element = i()(this.compileTemplate())),
                                this.$element.addClass("boost-pfs-product-slider-item"),
                                u.a.isMobile() && (this.parent.productSliderRange = 2),
                                window.BoostOTP && BoostOTP.OTPButtons.render(this));
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            if (this.$element && this.parent.$element) {
                                var t = this.parent.$element.width() / this.parent.productSliderRange;
                                this.$element.css({ width: t + "px" }), window.BoostOTP && BoostOTP.OTPButtons.bindEvents(this);
                            }
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            this.data = t;
                        },
                    },
                ]) && pn(e.prototype, r),
                n && pn(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function gn(t) {
            return (gn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function bn(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function vn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== gn(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== gn(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === gn(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Sn(t, e) {
            return (Sn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function On(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Tn(t);
                if (e) {
                    var i = Tn(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Pn(this, r);
            };
        }
        function Pn(t, e) {
            if (e && ("object" === gn(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Tn(t) {
            return (Tn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var wn = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Sn(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = On(a);
            function a() {
                return bn(this, a), o.apply(this, arguments);
            }
            return (
                (e = a),
                (n = [
                    {
                        key: "ProductSliderType",
                        get: function () {
                            return { MOST_POPULAR: "most-popular", RECENTLY_VIEWED: "recently-viewed" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n    <div class="boost-pfs-product-slider">\n\t\t\t\t<div class="boost-pfs-product-slider-inner">\n\t\t\t\t\t<div class="boost-pfs-product-slider-item-wrapper"></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-product-slider-nav">\n\t\t\t\t\t<div class="boost-pfs-product-slider-prev boost-pfs-product-slider-nav-btn-disabled"></div>\n          <div class="boost-pfs-product-slider-next"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n    '.trim();
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            if (i()(this.selector).length > 0) {
                                (this.$element = i()(this.getTemplate())),
                                    this.children.length > 0 &&
                                        ((this.$productSlider = this.$element.find(".boost-pfs-product-slider-item-wrapper")),
                                        this.children.forEach(function (e) {
                                            t.$productSlider.append(e.$element);
                                        })),
                                    i()(this.selector).first().html("").append(this.$element),
                                    m.a.call3rdAppFunction(this.data),
                                    m.a.call3rdIntegrationFunc(this.data);
                                var e = Settings.getSettingValue("actionlist.alStyle");
                                this.$element.hasClass(e) || this.$element.addClass(e);
                            }
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.initImageSlider();
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e) {
                            var r = this;
                            (this.data = t),
                                (this.children = []),
                                this.data.products.forEach(function (t) {
                                    var e = new mn();
                                    e.setData(t), r.addComponent(e);
                                }),
                                e && this.refresh();
                        },
                    },
                    {
                        key: "initImageSlider",
                        value: function () {
                            var t = this.$element.find(".boost-pfs-product-slider-item-wrapper"),
                                e = this.$element.find(".boost-pfs-product-slider-nav"),
                                r = this.$element.find(".boost-pfs-product-slider-item"),
                                n = this.$element.find(".boost-pfs-product-slider-prev"),
                                i = this.$element.find(".boost-pfs-product-slider-next");
                            0 != t.length &&
                                0 != r.length &&
                                ((this.imageSlider = {
                                    $itemsWrapper: t,
                                    $sliderNavWrapper: e,
                                    $prev: n,
                                    $next: i,
                                    posX1: 0,
                                    posX2: 0,
                                    posInitial: 0,
                                    posFinal: 0,
                                    threshold: 50,
                                    slidesLength: r.length,
                                    slideSize: r[0].style.width.replace("px", ""),
                                    index: 0,
                                    allowShift: !0,
                                    isDragging: !1,
                                }),
                                0 == this.imageSlider.index && this.imageSlider.$prev.addClass("boost-pfs-product-slider-nav-btn-disabled"),
                                (this.imageSlider.index == this.imageSlider.slidesLength - 1 || this.imageSlider.slidesLength <= this.productSliderRange) &&
                                    (this.imageSlider.$next.addClass("boost-pfs-product-slider-nav-btn-disabled"), this.imageSlider.$sliderNavWrapper.addClass("boost-pfs-product-slider-nav-disabled")),
                                this.imageSlider.$itemsWrapper.css("left", "0px"),
                                this.imageSlider.slidesLength <= this.productSliderRange ||
                                    (this.imageSlider.$itemsWrapper.on("mousedown", this.dragStart.bind(this)),
                                    this.imageSlider.$itemsWrapper.on("mousemove", this.dragAction.bind(this)),
                                    this.imageSlider.$itemsWrapper.on("mouseup", this.dragEnd.bind(this)),
                                    this.imageSlider.$itemsWrapper.on("touchstart", this.dragStart.bind(this)),
                                    this.imageSlider.$itemsWrapper.on("touchmove", this.dragAction.bind(this)),
                                    this.imageSlider.$itemsWrapper.on("touchend", this.dragEnd.bind(this)),
                                    this.imageSlider.$prev.on("click", this.shiftSlide.bind(this, null, -1)),
                                    this.imageSlider.$next.on("click", this.shiftSlide.bind(this, null, 1))));
                        },
                    },
                    {
                        key: "dragStart",
                        value: function (t) {
                            (t = t || window.event), (this.imageSlider.posInitial = this.imageSlider.$itemsWrapper[0].offsetLeft);
                            var e = t.type.includes("touch") ? t.originalEvent.touches[0].clientX : t.clientX;
                            (this.imageSlider.posX1 = e), (this.imageSlider.isDragging = !0);
                        },
                    },
                    {
                        key: "dragAction",
                        value: function (t) {
                            if (this.imageSlider.isDragging) {
                                var e = (t = t || window.event).type.includes("touch") ? t.originalEvent.touches[0].clientX : t.clientX;
                                (this.imageSlider.posX2 = this.imageSlider.posX1 - e), (this.imageSlider.posX1 = e);
                                var r = this.imageSlider.$itemsWrapper[0].offsetLeft - this.imageSlider.posX2,
                                    n = 0.2 * this.imageSlider.slideSize,
                                    i = -this.imageSlider.slideSize * (this.imageSlider.slidesLength - this.productSliderRange) - n;
                                r > n ? (r = n) : r < i && (r = i), this.imageSlider.$itemsWrapper.css("left", r + "px");
                            }
                        },
                    },
                    {
                        key: "dragEnd",
                        value: function (t) {
                            if (this.imageSlider.isDragging)
                                if (((this.imageSlider.isDragging = !1), (this.imageSlider.posFinal = this.imageSlider.$itemsWrapper[0].offsetLeft), this.imageSlider.posFinal - this.imageSlider.posInitial < -this.imageSlider.threshold)) {
                                    var e = Math.round(Math.abs(this.imageSlider.posFinal - this.imageSlider.posInitial) / this.imageSlider.slideSize);
                                    this.shiftSlide(null, e);
                                } else
                                    this.imageSlider.posFinal - this.imageSlider.posInitial > this.imageSlider.threshold
                                        ? ((e = Math.round(Math.abs(this.imageSlider.posFinal - this.imageSlider.posInitial) / this.imageSlider.slideSize)), this.shiftSlide(null, -1 * e))
                                        : this.imageSlider.$itemsWrapper.css("left", this.imageSlider.posInitial + "px");
                        },
                    },
                    {
                        key: "shiftSlide",
                        value: function (t, e) {
                            if ((null == t && (t = this.imageSlider.index + e), this.imageSlider.allowShift)) {
                                var r,
                                    n = this.imageSlider.$itemsWrapper.css("left");
                                t > -1 && t < this.imageSlider.slidesLength - this.productSliderRange + 1
                                    ? ((r = -1 * t * this.imageSlider.slideSize + "px"), (this.imageSlider.index = t))
                                    : (r = -1 * this.imageSlider.index * this.imageSlider.slideSize + "px"),
                                    n != r &&
                                        (0 == this.imageSlider.index ? this.imageSlider.$prev.addClass("boost-pfs-product-slider-nav-btn-disabled") : this.imageSlider.$prev.removeClass("boost-pfs-product-slider-nav-btn-disabled"),
                                        this.imageSlider.index == this.imageSlider.slidesLength - this.productSliderRange
                                            ? this.imageSlider.$next.addClass("boost-pfs-product-slider-nav-btn-disabled")
                                            : this.imageSlider.$next.removeClass("boost-pfs-product-slider-nav-btn-disabled"),
                                        this.imageSlider.$itemsWrapper.addClass("boost-pfs-product-slider-shifting"),
                                        this.imageSlider.$itemsWrapper.css("left", r),
                                        (this.imageSlider.allowShift = !1),
                                        setTimeout(this.afterShiftSlide.bind(this), 300));
                            }
                        },
                    },
                    {
                        key: "afterShiftSlide",
                        value: function () {
                            this.imageSlider.$itemsWrapper.removeClass("boost-pfs-product-slider-shifting"), (this.imageSlider.allowShift = !0);
                        },
                    },
                ]) && vn(e.prototype, r),
                n && vn(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function _n(t) {
            return (_n =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Cn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== _n(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== _n(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === _n(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function kn() {
            return (kn =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = En(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function En(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ln(t)); );
            return t;
        }
        function Rn(t, e) {
            return (Rn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function In(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ln(t);
                if (e) {
                    var i = Ln(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return jn(this, r);
            };
        }
        function jn(t, e) {
            if (e && ("object" === _n(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ln(t) {
            return (Ln = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Bn = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Rn(t, e);
            })(l, t);
            var e,
                r,
                n,
                o = In(l);
            function l() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((t = o.call(this)).type = wn.ProductSliderType.MOST_POPULAR),
                    (t.selector = s.a.mostPopular),
                    (t.header = a.a.mostPopular.popularProductsHeading),
                    (t.productSliderRange = Settings.getSettingValue("mostPopular.popularProductSliderRange")),
                    t.productSliderRange <= 0 && (t.productSliderRange = 4),
                    (t.isFetchedMostPopularData = !1),
                    (t.collectionHandle = boostPFSAppConfig.general.collection_handle ? boostPFSAppConfig.general.collection_handle : "all"),
                    t
                );
            }
            return (
                (e = l),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            var t = this;
                            if (void 0 === this.data || !this.data.hasOwnProperty("products")) {
                                var e = "/collections/" + this.collectionHandle + "?view=boost-pfs-most-popular&sort_by=best-selling";
                                i.a.ajax({
                                    type: "GET",
                                    url: e,
                                    success: function (e) {
                                        var r = null;
                                        try {
                                            /<\!--.*?-->/.test(e) && (e = e.replace(/<\!--.*?-->/g, "")), (r = t.prepareData(JSON.parse(e)));
                                        } catch (t) {
                                            console.warn("Could not parse json from collection.boost-pfs-most-popular.liquid");
                                        }
                                        (t.isFetchedMostPopularData = !0), t.setData(r, !0);
                                    },
                                    error: function (t) {
                                        console.warn("Error getting most popular: " + t.status + " " + t.statusText);
                                    },
                                });
                            }
                        },
                    },
                    {
                        key: "prepareData",
                        value: function (t) {
                            return (
                                t.products.forEach(function (t) {
                                    (t.price /= 100),
                                        (t.price_min /= 100),
                                        (t.price_max /= 100),
                                        (t.compare_at_price /= 100),
                                        (t.compare_at_price_min /= 100),
                                        (t.compare_at_price_max /= 100),
                                        t.variants.forEach(function (t) {
                                            (t.price /= 100), (t.compare_at_price /= 100);
                                        });
                                }),
                                t
                            );
                        },
                    },
                    {
                        key: "setProductData",
                        value: function (t) {
                            this.isFetchedMostPopularData = !0;
                            var e = { products: t };
                            this.setData(e, !0);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return this.isFetchedMostPopularData && this.data.products.length > 0;
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return this.$element;
                        },
                    },
                    {
                        key: "isLoopThroughChild",
                        value: function () {
                            return this.isFetchedMostPopularData && this.data.products.length > 0;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            kn(Ln(l.prototype), "bindEvents", this).call(this), boostPFSConfig.general.isInitFilter && i()(window).on("boost-pfs-change-address-bar", this.updateMostPopularData.bind(this));
                        },
                    },
                    {
                        key: "updateMostPopularData",
                        value: function () {
                            if (window.location.pathname.startsWith("/collections/")) {
                                var t = window.location.pathname.replace("/collections/", "");
                                t && t != this.collectionHandle && ((this.collectionHandle = t), (this.isFetchedMostPopularData = !1), (this.isInit = !1), this.refresh());
                            }
                        },
                    },
                ]) && Cn(e.prototype, r),
                n && Cn(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(wn);
        function An(t) {
            return (An =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function xn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== An(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== An(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === An(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Fn(t, e) {
            return (Fn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function $n(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Mn(t);
                if (e) {
                    var i = Mn(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Dn(this, r);
            };
        }
        function Dn(t, e) {
            if (e && ("object" === An(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Mn(t) {
            return (Mn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Vn = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Fn(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = $n(p);
            function p() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((t = c.call(this)).productsData = null),
                    (t.$element = i()(s.a.products)),
                    t
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "getTitleTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="product-list-no-search-result-text boost-pfs-search-panel-product-show">{{label.resultEmpty}}</div>\n\t\t\t{{noResultSearchTipsTemplate}}\n\t\t\t{{noResultSearchSuggestionTemplate}}\n\n\t\t\t{{noResultSearchMostPopular}}\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getNoResultSearchTipsTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-search-tips-content-wrapper boost-pfs-search-panel-product-show">\n\t\t\t\t<div class="boost-pfs-filter-search-tips-title">{{searchTipsTitle}}</div>\n\t\t\t\t<div class="boost-pfs-filter-search-tips-content">\n\t\t\t\t\t<ul>{{searchTipsListItem}}</ul>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getNoResultSearchSuggestionsTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-search-term-suggestion-wrapper boost-pfs-search-panel-product-show">\n\t\t\t\t<div class="boost-pfs-filter-search-term-suggestion-title">{{searchTermSuggestionTitle}}</div>\n\t\t\t\t<div class="boost-pfs-filter-search-term-suggestion-content">\n\t\t\t\t<ul>\n\t\t\t\t\t{{searchTermSuggestionListItem}}\n\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getNoResultSearchMostPopular",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-most-popular-wrapper boost-pfs-search-panel-product-show">\n\t\t\t\t<div class="boost-pfs-product-no-search-result-title"><h2>{{noSearchResultTitle}}</h2></div>\n\t\t\t\t<div class="boost-pfs-most-popular"></div>\n\t\t\t</div>';
                        },
                    },
                    {
                        key: "compileTitleTemplate",
                        value: function () {
                            o.a.getSettingValue("search.suggestionNoResult");
                            var t = a.a.suggestion.noSearchResultProductsLabel,
                                e = a.a.search.resultEmpty,
                                r = o.a.getSettingValue("general.current_locale"),
                                n = o.a.getSettingValue("labelTranslations." + r + ".search.resultEmpty");
                            n && (e = n);
                            var i = "";
                            if (o.a.getSettingValue("search.searchPanelBlocks.searchTips.active")) {
                                for (var s = a.a.search.searchTipsContent.split("{{ breakline }}"), c = "", p = 0; p < s.length; p++) "" != s[p] && (c += "<li>".concat(s[p], "</li>"));
                                i = this.getNoResultSearchTipsTemplate()
                                    .replace(/{{searchTipsTitle}}/g, a.a.search.searchTipsTitle)
                                    .replace(/{{searchTipsListItem}}/g, c);
                            }
                            var f = "";
                            if (o.a.getSettingValue("search.searchPanelBlocks.searchTermSuggestions.active")) {
                                var h = o.a.getSettingValue("search.suggestionNoResult.search_terms.data");
                                for (p = 0; p < h.length; p++) f += '\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a href="/search?q='.concat(u.a.encodeURIParamValue(h[p]), '">').concat(h[p], "</a>\n\t\t\t\t\t</li>\n\t\t\t\t").trim();
                                h.length > 0 &&
                                    (f = this.getNoResultSearchSuggestionsTemplate()
                                        .replace(/{{searchTermSuggestionTitle}}/g, a.a.suggestion.noSearchResultSearchTermLabel)
                                        .replace(/{{searchTermSuggestionListItem}}/g, f));
                            }
                            var y = "";
                            return (
                                o.a.getSettingValue("search.searchPanelBlocks.mostPopularProducts.active") && this.data.length > 0 && (y = this.getNoResultSearchMostPopular()),
                                this.getTitleTemplate()
                                    .replace(/{{noResultSearchTipsTemplate}}/g, i)
                                    .replace(/{{noResultSearchSuggestionTemplate}}/g, f)
                                    .replace(/{{noResultSearchMostPopular}}/g, y)
                                    .replace(/{{noSearchResultTitle}}/g, t)
                                    .replace(/{{label.resultEmpty}}/g, e)
                                    .replace(/{{ terms }}/g, "<b>" + u.a.stripHtml(l.a.queryParams.q) + "</b>")
                                    .replace(/{{ breakline }}/g, "<br />")
                            );
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return u.a.isSearchPage() && X.isPanelActive(at.Enum.PRODUCT) && 0 == this.parent.totalProduct && "filter" != this.eventType && "collection" != this.eventType;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            if (this.$element && 0 == this.$element.parent().find(".boost-pfs-product-slider-title").length) {
                                var t = this.compileTitleTemplate();
                                i()(s.a.products).before(t);
                            }
                            "init" == this.eventType &&
                                (i()(".boost-pfs-filter-tree-mobile-button").hide(),
                                i()(".boost-pfs-filter-tree-desktop-button").hide(),
                                i()(".boost-pfs-filter-tree").hide(),
                                i()(".boost-pfs-filter-left-col").hide(),
                                i()(".boost-pfs-filter-right-col, .boost-pfs-filter-right").css({ width: "100%" }),
                                i()(s.a.filterTree).hide(),
                                i()(s.a.topSorting).hide(),
                                i()(s.a.topShowLimit).hide(),
                                i()(s.a.topDisplayType).hide(),
                                i()(s.a.bottomPagination).hide(),
                                i()(s.a.btnLoadPreviousPageWrapperSelector).hide(),
                                i()(s.a.loadMoreButtonContainer).hide(),
                                i()(s.a.products).hide(),
                                i()("body").addClass("boost-pfs-search-no-result-body")),
                                o.a.getSettingValue("search.searchPanelBlocks.mostPopularProducts.active") && this.initMostPopular();
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !1;
                        },
                    },
                    {
                        key: "getNoSearchResultData",
                        value: function () {
                            var t = [];
                            if (i()(s.a.searchNoResultJson).length > 0)
                                try {
                                    var e = JSON.parse(i()(s.a.searchNoResultJson).html());
                                    if ((Array.isArray(e.products) && e.products.length > 0 && (t = e.products), i()("#boost-pfs-instant-search-products-not-found-metafields-json").length > 0))
                                        for (var r = JSON.parse(i()("#boost-pfs-instant-search-products-not-found-metafields-json").html()), n = 0; n < r.products.length; n++) t[n].metafields = r.products[n].metafields;
                                } catch (t) {}
                            return t;
                        },
                    },
                    {
                        key: "initMostPopular",
                        value: function () {
                            new Bn().setProductData(this.data);
                        },
                    },
                    {
                        key: "prepareProductData",
                        value: function () {
                            this.data.forEach(function (t) {
                                if (
                                    ((t.price /= 100),
                                    (t.price_max /= 100),
                                    (t.price_min /= 100),
                                    (t.compare_at_price /= 100),
                                    (t.compare_at_price_max /= 100),
                                    (t.compare_at_price_min /= 100),
                                    t.variants.forEach(function (t) {
                                        (t.price /= 100), (t.compare_at_price /= 100);
                                    }),
                                    (t.options_with_values = []),
                                    Array.isArray(t.options)
                                        ? t.options.forEach(function (e, r) {
                                              t.options_with_values.push({ values: [], name: u.a.slugify(e), label: e }), (t.options[r] = e.toLowerCase());
                                          })
                                        : (t.options = []),
                                    t.options.length > 0 && Array.isArray(t.variants))
                                ) {
                                    var e = [];
                                    t.variants.forEach(function (r) {
                                        r.merged_options = [];
                                        for (var n = 0; n < t.options_with_values.length; n++) {
                                            var i = r["option" + (n + 1)];
                                            i && !e.includes(i) && (t.options_with_values[n].values.push({ image: null, title: i }), e.push(i)),
                                                r.merged_options.push(t.options_with_values[n].name + ":" + i),
                                                (r["option_" + t.options_with_values[n].name] = i);
                                        }
                                    });
                                } else t.variants = [];
                                (t.images_info = []),
                                    Array.isArray(t.media) &&
                                        (t.images_info = t.media.filter(function (t) {
                                            return "image" == t.media_type;
                                        })),
                                    Array.isArray(t.variants) &&
                                        t.variants.forEach(function (e) {
                                            (e.image = e.featured_image ? e.featured_image.src : null),
                                                e.image &&
                                                    Array.isArray(t.options_with_values) &&
                                                    Array.isArray(t.images) &&
                                                    t.options_with_values.forEach(function (r) {
                                                        var n = e["option_" + r.name];
                                                        n &&
                                                            r.values.forEach(function (r) {
                                                                if (r.title && r.title == n && !r.image) {
                                                                    var i = t.images.indexOf(e.image.replace("https:", ""));
                                                                    i >= 0 && (r.image = i + 1);
                                                                }
                                                            });
                                                    });
                                        });
                                var r = {};
                                if (Array.isArray(t.images)) {
                                    for (var n = 0; n < t.images.length; n++) {
                                        var i = t.images[n];
                                        i.startsWith("//") && (i = "https:" + i), (r[n + 1] = i);
                                    }
                                    t.images = r;
                                }
                                t.media || (t.media = []),
                                    t.barcodes || (t.barcodes = []),
                                    t.collections || (t.collections = []),
                                    t.metafields || (t.metafields = []),
                                    t.skus || (t.skus = []),
                                    null == t.inventory_quantity && (t.inventory_quantity = t.available ? 99999 : 0),
                                    t.body_html || (t.body_html = u.a.stripHtml(t.content));
                            });
                        },
                    },
                    {
                        key: "setData",
                        value: function () {
                            var t = this.getNoSearchResultData();
                            (this.data = t), (this.totalProduct = this.data.length), (this.eventType = this.parent.eventType), this.prepareProductData(), (this.children = []), (this.productItems = []);
                        },
                    },
                ]) && xn(e.prototype, r),
                n && xn(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(Pt);
        function Nn(t) {
            return (Nn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Hn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Nn(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Nn(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Nn(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Un(t, e) {
            return (Un = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Wn(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Gn(t);
                if (e) {
                    var i = Gn(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return qn(this, r);
            };
        }
        function qn(t, e) {
            if (e && ("object" === Nn(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Gn(t) {
            return (Gn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var zn = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Un(t, e);
                })(l, t);
                var e,
                    r,
                    n,
                    a = Wn(l);
                function l() {
                    var t;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, l),
                        ((t = a.call(this)).data = null),
                        (t.productList = null),
                        (t.totalProduct = 0),
                        (t.pagination = ""),
                        (t.sorting = ""),
                        (t.breadcrumbs = ""),
                        (t.eventType = ""),
                        (t.displayType = ""),
                        (t.$element = i()(s.a.products)),
                        (t.settngs = { paginationType: o.a.getSettingValue("general.paginationType") }),
                        (t.productListGobackPreviousPosition = !1),
                        t
                    );
                }
                return (
                    (e = l),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                (this.productPlaceholder = new hr()), this.addComponent(this.productPlaceholder), (this.productList = new Pt()), this.addComponent(this.productList);
                                var t = this._getProductPaginationClass();
                                (this.pagination = new t()),
                                    this.addComponent(this.pagination),
                                    u.a.isLoadPreviousPagePaginationType() && ((this.loadPrevious = new Ze()), this.addComponent(this.loadPrevious)),
                                    (this.sorting = new Ut()),
                                    this.addComponent(this.sorting),
                                    (this.limit = new Qt()),
                                    this.addComponent(this.limit),
                                    (this.displayType = new Ft()),
                                    this.addComponent(this.displayType);
                                var e = this._getPageInfoClass();
                                (this.pageInfo = new e()),
                                    this.addComponent(this.pageInfo),
                                    (this.rebotsMeta = new Le()),
                                    this.addComponent(this.rebotsMeta),
                                    u.a.isSearchPage() &&
                                        ((this.searchResultPanels = new X()),
                                        this.addComponent(this.searchResultPanels),
                                        (this.collectionList = new Kr()),
                                        this.addComponent(this.collectionList),
                                        (this.collectionListPagination = new ar(s.a.searchCollectionPagination, at.Enum.COLLECTION)),
                                        this.addComponent(this.collectionListPagination),
                                        (this.pageList = new en()),
                                        this.addComponent(this.pageList),
                                        (this.pageListPagination = new ar(s.a.searchPagePagination, at.Enum.PAGE)),
                                        this.addComponent(this.pageListPagination),
                                        (this.searchResultTotal = new cn()),
                                        this.addComponent(this.searchResultTotal));
                            },
                        },
                        {
                            key: "isRender",
                            value: function () {
                                return this.parent.isFetchedProductData;
                            },
                        },
                        {
                            key: "setData",
                            value: function (t) {
                                (this.data = t),
                                    (this.totalProduct = t.total_product),
                                    (this.eventType = t.event_type),
                                    this.productList.setData(t.products),
                                    this.pagination.setData(t),
                                    this.loadPrevious && this.loadPrevious.setData(t),
                                    u.a.isSearchPage() &&
                                        (this.searchResultPanels.setData(t, this.eventType),
                                        this.collectionList.setData(t, this.eventType),
                                        this.pageList.setData(t, this.eventType),
                                        t.hasOwnProperty("total_product") && this.searchResultTotal.setData(t.total_product),
                                        0 == this.totalProduct && "init" == this.eventType && ((this.productList = new Vn()), this.addComponent(this.productList), this.productList.setData())),
                                    this.productPlaceholder.setData(t),
                                    this.pageInfo.setData(t);
                            },
                        },
                        {
                            key: "_getProductPaginationClass",
                            value: function () {
                                switch (o.a.getSettingValue("general.paginationType")) {
                                    case ht.Type.DEFAULT:
                                        return Rt;
                                    case ht.Type.LOAD_MORE:
                                        return Me;
                                    default:
                                        return Ge;
                                }
                            },
                        },
                        {
                            key: "_getPageInfoClass",
                            value: function () {
                                return u.a.isSearchPage() ? ue : _e;
                            },
                        },
                        {
                            key: "_shouldProductListGobackPreviousPosition",
                            value: function () {
                                return !this.productListGobackPreviousPosition;
                            },
                        },
                        {
                            key: "_changeProductListGobackPreviousPositionStatus",
                            value: function () {
                                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                                this.productListGobackPreviousPosition = t;
                            },
                        },
                        {
                            key: "_productPaginationInfiniteShouldLoadmore",
                            value: function () {
                                return !this.productListGobackPreviousPosition;
                            },
                        },
                    ]) && Hn(e.prototype, r),
                    n && Hn(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    l
                );
            })(d.a),
            Kn = r(6);
        function Yn(t) {
            return (Yn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Qn(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Yn(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Yn(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Yn(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Jn(t, e) {
            return (Jn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Xn(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ei(t);
                if (e) {
                    var i = ei(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Zn(this, r);
            };
        }
        function Zn(t, e) {
            if (e && ("object" === Yn(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return ti(t);
        }
        function ti(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        }
        function ei(t) {
            return (ei = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ri = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Jn(t, e);
            })(s, t);
            var e,
                r,
                n,
                l = Xn(s);
            function s(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, s),
                    ((e = l.call(this)).filterTree = t),
                    (e.filterTree.mobileButton = ti(e)),
                    (e.isCollapsed = !0),
                    (e.label = a.a.refineMobile),
                    (e.icon = o.a.getSettingValue("general.filterTreeMobileIcon")),
                    (e.$element = null),
                    e
                );
            }
            return (
                (e = s),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t\t<button type="button" aria-label="{{label}}">{{icon}} <span class="{{filterTreeMobileButton}}-label">{{label}}</span></button>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{filterTreeMobileButton}}/g, q.a.filterTreeMobileButton)
                                .replace(/{{label}}/g, this.label)
                                .replace(/{{icon}}/g, this.icon);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate())), this.parent.isFetchedFilterData && (this.filterTree.filterOptions.size > 0 || this.$element.hide());
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.filterTree && this.$element.on("click", this.onClick.bind(this));
                        },
                    },
                    {
                        key: "onClick",
                        value: function () {
                            "function" == typeof this.filterTree.onClickMobileButton ? this.filterTree.onClickMobileButton() : (this.toggleFilterTree(), i()("body").toggleClass(q.a.filterTreeOpenBody));
                        },
                    },
                    {
                        key: "toggleFilterTree",
                        value: function () {
                            var t = i()("#" + this.filterTree.id);
                            t &&
                                !t.hasClass("toggling") &&
                                ((this.isCollapsed = !this.isCollapsed),
                                o.a.getSettingValue("general.changeMobileButtonLabel") && ((this.label = this.isCollapsed ? a.a.refineMobile : a.a.refineMobileCollapse), this.$element.text(this.label)),
                                this.afterToggleFilterTree());
                        },
                    },
                    {
                        key: "afterToggleFilterTree",
                        value: function () {
                            this.isCollapsed ||
                                this.filterTree.filterOptions.forEach(function (t) {
                                    t.displayType != Kn.a.DisplayType.BOX ||
                                        t.isCollapsed ||
                                        t.filterItems.forEach(function (t) {
                                            t.setBoxItemSize();
                                        });
                                });
                        },
                    },
                ]) && Qn(e.prototype, r),
                n && Qn(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(d.a);
        function ni(t) {
            return (ni =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ii(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ni(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ni(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ni(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function oi(t, e) {
            return (oi = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function ai(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ci(t);
                if (e) {
                    var i = ci(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return li(this, r);
            };
        }
        function li(t, e) {
            if (e && ("object" === ni(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return si(t);
        }
        function si(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        }
        function ci(t) {
            return (ci = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ui = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && oi(t, e);
            })(s, t);
            var e,
                r,
                n,
                l = ai(s);
            function s(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, s),
                    ((e = l.call(this)).filterTree = t),
                    (e.filterTree.desktopButton = si(e)),
                    (e.isCollapsed = !0),
                    (e.label = a.a.refineDesktop),
                    (e.icon = o.a.getSettingValue("general.filterTreeIcon")),
                    (e.iconClose = o.a.getSettingValue("general.filterTreeIconClose")),
                    (e.$element = null),
                    e
                );
            }
            return (
                (e = s),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t\t<button type="button" aria-label="{{label}}"><span class="{{filterTreeDesktopButton}}-icon">{{icon}}</span> <span class="{{filterTreeDesktopButton}}-label">{{label}}</span></button>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{filterTreeDesktopButton}}/g, q.a.filterTreeDesktopButton)
                                .replace(/{{label}}/g, this.label)
                                .replace(/{{icon}}/g, this.icon);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate())), this.parent.isFetchedFilterData && (this.filterTree.filterOptions.size > 0 || this.$element.hide());
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.filterTree && this.$element.on("click", this.onClick.bind(this));
                        },
                    },
                    {
                        key: "onClick",
                        value: function () {
                            "function" == typeof this.filterTree.onClickDesktopButton ? this.filterTree.onClickDesktopButton() : (this.toggleFilterTree(), i()("body").toggleClass(q.a.filterTreeOpenBody));
                        },
                    },
                    {
                        key: "toggleFilterTree",
                        value: function () {
                            var t = i()("#" + this.filterTree.id);
                            t &&
                                !t.hasClass("toggling") &&
                                ((this.isCollapsed = !this.isCollapsed),
                                o.a.getSettingValue("general.changeDesktopButtonLabel") && ((this.label = this.isCollapsed ? a.a.refineDesktop : a.a.refineDesktopCollapse), (this.$element[0].children[1].innerHTML = this.label)),
                                o.a.getSettingValue("general.changeDesktopButtonIcon") &&
                                    ((this.icon = this.isCollapsed ? o.a.getSettingValue("general.filterTreeIcon") : o.a.getSettingValue("general.filterTreeIconClose")), (this.$element[0].children[0].innerHTML = this.icon)),
                                this.afterToggleFilterTree());
                        },
                    },
                    {
                        key: "afterToggleFilterTree",
                        value: function () {
                            this.isCollapsed ||
                                this.filterTree.filterOptions.forEach(function (t) {
                                    t.displayType != Kn.a.DisplayType.BOX ||
                                        t.isCollapsed ||
                                        t.filterItems.forEach(function (t) {
                                            t.setBoxItemSize();
                                        });
                                });
                        },
                    },
                ]) && ii(e.prototype, r),
                n && ii(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(d.a);
        function pi(t) {
            return (pi =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function fi(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function hi(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== pi(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== pi(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === pi(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function yi(t, e) {
            return (yi = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function di(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = gi(t);
                if (e) {
                    var i = gi(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return mi(this, r);
            };
        }
        function mi(t, e) {
            if (e && ("object" === pi(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function gi(t) {
            return (gi = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var bi = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && yi(t, e);
            })(l, t);
            var e,
                r,
                n,
                a = di(l);
            function l() {
                return fi(this, l), a.apply(this, arguments);
            }
            return (
                (e = l),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-loading" style="display: none;"><span class="boost-pfs-filter-loading-icon"></span></div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate();
                        },
                    },
                    {
                        key: "setShow",
                        value: function (t) {
                            this.$element || ((this.$element = i()(this.compileTemplate())), i()("body").append(this.$element)), this.isEnabled() && (t ? this.$element.show() : this.$element.hide());
                        },
                    },
                    {
                        key: "isEnabled",
                        value: function () {
                            var t = u.a.isMobile();
                            return (!t && o.a.getSettingValue("general.showLoading")) || (t && o.a.getSettingValue("general.showMobileLoading"));
                        },
                    },
                ]) && hi(e.prototype, r),
                n && hi(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(d.a);
        function vi(t) {
            return (vi =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Si(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== vi(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== vi(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === vi(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Oi(t, e) {
            return (Oi = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Pi(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = wi(t);
                if (e) {
                    var i = wi(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Ti(this, r);
            };
        }
        function Ti(t, e) {
            if (e && ("object" === vi(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function wi(t) {
            return (wi = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var _i = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Oi(t, e);
                })(l, t);
                var e,
                    r,
                    n,
                    a = Pi(l);
                function l() {
                    var t;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, l),
                        ((t = a.call(this)).style = o.a.getSettingValue("general.styleScrollToTop")),
                        (t.$element = null),
                        t
                    );
                }
                return (
                    (e = l),
                    (r = [
                        {
                            key: "getTemplate",
                            value: function () {
                                return '\n\t\t\t<button aria-label="Back to top" class="boost-pfs-filter-scroll-to-top {{style}}" style="display: inline;"></button>\n\t\t'.trim();
                            },
                        },
                        {
                            key: "compileTemplate",
                            value: function () {
                                return this.getTemplate().replace(/{{style}}/g, this.style);
                            },
                        },
                        {
                            key: "isRender",
                            value: function () {
                                return !this.$element;
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                !this.$element && this.isShow() && ((this.$element = i()(this.compileTemplate())), i()("body").append(this.$element));
                            },
                        },
                        {
                            key: "isBindEvents",
                            value: function () {
                                return !this.isBoundEvent;
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                this.$element && (this.$element.on("click", this.scrollToTop.bind(this)), i()(document).scroll(this.setVisibility.bind(this)));
                            },
                        },
                        {
                            key: "scrollToTop",
                            value: function () {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            },
                        },
                        {
                            key: "setVisibility",
                            value: function () {
                                ((document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop) > 100 ? this.$element.show() : this.$element.hide();
                            },
                        },
                        {
                            key: "isShow",
                            value: function () {
                                return o.a.getSettingValue("general.activeScrollToTop");
                            },
                        },
                    ]) && Si(e.prototype, r),
                    n && Si(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    l
                );
            })(d.a),
            Ci = { FilterTreeType: { VERTICAL: "vertical", HORIZONTAL: "horizontal" } };
        r(61), r(121), r(185), r(88), r(51);
        function ki(t) {
            return (ki =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ei(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ki(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ki(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ki(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ri(t, e) {
            return (Ri = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ii(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Li(t);
                if (e) {
                    var i = Li(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ji(this, r);
            };
        }
        function ji(t, e) {
            if (e && ("object" === ki(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Li(t) {
            return (Li = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Bi = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ri(t, e);
            })(c, t);
            var e,
                r,
                n,
                s = Ii(c);
            function c(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((r = s.call(this)).filterTreeType = t),
                    (r.clearType = e),
                    (r.requestInstantly = !0),
                    (r.label = r.clearType == c.ClearType.CLEAR_ALL ? a.a.clearAll : a.a.clear),
                    (r.filterOptionLabel = ""),
                    (r.filterValueLabel = ""),
                    r
                );
            }
            return (
                (e = c),
                (n = [
                    {
                        key: "ClearType",
                        get: function () {
                            return { CLEAR_SINGLE_VALUE: "clear-single-value", CLEAR_OPTION_VALUES: "clear-option-values", CLEAR_ALL: "clear-all" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            switch (this.clearType) {
                                case c.ClearType.CLEAR_SINGLE_VALUE:
                                    return '\n\t\t\t\t\t<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearButton}}">\n\t\t\t\t\t\t<span class="refine-by-type">\n\t\t\t\t\t\t\t<span class="refine-by-option">{{filterOptionLabel}}</span><span class="refine-by-value">{{filterValueLabel}}</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</button>\n\t\t\t\t'.trim();
                                case c.ClearType.CLEAR_OPTION_VALUES:
                                    return '\n\t\t\t\t\t<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearButton}}">{{label}}</button>\n\t\t\t\t'.trim();
                                case c.ClearType.CLEAR_ALL:
                                    return '\n\t\t\t\t\t<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearAllButton}}">{{label}}</button>\n\t\t\t\t'.trim();
                                default:
                                    console.warn("Wrong filter clear type");
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return (
                                this.buildLabel(),
                                this.getTemplate()
                                    .replace(/{{label.clear}}/g, a.a.clear)
                                    .replace(/{{class.button}}/g, q.a.button)
                                    .replace(/{{class.clearButton}}/g, q.a.clearButton)
                                    .replace(/{{class.clearAllButton}}/g, q.a.clearAllButton)
                                    .replace(/{{adaLabel}}/g, u.a.stripHtml(this.adaLabel))
                                    .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                    .replace(/{{filterOptionLabel}}/g, this.filterOptionLabel)
                                    .replace(/{{filterValueLabel}}/g, this.filterValueLabel)
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate())), this.isVisible() ? this.$element.show() : this.$element.hide();
                        },
                    },
                    {
                        key: "buildLabel",
                        value: function () {
                            switch (((this.adaLabel = ""), this.clearType)) {
                                case c.ClearType.CLEAR_SINGLE_VALUE:
                                    var t = this.parent;
                                    if (t && t.type && t.label) {
                                        var e = u.a.stripHtml(t.label);
                                        o.a.getSettingValue("general.enable3rdCurrencySupport") && "Price" == this.parent.type && (e = ""),
                                            (this.adaLabel = a.a.ada.clearFilterItem.replace(/{{filterOption}}/g, u.a.stripHtml(t.type)).replace(/{{filterItem}}/g, e)),
                                            (this.filterOptionLabel = u.a.stripHtml(t.type && this.filterTreeType == Ci.FilterTreeType.VERTICAL ? t.type + ": " : "")),
                                            (this.filterValueLabel = u.a.stripHtml(t.label));
                                    }
                                    break;
                                case c.ClearType.CLEAR_OPTION_VALUES:
                                    var r = this.parent;
                                    r && r.label && (this.adaLabel = a.a.ada.clearFilterOption.replace(/{{filterOption}}/g, u.a.stripHtml(r.label)));
                                    break;
                                case c.ClearType.CLEAR_ALL:
                                    this.adaLabel = a.a.ada.clearAllFilterItems;
                            }
                        },
                    },
                    {
                        key: "isVisible",
                        value: function () {
                            var t = !0;
                            switch (this.clearType) {
                                case c.ClearType.CLEAR_OPTION_VALUES:
                                    var e = this.parent;
                                    if (e.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS) {
                                        var r = e.filterOptionId.replace(l.a.prefix + "_c_", l.a.prefix + "_ct_");
                                        t = l.a.queryParams[e.filterOptionId] || l.a.queryParams[r];
                                    } else t = l.a.queryParams[e.filterOptionId];
                                    break;
                                case c.ClearType.CLEAR_ALL:
                                    (t = !1),
                                        Object.keys(l.a.queryParams).forEach(function (e) {
                                            if (e.startsWith(l.a.prefix)) {
                                                var r = l.a.queryParams[e];
                                                (!u.a.isCollectionPage() && e.startsWith(l.a.prefix + "_c_") && 0 == r) || (t = !0);
                                            }
                                        });
                            }
                            return !!t;
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$element.on("click", this.onClick.bind(this));
                        },
                    },
                    {
                        key: "onClick",
                        value: function (t) {
                            if ((t && t.preventDefault(), this.requestInstantly))
                                switch (this.clearType) {
                                    case c.ClearType.CLEAR_SINGLE_VALUE:
                                        this.onClearSingleValue();
                                        break;
                                    case c.ClearType.CLEAR_OPTION_VALUES:
                                        this.onClearOptionValues();
                                        break;
                                    case c.ClearType.CLEAR_ALL:
                                        this.onClearAll();
                                }
                            else
                                switch (this.clearType) {
                                    case c.ClearType.CLEAR_OPTION_VALUES:
                                        this.onDeselectOptionValues();
                                }
                        },
                    },
                    {
                        key: "onClearSingleValue",
                        value: function () {
                            var t = this.parent,
                                e = t.filterOptionId,
                                r = t.filterItemId,
                                n = l.a.queryParams[e];
                            if (null != n) {
                                Array.isArray(n) || (n = [n]);
                                var i = n.indexOf(r),
                                    o = [];
                                if (
                                    (i > -1 &&
                                        (o = n.filter(function (t, e) {
                                            return e != i;
                                        })),
                                    0 == o.length
                                        ? (Z.default.setParam(e, null),
                                          Z.default.setParam(e + "_and_condition", null),
                                          Z.default.setParam(e + "_show_exact_rating", null),
                                          Z.default.setParam(e + "_exclude_from_value", null),
                                          Z.default.setParam(e.replace(l.a.prefix + "_l_", l.a.prefix + "_li_").replace(l.a.prefix + "_vl_", l.a.prefix + "_vli_") + "_ibsl", null))
                                        : Z.default.setParam(e, o),
                                    !u.a.isCollectionPage() && e.startsWith(l.a.prefix + "_ct_"))
                                ) {
                                    var a = e.replace(l.a.prefix + "_ct_", l.a.prefix + "_c_");
                                    Z.default.setParam(a, null);
                                }
                                Z.default.setParam("page", 1);
                                var s = { filterOptionId: e, filterOptionValue: r };
                                Z.default.applyFilter("clear", s);
                            }
                        },
                    },
                    {
                        key: "onClearOptionValues",
                        value: function () {
                            var t = this.parent;
                            t.filterTreeType == Ci.FilterTreeType.HORIZONTAL && !o.a.getSettingValue("general.keepTabOpenState") && t.collapse && this.parent.collapse.onToggleHorizontal(), (l.a.internalClick = !0);
                            var e = t.filterOptionId;
                            t.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS && u.a.isCollectionPage() && (e = e.replace(l.a.prefix + "_c_", l.a.prefix + "_ct_"));
                            var r = { filterOptionId: e };
                            Z.default.setParam("page", 1),
                                Z.default.setParam(e, null),
                                Z.default.setParam(e + "_and_condition", null),
                                Z.default.setParam(e + "_show_exact_rating", null),
                                Z.default.setParam(e + "_exclude_from_value", null),
                                Z.default.setParam(e.replace(l.a.prefix + "_l_", l.a.prefix + "_li_").replace(l.a.prefix + "_vl_", l.a.prefix + "_vli_") + "_ibsl", null),
                                Z.default.applyFilter("clear", r);
                        },
                    },
                    {
                        key: "onClearAll",
                        value: function () {
                            var t = [];
                            Object.keys(l.a.queryParams).forEach(function (e) {
                                e.startsWith(l.a.prefix) && t.push(e);
                            }),
                                t.forEach(function (t) {
                                    Z.default.setParam(t, null);
                                }),
                                Z.default.setParam("page", 1),
                                Z.default.applyFilter("clearAll", {});
                        },
                    },
                    {
                        key: "onDeselectOptionValues",
                        value: function () {
                            this.parent.filterItems &&
                                this.parent.filterItems.forEach(function (t) {
                                    t.$element.removeClass("selected"), (t.isSelected = !1);
                                });
                        },
                    },
                ]) && Ei(e.prototype, r),
                n && Ei(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        function Ai(t) {
            return (Ai =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function xi(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ai(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ai(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ai(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Fi(t, e) {
            return (Fi = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function $i(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Mi(t);
                if (e) {
                    var i = Mi(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Di(this, r);
            };
        }
        function Di(t, e) {
            if (e && ("object" === Ai(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Mi(t) {
            return (Mi = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Vi = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Fi(t, e);
            })(c, t);
            var e,
                r,
                n,
                s = $i(c);
            function c(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((r = s.call(this)).filterTreeType = t || Ci.FilterTreeType.HORIZONTAL),
                    (r.applyType = e || c.ApplyType.APPLY_OPTION_VALUES),
                    r
                );
            }
            return (
                (e = c),
                (n = [
                    {
                        key: "ApplyType",
                        get: function () {
                            return { APPLY_OPTION_VALUES: "apply-option-values", APPLY_ALL: "apply-all" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            this.label = this.filterTreeType == Ci.FilterTreeType.HORIZONTAL && o.a.getSettingValue("general.requestInstantly") ? a.a.close : a.a.apply;
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            return this.applyType == c.ApplyType.APPLY_ALL
                                ? '\n\t\t\t\t<button class="{{class.button}} {{class.applyAllButton}}">{{label.applyAll}}</button>\n\t\t\t'.trim()
                                : '\n\t\t\t\t<button class="{{class.button}} {{class.applyButton}}">{{label.apply}}</button>\n\t\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{label.apply}}/g, u.a.stripHtml(this.label))
                                .replace(/{{label.applyAll}}/g, a.a.applyAll)
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/{{class.applyButton}}/g, q.a.applyButton)
                                .replace(/{{class.applyAllButton}}/g, q.a.applyAllButton);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return !(this.parent.filterType == Kn.a.FilterType.COLLECTION);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate()));
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$element.on("click", this.onClick.bind(this));
                        },
                    },
                    {
                        key: "onClick",
                        value: function (t) {
                            if ((t && t.preventDefault(), this.parent.desktopButton && this.parent.desktopButton.$element[0].click(), this.applyType == c.ApplyType.APPLY_ALL))
                                this.onApplyAll(), window.scrollTo({ top: 0, behavior: "smooth" });
                            else {
                                if (this.filterTreeType == Ci.FilterTreeType.HORIZONTAL) {
                                    if (!o.a.getSettingValue("general.keepTabOpenState") && this.parent.collapse) return void this.parent.collapse.onToggleHorizontal();
                                    if (o.a.getSettingValue("general.requestInstantly")) return;
                                }
                                this.onApplyOptionValues();
                            }
                        },
                    },
                    {
                        key: "onApplyOptionValues",
                        value: function () {
                            var t = [],
                                e = this.parent.filterOptionId,
                                r = this.parent.filterItems;
                            this.parent.displayType == Kn.a.DisplayType.MULTI_LEVEL_TAG && (r = this.parent.allNestedFilterItems),
                                r.forEach(function (e) {
                                    e.isSelected && t.push(e.value);
                                }),
                                Z.default.setParam(e, t),
                                Z.default.setParam(e + "_and_condition", !!(this.parent.useAndCondition && t.length > 0) || null),
                                Z.default.setParam(e + "_show_exact_rating", !!(this.parent.showExactRating && t.length > 0) || null),
                                Z.default.setParam(e + "_exclude_from_value", !!(this.parent.excludePriceFromValue && t.length > 0) || null),
                                Z.default.setParam(e.replace(l.a.prefix + "_l_", l.a.prefix + "_li_").replace(l.a.prefix + "_vl_", l.a.prefix + "_vli_") + "_ibsl", !!(this.parent.inventoryBaseSelectedLocations && t.length > 0) || null),
                                Z.default.setParam("page", 1);
                            var n = { filterOptionId: e, filterOptionValue: t };
                            Z.default.applyFilter("filter", n);
                        },
                    },
                    {
                        key: "onApplyAll",
                        value: function () {
                            (this.filterTreeType == Ci.FilterTreeType.HORIZONTAL &&
                                (this.parent.filterOptions &&
                                    this.parent.filterOptions.forEach(function (t) {
                                        t.collapse && !t.collapse.isCollapsed && t.collapse.onToggleHorizontal();
                                    }),
                                o.a.getSettingValue("general.requestInstantly"))) ||
                                (this.parent.filterOptions &&
                                    this.parent.filterOptions.forEach(function (t) {
                                        var e = [],
                                            r = t.filterOptionId;
                                        "pf_c_collection" != r &&
                                            ((t.displayType == Kn.a.DisplayType.MULTI_LEVEL_TAG ? t.allNestedFilterItems : t.filterItems).forEach(function (t) {
                                                t.isSelected && e.push(t.value);
                                            }),
                                            Z.default.setParam(r, e),
                                            Z.default.setParam(r + "_and_condition", !!(t.useAndCondition && e.length > 0) || null),
                                            Z.default.setParam(r + "_show_exact_rating", !!(t.showExactRating && e.length > 0) || null),
                                            Z.default.setParam(r + "_exclude_from_value", !!(t.excludePriceFromValue && e.length > 0) || null),
                                            Z.default.setParam(r.replace(l.a.prefix + "_l_", l.a.prefix + "_li_").replace(l.a.prefix + "_vl_", l.a.prefix + "_vli_") + "_ibsl", !!(t.inventoryBaseSelectedLocations && e.length > 0) || null));
                                    }),
                                Z.default.setParam("page", 1),
                                Z.default.applyFilter("filter"),
                                "style-expand" == o.a.getSettingValue("general.filterTreeHorizontalStyle") && i()("body").removeClass(q.a.filterTreeOpenBody));
                        },
                    },
                ]) && xi(e.prototype, r),
                n && xi(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        r(173);
        function Ni(t) {
            return (Ni =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Hi(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ni(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ni(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ni(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ui(t, e) {
            return (Ui = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Wi(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Gi(t);
                if (e) {
                    var i = Gi(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return qi(this, r);
            };
        }
        function qi(t, e) {
            if (e && ("object" === Ni(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Gi(t) {
            return (Gi = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var zi = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ui(t, e);
            })(p, t);
            var e,
                r,
                n,
                s = Wi(p);
            function p(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    (e = s.call(this)),
                    t || console.warn("Pass filterTreeType into FilterOptionItem constructor."),
                    (e.requestInstantly = !0),
                    (e.filterTreeType = t),
                    (e.$element = null),
                    (e.settings = { enable3rdCurrencySupport: o.a.getSettingValue("general.enable3rdCurrencySupport") }),
                    e
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            this.requestInstantly = this.filterTreeType == Ci.FilterTreeType.VERTICAL || o.a.getSettingValue("general.requestInstantly");
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            console.warn("Override this method");
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            console.warn("Override this method");
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            var t = this.filterOption ? this.filterOption : this.parent,
                                e = this.hasOwnProperty("docCount") && (this.docCount > 0 || null === this.docCount),
                                r = t.filterType == Kn.a.FilterType.REVIEW_RATINGS && t.showExactRating,
                                n = t.filterType == Kn.a.FilterType.COLLECTION && (t.keepValuesStatic || "all" == this.handle),
                                i = t.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS && 1 != this.level,
                                a = o.a.getSettingValue("general.showOutOfStockOption");
                            return r || n || i || e || a;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate())),
                                (this.isSelected = this.isAppliedFilter()),
                                this.isSelected
                                    ? (this.$element.addClass("selected"),
                                      this.$element.find("button").attr("aria-checked", !0),
                                      this.$element.find("a").attr("aria-current", !0),
                                      this.$element.find(".boost-pfs-check-box").attr("aria-checked", !0))
                                    : (this.$element.removeClass("selected"),
                                      this.$element.find("button").removeAttr("aria-checked"),
                                      this.$element.find("a").removeAttr("aria-current"),
                                      this.$element.find(".boost-pfs-check-box").removeAttr("aria-checked"));
                            var t = this.countLabel ? a.a.ada.productCount.replace(/{{count}}/g, this.countLabel) : "",
                                e = this.$element.find(".boost-pfs-filter-option-amount");
                            e && e.length > 0 && e.attr("aria-label", u.a.stripHtml(t));
                        },
                    },
                    {
                        key: "buildCount",
                        value: function () {
                            var t = "";
                            if (o.a.getSettingValue("general.showFilterOptionCount") && "box" != this.parent.displayType) {
                                var e = !1;
                                (this.docCount > 0 || o.a.getSettingValue("general.showOutOfStockOption") || (this.parent.filterType == Kn.a.FilterType.REVIEW_RATINGS && this.parent.showExactRating)) && (e = !0);
                                var r = "all" == this.handle && 0 == this.docCount;
                                !e || this.parent.keepValuesStatic || r || (t = "(" + this.docCount + ")");
                            }
                            return u.a.stripHtml(t);
                        },
                    },
                    {
                        key: "buildLabel",
                        value: function () {
                            var t = this.filterOption ? this.filterOption : this.parent,
                                e = u.a.unescape(this.label),
                                r = t.prefix;
                            return "string" != typeof e
                                ? ""
                                : ("string" == typeof r && ((r = r.replace(/\\/g, "")), (e = e.replace(r, "").trim())),
                                  e.indexOf("boost-pfs-filter-icon-star") > -1
                                      ? e
                                      : ((t.displayAllValuesInUppercaseForm = t.displayAllValuesInUppercaseForm || !1),
                                        t.displayAllValuesInUppercaseForm
                                            ? e.toUpperCase()
                                            : o.a.getSettingValue("general.forceCapitalizeFilterOptionValues")
                                            ? u.a.capitalize(e, !0)
                                            : o.a.getSettingValue("general.capitalizeFirstLetterFilterOptionValues")
                                            ? u.a.capitalize(e, !0, !0)
                                            : o.a.getSettingValue("general.capitalizeFilterOptionValues")
                                            ? u.a.capitalize(e)
                                            : u.a.stripHtml(e)));
                        },
                    },
                    {
                        key: "buildPercentSaleLabel",
                        value: function () {
                            var t = "";
                            return (t = this.from ? (this.to ? this.from + "% - " + this.to + "%" : a.a.above + " " + this.from + "%") : a.a.under + " " + this.to + "%"), u.a.stripHtml(t);
                        },
                    },
                    {
                        key: "buildPriceListLabel",
                        value: function () {
                            var t = "";
                            return (
                                (t = this.from
                                    ? this.to
                                        ? u.a.formatMoney(this.from, l.a.moneyFormat, !0) + " - " + u.a.formatMoney(this.to, l.a.moneyFormat, !0)
                                        : a.a.above + " " + u.a.formatMoney(this.from, l.a.moneyFormat, !0)
                                    : a.a.under + " " + u.a.formatMoney(this.to, l.a.moneyFormat, !0)),
                                u.a.stripHtml(t)
                            );
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$element.on("click", this.onClick.bind(this));
                        },
                    },
                    {
                        key: "onClick",
                        value: function (t) {
                            t && t.preventDefault(), this.isDisabled() || (this.requestInstantly || this.parent.filterType == Kn.a.FilterType.COLLECTION ? this.onApplyFilter() : this.onSelectFilter());
                        },
                    },
                    {
                        key: "isDisabled",
                        value: function () {
                            return this.parent.filterType == Kn.a.FilterType.COLLECTION ? !this.parent.keepValuesStatic && "all" != this.handle && 0 == this.docCount : 0 == this.docCount;
                        },
                    },
                    {
                        key: "isAppliedFilter",
                        value: function () {
                            var t = this.parent.filterOptionId;
                            if (this.parent.filterType == Kn.a.FilterType.COLLECTION) {
                                if (l.a.queryParams.collection_scope == this.collectionId) return !0;
                            } else {
                                var e = l.a.queryParams[t];
                                if (Array.isArray(e) && e.includes(this.value)) return !0;
                            }
                            return !1;
                        },
                    },
                    {
                        key: "onSelectFilter",
                        value: function () {
                            var t = this;
                            (this.isSelected = !this.isSelected),
                                this.$element.toggleClass("selected"),
                                this.isSelected ? this.$element.find("button").attr("aria-checked", !0) : this.$element.find("button").removeAttr("aria-checked"),
                                this.isSelected ? this.$element.find(".boost-pfs-check-box").attr("aria-checked", !0) : this.$element.find(".boost-pfs-check-box").removeAttr("aria-checked"),
                                this.isSelected &&
                                    this.parent.selectType == Kn.a.SelectType.SINGLE &&
                                    this.parent.filterItems.forEach(function (e) {
                                        e != t &&
                                            (e.$element && (e.$element.removeClass("selected"), t.$element.find("button").removeAttr("aria-checked"), t.$element.find(".boost-pfs-check-box").removeAttr("aria-checked")), (e.isSelected = !1));
                                    });
                        },
                    },
                    {
                        key: "onApplyFilter",
                        value: function () {
                            var t = this,
                                e = this.parent.filterType,
                                r = this.parent.displayType,
                                n = this.parent.selectType,
                                i = this.parent.filterOptionId,
                                o = "all" == this.handle && 0 == this.docCount && e == Kn.a.FilterType.COLLECTION;
                            if (this.docCount > 0 || this.parent.keepValuesStatic || r == Kn.a.DisplayType.RANGE || o) {
                                l.a.internalClick = !0;
                                var a = "";
                                if (e == Kn.a.FilterType.COLLECTION) {
                                    (this.isSelected = !0),
                                        (l.a.collectionId = this.collectionId),
                                        Z.default.setParam("collection_scope", this.collectionId),
                                        u.a.isCollectionPage()
                                            ? (c.a.setAddressBarPathAfterFilter("/collections/" + this.handle),
                                              c.a.setWindowTitleAfterFilter(u.a.stripHtml(this.label) + " - " + l.a.shopName),
                                              Z.default.setParam("sort", this.sortOrder),
                                              (l.a.defaultSorting = this.sortOrder))
                                            : Z.default.setParam(i, this.collectionId);
                                    var s = [];
                                    Object.keys(l.a.queryParams).forEach(function (t) {
                                        t.startsWith(l.a.prefix) && !t.startsWith(l.a.prefix + "_c") && s.push(t);
                                    }),
                                        s.forEach(function (t) {
                                            Z.default.setParam(t, null);
                                        }),
                                        (a = "collection");
                                } else {
                                    this.isSelected = !this.isSelected;
                                    var p = null;
                                    n == Kn.a.SelectType.SINGLE
                                        ? (p = this.isSelected ? [this.value] : [])
                                        : ((p = l.a.queryParams[i]),
                                          Array.isArray(p) || (p = []),
                                          this.isSelected
                                              ? p.includes(this.value) || p.push(this.value)
                                              : (p = p.filter(function (e) {
                                                    return e !== t.value;
                                                }))),
                                        Z.default.setParam(i, p),
                                        Z.default.setParam(i + "_and_condition", !!(this.parent.useAndCondition && p.length > 0) || null),
                                        Z.default.setParam(i + "_show_exact_rating", !!(this.parent.showExactRating && p.length > 0) || null),
                                        Z.default.setParam(i + "_exclude_from_value", !!(this.parent.excludePriceFromValue && p.length > 0) || null),
                                        Z.default.setParam(
                                            i.replace(l.a.prefix + "_l_", l.a.prefix + "_li_").replace(l.a.prefix + "_vl_", l.a.prefix + "_vli_") + "_ibsl",
                                            !!(this.parent.inventoryBaseSelectedLocations && p.length > 0) || null
                                        ),
                                        (a = "filter");
                                }
                                Z.default.setParam("page", 1);
                                var f = { filterOptionId: i, filterValue: this.value };
                                Z.default.applyFilter(a, f);
                            }
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            switch (((this.value = t.key), (this.label = u.a.stripHtml(t.key)), (this.docCount = t.doc_count ? t.doc_count : 0), (this.isRenderOnScroll = t.isRenderOnScroll), this.parent.filterType)) {
                                case Kn.a.FilterType.COLLECTION:
                                    (this.collectionId = t.key), (this.label = u.a.stripHtml(t.displayName ? t.displayName : t.label)), (this.handle = t.handle), (this.href = u.a.isCollectionPage() ? "/collections/" + this.handle : "#");
                                    var e = u.a.getDefaultSorting(this.collectionId);
                                    this.sortOrder = "" != e ? e : t.sort_order ? t.sort_order : l.a.defaultSorting;
                                    break;
                                case Kn.a.FilterType.REVIEW_RATINGS:
                                    (this.from = parseFloat(t.from).toFixed()), (this.value = this.from);
                                    break;
                                case Kn.a.FilterType.STOCK:
                                    (this.value = "in-stock" == t.key ? "true" : "false"), (this.label = u.a.stripHtml(t.label));
                                    break;
                                case Kn.a.FilterType.PERCENT_SALE:
                                    (this.from = t.from), (this.to = t.to), (this.label = this.buildPercentSaleLabel()), (this.value = (this.from ? this.from : "") + ":" + (this.to ? this.to : ""));
                                    break;
                                case Kn.a.FilterType.PRICE:
                                case Kn.a.FilterType.VARIANTS_PRICE:
                                    (this.from = t.from), (this.to = t.to), (this.label = this.buildPriceListLabel()), (this.value = (this.from ? this.from : "") + ":" + (this.to ? this.to : ""));
                            }
                            (this.label = this.buildLabel()), (this.countLabel = this.buildCount()), (this.isSelected = this.isAppliedFilter());
                        },
                    },
                ]) && Hi(e.prototype, r),
                n && Hi(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(d.a);
        function Ki(t) {
            return (Ki =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Yi(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ki(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ki(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ki(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Qi(t, e) {
            return (Qi = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ji(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Zi(t);
                if (e) {
                    var i = Zi(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Xi(this, r);
            };
        }
        function Xi(t, e) {
            if (e && ("object" === Ki(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Zi(t) {
            return (Zi = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var to = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Qi(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = Ji(o);
            function o(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, o),
                    ((e = i.call(this, t)).$element = null),
                    e
                );
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return this.parent.filterType == Kn.a.FilterType.COLLECTION
                                ? '\n\t\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t\t<a class="{{class.button}}" href="{{href}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t'.trim()
                                : '\n\t\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t\t<button role="checkbox" class="{{class.button}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</li>\n\t\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                .replace(/{{href}}/g, this.href)
                                .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel));
                        },
                    },
                ]) && Yi(e.prototype, r),
                n && Yi(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(zi);
        function eo(t) {
            return (eo =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ro(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function no(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== eo(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== eo(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === eo(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function io() {
            return (io =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = oo(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function oo(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = co(t)); );
            return t;
        }
        function ao(t, e) {
            return (ao = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function lo(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = co(t);
                if (e) {
                    var i = co(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return so(this, r);
            };
        }
        function so(t, e) {
            if (e && ("object" === eo(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function co(t) {
            return (co = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var uo = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ao(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = lo(o);
            function o() {
                return ro(this, o), i.apply(this, arguments);
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t<button role="checkbox" class="{{class.button}}">\n        <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t</button>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel));
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            io(co(o.prototype), "bindEvents", this).call(this), this.setBoxItemSize();
                        },
                    },
                    {
                        key: "setBoxItemSize",
                        value: function () {
                            this.filterTreeType == Ci.FilterTreeType.VERTICAL && this.$element && this.$element.css("width", this.parent.calculateBoxItemSize());
                        },
                    },
                ]) && no(e.prototype, r),
                n && no(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(zi);
        function po(t) {
            return (po =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function fo(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function ho(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== po(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== po(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === po(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function yo() {
            return (yo =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = mo(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function mo(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = So(t)); );
            return t;
        }
        function go(t, e) {
            return (go = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function bo(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = So(t);
                if (e) {
                    var i = So(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return vo(this, r);
            };
        }
        function vo(t, e) {
            if (e && ("object" === po(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function So(t) {
            return (So = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Oo = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && go(t, e);
            })(a, t);
            var e,
                r,
                n,
                i = bo(a);
            function a() {
                return fo(this, a), i.apply(this, arguments);
            }
            return (
                (e = a),
                (n = [
                    {
                        key: "SwatchType",
                        get: function () {
                            return { ONE_COLOR: "one_color", TWO_COLORS: "two_colors", IMAGE: "image" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.filterOptionItem}} {{disabled}} {{swatchBorder}}">\n\t\t\t\t<span class="boost-pfs-filter-option-swatch-image" \n\t\t\t\t\tstyle="background-color: {{backgroundColor}}; \n\t\t\t\t\tbackground-image: {{backgroundImage}};" title="{{label}}">\n\t\t\t\t</span>\n\t\t\t\t<button role="checkbox" class="{{class.button}}">\n          <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t</button>\n\t\t\t</li> \n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/{{label}}/g, this.label)
                                .replace(/{{countLabel}}/g, this.countLabel)
                                .replace(/{{backgroundColor}}/g, this.backgroundColor)
                                .replace(/{{backgroundImage}}/g, this.backgroundImage)
                                .replace(/{{swatchBorder}}/g, this.swatchBorder);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.buildSwatchSettings() ||
                                ((this.swatchFileName = this.buildSwatchFileName()),
                                (this.swatchFileUrl = u.a.getFilePath(this.swatchFileName, l.a.swatchExtension, o.a.getSettingValue("general.swatchImageVersion"))),
                                (this.backgroundImage = "url(" + this.swatchFileUrl + ");"),
                                (this.backgroundColor = this.buildBackgroundColor())),
                                (this.swatchBorder = ["white", "#FFFFFF"].includes(this.backgroundColor) ? "has-border" : ""),
                                yo(So(a.prototype), "render", this).call(this);
                        },
                    },
                    {
                        key: "buildSwatchSettings",
                        value: function () {
                            var t = this,
                                e = o.a.getSettingValue("swatch_settings"),
                                r = !1;
                            if (((this.swatchSettingKey = null), (this.swatchSetting = null), e)) {
                                var n = Object.keys(e);
                                Array.isArray(n) &&
                                    n.length > 0 &&
                                    (n.forEach(function (t) {
                                        if (t.toString().trim() !== t.toString()) {
                                            var r = t.toString().trim(),
                                                i = e[t];
                                            (i.name = r), (e[r] = i), n.push(r);
                                        }
                                    }),
                                    (this.swatchSettingKey = n.find(function (e) {
                                        return e.replace("pfs-swatch-", "") == t.value || e.replace("pfs-swatch-", "").toLowerCase() == t.value.toLowerCase();
                                    })),
                                    (this.swatchSetting = e[this.swatchSettingKey]));
                            }
                            if (e && this.swatchSetting)
                                switch (this.swatchSetting.type) {
                                    case a.SwatchType.ONE_COLOR:
                                        this.swatchSetting.colorCodes.length > 0 && this.swatchSetting.colorCodes[0] && ((this.backgroundImage = "none"), (this.backgroundColor = this.swatchSetting.colorCodes[0]), (r = !0));
                                        break;
                                    case a.SwatchType.TWO_COLORS:
                                        this.swatchSetting.colorCodes.length > 1 &&
                                            this.swatchSetting.colorCodes[0] &&
                                            this.swatchSetting.colorCodes[1] &&
                                            ((this.backgroundImage = "linear-gradient(to top left, " + this.swatchSetting.colorCodes[1] + " 50%, " + this.swatchSetting.colorCodes[0] + " 50%);"),
                                            (this.backgroundColor = "transparent"),
                                            (r = !0));
                                        break;
                                    case a.SwatchType.IMAGE:
                                        this.swatchSetting.imageUrl &&
                                            ((this.swatchFileUrl = this.swatchSetting.imageUrl), (this.backgroundImage = "url(" + this.swatchFileUrl + ");"), (this.backgroundColor = this.buildBackgroundColor()), (r = !0));
                                }
                            return r;
                        },
                    },
                    {
                        key: "buildSwatchFileName",
                        value: function () {
                            this.parent.filterOptionId;
                            var t = this.parent.prefix,
                                e = this.value;
                            this.parent.filterType == Kn.a.FilterType.COLLECTION && (e = this.label);
                            var r = this.parent.label.trim().toLowerCase().replace(/ /g, "_");
                            if (o.a.getSettingValue("general.removePrefixFromSwatchFile") && t) {
                                var n = t.replace(/\\/g, "");
                                e = e.replace(n, "");
                            }
                            return r + "-" + u.a.slugify(e).replace(/\#/g, "");
                        },
                    },
                    {
                        key: "buildBackgroundColor",
                        value: function () {
                            var t = u.a.slugify(this.label).split("-");
                            return t[t.length - 1];
                        },
                    },
                ]) && ho(e.prototype, r),
                n && ho(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(zi);
        function Po(t) {
            return (Po =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function To(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function wo(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Po(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Po(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Po(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function _o() {
            return (_o =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = Co(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function Co(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Io(t)); );
            return t;
        }
        function ko(t, e) {
            return (ko = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Eo(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Io(t);
                if (e) {
                    var i = Io(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Ro(this, r);
            };
        }
        function Ro(t, e) {
            if (e && ("object" === Po(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Io(t) {
            return (Io = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var jo = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ko(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = Eo(o);
            function o() {
                return To(this, o), i.apply(this, arguments);
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t<button role="checkbox" class="{{class.button}}" aria-label="{{adaLabel}}">\n          <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span> \n\t\t\t\t\t<span role="presentation" class="boost-pfs-filter-option-value">\n\t\t\t\t\t\t<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\x3c!--\n\t\t\t\t\t\t--\x3e<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\x3c!--\n\t\t\t\t\t\t--\x3e<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\x3c!--\n\t\t\t\t\t\t--\x3e<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\x3c!--\n\t\t\t\t\t\t--\x3e<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\n\t\t\t\t\t\t<span>{{label}}</span>\n\t\t\t\t\t</span>\t\n\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t</button>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            for (var t = this.getTemplate(), e = 0; e < this.from; e++) t = t.replace(/{{active}}/, "{{class.filterOptionItemStarActive}}");
                            return (t = t.replace(/{{active}}/g, ""))
                                .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                .replace(/{{class.filterOptionItemStar}}/g, q.a.filterOptionItemStar)
                                .replace(/{{class.filterOptionItemStarActive}}/g, q.a.filterOptionItemStarActive)
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel))
                                .replace(/{{adaLabel}}/g, u.a.stripHtml(this.adaLabel))
                                .replace(/{{starColor}}/g, u.a.stripHtml(this.parent.starColor))
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/\r?\n|\r/g, "");
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            (this.label = u.a.stripHtml(this.parent.showExactRating ? "" : a.a.ratingUp)),
                                (this.adaLabel = this.from),
                                1 == this.from ? (this.adaLabel += " " + a.a.ratingStar) : (this.adaLabel += " " + a.a.ratingStars),
                                this.parent.showExactRating && (this.adaLabel += " " + a.a.ratingUp);
                            var t = this.countLabel ? a.a.ada.productCount.replace(/{{count}}/g, this.countLabel) : "";
                            (this.adaLabel += ". " + t), (this.adaLabel = u.a.stripHtml(this.adaLabel)), _o(Io(o.prototype), "render", this).call(this);
                        },
                    },
                ]) && wo(e.prototype, r),
                n && wo(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(zi);
        function Lo(t) {
            return (Lo =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Bo(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Ao(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Lo(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Lo(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Lo(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function xo() {
            return (xo =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = Fo(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function Fo(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Vo(t)); );
            return t;
        }
        function $o(t, e) {
            return ($o = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Do(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Vo(t);
                if (e) {
                    var i = Vo(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Mo(this, r);
            };
        }
        function Mo(t, e) {
            if (e && ("object" === Lo(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Vo(t) {
            return (Vo = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var No = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && $o(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = Do(a);
            function a() {
                return Bo(this, a), o.apply(this, arguments);
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t<div class="boost-pfs-filter-option-item-parent-category">\n\t\t\t\t\t<span role="button" aria-controls="sub-category-{{value}}" aria-expanded="true" class="sub-icon {{closeClass}}"></span>\n\t\t\t\t\t<span class="{{class.filterOptionItem}} {{class.filterOptionLabel}} boost-pfs-filter-option-main-cat">\n\t\t\t\t\t\t{{label}}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<ul class="boost-pfs-filter-option-item-sub-category-list">\n\t\t\t\t\t{{subItems}}\n\t\t\t\t</ul>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getSubItemTemplate",
                        value: function () {
                            return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{selected}} boost-pfs-filter-option-item-sub-category">\n\t\t\t\t<span>\n\t\t\t\t\t{{subLabel}}\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = this,
                                e = "";
                            return (
                                Array.isArray(this.tags) &&
                                    this.tags.forEach(function (r) {
                                        var n = t.isSubCategorySelected(r);
                                        e += t
                                            .getSubItemTemplate()
                                            .replace(/{{subLabel}}/g, r)
                                            .replace(/{{selected}}/g, n ? "selected" : "");
                                    }),
                                this.getTemplate()
                                    .replace(/{{subItems}}/g, e)
                                    .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                    .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                    .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                                    .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                    .replace(/{{value}}/g, u.a.stripHtml(this.value))
                                    .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel))
                            );
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element.on("click", this.redirectToCollection.bind(this)), this.$element.find("ul > li").on("click", this.redirectToSubCategory.bind(this));
                        },
                    },
                    {
                        key: "isSubCategorySelected",
                        value: function (t) {
                            if (!u.a.isSearchPage()) {
                                var e = decodeURIComponent(window.location.pathname).split("/");
                                if (e[e.length - 1] == u.a.slugify(t)) return (this.isAnyTagSelected = !0), !0;
                            }
                            return !1;
                        },
                    },
                    {
                        key: "redirectToCollection",
                        value: function (t) {
                            t.preventDefault(), t.stopPropagation();
                            var e = "/collections/" + this.handle;
                            u.a.setWindowLocation(e);
                        },
                    },
                    {
                        key: "redirectToSubCategory",
                        value: function (t) {
                            t.preventDefault(), t.stopPropagation();
                            var e = i()(t.currentTarget).find("a").html(),
                                r = u.a.slugify(e),
                                n = "/collections/" + this.handle + "/" + r;
                            u.a.setWindowLocation(n);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            xo(Vo(a.prototype), "setData", this).call(this, t), (this.tags = t.tags);
                        },
                    },
                ]) && Ao(e.prototype, r),
                n && Ao(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(zi);
        function Ho(t) {
            return (Ho =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Uo(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Wo(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ho(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ho(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ho(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function qo() {
            return (qo =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = Go(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function Go(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Qo(t)); );
            return t;
        }
        function zo(t, e) {
            return (zo = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ko(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Qo(t);
                if (e) {
                    var i = Qo(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Yo(this, r);
            };
        }
        function Yo(t, e) {
            if (e && ("object" === Ho(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Qo(t) {
            return (Qo = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Jo = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && zo(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = Ko(o);
            function o() {
                return Uo(this, o), i.apply(this, arguments);
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "isRender",
                        value: function () {
                            return !1;
                        },
                    },
                    {
                        key: "setValue",
                        value: function (t, e) {
                            (this.value = t + ":" + e), (this.isSelected = this.min != t || this.max != e);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            qo(Qo(o.prototype), "setData", this).call(this, t), null != t.min && null != t.max && ((this.min = t.min), (this.max = t.max), (this.key = this.parent.filterOptionId), (this.value = t.min + ":" + t.max));
                        },
                    },
                ]) && Wo(e.prototype, r),
                n && Wo(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(zi);
        r(190);
        function Xo(t) {
            return (Xo =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Zo(t, e) {
            return (
                (function (t) {
                    if (Array.isArray(t)) return t;
                })(t) ||
                (function (t, e) {
                    var r = null == t ? null : ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                    if (null != r) {
                        var n,
                            i,
                            o,
                            a,
                            l = [],
                            s = !0,
                            c = !1;
                        try {
                            if (((o = (r = r.call(t)).next), 0 === e)) {
                                if (Object(r) !== r) return;
                                s = !1;
                            } else for (; !(s = (n = o.call(r)).done) && (l.push(n.value), l.length !== e); s = !0);
                        } catch (t) {
                            (c = !0), (i = t);
                        } finally {
                            try {
                                if (!s && null != r.return && ((a = r.return()), Object(a) !== a)) return;
                            } finally {
                                if (c) throw i;
                            }
                        }
                        return l;
                    }
                })(t, e) ||
                (function (t, e) {
                    if (!t) return;
                    if ("string" == typeof t) return ta(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    "Object" === r && t.constructor && (r = t.constructor.name);
                    if ("Map" === r || "Set" === r) return Array.from(t);
                    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ta(t, e);
                })(t, e) ||
                (function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                })()
            );
        }
        function ta(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
        }
        function ea(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Xo(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Xo(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Xo(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ra(t, e) {
            return (ra = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function na(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = oa(t);
                if (e) {
                    var i = oa(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ia(this, r);
            };
        }
        function ia(t, e) {
            if (e && ("object" === Xo(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function oa(t) {
            return (oa = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var aa = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ra(t, e);
                })(s, t);
                var e,
                    r,
                    n,
                    l = na(s);
                function s(t) {
                    var e;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, s),
                        ((e = l.call(this)).filterTreeType = t),
                        (e.isExpanded = !1),
                        (e.label = a.a.viewMore),
                        (e.class = q.a.filterOptionViewMore),
                        (e.isVisible = !0),
                        (e.$element = null),
                        e
                    );
                }
                return (
                    (e = s),
                    (n = [
                        {
                            key: "getViewMoreStateData",
                            value: function (t) {
                                return la.get(t);
                            },
                        },
                        {
                            key: "setViewMoreStateData",
                            value: function (t, e) {
                                la.set(t, e);
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                this.numberVisibleItems = this.getNumberVisibleItems();
                            },
                        },
                        {
                            key: "getTemplate",
                            value: function () {
                                switch (this.filterTreeType) {
                                    case Ci.FilterTreeType.VERTICAL:
                                        return '\n\t\t\t\t\t<div class="{{class.button}} {{class}}"><button>{{label}}</button></div>\n\t\t\t\t'.trim();
                                    case Ci.FilterTreeType.HORIZONTAL:
                                        return '\n\t\t\t\t\t<div class="{{class.button}} {{class}}"><button aria-label="{{label}}"></button></div>\n\t\t\t\t'.trim();
                                    default:
                                        console.warn("Pass a filter tree type into the constructor");
                                }
                            },
                        },
                        {
                            key: "compileTemplate",
                            value: function () {
                                return this.getTemplate()
                                    .replace(/{{class.button}}/g, q.a.button)
                                    .replace(/{{class}}/g, this.class)
                                    .replace(/{{label}}/g, u.a.stripHtml(this.label));
                            },
                        },
                        {
                            key: "isRender",
                            value: function () {
                                return this.parent.displayType != Kn.a.DisplayType.RANGE && (this.parent.showMoreType == Kn.a.ShowMoreType.VIEWMORE || this.parent.showMoreType == Kn.a.ShowMoreType.VIEWMORE_SCROLLBAR);
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                this.$element || (this.$element = i()(this.compileTemplate())), this.setVisibility();
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                this.$element &&
                                    (this.isBoundEvent || this.$element.on("click", this.onClick.bind(this)),
                                    this.parent.$filterOptionContentElement && this.parent.$filterOptionContentElement.addClass(q.a.filterHasViewMore),
                                    !this.isExpanded && s.getViewMoreStateData(this.parent.filterOptionId) ? this.onClick() : this.setFilterItemsVisibility());
                            },
                        },
                        {
                            key: "onClick",
                            value: function () {
                                (this.isExpanded = !this.isExpanded), s.setViewMoreStateData(this.parent.filterOptionId, this.isExpanded);
                                var t = "";
                                this.isExpanded
                                    ? ((this.label = a.a.viewLess), (this.class = q.a.filterOptionViewLess), (t = q.a.filterOptionViewMore))
                                    : ((this.label = a.a.viewMore), (this.class = q.a.filterOptionViewMore), (t = q.a.filterOptionViewLess)),
                                    this.filterTreeType == Ci.FilterTreeType.VERTICAL ? this.$element.find("button").html(u.a.stripHtml(this.label)) : this.$element.removeClass(t).addClass(this.class),
                                    this.setFilterItemsVisibility();
                            },
                        },
                        {
                            key: "getNumberVisibleItems",
                            value: function () {
                                var t = o.a.getSettingValue("general.startViewMore")[this.parent.displayType];
                                if (this.filterTreeType == Ci.FilterTreeType.HORIZONTAL) {
                                    var e = o.a.getSettingValue("general.filterHorizontalColumn");
                                    Number.isInteger(e) ? (t *= e) : (t = o.a.getSettingValue("general.startViewMoreH")[this.parent.displayType]);
                                }
                                return (!t || t <= 1) && (t = 5), t;
                            },
                        },
                        {
                            key: "setVisibility",
                            value: function () {
                                if (this.$element) {
                                    var t = this.parent.filterItems.size;
                                    this.parent.keepValuesStatic ||
                                        o.a.getSettingValue("general.showOutOfStockOption") ||
                                        (t = Array.from(this.parent.filterItems, function (t) {
                                            var e = Zo(t, 2);
                                            return { key: e[0], value: e[1] };
                                        }).filter(function (t) {
                                            return t.value.docCount > 0;
                                        }).length),
                                        this.parent.$filterItemsContainerElement && (t = this.parent.$filterItemsContainerElement.find("li").length),
                                        (this.isVisible = t > this.numberVisibleItems),
                                        this.isVisible ? this.$element.show() : this.$element.hide();
                                } else this.isVisible = !1;
                            },
                        },
                        {
                            key: "setFilterItemsVisibility",
                            value: function () {
                                if (this.parent.$filterItemsContainerElement) {
                                    var t = this.parent.$filterItemsContainerElement.find("li");
                                    if ((t.show(), !this.isExpanded)) {
                                        var e = this.numberVisibleItems,
                                            r = t.length;
                                        t.slice(e, r).hide();
                                    }
                                }
                            },
                        },
                    ]) && ea(e.prototype, r),
                    n && ea(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    s
                );
            })(d.a),
            la = new Map(),
            sa = aa;
        function ca(t) {
            return (ca =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ua(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ca(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ca(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ca(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function pa(t, e) {
            return (pa = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function fa(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ya(t);
                if (e) {
                    var i = ya(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ha(this, r);
            };
        }
        function ha(t, e) {
            if (e && ("object" === ca(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function ya(t) {
            return (ya = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var da = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && pa(t, e);
            })(s, t);
            var e,
                r,
                n,
                l = fa(s);
            function s() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, s),
                    ((t = l.call(this)).$element = null),
                    (t.searchValue = ""),
                    t
                );
            }
            return (
                (e = s),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.filterOptionShowSearchBox}}-wrapper">\n\t\t\t\t<input role="textbox" aria-label="Search Options" class="{{class.filterOptionShowSearchBox}}" type="text" autocomplete="on" placeholder="{{label.searchOptions}}" />\n\t\t\t</div>\n        '.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{class.filterOptionShowSearchBox}}/g, q.a.filterOptionShowSearchBox)
                                .replace(/{{label.searchOptions}}/g, a.a.searchOptions);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            if (this.parent.filterTreeType == Ci.FilterTreeType.HORIZONTAL) return !1;
                            var t = this.parent.showSearchBoxFilterPC || o.a.getSettingValue("general.showSearchBoxFilterPCByDefault"),
                                e = this.parent.showSearchBoxFilterMobile || o.a.getSettingValue("general.showSearchBoxFilterMobileByDefault"),
                                r = [Kn.a.FilterType.PRICE, Kn.a.FilterType.PERCENT_SALE, Kn.a.FilterType.STOCK],
                                n = [Kn.a.DisplayType.RANGE, Kn.a.DisplayType.MULTI_LEVEL_TAG, Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS],
                                i = !r.includes(this.parent.filterType) && !n.includes(this.parent.displayType),
                                a = u.a.isMobile();
                            return i && ((!a && t) || (a && e));
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate()));
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && (this.$element.find("input").on("keyup", this.onKeyUp.bind(this)), this.parent.$filterOptionContentElement && this.parent.$filterOptionContentElement.addClass(q.a.filterHasSearchBox));
                        },
                    },
                    {
                        key: "onKeyUp",
                        value: function (t) {
                            this.setSearchValue(t), this.setFilterItemsList();
                        },
                    },
                    {
                        key: "setSearchValue",
                        value: function (t) {
                            if (t && t.target) {
                                var e = u.a.stripHtml(t.target.value);
                                if (u.a.isBadSearchTerm(e)) return void (this.searchValue = "");
                                (e = "function" == typeof e.toString ? e.toLowerCase().trim() : ""), (this.searchValue = e);
                            } else this.searchValue = "";
                        },
                    },
                    {
                        key: "setFilterItemsList",
                        value: function () {
                            var t = this;
                            if (this.parent.$filterItemsContainerElement) {
                                if (this.searchValue)
                                    this.parent.filterItems.forEach(function (e) {
                                        e.$element && (e.label && e.label.toLowerCase().includes(t.searchValue) ? e.$element.appendTo(t.parent.$filterItemsContainerElement) : e.$element.detach());
                                    });
                                else {
                                    var e = 0,
                                        r = o.a.getSettingValue("general.scrollFirstLoadLength");
                                    this.parent.filterItems.forEach(function (n) {
                                        (n.isRenderOnScroll = t.parent.isLoadMoreOnScroll && e >= r), n.$element && (n.isRenderOnScroll ? n.$element.detach() : n.$element.appendTo(t.parent.$filterItemsContainerElement)), e++;
                                    }),
                                        (this.parent.scrollbar.numberFilterItemsRendered = r);
                                }
                                this.parent.viewMore && this.parent.viewMore.isRender() && (this.parent.viewMore.setVisibility(), this.parent.viewMore.setFilterItemsVisibility());
                            }
                        },
                    },
                ]) && ua(e.prototype, r),
                n && ua(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(d.a);
        function ma(t) {
            return (ma =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ga(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== ma(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== ma(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === ma(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ba(t, e) {
            return (ba = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function va(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Oa(t);
                if (e) {
                    var i = Oa(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Sa(this, r);
            };
        }
        function Sa(t, e) {
            if (e && ("object" === ma(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Oa(t) {
            return (Oa = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Pa = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ba(t, e);
            })(a, t);
            var e,
                r,
                n,
                o = va(a);
            function a(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((e = o.call(this)).tooltipText = "string" == typeof t ? u.a.stripHtml(u.a.stripHtml(t)).trim() : null),
                    (e.$element = null),
                    (e.$popupElement = null),
                    e
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case "popup":
                                    return '\n\t\t\t\t\t<div class="boost-pfs-filter-tooltip-wrapper">\n\t\t\t\t\t\t<div class="boost-pfs-filter-qtip-content">{{tooltipText}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.filterOptionTooltip}}">\n\t\t\t\t\t\t<span class="boost-pfs-filter-tooltip-arrow"></span>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function (t) {
                            return this.getTemplate(t)
                                .replace(/{{tooltipText}}/g, this.tooltipText)
                                .replace(/{{class.filterOptionTooltip}}/g, q.a.filterOptionTooltip);
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return !!this.tooltipText;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.$element || (this.$element = i()(this.compileTemplate())), this.$popupElement || (this.$popupElement = i()(this.compileTemplate("popup")));
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            this.$element && this.$popupElement && this.$element.on("mouseover", this.showTooltipPopup.bind(this));
                        },
                    },
                    {
                        key: "showTooltipPopup",
                        value: function () {
                            var t = this.$element.position(),
                                e = this.$popupElement.find(".boost-pfs-filter-qtip-content").outerWidth();
                            this.$popupElement.css("left", t.left + "px"), e / 2 < t.left ? this.$popupElement.css("margin-left", -(e / 2 - 12) + "px") : e / 2 > t.left && this.$popupElement.css("margin-left", -t.left / 2 + "px");
                        },
                    },
                ]) && ga(e.prototype, r),
                n && ga(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(d.a);
        function Ta(t) {
            return (Ta =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function wa(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ta(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ta(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ta(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function _a(t, e) {
            return (_a = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ca(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ea(t);
                if (e) {
                    var i = Ea(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ka(this, r);
            };
        }
        function ka(t, e) {
            if (e && ("object" === Ta(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ea(t) {
            return (Ea = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ra = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && _a(t, e);
                })(a, t);
                var e,
                    r,
                    n,
                    i = Ca(a);
                function a() {
                    var t;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, a),
                        ((t = i.call(this)).placeHolderHeight = ""),
                        (t.numberFilterItemsRendered = 0),
                        (t.$scrollElement = null),
                        t
                    );
                }
                return (
                    (e = a),
                    (n = [
                        {
                            key: "getScrollStateData",
                            value: function (t) {
                                return Ia.get(t);
                            },
                        },
                        {
                            key: "setScrollStateData",
                            value: function (t, e) {
                                Ia.set(t, e);
                            },
                        },
                        {
                            key: "isEnabled",
                            value: function (t, e, r) {
                                var n = [Kn.a.DisplayType.RANGE],
                                    i = [Kn.a.FilterType.REVIEW_RATINGS, Kn.a.FilterType.STOCK, Kn.a.FilterType.PERCENT_SALE, Kn.a.FilterType.PRICE, Kn.a.FilterType.VARIANTS_PRICE],
                                    a = r == Kn.a.ShowMoreType.SCROLLBAR || r == Kn.a.ShowMoreType.VIEWMORE_SCROLLBAR,
                                    l = u.a.isMobile(),
                                    s = (l && o.a.getSettingValue("general.activeFilterScrollbarMobile")) || (!l && o.a.getSettingValue("general.activeFilterScrollbarPC"));
                                return !n.includes(t) && !i.includes(e) && a && s;
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "isBindEvents",
                            value: function () {
                                return !this.isBoundEvent;
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                if (this.parent.$element && a.isEnabled(this.parent.displayType, this.parent.filterType, this.parent.showMoreType)) {
                                    var t = this.parent.$element.find("." + q.a.filterOptionContentInner);
                                    if (
                                        t.length > 0 &&
                                        ((this.$scrollElement = t),
                                        (this.parent.isLoadMoreOnScroll || o.a.getSettingValue("general.keepScrollState")) && this.$scrollElement.on("scroll", this.onScroll.bind(this)),
                                        o.a.getSettingValue("general.keepScrollState"))
                                    ) {
                                        var e = a.getScrollStateData(this.parent.filterOptionId);
                                        isNaN(e) || (this.$scrollElement[0].scrollTop = e);
                                    }
                                }
                            },
                        },
                        {
                            key: "onScroll",
                            value: function () {
                                if (o.a.getSettingValue("general.keepScrollState")) {
                                    var t = this.$scrollElement[0].scrollTop;
                                    a.setScrollStateData(this.parent.filterOptionId, t);
                                }
                                this.parent.isLoadMoreOnScroll && this.isScrollToBottom() && ((this.parent.searchBox && this.parent.searchBox.searchValue) || this.appendFilterItems());
                            },
                        },
                        {
                            key: "isScrollToBottom",
                            value: function () {
                                return !!this.$scrollElement && this.$scrollElement[0].scrollHeight - this.$scrollElement[0].scrollTop - this.$scrollElement.outerHeight() < 1;
                            },
                        },
                        {
                            key: "appendFilterItems",
                            value: function () {
                                var t = this;
                                if (this.parent.$filterItemsContainerElement) {
                                    var e = o.a.getSettingValue("general.scrollFirstLoadLength");
                                    if (0 == this.numberFilterItemsRendered) this.numberFilterItemsRendered = e;
                                    else if (this.numberFilterItemsRendered == this.parent.filterItems.size) return;
                                    this.parent.$element.addClass("boost-pfs-filter-scrollbar-loading");
                                    var r = 0;
                                    this.parent.filterItems.forEach(function (n) {
                                        n.isRenderOnScroll && r < e && (t.parent.$filterItemsContainerElement.append(n.$element), (n.isRenderOnScroll = !1), r++, t.numberFilterItemsRendered++);
                                    }),
                                        setTimeout(
                                            function () {
                                                this.parent.$element.removeClass("boost-pfs-filter-scrollbar-loading");
                                            }.bind(this),
                                            200
                                        );
                                }
                            },
                        },
                    ]) && wa(e.prototype, r),
                    n && wa(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    a
                );
            })(d.a),
            Ia = new Map(),
            ja = Ra;
        function La(t) {
            return (La =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ba(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Aa(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== La(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== La(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === La(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function xa(t, e, r) {
            return e && Aa(t.prototype, e), r && Aa(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
        }
        function Fa() {
            return (Fa =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = $a(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function $a(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ha(t)); );
            return t;
        }
        function Da(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ma(t, e);
        }
        function Ma(t, e) {
            return (Ma = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Va(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ha(t);
                if (e) {
                    var i = Ha(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Na(this, r);
            };
        }
        function Na(t, e) {
            if (e && ("object" === La(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ha(t) {
            return (Ha = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ua = (function (t) {
                Da(r, t);
                var e = Va(r);
                function r(t) {
                    var n;
                    return Ba(this, r), ((n = e.call(this, t)).$element = null), (n.$itemElement = null), (n.$childContainerElement = null), n;
                }
                return (
                    xa(
                        r,
                        [
                            {
                                key: "init",
                                value: function () {
                                    var t = this.filterOption ? this.filterOption.selectType : this.parent.selectType;
                                    this.requestInstantly = this.filterTreeType == Ci.FilterTreeType.VERTICAL || t == Kn.a.SelectType.SINGLE || o.a.getSettingValue("general.requestInstantly");
                                },
                            },
                            {
                                key: "getTemplate",
                                value: function () {
                                    return '\n\t\t\t<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t'.trim();
                                },
                            },
                            {
                                key: "getArrowTemplate",
                                value: function () {
                                    return '\n\t\t\t<button class="{{class.button}} {{class.button}}-arrow" data-action="expand-filter-item" aria-label="{{label.ada.toggleMultiLevel}}">\n\t\t\t\t<span class="boost-pfs-arrow"></span>\n\t\t\t</button>\n\t\t'.trim();
                                },
                            },
                            {
                                key: "compileArrowTemplate",
                                value: function () {
                                    return 3 != this.level && this.children && this.children.length > 0
                                        ? this.getArrowTemplate().replace(/{{label.ada.toggleMultiLevel}}/g, Labels.ada.toggleMultiLevel.replace(/{{filterItem}}/g, this.label))
                                        : "";
                                },
                            },
                            {
                                key: "compileTemplate",
                                value: function () {
                                    return this.getTemplate()
                                        .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                        .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                        .replace(/{{label}}/g, this.label)
                                        .replace(/{{href}}/g, this.href)
                                        .replace(/{{arrow}}/g, this.compileArrowTemplate())
                                        .replace(/{{class.button}}/g, q.a.button)
                                        .replace(/{{childItems}}/g, "");
                                },
                            },
                            {
                                key: "render",
                                value: function () {
                                    var t = this;
                                    if (
                                        (this.$element ||
                                            ((this.$element = i()(this.compileTemplate())),
                                            (this.$itemElement = this.$element.find("." + q.a.filterOptionItem)),
                                            (this.$itemClickElement = this.$itemElement.find('[data-action="select-filter-item"]')),
                                            (this.$toggleClickElement = this.$itemElement.find('[data-action="expand-filter-item"]')),
                                            (this.$childContainerElement = this.$element.find(".boost-pfs-filter-option-multi-level-list")),
                                            this.$childContainerElement &&
                                                this.children &&
                                                this.children.length > 0 &&
                                                this.children.forEach(function (e) {
                                                    e.$element && t.$childContainerElement.append(e.$element);
                                                })),
                                        this.$itemElement)
                                    ) {
                                        this.isSelected || this.isSelectedChild
                                            ? (this.$itemElement.addClass("selected"), this.$itemElement.find("a").attr("aria-current", !0))
                                            : (this.$itemElement.removeClass("selected"), this.$itemElement.find("a").removeAttr("aria-current"));
                                        var e = r.getLevelOpenStateData(this),
                                            n = o.a.getSettingValue("general.openMultiLevelByDefault");
                                        e || (Array.isArray(n) && n.includes(this.level)) || (null == e && this.isSelectedChild)
                                            ? (this.$itemElement.addClass("boost-pfs-open"), r.setLevelOpenStateData(this, !0))
                                            : r.setLevelOpenStateData(this, !1);
                                    }
                                },
                            },
                            {
                                key: "bindEvents",
                                value: function () {
                                    this.$itemClickElement && this.$itemClickElement.on("click", this.onClick.bind(this)), this.$toggleClickElement && this.$toggleClickElement.on("click", this.onClickToggle.bind(this));
                                },
                            },
                            {
                                key: "onClick",
                                value: function (t) {
                                    t && t.preventDefault(),
                                        this.setCollectionParams(),
                                        this.clearAllTagParams(),
                                        Z.default.setParam("page", 1),
                                        this.children && this.children.length > 0 && r.setLevelOpenStateData(this, !0),
                                        this.requestInstantly && Z.default.applyFilter("collection");
                                },
                            },
                            {
                                key: "onClickToggle",
                                value: function () {
                                    this.$itemElement.toggleClass("boost-pfs-open"), this.$itemElement.hasClass("boost-pfs-open") ? r.setLevelOpenStateData(this, !0) : r.setLevelOpenStateData(this, !1);
                                },
                            },
                            {
                                key: "isAppliedFilter",
                                value: function () {
                                    return l.a.collectionId == this.collectionId;
                                },
                            },
                            {
                                key: "setCollectionParams",
                                value: function () {
                                    u.a.isCollectionPage()
                                        ? (c.a.setAddressBarPathAfterFilter(this.href), c.a.setWindowTitleAfterFilter(this.label + " - " + l.a.shopName), Z.default.setParam("sort", this.sortOrder), (l.a.defaultSorting = this.sortOrder))
                                        : Z.default.setParam(this.filterOption.filterOptionId, this.collectionId),
                                        (l.a.collectionId = this.collectionId),
                                        Z.default.setParam("collection_scope", this.collectionId);
                                },
                            },
                            {
                                key: "clearAllTagParams",
                                value: function () {
                                    var t = this.filterOption.filterOptionId.replace(l.a.prefix + "_c", l.a.prefix + "_ct");
                                    Z.default.setParam(t, null), (l.a.collectionTags = []);
                                    var e = [];
                                    Object.keys(l.a.queryParams).forEach(function (t) {
                                        t.startsWith(l.a.prefix) && !t.startsWith(l.a.prefix + "_c") && e.push(t);
                                    }),
                                        e.forEach(function (t) {
                                            Z.default.setParam(t, null);
                                        });
                                },
                            },
                            {
                                key: "setData",
                                value: function (t) {
                                    var e = this;
                                    Fa(Ha(r.prototype), "setData", this).call(this, t), (this.filterOption = this.parent), (this.level = 1), (this.href = u.a.isCollectionPage() ? "/collections/" + this.handle : "#");
                                    var n = u.a.getDefaultSorting(this.collectionId);
                                    (this.sortOrder = "" != n ? n : t.sort_order ? t.sort_order : l.a.defaultSorting),
                                        (this.children = []),
                                        Array.isArray(t.tags) &&
                                            t.tags.forEach(function (t) {
                                                if (t.tag) {
                                                    var r = new Wa(e.filterTreeType);
                                                    e.addComponent(r), r.setData(t);
                                                }
                                            }),
                                        (this.isSelected = this.isAppliedFilter()),
                                        (this.isSelectedChild = this.children.some(function (t) {
                                            return t.isSelected || t.isSelectedChild;
                                        })),
                                        this.filterOption.allNestedFilterItems.set(this.collectionId, this);
                                },
                            },
                        ],
                        [
                            {
                                key: "getLevelOpenStateData",
                                value: function (t) {
                                    var e = t.filterOption.filterOptionId,
                                        r = t.collectionId,
                                        n = t.tag,
                                        i = e + ":" + r + (n ? ":" + n : "");
                                    return Ga.get(i);
                                },
                            },
                            {
                                key: "setLevelOpenStateData",
                                value: function (t, e) {
                                    var r = t.filterOption.filterOptionId,
                                        n = t.collectionId,
                                        i = t.tag,
                                        o = r + ":" + n + (i ? ":" + i : "");
                                    Ga.set(o, e);
                                },
                            },
                        ]
                    ),
                    r
                );
            })(zi),
            Wa = (function (t) {
                Da(r, t);
                var e = Va(r);
                function r() {
                    return Ba(this, r), e.apply(this, arguments);
                }
                return (
                    xa(r, [
                        {
                            key: "getTemplate",
                            value: function () {
                                return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                            },
                        },
                        {
                            key: "onClick",
                            value: function (t) {
                                t && t.preventDefault(),
                                    (this.collectionId == l.a.collectionId && o.a.getSettingValue("general.multiLevelCollectionSelectType") != Kn.a.SelectType.SINGLE) || this.clearAllTagParams(),
                                    this.setCollectionParams(),
                                    this.setTagParams(),
                                    Z.default.setParam("page", 1),
                                    this.children && this.children.length > 0 && Ua.setLevelOpenStateData(this, !0),
                                    this.requestInstantly && Z.default.applyFilter("collection");
                            },
                        },
                        {
                            key: "setTagParams",
                            value: function () {
                                if (u.a.isCollectionPage() && o.a.getSettingValue("general.multiLevelCollectionSelectType") != Kn.a.SelectType.MULTIPLE) (l.a.collectionTags = this.tag), c.a.setAddressBarPathAfterFilter(this.href);
                                else {
                                    Array.isArray(l.a.collectionTags) || (l.a.collectionTags = []);
                                    var t = l.a.collectionTags.indexOf(this.tag);
                                    t > -1 ? l.a.collectionTags.splice(t, 1) : l.a.collectionTags.push(this.tag), (o.a.general.tagMode = "2");
                                    var e = this.filterOption.filterOptionId.replace(l.a.prefix + "_c_", l.a.prefix + "_ct_");
                                    Array.isArray(l.a.collectionTags) && l.a.collectionTags.length > 0 ? Z.default.setParam(e, l.a.collectionTags) : Z.default.setParam(e, null);
                                }
                            },
                        },
                        {
                            key: "isAppliedFilter",
                            value: function () {
                                var t = (Array.isArray(l.a.collectionTags) && l.a.collectionTags.includes(this.tag)) || l.a.collectionTags == this.tag;
                                return l.a.collectionId == this.collectionId && t;
                            },
                        },
                        {
                            key: "setData",
                            value: function (t) {
                                var e = this;
                                (this.tag = t.tag),
                                    (this.slugifyTag = u.a.slugify(this.tag)),
                                    (this.label = t.displayName ? t.displayName : t.tag),
                                    (this.filterOption = this.parent.filterOption),
                                    (this.requestInstantly = this.parent.requestInstantly),
                                    (this.collectionId = this.parent.collectionId),
                                    (this.handle = this.parent.handle),
                                    (this.level = 2),
                                    (this.href = u.a.isCollectionPage() && o.a.getSettingValue("general.multiLevelCollectionSelectType") != Kn.a.SelectType.MULTIPLE ? "/collections/" + this.handle + "/" + this.slugifyTag : "#"),
                                    (this.sortOrder = this.parent.sortOrder ? this.parent.sortOrder : l.a.defaultSorting),
                                    (this.children = []),
                                    Array.isArray(t.subTags) &&
                                        t.subTags.forEach(function (t) {
                                            if (t.tag) {
                                                var r = new qa(e.filterTreeType);
                                                e.addComponent(r), r.setData(t);
                                            }
                                        }),
                                    (this.label = this.buildLabel()),
                                    (this.isSelected = this.isAppliedFilter()),
                                    (this.isSelectedChild = this.children.some(function (t) {
                                        return t.isSelected || t.isSelectedChild;
                                    })),
                                    this.filterOption.allNestedFilterItems.set(this.collectionId + ":" + this.tag, this);
                            },
                        },
                    ]),
                    r
                );
            })(Ua),
            qa = (function (t) {
                Da(r, t);
                var e = Va(r);
                function r() {
                    return Ba(this, r), e.apply(this, arguments);
                }
                return (
                    xa(r, [
                        {
                            key: "getTemplate",
                            value: function () {
                                return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-third-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                            },
                        },
                        {
                            key: "setData",
                            value: function (t) {
                                (this.tag = t.tag),
                                    (this.slugifyTag = u.a.slugify(this.tag)),
                                    (this.label = t.displayName ? t.displayName : t.tag),
                                    (this.filterOption = this.parent.filterOption),
                                    (this.requestInstantly = this.parent.requestInstantly),
                                    (this.collectionId = this.parent.collectionId),
                                    (this.handle = this.parent.handle),
                                    (this.level = 3),
                                    (this.href = u.a.isCollectionPage() && o.a.getSettingValue("general.multiLevelCollectionSelectType") != Kn.a.SelectType.MULTIPLE ? "/collections/" + this.handle + "/" + this.slugifyTag : "#"),
                                    this.filterOption.allNestedFilterItems.set(this.collectionId + ":" + this.tag, this),
                                    (this.sortOrder = this.parent.sortOrder ? this.parent.sortOrder : l.a.defaultSorting),
                                    (this.label = this.buildLabel()),
                                    (this.isSelected = this.isAppliedFilter());
                            },
                        },
                    ]),
                    r
                );
            })(Wa),
            Ga = new Map(),
            za = Ua;
        function Ka(t) {
            return (Ka =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ya(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Qa(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ka(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ka(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ka(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ja(t, e, r) {
            return e && Qa(t.prototype, e), r && Qa(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
        }
        function Xa(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Za(t, e);
        }
        function Za(t, e) {
            return (Za = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function tl(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = rl(t);
                if (e) {
                    var i = rl(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return el(this, r);
            };
        }
        function el(t, e) {
            if (e && ("object" === Ka(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function rl(t) {
            return (rl = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var nl = (function (t) {
                Xa(r, t);
                var e = tl(r);
                function r(t) {
                    var n;
                    return Ya(this, r), ((n = e.call(this, t)).$element = null), (n.$itemElement = null), (n.$childContainerElement = null), n;
                }
                return (
                    Ja(
                        r,
                        [
                            {
                                key: "init",
                                value: function () {
                                    this.filterOption ? this.filterOption.selectType : this.parent.selectType;
                                    this.requestInstantly = this.filterTreeType == Ci.FilterTreeType.VERTICAL || o.a.getSettingValue("general.requestInstantly");
                                },
                            },
                            {
                                key: "getTemplate",
                                value: function () {
                                    return '\n\t\t\t<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t{{swatch}}\n\t\t\t\t\t<button class="{{class.button}}" data-action="select-filter-item">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t'.trim();
                                },
                            },
                            {
                                key: "getSwatchTemplate",
                                value: function () {
                                    return '\n\t\t\t<span class="boost-pfs-filter-option-swatch-image" \n\t\t\t\tstyle="background-color: {{backgroundColor}}; \n\t\t\t\tbackground-image: url({{swatchFileUrl}});" title="{{label}}">\n\t\t\t</span>\n\t\t'.trim();
                                },
                            },
                            {
                                key: "getArrowTemplate",
                                value: function () {
                                    return '\n\t\t\t<button class="{{class.button}} {{class.button}}-arrow" data-action="expand-filter-item" aria-label="{{label.ada.toggleMultiLevel}}">\n\t\t\t\t<span class="boost-pfs-arrow"></span>\n\t\t\t</button>\n\t\t'.trim();
                                },
                            },
                            {
                                key: "compileSwatchTemplate",
                                value: function () {
                                    return this.getSwatchTemplate()
                                        .replace(/{{backgroundColor}}/g, this.backgroundColor)
                                        .replace(/{{swatchFileUrl}}/g, this.swatchFileUrl);
                                },
                            },
                            {
                                key: "compileArrowTemplate",
                                value: function () {
                                    return 3 != this.level && this.children && this.children.length > 0
                                        ? this.getArrowTemplate().replace(/{{label.ada.toggleMultiLevel}}/g, Labels.ada.toggleMultiLevel.replace(/{{filterItem}}/g, u.a.stripHtml(this.label)))
                                        : "";
                                },
                            },
                            {
                                key: "compileTemplate",
                                value: function () {
                                    return this.getTemplate()
                                        .replace(/{{class.filterOptionItem}}/g, q.a.filterOptionItem)
                                        .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                        .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                        .replace(/{{swatch}}/g, this.filterOption.displayTypeItem == Kn.a.DisplayType.SWATCH ? this.compileSwatchTemplate() : "")
                                        .replace(/{{arrow}}/g, this.compileArrowTemplate())
                                        .replace(/{{class.button}}/g, q.a.button)
                                        .replace(/{{childItems}}/g, "");
                                },
                            },
                            {
                                key: "render",
                                value: function () {
                                    var t = this;
                                    if (
                                        (this.$element ||
                                            ((this.$element = i()(this.compileTemplate())),
                                            (this.$itemElement = this.$element.find("." + q.a.filterOptionItem)),
                                            (this.$itemClickElement = this.$itemElement.find('[data-action="select-filter-item"]')),
                                            (this.$toggleClickElement = this.$itemElement.find('[data-action="expand-filter-item"]')),
                                            (this.$childContainerElement = this.$element.find(".boost-pfs-filter-option-multi-level-list")),
                                            this.$childContainerElement &&
                                                this.children &&
                                                this.children.length > 0 &&
                                                this.children.forEach(function (e) {
                                                    e.$element && t.$childContainerElement.append(e.$element);
                                                })),
                                        (this.isSelected = this.isAppliedFilter()),
                                        (this.isSelectedChild = !1),
                                        Array.isArray(this.children) &&
                                            (this.isSelectedChild = this.children.some(function (t) {
                                                return t.isSelected || t.isSelectedChild;
                                            })),
                                        this.$itemElement)
                                    ) {
                                        this.isSelected || (this.filterOption.selectType == Kn.a.SelectType.SINGLE && this.isSelectedChild)
                                            ? (this.$itemElement.addClass("selected"), this.$itemElement.find("button").attr("aria-checked", !0), this.$itemElement.find(".boost-pfs-check-box").attr("aria-checked", !0))
                                            : (this.$itemElement.removeClass("selected"), this.$itemElement.find("button").removeAttr("aria-checked"), this.$itemElement.find(".boost-pfs-check-box").removeAttr("aria-checked"));
                                        var e = r.getLevelOpenStateData(this),
                                            n = o.a.getSettingValue("general.openMultiLevelByDefault");
                                        e || (Array.isArray(n) && n.includes(this.level)) || (null == e && this.isSelectedChild)
                                            ? (this.$itemElement.addClass("boost-pfs-open"), r.setLevelOpenStateData(this, !0))
                                            : r.setLevelOpenStateData(this, !1);
                                    }
                                },
                            },
                            {
                                key: "bindEvents",
                                value: function () {
                                    this.$itemClickElement && this.$itemClickElement.on("click", this.onClick.bind(this)), this.$toggleClickElement && this.$toggleClickElement.on("click", this.onClickToggle.bind(this));
                                },
                            },
                            {
                                key: "isAppliedFilter",
                                value: function () {
                                    var t = l.a.queryParams[this.filterOption.filterOptionId];
                                    return !(!Array.isArray(t) || !t.includes(this.value));
                                },
                            },
                            {
                                key: "onSelectFilter",
                                value: function () {
                                    this.children && this.children.length > 0 && (this.$itemElement.addClass("boost-pfs-open"), r.setLevelOpenStateData(this, !0)),
                                        this.filterOption.selectType == Kn.a.SelectType.SINGLE &&
                                            this.filterOption.allNestedFilterItems.forEach(function (t) {
                                                t.$itemElement &&
                                                    (t.$itemElement.removeClass("selected"),
                                                    t.$itemElement.find("button").removeAttr("aria-checked"),
                                                    t.$itemElement.find(".boost-pfs-check-box").removeAttr("aria-checked"),
                                                    (t.isSelected = !1));
                                            }),
                                        this.filterOption.selectType == Kn.a.SelectType.SINGLE
                                            ? ((this.isSelected = !0),
                                              this.$itemElement.addClass("selected"),
                                              this.level > 1 &&
                                                  (this.parent.$itemElement.addClass("selected"),
                                                  this.parent.$itemElement.find("button").attr("aria-checked", !0),
                                                  this.parent.$itemElement.find(".boost-pfs-check-box").attr("aria-checked", !0)),
                                              this.level > 2 &&
                                                  (this.parent.parent.$itemElement.addClass("selected"),
                                                  this.parent.parent.$itemElement.find("button").attr("aria-checked", !0),
                                                  this.parent.parent.$itemElement.find(".boost-pfs-check-box").attr("aria-checked", !0)))
                                            : ((this.isSelected = !this.isSelected),
                                              this.$itemElement.toggleClass("selected"),
                                              this.$itemElement.find("button").toggleAttr("aria-checked"),
                                              this.$itemElement.find(".boost-pfs-check-box").toggleAttr("aria-checked"));
                                },
                            },
                            {
                                key: "onApplyFilter",
                                value: function () {
                                    var t = this;
                                    if (this.isSelected && this.filterOption.selectType == Kn.a.SelectType.SINGLE)
                                        this.children && this.children.length > 0 && (this.$itemElement.addClass("boost-pfs-open"), r.setLevelOpenStateData(this, !0));
                                    else {
                                        this.children && this.children.length > 0 && r.setLevelOpenStateData(this, !0);
                                        var e = this.filterOption.filterOptionId;
                                        this.isSelected = !this.isSelected;
                                        var n = null;
                                        this.filterOption.selectType == Kn.a.SelectType.SINGLE
                                            ? (n = this.isSelected ? [this.value] : [])
                                            : ((n = l.a.queryParams[e]),
                                              Array.isArray(n) || (n = []),
                                              this.isSelected
                                                  ? n.includes(this.value) || n.push(this.value)
                                                  : (n = n.filter(function (e) {
                                                        return e !== t.value;
                                                    }))),
                                            Z.default.setParam(e, n),
                                            Z.default.setParam(e + "_and_condition", !!(this.filterOption.useAndCondition && n.length > 0) || null),
                                            Z.default.setParam("page", 1);
                                        var i = { filterOptionId: e, filterValue: this.value };
                                        Z.default.applyFilter("filter", i);
                                    }
                                },
                            },
                            {
                                key: "onClickToggle",
                                value: function () {
                                    this.$itemElement.toggleClass("boost-pfs-open"), this.$itemElement.hasClass("boost-pfs-open") ? r.setLevelOpenStateData(this, !0) : r.setLevelOpenStateData(this, !1);
                                },
                            },
                            {
                                key: "setData",
                                value: function (t) {
                                    var e = this;
                                    (this.value = t.tag),
                                        (this.label = u.a.stripHtml(t.displayName ? t.displayName : t.tag)),
                                        (this.docCount = t.doc_count ? t.doc_count : 0),
                                        (this.level = 1),
                                        (this.id = this.value),
                                        (this.filterOption = this.parent),
                                        (this.label = u.a.stripHtml(this.buildLabel())),
                                        this.filterOption.displayTypeItem == Kn.a.DisplayType.SWATCH && this.setSwatchData(),
                                        (this.children = []),
                                        Array.isArray(t.subTags) &&
                                            t.subTags.forEach(function (t) {
                                                if (t.tag) {
                                                    var r = new il(e.filterTreeType);
                                                    e.addComponent(r), r.setData(t);
                                                }
                                            }),
                                        this.filterOption.allNestedFilterItems.set(this.value, this);
                                },
                            },
                            {
                                key: "setSwatchData",
                                value: function () {
                                    var t = this.filterOption.filterOptionId.replace("pf_t_", "").replace("pf_opt_", "");
                                    (this.swatchFileName = t + "-" + u.a.slugify(u.a.stripHtml(this.label)).replace(/\#/g, "")),
                                        (this.swatchFileUrl = u.a.getFilePath(this.swatchFileName, l.a.swatchExtension, o.a.getSettingValue("general.swatchImageVersion")));
                                    var e = u.a.slugify(u.a.stripHtml(this.label)).split("-");
                                    this.backgroundColor = e[e.length - 1];
                                },
                            },
                        ],
                        [
                            {
                                key: "getLevelOpenStateData",
                                value: function (t) {
                                    var e = t.filterOption.filterOptionId + ":" + t.value;
                                    return al.get(e);
                                },
                            },
                            {
                                key: "setLevelOpenStateData",
                                value: function (t, e) {
                                    var r = t.filterOption.filterOptionId + ":" + t.value;
                                    al.set(r, e);
                                },
                            },
                        ]
                    ),
                    r
                );
            })(zi),
            il = (function (t) {
                Xa(r, t);
                var e = tl(r);
                function r() {
                    return Ya(this, r), e.apply(this, arguments);
                }
                return (
                    Ja(r, [
                        {
                            key: "getTemplate",
                            value: function () {
                                return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t{{swatch}}\n\t\t\t\t\t<button class="{{class.button}}" data-action="select-filter-item">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                            },
                        },
                        {
                            key: "setData",
                            value: function (t) {
                                var e = this;
                                (this.value = t.tag),
                                    (this.label = u.a.stripHtml(t.displayName ? t.displayName : t.tag)),
                                    (this.docCount = t.doc_count ? t.doc_count : 0),
                                    (this.level = 2),
                                    this.parent && ((this.requestInstantly = this.parent.requestInstantly), (this.filterOption = this.parent.filterOption)),
                                    (this.label = u.a.stripHtml(this.buildLabel())),
                                    this.filterOption.displayTypeItem == Kn.a.DisplayType.SWATCH && this.setSwatchData(),
                                    (this.children = []),
                                    Array.isArray(t.subTags) &&
                                        t.subTags.forEach(function (t) {
                                            if (t.tag) {
                                                var r = new ol(e.filterTreeType);
                                                e.addComponent(r), r.setData(t);
                                            }
                                        }),
                                    this.filterOption.allNestedFilterItems.set(this.value, this);
                            },
                        },
                    ]),
                    r
                );
            })(nl),
            ol = (function (t) {
                Xa(r, t);
                var e = tl(r);
                function r() {
                    return Ya(this, r), e.apply(this, arguments);
                }
                return (
                    Ja(r, [
                        {
                            key: "getTemplate",
                            value: function () {
                                return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-third-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t{{swatch}}\n\t\t\t\t\t<button class="{{class.button}}" data-action="select-filter-item">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                            },
                        },
                        {
                            key: "setData",
                            value: function (t) {
                                (this.value = t.tag),
                                    (this.label = u.a.stripHtml(t.displayName ? t.displayName : t.tag)),
                                    (this.docCount = t.doc_count ? t.doc_count : 0),
                                    (this.level = 3),
                                    this.parent && ((this.requestInstantly = this.parent.requestInstantly), (this.filterOption = this.parent.filterOption)),
                                    (this.label = u.a.stripHtml(this.buildLabel())),
                                    this.filterOption.displayTypeItem == Kn.a.DisplayType.SWATCH && this.setSwatchData(),
                                    this.filterOption.allNestedFilterItems.set(this.value, this);
                            },
                        },
                    ]),
                    r
                );
            })(il),
            al = new Map(),
            ll = nl;
        function sl(t) {
            return (sl =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function cl(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== sl(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== sl(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === sl(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ul(t, e) {
            return (ul = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function pl(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = hl(t);
                if (e) {
                    var i = hl(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return fl(this, r);
            };
        }
        function fl(t, e) {
            if (e && ("object" === sl(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function hl(t) {
            return (hl = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var yl = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ul(t, e);
                })(l, t);
                var e,
                    r,
                    n,
                    a = pl(l);
                function l(t) {
                    var e;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, l),
                        ((e = a.call(this)).filterTreeType = t),
                        (e.$clickElement = null),
                        (e.$toggleElement = null),
                        e
                    );
                }
                return (
                    (e = l),
                    (n = [
                        {
                            key: "getCollapsedStateData",
                            value: function (t) {
                                return ml.get(t);
                            },
                        },
                        {
                            key: "setCollapsedStateData",
                            value: function (t, e) {
                                ml.set(t, e);
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                var t;
                                if (((this.isCollapsed = !1), this.filterTreeType == Ci.FilterTreeType.HORIZONTAL)) this.isCollapsed = !0;
                                else if ((o.a.getSettingValue("general.keepToggleState") && (t = l.getCollapsedStateData(this.parent.filterOptionId)), void 0 === t)) {
                                    var e = u.a.isMobile();
                                    this.isCollapsed =
                                        (e && (this.parent.isCollapseMobile || o.a.getSettingValue("general.collapseOnMobileByDefault"))) || (!e && (this.parent.isCollapsePC || o.a.getSettingValue("general.collapseOnPCByDefault")));
                                } else this.isCollapsed = t;
                            },
                        },
                        {
                            key: "isBindEvents",
                            value: function () {
                                return !(this.isBoundEvent || !this.parent.$element || !this.parent.$filterOptionContentElement || !this.parent.$filterOptionTitleElement);
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                (this.$clickElement = this.parent.$filterOptionTitleElement),
                                    (this.$toggleElement = this.parent.$filterOptionContentElement),
                                    this.filterTreeType == Ci.FilterTreeType.VERTICAL
                                        ? this.$clickElement.on("click", this.onToggleVertical.bind(this))
                                        : (this.$clickElement.on("click", this.onToggleHorizontal.bind(this)),
                                          gl || ((gl = !0), i()("body").on("click", this.onClickOutSideHorizontal.bind(this))),
                                          this.parent.filterOptionId == dl && ((dl = ""), this.onToggleHorizontal())),
                                    this.$clickElement.attr("aria-expanded", !this.isCollapsed);
                            },
                        },
                        {
                            key: "onToggleVertical",
                            value: function () {
                                (this.isCollapsed = !this.isCollapsed),
                                    o.a.getSettingValue("general.keepToggleState") && l.setCollapsedStateData(this.parent.filterOptionId, this.isCollapsed),
                                    this.parent.$element.toggleClass("boost-pfs-filter-option-collapsed"),
                                    this.$clickElement.attr("aria-expanded", !this.isCollapsed),
                                    this.isCollapsed
                                        ? this.$toggleElement.addClass("toggled")
                                        : (this.$toggleElement.show(), this.$toggleElement.removeClass("toggled"), !u.a.isMobile() && o.a.getSettingValue("general.stickyFilterOnDesktop") && this.parent.parent.parent.stickyFilterDesktop()),
                                    this.afterToggle();
                            },
                        },
                        {
                            key: "onToggleHorizontal",
                            value: function () {
                                var t = !this.isCollapsed;
                                this.calculateHorizontalColumn();
                                var e = this.closeAllHorizontalTabs();
                                t ||
                                    (e
                                        ? (dl = this.parent.filterOptionId)
                                        : ((dl = ""), this.parent.$element.removeClass("boost-pfs-filter-option-collapsed"), this.$clickElement.attr("aria-expanded", !0), this.$toggleElement.show(), (this.isCollapsed = !1))),
                                    this.afterToggle();
                            },
                        },
                        {
                            key: "onClickOutSideHorizontal",
                            value: function (t) {
                                if (t && t.target) {
                                    var e = i()(t.target);
                                    e.closest(s.a.filterTreeHorizontal + " ." + q.a.filterOption).length > 0 ||
                                        e.closest(s.a.filterTreeHorizontal + " ." + q.a.clearButton).length > 0 ||
                                        e.closest(s.a.filterTreeHorizontal + " ." + q.a.clearAllButton).length > 0 ||
                                        this.closeAllHorizontalTabs();
                                }
                            },
                        },
                        {
                            key: "closeAllHorizontalTabs",
                            value: function () {
                                var t = this.parent.parent,
                                    e = !1;
                                return (
                                    t.filterOptions.forEach(function (t) {
                                        t.$element &&
                                            t.collapse &&
                                            !t.collapse.isCollapsed &&
                                            (t.$element.addClass("boost-pfs-filter-option-collapsed"),
                                            t.$filterOptionTitleElement.attr("aria-expanded", !1),
                                            (t.collapse.isCollapsed = !0),
                                            t.collapse.$toggleElement.hide(),
                                            (t.allNestedFilterItems ? t.allNestedFilterItems : t.filterItems).forEach(function (r) {
                                                e || (void 0 !== r.isSelected && r.isAppliedFilter() != r.isSelected && (e = t));
                                            }));
                                    }),
                                    !!e && (e.applyButton.onApplyOptionValues(), !0)
                                );
                            },
                        },
                        { key: "afterToggle", value: function () {} },
                        {
                            key: "calculateHorizontalColumn",
                            value: function () {
                                var t = this.parent.displayColumn,
                                    e = "left",
                                    r = this.parent.$filterOptionTitleElement.offset();
                                if (((1 != t && "1" != t) || this.parent.displayType != FilterOptionEnum.DisplayType.RANGE || (t = 2), r && r.left))
                                    switch (t) {
                                        case 1:
                                        case "1":
                                            r.left + 250 > i()(window).width() && (e = "right");
                                            break;
                                        case 2:
                                        case "2":
                                            r.left + 532 > i()(window).width() && (e = r.left < 532 ? "center" : "right");
                                            break;
                                        case 3:
                                        case "3":
                                            r.left + 700 > i()(window).width() && (e = "right");
                                    }
                                "left" == e
                                    ? (this.parent.$element.removeClass("boost-pfs-filter-option-right"), this.parent.$element.addClass("boost-pfs-filter-option-left"))
                                    : "center" == e
                                    ? (this.parent.$element.removeClass("boost-pfs-filter-option-left"), this.parent.$element.removeClass("boost-pfs-filter-option-right"), this.parent.$element.addClass("boost-pfs-filter-option-center"))
                                    : (this.parent.$element.removeClass("boost-pfs-filter-option-left"), this.parent.$element.addClass("boost-pfs-filter-option-right"));
                            },
                        },
                    ]) && cl(e.prototype, r),
                    n && cl(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    l
                );
            })(d.a),
            dl = "",
            ml = new Map(),
            gl = !1,
            bl = yl;
        function vl(t) {
            return (vl =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Sl(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== vl(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== vl(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === vl(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ol(t, e) {
            return (Ol = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Pl(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = wl(t);
                if (e) {
                    var i = wl(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Tl(this, r);
            };
        }
        function Tl(t, e) {
            if (e && ("object" === vl(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function wl(t) {
            return (wl = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var _l = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ol(t, e);
            })(c, t);
            var e,
                r,
                n,
                s = Pl(c);
            function c(t) {
                var e;
                !(function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, c),
                    ((e = s.call(this)).filterItems = new Map()),
                    (e.clearButton = null),
                    (e.applyButton = null),
                    (e.searchBox = null),
                    (e.filterTreeType = t),
                    (e.$element = null),
                    (e.$filterOptionTitleElement = null),
                    (e.$filterOptionContentElement = null),
                    (e.$filterItemsContainerElement = null);
                var r = e.filterTreeType == Ci.FilterTreeType.VERTICAL;
                return (
                    (e.selector = {
                        filterOptionTitle: "." + q.a.filterOptionTitle + " ." + q.a.filterOptionTitle + "-heading",
                        filterOptionContent: "." + q.a.filterOptionContent,
                        filterItemsContainer: "ul",
                        clearButtonContainer: r ? "." + q.a.filterOptionTitle : "." + q.a.filterOptionContent,
                        applyButtonContainer: "." + q.a.filterOptionContent,
                        viewMoreContainer: "." + q.a.filterOptionContent,
                        searchBoxContainer: "." + q.a.filterOptionContent,
                        tooltipContainer: "." + q.a.filterOptionTitle + " ." + q.a.filterOptionTitle + "-heading",
                        numberFilterItemsContainer: "." + q.a.filterOptionTitle + "-count",
                    }),
                    e
                );
            }
            return (
                (e = c),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            (this.collapse = new bl(this.filterTreeType)),
                                this.addComponent(this.collapse),
                                (this.clearButton = new Bi(this.filterTreeType, Bi.ClearType.CLEAR_OPTION_VALUES)),
                                this.addComponent(this.clearButton),
                                (this.applyButton = new Vi(this.filterTreeType, Vi.ApplyType.APPLY_OPTION_VALUES)),
                                this.addComponent(this.applyButton),
                                (this.viewMore = new sa(this.filterTreeType)),
                                this.addComponent(this.viewMore),
                                (this.scrollbar = new ja()),
                                this.addComponent(this.scrollbar),
                                (this.searchBox = new da()),
                                this.addComponent(this.searchBox),
                                (this.filterTooltip = new Pa(this.tooltip)),
                                this.addComponent(this.filterTooltip);
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            switch (this.filterTreeType) {
                                case "vertical":
                                    return '\n\t\t\t\t<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">\n\t\t\t\t\t<div class="{{class.filterOptionTitle}}">\n\t\t\t\t\t\t<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">\n\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-text">\n\t\t\t\t\t\t\t\t{{blockTitle}}\n\t\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-count">\n\t\t\t\t\t\t\t\t\t{{numberAppliedFilterItems}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t{{tooltip}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p class="boost-pfs-filter-selected-items-mobile"></p>\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="{{class.filterOptionContent}}">\n\t\t\t\t\t\t{{searchBox}}\n\t\t\t\t\t\t<div class="{{class.filterOptionContentInner}}">\n\t\t\t\t\t\t\t{{blockContent}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t{{viewMore}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t'.trim();
                                case "horizontal":
                                    return '\n\t\t\t\t<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">\n\t\t\t\t\t<div class="{{class.filterOptionTitle}}">\n\t\t\t\t\t\t<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">\n\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-text">\n\t\t\t\t\t\t\t{{blockTitle}}\n\t\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-count">\n\t\t\t\t\t\t\t\t\t{{numberAppliedFilterItems}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t{{tooltip}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="{{class.filterOptionContent}}">\n\t\t\t\t\t\t<div class="{{class.filterOptionContentInner}}">\n\t\t\t\t\t\t\t{{blockContent}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t{{viewMore}}\n\t\t\t\t\t\t{{applyButton}}\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t'.trim();
                                default:
                                    console.warn("filterTreeType is wrong");
                            }
                        },
                    },
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            console.warn("Override this method");
                        },
                    },
                    {
                        key: "compileBlockContentTemplate",
                        value: function () {
                            return this.getBlockContentTemplate();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = u.a.slugify(u.a.stripHtml(this.label)),
                                e = u.a.slugify(this.displayType.replace(/_/g, "-")),
                                r = ja.isEnabled(this.displayType, this.filterType, this.showMoreType) ? q.a.filterHasScrollbar : q.a.filterNoScrollbar,
                                n = "boost-pfs-filter-option-column-" + this.displayColumn;
                            return this.getTemplate()
                                .replace(/{{blockTitle}}/g, u.a.stripHtml(this.label))
                                .replace(/{{blockTypeClass}}/g, q.a.filterOption + "-" + e)
                                .replace(/{{blockId}}/g, q.a.filterOption + "-" + t)
                                .replace(/{{blockContent}}/g, this.compileBlockContentTemplate())
                                .replace(/{{blockContentId}}/g, q.a.filterOptionContent + "-" + t)
                                .replace(/{{displayColumn}}/g, n)
                                .replace(/{{class.filterOption}}/g, q.a.filterOption)
                                .replace(/{{class.filterOptionContent}}/g, q.a.filterOptionContent)
                                .replace(/{{class.filterOptionContentInner}}/g, q.a.filterOptionContentInner)
                                .replace(/{{class.filterOptionTitle}}/g, q.a.filterOptionTitle)
                                .replace(/{{class.filterScrollbar}}/g, r)
                                .replace(/{{class.filterOptionItemList}}/g, q.a.filterOptionItemList)
                                .replace(/{{class.filterOptionItemListSingleList}}/g, q.a.filterOptionItemListSingleList)
                                .replace(/{{class.filterOptionItemListMultipleList}}/g, q.a.filterOptionItemListMultipleList)
                                .replace(/{{class.filterOptionItemListBox}}/g, q.a.filterOptionItemListBox)
                                .replace(/{{class.filterOptionItemListSwatch}}/g, q.a.filterOptionItemListSwatch)
                                .replace(/{{class.filterOptionItemListRating}}/g, q.a.filterOptionItemListRating)
                                .replace(/{{class.filterOptionMultiLevelTag}}/g, q.a.filterOptionMultiLevelTag)
                                .replace(/{{class.filterOptiontemListMultiLevelCollections}}/g, q.a.filterOptiontemListMultiLevelCollections)
                                .replace(/{{class.button}}/g, q.a.button)
                                .replace(/{{ada.filterOptionTitle}}/g, a.a.ada.filterOptionTitle.replace("{{filterOption}}", u.a.stripHtml(this.label)))
                                .replace(/{{ada.filterOptionDomId}}/g, this.parent.id + "-" + this.filterOptionId.replace(/_/g, "-"))
                                .replace(/{{tooltip}}/g, "")
                                .replace(/{{clearButton}}/g, "")
                                .replace(/{{applyButton}}/g, "")
                                .replace(/{{searchBox}}/g, "")
                                .replace(/{{viewMore}}/g, "")
                                .replace(/{{filterItems}}/g, "")
                                .replace(/\n/g, "")
                                .replace(/\t/g, "");
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            if (this.status == Kn.a.Status.ACTIVE) {
                                var t = o.a.getSettingValue("general.showSingleOption"),
                                    e = 0,
                                    r = this.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS || this.displayType == Kn.a.DisplayType.MULTI_LEVEL_TAG;
                                return (
                                    this.filterItems.forEach(function (t) {
                                        t.$element && t.$element.length && (e++, r && Array.isArray(t.children) && t.children.length > 0 && (e += t.children.length));
                                    }),
                                    t ? e > 1 : e > 0
                                );
                            }
                            return !1;
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            if (!this.$element) {
                                (this.$element = i()(this.compileTemplate())),
                                    (this.$filterOptionContentElement = this.$element.find(this.selector.filterOptionContent)),
                                    (this.$filterOptionTitleElement = this.$element.find(this.selector.filterOptionTitle)),
                                    (this.$filterItemsContainerElement = this.$element.find(this.selector.filterItemsContainer).html("")),
                                    this.filterItems.forEach(function (e) {
                                        e.isRenderOnScroll || t.$filterItemsContainerElement.append(e.$element);
                                    }),
                                    this.$element.find(this.selector.searchBoxContainer).prepend(this.searchBox.$element),
                                    this.$element.find(this.selector.viewMoreContainer).append(this.viewMore.$element),
                                    this.$element.find(this.selector.applyButtonContainer).append(this.applyButton.$element),
                                    this.$element.find(this.selector.clearButtonContainer).append(this.clearButton.$element);
                                var e = this.$element.find(this.selector.tooltipContainer);
                                e.append(this.filterTooltip.$element),
                                    e.append(this.filterTooltip.$popupElement),
                                    this.collapse.isCollapsed && (this.$element.addClass("boost-pfs-filter-option-collapsed"), this.$filterOptionContentElement.addClass("toggled"), this.$filterOptionContentElement.hide()),
                                    this.$filterOptionContentElement.attr("id", u.a.stripHtml(this.parent.id + "-" + this.filterOptionId.replace(/_/g, "-")));
                            }
                            (this.numberAppliedFilterItems = this.getNumberAppliedFilterItems()),
                                this.$element.find(this.selector.numberFilterItemsContainer).html(u.a.stripHtml(this.numberAppliedFilterItems > 0 ? this.numberAppliedFilterItems : ""));
                        },
                    },
                    {
                        key: "getNumberAppliedFilterItems",
                        value: function () {
                            var t = 0,
                                e = [Kn.a.DisplayType.LIST, Kn.a.DisplayType.BOX, Kn.a.DisplayType.SWATCH, Kn.a.DisplayType.RATING, Kn.a.DisplayType.MULTI_LEVEL_TAG];
                            return (
                                this.filterItems &&
                                    e.includes(this.displayType) &&
                                    this.filterItems.forEach(function (e) {
                                        e.isSelected && t++;
                                    }),
                                t
                            );
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            var e = this;
                            (this.status = t.status),
                                (this.position = t.position),
                                (this.label = u.a.stripHtml(t.label)),
                                (this.filterOptionId = t.filterOptionId),
                                (this.filterType = t.filterType),
                                (this.displayType = t.displayType),
                                (this.selectType = t.selectType),
                                (this.valueType = t.valueType),
                                (this.displayTypeItem = t.displayTypeItem),
                                (this.manualValues = t.manualValues ? t.manualValues : []),
                                (this.prefix = t.prefix),
                                (this.isCollapsePC = t.isCollapsePC),
                                (this.isCollapseMobile = t.isCollapseMobile),
                                (this.showSearchBoxFilterPC = t.showSearchBoxFilterPC),
                                (this.showSearchBoxFilterMobile = t.showSearchBoxFilterMobile),
                                (this.keepValuesStatic = t.keepValuesStatic),
                                (this.activeCollectionAll = t.activeCollectionAll),
                                (this.tooltip = t.tooltip),
                                (this.showMoreType = null == t.showMoreType || "" == t.showMoreType ? Kn.a.ShowMoreType.SCROLLBAR : t.showMoreType),
                                (this.sortType = t.sortType),
                                (this.sortManualValues = t.sortManualValues),
                                (this.displayAllValuesInUppercaseForm = t.displayAllValuesInUppercaseForm),
                                (this.useAndCondition = t.useAndCondition),
                                (this.showExactRating = t.showExactRating),
                                (this.excludePriceFromValue = t.excludePriceFromValue),
                                (this.starColor = u.a.stripHtml(t.starColor)),
                                (this.displayColumn = t.displayColumn ? t.displayColumn : o.a.getSettingValue("general.filterHorizontalColumn")),
                                (this.filterTreeHorizontalStyle = o.a.getSettingValue("general.filterTreeHorizontalStyle")),
                                "style1" == this.filterTreeHorizontalStyle
                                    ? (this.displayColumn = "1")
                                    : "style2" == this.filterTreeHorizontalStyle
                                    ? (this.displayColumn = "2")
                                    : "style3" == this.filterTreeHorizontalStyle && (this.displayColumn = "full"),
                                (this.swatchStyle = t.swatchStyle),
                                (this.shortenPipsRange = t.shortenPipsRange),
                                t.inventoryBaseSelectedLocations && ((this.inventoryBaseSelectedLocations = t.inventoryBaseSelectedLocations), (l.a.inventoryBaseSelectedLocations = t.inventoryBaseSelectedLocations)),
                                t.filterType == Kn.a.FilterType.LOCATION && (l.a.hasFilterByLocation = !0),
                                (this.children = []),
                                (this.filterItems = new Map());
                            var r = [];
                            t.values ? (r = Array.isArray(t.values) ? t.values : [t.values]) : t.manualValues && (r = Array.isArray(t.manualValues) ? t.manualValues : [t.manualValues]),
                                this.isSortValues() && this.sortValues(r),
                                this.modifyValues(r),
                                this.markValuesAsNoRender(r),
                                r.forEach(function (t) {
                                    var r = null;
                                    switch (e.displayType) {
                                        case Kn.a.DisplayType.LIST:
                                            r = new to(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.BOX:
                                            r = new uo(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.SWATCH:
                                            r = new Oo(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.RATING:
                                            r = new jo(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.RANGE:
                                            r = new Jo(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.SUB_CATEGORY:
                                            r = new No(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                                            r = new za(e.filterTreeType);
                                            break;
                                        case Kn.a.DisplayType.MULTI_LEVEL_TAG:
                                            r = new ll(e.filterTreeType);
                                    }
                                    if (r) {
                                        e.addComponent(r), r.setData(t);
                                        var n = r.key ? r.key : r.value;
                                        e.filterItems.set(n, r);
                                    }
                                });
                        },
                    },
                    {
                        key: "isSortValues",
                        value: function () {
                            if ([Kn.a.FilterType.REVIEW_RATINGS, Kn.a.FilterType.PERCENT_SALE].includes(this.filterType)) return !0;
                            var t = [Kn.a.FilterType.STOCK],
                                e = [Kn.a.DisplayType.RANGE, Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS],
                                r = this.valueType == Kn.a.ValueType.ALL,
                                n = this.valueType != Kn.a.ValueType.ALL && (this.sortManualValues || o.a.getSettingValue("general.sortManualValues")),
                                i = this.displayType == Kn.a.DisplayType.RANGE && 0 == this.isNumberRangeSlider;
                            return !t.includes(this.filterType) && (!e.includes(this.displayType) || i) && (r || n);
                        },
                    },
                    {
                        key: "sortValues",
                        value: function (t) {
                            var e = this.sortType ? this.sortType : Kn.a.SortType.KEY_ASCENDING,
                                r = e.split("-")[0],
                                n = "key" == r ? "doc_count" : "key";
                            this.filterType == Kn.a.FilterType.COLLECTION && "key" == r && (r = "label"),
                                t &&
                                    t.length > 0 &&
                                    t.sort(
                                        function (t, e) {
                                            var i = -1;
                                            if (null != t[r] && null != e[r]) {
                                                var o = t[r].toString().toLowerCase(),
                                                    a = e[r].toString().toLowerCase();
                                                if (0 == (i = this.naturalSortFunction(o, a)) && null != t[n] && null != e[n]) {
                                                    var l = t[n].toString().toLowerCase(),
                                                        s = e[n].toString().toLowerCase();
                                                    i = this.naturalSortFunction(l, s);
                                                }
                                            }
                                            return i;
                                        }.bind(this)
                                    ),
                                (e.indexOf("desc") > -1 || (e.startsWith("alpha") && (this.filterType == Kn.a.FilterType.REVIEW_RATINGS || this.filterType == Kn.a.FilterType.PERCENT_SALE))) && t.reverse();
                        },
                    },
                    {
                        key: "naturalSortFunction",
                        value: function (t, e) {
                            function r(t) {
                                for (var e, r, n = [], i = 0, o = -1, a = 0; (e = (r = t.charAt(i++)).charCodeAt(0)); ) {
                                    var l = 46 == e || (e >= 48 && e <= 57);
                                    l !== a && ((n[++o] = ""), (a = l)), (n[o] += r);
                                }
                                return n;
                            }
                            for (var n = r(t), i = r(e), o = 0; n[o] && i[o]; o++)
                                if (n[o] !== i[o]) {
                                    var a = Number(n[o]),
                                        l = Number(i[o]);
                                    return a == n[o] && l == i[o] ? a - l : n[o] > i[o] ? 1 : -1;
                                }
                            return n.length - i.length;
                        },
                    },
                    {
                        key: "modifyValues",
                        value: function (t) {
                            if (this.filterType == Kn.a.FilterType.COLLECTION) {
                                if (
                                    this.activeCollectionAll &&
                                    !t.some(function (t) {
                                        return "all" == t.handle;
                                    })
                                ) {
                                    var e = { key: "0", label: a.a.collectionAll, handle: "all" };
                                    t.unshift(e);
                                }
                                if (
                                    (t.forEach(function (t) {
                                        t.sort_order &&
                                            (t.sort_order.endsWith("-desc") ? (t.sort_order = t.sort_order.replace(/-desc$/, "-descending")) : t.sort_order.endsWith("-asc") && (t.sort_order = t.sort_order.replace(/-asc$/, "-ascending")),
                                            t.sort_order.startsWith("alpha") && (t.sort_order = t.sort_order.replace(/alpha/, "title")));
                                    }),
                                    !this.keepValuesStatic && !o.a.getSettingValue("general.showOutOfStockOption"))
                                )
                                    for (var r = t.length - 1; r >= 0; r--) 0 == t[r].doc_count && t.splice(r, 1);
                            }
                        },
                    },
                    {
                        key: "markValuesAsNoRender",
                        value: function (t) {
                            var e = o.a.getSettingValue("general.scrollFirstLoadLength"),
                                r = [Kn.a.DisplayType.LIST];
                            Array.isArray(t) &&
                                t.length > e &&
                                r.includes(this.displayType) &&
                                ja.isEnabled(this.displayType, this.filterType, this.showMoreType) &&
                                ((this.isLoadMoreOnScroll = !0),
                                t.forEach(function (t, r) {
                                    t.isRenderOnScroll = r >= e;
                                }));
                        },
                    },
                ]) && Sl(e.prototype, r),
                n && Sl(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        function Cl(t) {
            return (Cl =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function kl(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function El(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Cl(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Cl(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Cl(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Rl() {
            return (Rl =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = Il(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function Il(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Al(t)); );
            return t;
        }
        function jl(t, e) {
            return (jl = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ll(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Al(t);
                if (e) {
                    var i = Al(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Bl(this, r);
            };
        }
        function Bl(t, e) {
            if (e && ("object" === Cl(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Al(t) {
            return (Al = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var xl = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && jl(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = Ll(o);
            function o() {
                return kl(this, o), i.apply(this, arguments);
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return this.selectType == Kn.a.SelectType.SINGLE
                                ? '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSingleList}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t'.trim()
                                : '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListMultipleList}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t'.trim();
                        },
                    },
                    {
                        key: "prepareFilterOptionData",
                        value: function (t) {
                            if (("price" == t.filterType || "variants_price" == t.filterType) && t.values && Array.isArray(t.values) && !t.isConvertedPrice && u.a.isEnableShopifyMultipleCurrencies() && u.a.isConvertCurrenciesOnFrontEnd()) {
                                for (var e = 0; e < t.values.length; e++) {
                                    var r = !1,
                                        n = !1;
                                    t.values[e].hasOwnProperty("to") && ((r = !0), (t.values[e].to = u.a.convertPriceBasedOnActiveCurrency(t.values[e].to))),
                                        t.values[e].hasOwnProperty("from") && ((n = !0), (t.values[e].from = u.a.convertPriceBasedOnActiveCurrency(t.values[e].from))),
                                        (t.values[e].key = r && n ? t.values[e].from + "-" + t.values[e].to : r ? "*-" + t.values[e].to : t.values[e].from + "-*");
                                }
                                t.isConvertedPrice = !0;
                            }
                            return t;
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            (t = this.prepareFilterOptionData(t)), Rl(Al(o.prototype), "setData", this).call(this, t);
                        },
                    },
                ]) && El(e.prototype, r),
                n && El(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(_l);
        function Fl(t) {
            return (Fl =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function $l(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Dl(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Fl(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Fl(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Fl(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ml(t, e) {
            return (Ml = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Vl(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Hl(t);
                if (e) {
                    var i = Hl(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Nl(this, r);
            };
        }
        function Nl(t, e) {
            if (e && ("object" === Fl(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Hl(t) {
            return (Hl = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ul = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ml(t, e);
            })(a, t);
            var e,
                r,
                n,
                i = Vl(a);
            function a() {
                return $l(this, a), i.apply(this, arguments);
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListBox}}">{{filterItems}}</ul>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "calculateBoxItemSize",
                        value: function () {
                            if (!o.a.getSettingValue("general.enableFilterOptionBoxStyle")) return "";
                            var t = this.$element ? this.$element.width() : 0;
                            if (!t || t < 0) return "100%";
                            if (!this.boxItemSize) {
                                var e = 4,
                                    r = o.a.getSettingValue("general.filterOptionBoxCharWidth") || 14;
                                this.filterItems.forEach(function (t) {
                                    var n = u.a.stripHtml(t.label).length * r;
                                    e = Math.max(n, e);
                                });
                                var n = 100 / (Math.floor(this.$element.width() / (e + 8)) || 1) - 2;
                                n < 1 && (n = 100), (this.boxItemSize = n + "%");
                            }
                            return this.boxItemSize;
                        },
                    },
                ]) && Dl(e.prototype, r),
                n && Dl(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(_l);
        function Wl(t) {
            return (Wl =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ql(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Gl(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Wl(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Wl(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Wl(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function zl(t, e) {
            return (zl = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Kl(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ql(t);
                if (e) {
                    var i = Ql(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Yl(this, r);
            };
        }
        function Yl(t, e) {
            if (e && ("object" === Wl(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ql(t) {
            return (Ql = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Jl = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && zl(t, e);
            })(a, t);
            var e,
                r,
                n,
                i = Kl(a);
            function a() {
                return ql(this, a), i.apply(this, arguments);
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSwatch}} {{swatchStyle}}">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileBlockContentTemplate",
                        value: function () {
                            return (this.swatchStyle = this.buildSwatchStyle()), this.getBlockContentTemplate().replace(/{{swatchStyle}}/g, this.swatchStyle);
                        },
                    },
                    {
                        key: "buildSwatchStyle",
                        value: function () {
                            var t = this.swatchStyle;
                            return t || (this.filterTreeType == Ci.FilterTreeType.HORIZONTAL || (u.a.isMobile() && "style2" == o.a.getSettingValue("general.filterTreeMobileStyle")) ? "circle-list" : "circle-grid");
                        },
                    },
                ]) && Gl(e.prototype, r),
                n && Gl(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(_l);
        function Xl(t) {
            return (Xl =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Zl(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function ts(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Xl(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Xl(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Xl(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function es(t, e) {
            return (es = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function rs(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = is(t);
                if (e) {
                    var i = is(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ns(this, r);
            };
        }
        function ns(t, e) {
            if (e && ("object" === Xl(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function is(t) {
            return (is = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var os = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && es(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = rs(o);
            function o() {
                return Zl(this, o), i.apply(this, arguments);
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return this.selectType == Kn.a.SelectType.MULTIPLE && this.showExactRating
                                ? '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListRating}} {{class.filterOptionItemListMultipleList}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t'.trim()
                                : '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListRating}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t'.trim();
                        },
                    },
                ]) && ts(e.prototype, r),
                n && ts(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(_l);
        function as(t) {
            return (as =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ls(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== as(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== as(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === as(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ss(t, e) {
            return (ss = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function cs(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = ps(t);
                if (e) {
                    var i = ps(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return us(this, r);
            };
        }
        function us(t, e) {
            if (e && ("object" === as(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function ps(t) {
            return (ps = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var fs = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ss(t, e);
            })(l, t);
            var e,
                r,
                n,
                o = cs(l);
            function l(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((e = o.call(this)).filterTreeType = t),
                    (e.$element = null),
                    e
                );
            }
            return (
                (e = l),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            (this.clearButton = new Bi(this.filterTreeType, Bi.ClearType.CLEAR_SINGLE_VALUE)), this.addComponent(this.clearButton);
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            switch (this.filterTreeType) {
                                case Ci.FilterTreeType.VERTICAL:
                                    return '\n\t\t\t\t\t<div class="refine-by-item {{class.filterOptionLabel}}">\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                case Ci.FilterTreeType.HORIZONTAL:
                                    return '\n\t\t\t\t\t<div class="refine-by-item">\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                default:
                                    console.warn("Wrong filterTreeType");
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .trim()
                                .replace(/{{class.filterOptionLabel}}/g, q.a.filterOptionLabel)
                                .replace(/{{type}}/g, this.type ? u.a.stripHtml(this.type + ": ") : "")
                                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                                .replace(/{{clearButton}}/g, "");
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return "" != this.label;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            (this.$element = i()(this.compileTemplate())), this.$element.append(this.clearButton.$element);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e, r) {
                            (this.filterOption = t), (this.filterItem = e), (this.filterOptionId = t.filterOptionId), (this.filterItemId = r), (this.type = u.a.stripHtml(t.label)), (this.label = u.a.stripHtml(this.buildLabel()));
                        },
                    },
                    {
                        key: "buildLabel",
                        value: function () {
                            var t = this.filterItemId;
                            if (this.filterOption)
                                switch (this.filterOption.displayType) {
                                    case Kn.a.DisplayType.RANGE:
                                        t = this.buildLabelRange();
                                        break;
                                    case Kn.a.DisplayType.RATING:
                                        t = this.buildLabelRating();
                                        break;
                                    case Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                                    case Kn.a.DisplayType.MULTI_LEVEL_TAG:
                                        t = this.buildLabelMultiLevel();
                                        break;
                                    default:
                                        if (this.filterItem) t = u.a.stripHtml(this.filterItem.label);
                                        else {
                                            var e = new zi(this.filterOption.filterTreeType);
                                            (e.filterOption = this.filterOption), (e.label = u.a.stripHtml(this.filterItemId)), (t = u.a.stripHtml(e.buildLabel()));
                                        }
                                }
                            return u.a.stripHtml(t);
                        },
                    },
                    {
                        key: "buildLabelRating",
                        value: function () {
                            var t = "";
                            if (this.filterItem) {
                                var e = this.filterItem.from;
                                (t = Math.ceil(e) + " "), 1 == Math.ceil(e) ? (t += a.a.ratingStar) : (t += a.a.ratingStars), this.filterOption.showExactRating || (t += " " + a.a.ratingUp);
                            }
                            return t;
                        },
                    },
                    {
                        key: "buildLabelRange",
                        value: function () {
                            var t = "";
                            if (this.filterOption)
                                if (this.filterOption.isNumberRangeSlider) {
                                    if ((i = this.filterItemId.split(":")) && 2 == i.length) {
                                        var e = this.filterOption.buildLabel(i[0]),
                                            r = this.filterOption.buildLabel(i[1]);
                                        if ("price" === this.filterOption.filterType || "variants_price" === this.filterOption.filterType) {
                                            var n = Globals.moneyFormat.replace(/{{.+}}/g, "").replace("&#36;", "$");
                                            -1 === e.indexOf(n) && ((e = n + e), (r = n + r));
                                        }
                                        t = e == r ? e : e + " - " + r;
                                    }
                                } else {
                                    var i = this.filterItemId;
                                    if (
                                        ((e = ""),
                                        (r = ""),
                                        this.filterOption.currentMax - 1 > 0 && this.filterOption.currentMax - 1 < this.filterOption.valuesData.length
                                            ? ((e = this.filterOption.valuesData[this.filterOption.currentMin].key), (r = this.filterOption.valuesData[this.filterOption.currentMax - 1].key))
                                            : Array.isArray(i) && i.length > 0 && ((e = i[0]), (r = i[i.length - 1])),
                                        this.filterOption.prefix)
                                    ) {
                                        var o = this.filterOption.prefix.replace(/\\/g, "");
                                        (e = e.replace(o, "").trim()), (r = r.replace(o, "").trim());
                                    }
                                    t = e == r ? e : e + " - " + r;
                                }
                            return t;
                        },
                    },
                    {
                        key: "buildLabelMultiLevel",
                        value: function () {
                            var t = "";
                            if (this.filterOption && this.filterItem && (this.filterOption.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS || this.filterOption.displayType == Kn.a.DisplayType.MULTI_LEVEL_TAG))
                                switch (this.filterItem.level) {
                                    case 1:
                                        (this.type = u.a.stripHtml(this.filterOption.label)), (t = u.a.stripHtml(this.filterItem.buildLabel()));
                                        break;
                                    case 2:
                                    case 3:
                                        (this.filterOptionId = this.filterOptionId.replace(Globals.prefix + "_c_", Globals.prefix + "_ct_")),
                                            (this.type = u.a.stripHtml(this.filterOption.label)),
                                            (t = u.a.stripHtml(this.filterItem.buildLabel()));
                                }
                            var e = t || this.filterItemId;
                            return !isNaN(e) && this.filterItem && 1 == this.filterItem.level && (e = ""), u.a.stripHtml(e);
                        },
                    },
                ]) && ls(e.prototype, r),
                n && ls(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(d.a);
        function hs(t) {
            return (hs =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ys(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== hs(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== hs(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === hs(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function ds(t, e) {
            return (ds = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function ms(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = bs(t);
                if (e) {
                    var i = bs(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return gs(this, r);
            };
        }
        function gs(t, e) {
            if (e && ("object" === hs(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function bs(t) {
            return (bs = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var vs = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ds(t, e);
            })(c, t);
            var e,
                r,
                n,
                o = ms(c);
            function c(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((e = o.call(this)).refineByItems = []),
                    (e.clearAllButton = null),
                    (e.filterTreeType = t),
                    (e.$element = null),
                    e
                );
            }
            return (
                (e = c),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            Settings.getSettingValue("general.separateRefineByFromFilter") &&
                                (i()(s.a.filterRefineByHorizontal).length > 0 ? (this.filterTreeType = Ci.FilterTreeType.HORIZONTAL) : i()(s.a.filterRefineByVertical).length > 0 && (this.filterTreeType = Ci.FilterTreeType.VERTICAL)),
                                (this.clearAllButton = new Bi(this.filterTreeType, Bi.ClearType.CLEAR_ALL)),
                                this.addComponent(this.clearAllButton);
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            switch (this.filterTreeType) {
                                case Ci.FilterTreeType.VERTICAL:
                                    return '\n\t\t\t\t\t<div class="{{class.filterRefineBy}}">\n\t\t\t\t\t\t<div class="{{class.filterOptionTitle}}">\n\t\t\t\t\t\t\t<div class="{{class.filterOptionTitle}}-heading" role="heading" aria-level="2"><span>{{label}}</span></div>\n\t\t\t\t\t\t\t{{clearAllButton}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                case Ci.FilterTreeType.HORIZONTAL:
                                    return '\n\t\t\t\t\t<div class="boost-pfs-filter-pc {{class.filterRefineBy}}">\n\t\t\t\t\t\t<span>{{label}}</span>\n\t\t\t\t\t\t<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>\n\t\t\t\t\t\t{{clearAllButton}}\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                default:
                                    console.warn("Wrong filterTreeType");
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{class.filterRefineBy}}/g, q.a.filterRefineBy)
                                .replace(/{{class.filterOptionTitle}}/g, q.a.filterOptionTitle)
                                .replace(/{{class.filterSelectedItems}}/g, q.a.filterSelectedItems)
                                .replace(/{{label}}/g, a.a.refine)
                                .replace(/{{refineByItems}}/g, "")
                                .replace(/{{clearAllButton}}/g, "");
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            this.refineByItems && this.refineByItems.length > 0
                                ? ((this.$element = i()(this.compileTemplate())),
                                  (this.$refineByItemsContainer = this.$element.find("." + q.a.filterSelectedItems)),
                                  this.refineByItems.forEach(function (e) {
                                      t.$refineByItemsContainer.append(e.$element);
                                  }),
                                  (this.$clearAllButtonContainer = this.filterTreeType == Ci.FilterTreeType.VERTICAL ? this.$element.find("." + q.a.filterOptionTitle) : this.$element),
                                  this.$clearAllButtonContainer.append(this.clearAllButton.$element))
                                : (this.$element = null);
                        },
                    },
                    {
                        key: "setData",
                        value: function () {
                            var t = this;
                            this.refineByItems = [];
                            var e = Object.keys(l.a.queryParams).filter(function (t) {
                                return t.startsWith(l.a.prefix);
                            });
                            e &&
                                e.length > 0 &&
                                e.forEach(function (e) {
                                    var r = t.parent.filterOptions.get(e),
                                        n = e.startsWith(l.a.prefix + "_ct_");
                                    n && (r = t.parent.filterOptions.get(e.replace(l.a.prefix + "_ct_", l.a.prefix + "_c_")));
                                    var i = l.a.queryParams[e],
                                        o = e.startsWith(l.a.prefix + "_c_");
                                    if ((o && !Array.isArray(i) && (i = [i]), r && i)) {
                                        var a = r.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS || r.displayType == Kn.a.DisplayType.MULTI_LEVEL_TAG;
                                        if (r.displayType == Kn.a.DisplayType.RANGE) {
                                            var s = new fs(t.filterTreeType),
                                                c = "";
                                            (c = r.isNumberRangeSlider ? i[0] : i), s.setData(r, null, c), t.refineByItems.push(s), t.addComponent(s);
                                        } else if (a) {
                                            var u =
                                                (r.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS && Settings.getSettingValue("general.multiLevelCollectionSelectType") == Kn.a.SelectType.SINGLE) ||
                                                (r.displayType == Kn.a.DisplayType.MULTI_LEVEL_TAG && r.selectType == Kn.a.SelectType.SINGLE);
                                            Object.values(i).forEach(function (e) {
                                                var i = e;
                                                n && (i = l.a.collectionId + ":" + e);
                                                var a = r.allNestedFilterItems.get(i);
                                                if (!(u && o && a && a.isSelectedChild)) {
                                                    var s = new fs(t.filterTreeType);
                                                    s.setData(r, a, e), t.refineByItems.push(s), t.addComponent(s);
                                                }
                                            });
                                        } else
                                            Object.values(i).forEach(function (e) {
                                                var n = r.filterItems.get(e),
                                                    i = new fs(t.filterTreeType);
                                                i.setData(r, n, e), t.refineByItems.push(i), t.addComponent(i);
                                            });
                                    }
                                });
                        },
                    },
                ]) && ys(e.prototype, r),
                n && ys(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(d.a);
        function Ss(t) {
            return (Ss =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Os(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Ps(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ss(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ss(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ss(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ts(t, e) {
            return (Ts = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function ws(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Cs(t);
                if (e) {
                    var i = Cs(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return _s(this, r);
            };
        }
        function _s(t, e) {
            if (e && ("object" === Ss(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Cs(t) {
            return (Cs = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ks = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ts(t, e);
                })(o, t);
                var e,
                    r,
                    n,
                    i = ws(o);
                function o() {
                    return Os(this, o), i.apply(this, arguments);
                }
                return (
                    (e = o),
                    (r = [
                        {
                            key: "getBlockContentTemplate",
                            value: function () {
                                return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSingleList}}">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'.trim();
                            },
                        },
                    ]) && Ps(e.prototype, r),
                    n && Ps(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    o
                );
            })(_l),
            Es = (r(102), r(133)),
            Rs = r.n(Es);
        function Is(t) {
            return (Is =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function js(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Ls(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Is(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Is(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Is(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Bs() {
            return (Bs =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = As(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function As(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ds(t)); );
            return t;
        }
        function xs(t, e) {
            return (xs = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Fs(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ds(t);
                if (e) {
                    var i = Ds(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return $s(this, r);
            };
        }
        function $s(t, e) {
            if (e && ("object" === Is(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Ds(t) {
            return (Ds = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Ms = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && xs(t, e);
            })(s, t);
            var e,
                r,
                n,
                i = Fs(s);
            function s() {
                return js(this, s), i.apply(this, arguments);
            }
            return (
                (e = s),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            Bs(Ds(s.prototype), "init", this).call(this), (this.requestInstantly = this.filterTreeType == Ci.FilterTreeType.VERTICAL || o.a.getSettingValue("general.requestInstantly"));
                        },
                    },
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return this.hideInputElement
                                ? '\n\t\t\t\t<div>\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider"></div>\n\t\t\t\t</div>\n\t\t\t'.trim()
                                : "style3" == this.style
                                ? '\n\t\t\t\t<div class="boost-pfs-filter-block-content-inner">\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider"></div>\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount">\n\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-min" type="text" role="textbox" readonly />\n\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-max" type="text" role="textbox" readonly />\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t'.trim()
                                : '\n\t\t\t\t<div class="boost-pfs-filter-block-content-inner">\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount">\n\t\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount-wrapper boost-pfs-filter-option-range-amount-min-wrapper">\n\t\t\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider-unit">{{itemCurrencySymbol}}</div>\n\t\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-min" role="textbox" type="text" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount-split"> - </div>\n\t\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount-wrapper boost-pfs-filter-option-range-amount-max-wrapper">\n\t\t\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider-unit">{{itemCurrencySymbol}}</div>\n\t\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-max" role="textbox" type="text"/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider"></div>\n\t\t\t\t</div>\n\t\t\t\t'
                                      .trim()
                                      .replace(/{{itemCurrencySymbol}}/g, l.a.moneyFormat.replace(/{{.+}}/g, "").replace("&#36;", "$"));
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            if (this.status == Kn.a.Status.ACTIVE) {
                                var t = o.a.getSettingValue("general.oneValueRangeSlider");
                                return !(this.isNumberRangeSlider ? this.rangeMax == this.rangeMin : this.valuesData.length <= 1) || t;
                            }
                            return !1;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            Bs(Ds(s.prototype), "render", this).call(this), this.$element.addClass("boost-pfs-filter-option-range-" + this.style), this.renderRangeValue(), this.renderInputField();
                        },
                    },
                    {
                        key: "renderRangeValue",
                        value: function () {
                            this.setCurrentValues(), this.noUiSlider && this.noUiSlider.set([this.currentMin, this.currentMax]);
                        },
                    },
                    {
                        key: "renderInputField",
                        value: function () {
                            if (this.$element && !this.hideInputElement) {
                                (this.$minInputElement && this.$maxInputElement) ||
                                    ((this.$minInputElement = this.$element.find(".boost-pfs-filter-option-range-amount-min")), (this.$maxInputElement = this.$element.find(".boost-pfs-filter-option-range-amount-max")));
                                var t = this.buildNumberLabel(this.currentMin),
                                    e = this.buildNumberLabel(this.currentMax);
                                this.$minInputElement.val(t), this.$maxInputElement.val(e);
                            }
                        },
                    },
                    {
                        key: "renderTextLabelPosition",
                        value: function () {
                            var t = this.$element.find(".noUi-value"),
                                e = 100 / (2 * this.valuesData.length);
                            t.each(function (t, r) {
                                var n = r.style.left;
                                if ("string" == typeof n) {
                                    var i = parseFloat(n.replace("%", "")) + e;
                                    r.style.left = i + "%";
                                }
                            });
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            Bs(Ds(s.prototype), "bindEvents", this).call(this),
                                this.$element &&
                                    ((this.$rangeSliderElement = this.$element.find(".boost-pfs-filter-option-range-slider")),
                                    (this.noUiSlider = Rs.a.create(this.$rangeSliderElement[0], this.getSliderConfig())),
                                    this.noUiSlider.on("slide", this.onDrag.bind(this)),
                                    this.noUiSlider.on("change", this.onFinishDragging.bind(this)),
                                    this.hideInputElement || (this.$minInputElement.on("change", this.onChangeInput.bind(this, "min")), this.$maxInputElement.on("change", this.onChangeInput.bind(this, "max"))),
                                    this.isNumberRangeSlider || this.renderTextLabelPosition(),
                                    this.$element.find(".boost-pfs-filter-option-range-amount-min, .noUi-handle-lower").attr("aria-label", a.a.ada.minValue),
                                    this.$element.find(".boost-pfs-filter-option-range-amount-max, .noUi-handle-upper").attr("aria-label", a.a.ada.maxValue));
                        },
                    },
                    {
                        key: "onChangeInput",
                        value: function (t) {
                            var e = "min" == t ? u.a.stripHtml(this.$minInputElement.val().trim()) : this.currentMin.toString(),
                                r = "max" == t ? u.a.stripHtml(this.$maxInputElement.val().trim()) : this.currentMax.toString();
                            this.thousandSeparator && ((e = e.split(this.thousandSeparator).join("")), (r = r.split(this.thousandSeparator).join(""))),
                                this.decimalSeparator && "." != this.decimalSeparator && ((e = e.replace(this.decimalSeparator, ".")), (r = r.replace(this.decimalSeparator, "."))),
                                !this.isNumberRangeSlider || null == e || null == r || "" == e || "" == r || isNaN(e) || isNaN(r) || (e = parseFloat(e)) > (r = parseFloat(r))
                                    ? this.renderInputField()
                                    : ((this.currentMin = Math.max(e, this.rangeMin)), (this.currentMax = Math.min(r, this.rangeMax)), this.noUiSlider && this.noUiSlider.set([this.currentMin, this.currentMax]), this.onFinishDragging());
                        },
                    },
                    {
                        key: "onDrag",
                        value: function () {
                            var t = this.noUiSlider.get();
                            if (null != t)
                                if (Array.isArray(t) && 2 == t.length) {
                                    if (this.isNumberRangeSlider) (this.currentMin = t[0]), (this.currentMax = t[1]);
                                    else {
                                        var e = Math.round(t[0]),
                                            r = Math.round(t[1]);
                                        r <= e ? this.noUiSlider.set([this.currentMin, this.currentMax]) : ((this.currentMin = e), (this.currentMax = r));
                                    }
                                    this.renderInputField();
                                } else ("string" != typeof t && "number" != typeof t) || ((this.currentMin = t), (this.currentMax = t));
                        },
                    },
                    {
                        key: "onFinishDragging",
                        value: function () {
                            var t = this;
                            if (this.isNumberRangeSlider)
                                this.filterItems.forEach(function (e) {
                                    e.setValue(t.currentMin, t.currentMax);
                                });
                            else {
                                var e = [];
                                if (this.currentMin != this.rangeMin || this.currentMax != this.rangeMax) for (var r = this.currentMin; r <= this.currentMax - 1; r++) e.push(this.valuesData[r].key);
                                this.filterItems.forEach(function (t) {
                                    t.isSelected = e.includes(t.value);
                                });
                            }
                            if (this.requestInstantly) {
                                var n = [];
                                this.filterItems.forEach(function (t) {
                                    t.isSelected && n.push(t.value);
                                }),
                                    Z.default.setParam(this.filterOptionId, n),
                                    Z.default.setParam("page", 1);
                                var i = { filterOptionId: this.filterOptionId, filterOptionValue: n };
                                Z.default.applyFilter("filter", i);
                            }
                        },
                    },
                    {
                        key: "getSliderConfig",
                        value: function () {
                            var t = {
                                start: this.isSingleHandle ? [this.currentMin] : [this.currentMin, this.currentMax],
                                step: this.sliderStep,
                                connect: !0,
                                snap: !this.isNumberRangeSlider,
                                animate: !0,
                                animationDuration: 300,
                                range: this.getSliderRange(),
                                pips: this.getSliderPipsConfig(),
                            };
                            if (this.isShowTooltip) {
                                var e = { to: this.buildLabel.bind(this) };
                                t.tooltips = [e, e];
                            }
                            return t;
                        },
                    },
                    {
                        key: "getSliderRange",
                        value: function () {
                            var t = { min: this.rangeMin, max: this.rangeMax };
                            if (!this.isNumberRangeSlider) for (var e = 1; e < this.valuesData.length; e++) t[e * (100 / this.valuesData.length) + "%"] = e;
                            return t;
                        },
                    },
                    {
                        key: "getSliderPipsConfig",
                        value: function () {
                            var t = this.isNumberRangeSlider ? this.sliderRange + 1 : this.valuesData.length + 1;
                            return (
                                t < 2 && (t = 2),
                                {
                                    mode: "count",
                                    values: t,
                                    filter: function (t, e) {
                                        return 1 == e ? e : -1;
                                    },
                                    format: { to: this.buildLabel.bind(this) },
                                }
                            );
                        },
                    },
                    {
                        key: "buildLabel",
                        value: function (t) {
                            var e = "";
                            if (this.isNumberRangeSlider) {
                                var r = l.a.moneyFormat.replace(/{{.+}}/g, "").replace("&#36;", "$");
                                e = this.isPriceFilter
                                    ? "style2" == this.style
                                        ? '<span class="boost-pfs-filter-option-range-slider-unit">' + r + "</span>" + this.buildMoneyLabel(t)
                                        : this.buildMoneyLabel(t)
                                    : this.buildNumberLabel(t, !0);
                            } else Number.isInteger(t) && t >= 0 && t < this.valuesData.length && ((e = this.valuesData[t].key), (e = this.buildTextLabel(e)));
                            return e;
                        },
                    },
                    {
                        key: "buildMoneyLabel",
                        value: function (t) {
                            var e = o.a.getSettingValue("general.enable3rdCurrencySupport"),
                                r = this.buildNumberLabel(t, !0),
                                n = this.moneyFormat.replace(/{{\s*(\w+)\s*}}/, r);
                            return (n = n.replace(/[A-Z][A-Z][A-Z]/, "")), e && (n = u.a.moneyWrapper(n)), n;
                        },
                    },
                    {
                        key: "buildNumberLabel",
                        value: function (t, e) {
                            if (this.shortenPipsRange && e) {
                                var r = o.a.getSettingValue("general.formatPipsRange");
                                if (Array.isArray(r) && r.length > 0)
                                    for (var n = 0, i = "", a = r.length - 1; a >= 0; a--) {
                                        var l = r[a];
                                        if (t >= l.node) {
                                            n = Math.floor(t / l.node).toString();
                                            var s = t.toString(),
                                                c = l.node.toString(),
                                                p = s.length - c.length + 1;
                                            return (i = s.substring(p, p + l.fix)), l.suffix ? n + this.decimalSeparator + i + l.symbol : n + l.symbol + i;
                                        }
                                    }
                            }
                            var f = !o.a.getSettingValue("general.removePriceDecimal");
                            return u.a.formatNumberWithSeparator(t, this.precision, this.thousandSeparator, this.decimalSeparator, f);
                        },
                    },
                    {
                        key: "buildTextLabel",
                        value: function (t) {
                            if (this.prefix) {
                                var e = this.prefix.replace(/\\/g, "");
                                t = t.replace(e, "").trim();
                            }
                            return t;
                        },
                    },
                    {
                        key: "setMoneyFormat",
                        value: function () {
                            if (this.isPriceFilter) {
                                var t = o.a.getSettingValue("general.rangeSliderMoneyFormat");
                                this.moneyFormat = t || "{{amount}}";
                            }
                        },
                    },
                    {
                        key: "setCurrentValues",
                        value: function () {
                            var t = this,
                                e = this.rangeMin,
                                r = this.rangeMax,
                                n = null;
                            if (l.a.queryParams.hasOwnProperty(this.filterOptionId))
                                if (this.isNumberRangeSlider) (n = l.a.queryParams[this.filterOptionId][0].split(":")) && 2 == n.length && (e < n[0] && (e = n[0]), r > n[1] && (r = n[1]));
                                else if (((n = l.a.queryParams[this.filterOptionId]), Array.isArray(n))) {
                                    var i = this.valuesData.map(function (t) {
                                        return t.key;
                                    });
                                    (e = this.rangeMax),
                                        (r = this.rangeMin),
                                        n.forEach(function (n) {
                                            var o = i.indexOf(n);
                                            o >= t.rangeMin && o <= t.rangeMax && (o < e && (e = o), o + 1 > r && (r = o + 1));
                                        });
                                }
                            (this.currentMin = e), (this.currentMax = r);
                        },
                    },
                    {
                        key: "setDisplayStyle",
                        value: function () {
                            var t = o.a.getSettingValue("general.rangeSlidersStyle3"),
                                e = o.a.getSettingValue("general.rangeSlidersSingleHandle");
                            this.isNumberRangeSlider
                                ? Array.isArray(e) && e.includes(this.filterOptionId)
                                    ? ((this.style = "style4"), (this.hideInputElement = !0), (this.isSingleHandle = !0), (this.currentMax = this.currentMin))
                                    : Array.isArray(t) && t.includes(this.filterOptionId)
                                    ? ((this.style = "style3"), (this.hideInputElement = !1))
                                    : this.hideInputElement
                                    ? ((this.style = "style2"), (this.isShowTooltip = !0))
                                    : (this.style = "style1")
                                : ((this.style = "style5"), (this.hideInputElement = !0)),
                                o.a.getSettingValue("general.enable3rdCurrencySupport") && ["style1", "style3"].indexOf(this.style) > -1 && ((this.style = "style2"), (this.hideInputElement = !0), (this.isShowTooltip = !0));
                        },
                    },
                    {
                        key: "prepareFilterOptionData",
                        value: function (t) {
                            return (
                                t.isConvertedPrice ||
                                    (t.values.max && t.values.min && ((t.values.max = Math.ceil(100 * t.values.max) / 100), (t.values.min = Math.floor(100 * t.values.min) / 100)),
                                    ("price" != t.filterType && "variants_price" != t.filterType) ||
                                        !t.values ||
                                        (u.a.isEnableShopifyMultipleCurrencies() &&
                                            u.a.isConvertCurrenciesOnFrontEnd() &&
                                            ((t.values.min = u.a.convertPriceBasedOnActiveCurrency(t.values.min)), (t.values.max = u.a.convertPriceBasedOnActiveCurrency(t.values.max)))),
                                    (t.isConvertedPrice = !0)),
                                t
                            );
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            if (
                                ((t = this.prepareFilterOptionData(t)),
                                Bs(Ds(s.prototype), "setData", this).call(this, t),
                                ("price" == this.filterType || "variants_price" == this.filterType) && !o.a.getSettingValue("general.enable3rdCurrencySupport"))
                            ) {
                                var e = o.a.getSettingValue("general.rangeSliderMoneyFormat");
                                e || (e = l.a.moneyFormat);
                                var r = e.replace(/<.*?>/g, "").replace(/{{.*?}}/, "");
                                1 == r.length && (this.label += u.a.stripHtml(" (" + r + ")"));
                            }
                            if (
                                ((this.isNumberRangeSlider = !Array.isArray(t.values)),
                                (this.isPriceFilter = t.filterType == Kn.a.FilterType.PRICE || t.filterType == Kn.a.FilterType.VARIANTS_PRICE),
                                this.isPriceFilter && this.setMoneyFormat(),
                                this.isSortValues() && this.sortValues(t.values),
                                (this.valuesData = JSON.parse(JSON.stringify(t.values))),
                                this.isNumberRangeSlider && null != t.values.min && null != t.values.max && t.values.min != t.values.max)
                            ) {
                                if (
                                    ((this.hideInputElement = t.hideTextBoxes),
                                    (this.sliderStep = parseFloat(t.sliderStep)),
                                    (isNaN(this.sliderStep) || this.sliderStep > t.values.max) && (this.sliderStep = 1),
                                    (this.sliderRange = parseFloat(t.sliderRange)),
                                    isNaN(this.sliderRange) && (this.sliderRange = 4),
                                    t.values.max - t.values.min < 2 * this.sliderStep && (this.sliderRange = 1),
                                    (this.precision = 0),
                                    Math.floor(this.sliderStep) != this.sliderStep)
                                ) {
                                    var n = this.sliderStep.toString().split(".");
                                    n.length > 1 && (this.precision = n[1].length);
                                }
                                (this.thousandSeparator = t.sliderDelimiter ? t.sliderDelimiter : ""),
                                    "." == this.thousandSeparator ? (this.decimalSeparator = ",") : (this.decimalSeparator = "."),
                                    (this.rangeMin = Math.round(100 * parseFloat(t.values.min)) / 100),
                                    (this.rangeMax = Math.round(100 * parseFloat(t.values.max)) / 100),
                                    this.setCurrentValues(),
                                    this.setDisplayStyle();
                            } else
                                Array.isArray(t.values) && t.values.length > 1
                                    ? ((this.hideInputElement = !0), (this.sliderStep = 1), (this.rangeMin = 0), (this.rangeMax = this.valuesData.length), this.setCurrentValues(), this.setDisplayStyle())
                                    : (this.status = Kn.a.Status.DISABLED);
                        },
                    },
                ]) && Ls(e.prototype, r),
                n && Ls(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                s
            );
        })(_l);
        function Vs(t) {
            return (Vs =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ns(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Vs(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Vs(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Vs(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Hs(t, e) {
            return (Hs = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Us(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = qs(t);
                if (e) {
                    var i = qs(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Ws(this, r);
            };
        }
        function Ws(t, e) {
            if (e && ("object" === Vs(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function qs(t) {
            return (qs = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Gs = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Hs(t, e);
            })(o, t);
            var e,
                r,
                n,
                i = Us(o);
            function o(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, o),
                    ((e = i.call(this, t)).allNestedFilterItems = new Map()),
                    e
                );
            }
            return (
                (e = o),
                (r = [
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptiontemListMultiLevelCollections}} {{class.filterOptionItemListSingleList}} boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-first-level-list">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'.trim();
                        },
                    },
                ]) && Ns(e.prototype, r),
                n && Ns(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                o
            );
        })(_l);
        function zs(t) {
            return (zs =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Ks(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== zs(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== zs(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === zs(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Ys(t, e) {
            return (Ys = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Qs(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Xs(t);
                if (e) {
                    var i = Xs(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Js(this, r);
            };
        }
        function Js(t, e) {
            if (e && ("object" === zs(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Xs(t) {
            return (Xs = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Zs = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ys(t, e);
            })(a, t);
            var e,
                r,
                n,
                i = Qs(a);
            function a(t) {
                var e;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, a),
                    ((e = i.call(this, t)).allNestedFilterItems = new Map()),
                    e
                );
            }
            return (
                (e = a),
                (r = [
                    {
                        key: "getBlockContentTemplate",
                        value: function () {
                            return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptiontemListMultiLevelCollections}} {{displayTypeClass}} boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-first-level-list">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileBlockContentTemplate",
                        value: function () {
                            var t = this.getDisplayTypeClass();
                            return this.getBlockContentTemplate().replace(/{{displayTypeClass}}/g, t);
                        },
                    },
                    {
                        key: "getDisplayTypeClass",
                        value: function () {
                            var t = "";
                            switch (this.displayTypeItem) {
                                case Kn.a.DisplayType.LIST:
                                    t = this.selectType == Kn.a.SelectType.SINGLE ? q.a.filterOptionItemListSingleList : q.a.filterOptionItemListMultipleList;
                                    break;
                                case Kn.a.DisplayType.BOX:
                                    t = q.a.filterOptionItemListBox;
                                    break;
                                case Kn.a.DisplayType.SWATCH:
                                    t = q.a.filterOptionItemListSwatch;
                                    var e = o.a.getSettingValue("general.swatchStyle");
                                    t += " " + (e = e ? e.replace("grid", "list") : "circle-list");
                            }
                            return t;
                        },
                    },
                ]) && Ks(e.prototype, r),
                n && Ks(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                a
            );
        })(_l);
        function tc(t) {
            return (tc =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function ec(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== tc(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== tc(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === tc(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function rc(t, e) {
            return (rc = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function nc(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = oc(t);
                if (e) {
                    var i = oc(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return ic(this, r);
            };
        }
        function ic(t, e) {
            if (e && ("object" === tc(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function oc(t) {
            return (oc = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ac = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && rc(t, e);
            })(p, t);
            var e,
                r,
                n,
                c = nc(p);
            function p(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, p),
                    ((r = c.call(this)).id = t),
                    (r.idSelector = "#" + r.id),
                    (r.filterTreeType = e),
                    (r.isMobileOnly = !1),
                    (r.isDesktopOnly = !1),
                    (r.isRenderOnDOM = !0),
                    (r.collectionId = l.a.collectionId),
                    (r.clickedFilterOption = null),
                    (r.refineBy = null),
                    (r.filterOptions = new Map()),
                    (r.$element = null),
                    (r.filterHorizontalOptionsAlign = o.a.getSettingValue("general.filterHorizontalOptionsAlign")),
                    (r.numberResult = ""),
                    (r.selector = {
                        refineByWrapper: "." + q.a.filterRefineByWrapper,
                        filterOptionsWrapper: "." + q.a.filterOptionsWrapper,
                        clearAllButton: ".boost-pfs-filter-mobile-toolbar-bottom ." + q.a.clearAllButton,
                        clearAllButtonContainer: ".boost-pfs-filter-mobile-toolbar-bottom",
                        applyAllButton: ".boost-pfs-filter-mobile-toolbar-bottom ." + q.a.applyAllFilterOptionButton,
                        applyAllButtonContainer: ".boost-pfs-filter-mobile-footer",
                        closeFilter: "." + q.a.closeFilterButton + ",." + q.a.showResultFilterButton,
                        filterHeader: ".boost-pfs-filter-mobile-toolbar",
                        filterHeaderTop: ".boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-top",
                        filterHeaderBottom: ".boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-bottom",
                        filterFooter: ".boost-pfs-filter-mobile-footer",
                        numberResult: "." + q.a.numberResult,
                    }),
                    r
                );
            }
            return (
                (e = p),
                (r = [
                    {
                        key: "getTemplate",
                        value: function () {
                            switch (this.filterTreeType) {
                                case "vertical":
                                    return '\n\t\t\t\t\t<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}"><div class="boost-drawer__heading">Filter By</div>\n\t\t\t\t\t\t{{header}}\n\t\t\t\t\t\t<div class="{{class.filterRefineByWrapper}}">\n\t\t\t\t\t\t\t{{refineBy}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="{{class.filterOptionsWrapper}}">\n\t\t\t\t\t\t\t{{filterOptions}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t{{footer}}\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                case "horizontal":
                                    return "top" == o.a.getSettingValue("general.refineByHorizontalPosition")
                                        ? '\n\t\t\t\t\t\t<div class="boost-pfs-filter-tree-content boost-pfs-filter-tree-options-align-{{filterHorizontalOptionsAlign}}" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n\t\t\t\t\t\t\t{{header}}\n\t\t\t\t\t\t\t<div class="{{class.filterRefineByWrapper}}">\n\t\t\t\t\t\t\t\t{{refineBy}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="{{class.filterOptionsWrapper}}">\n\t\t\t\t\t\t\t\t{{filterOptions}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t{{footer}}\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t'.trim()
                                        : '\n\t\t\t\t\t\t<div class="boost-pfs-filter-tree-content boost-pfs-filter-tree-options-align-{{filterHorizontalOptionsAlign}}" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n\t\t\t\t\t\t\t{{header}}\n\t\t\t\t\t\t\t<div class="{{class.filterOptionsWrapper}}">\n\t\t\t\t\t\t\t\t{{filterOptions}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="{{class.filterRefineByWrapper}}">\n\t\t\t\t\t\t\t\t{{refineBy}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t{{footer}}\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t'.trim();
                                default:
                                    console.warn("filterTreeType is wrong");
                            }
                        },
                    },
                    {
                        key: "getHeaderTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-mobile-toolbar">\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-top">\n\t\t\t\t\t<a href="javascript:;" class="{{class.closeFilterButton}}"><span>{{label.close}}</span></a>\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-header">{{label.refineMobile}}</div>\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-bottom">\n\t\t\t\t\t{{clearButton}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "getFooterTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-mobile-footer">\n\t\t\t\t<button class="{{class.showResultFilterButton}}" type="button">{{label.showResult}}<span class="{{class.numberResult}}">{{numberResult}}</span></button>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            return this.getTemplate()
                                .replace(/{{header}}/g, this.getHeaderTemplate())
                                .replace(/{{footer}}/g, this.getFooterTemplate())
                                .replace(/{{filterHorizontalOptionsAlign}}/g, this.filterHorizontalOptionsAlign)
                                .replace(/{{label.productFilter}}/g, a.a.productFilter)
                                .replace(/{{label.showResult}}/g, a.a.showResult)
                                .replace(/{{label.refineMobile}}/g, a.a.refineMobile)
                                .replace(/{{label.apply}}/g, a.a.apply)
                                .replace(/{{label.close}}/g, a.a.close)
                                .replace(/{{label.back}}/g, a.a.back)
                                .replace(/{{class.filterOptionsWrapper}}/g, q.a.filterOptionsWrapper)
                                .replace(/{{class.filterRefineByWrapper}}/g, q.a.filterRefineByWrapper)
                                .replace(/{{class.closeFilterButton}}/g, q.a.closeFilterButton)
                                .replace(/{{class.showResultFilterButton}}/g, q.a.showResultFilterButton)
                                .replace(/{{class.numberResult}}/g, q.a.numberResult)
                                .replace(/{{numberResult}}/g, this.numberResult)
                                .replace(/{{refineBy}}/g, "")
                                .replace(/{{clearButton}}/g, "")
                                .replace(/{{applyButton}}/g, "")
                                .replace(/{{filterOptions}}/g, "");
                        },
                    },
                    {
                        key: "init",
                        value: function () {
                            var t = i()(this.idSelector);
                            if (1 == t.length)
                                if (
                                    ((this.isMobileOnly = t[0].hasAttribute("data-is-mobile")),
                                    (this.isDesktopOnly = t[0].hasAttribute("data-is-desktop")),
                                    (this.isDesktopOnly && this.isMobileOnly) || (!this.isMobileOnly && !this.isDesktopOnly))
                                )
                                    (this.isDesktopOnly = !1), (this.isMobileOnly = !1);
                                else {
                                    var e = u.a.isMobile();
                                    this.isRenderOnDOM = (e && this.isMobileOnly) || (!e && this.isDesktopOnly);
                                }
                            (this.clearAllButton = new Bi(this.filterTreeType, Bi.ClearType.CLEAR_ALL)), (this.applyAllButton = new FilterApplyButton(this.filterTreeType, FilterApplyButton.ApplyType.APPLY_ALL));
                        },
                    },
                    {
                        key: "isRender",
                        value: function () {
                            return this.parent.isFetchedFilterData && this.isRenderOnDOM && X.isPanelActive(at.Enum.PRODUCT);
                        },
                    },
                    {
                        key: "isLoopThroughChild",
                        value: function () {
                            return this.isRenderOnDOM && this.parent.isFetchedFilterData;
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            if (
                                (!0 === l.a.queryParams.build_filter_tree && this.filterOptions && (this.isRenderPartially ? this.renderPartially() : this.renderFull(), this.renderRefineBy(), this.renderExtraElements()),
                                o.a.getSettingValue("general.filterTreeNumberResultEnable"))
                            ) {
                                var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
                                this.$element
                                    .find(this.selector.numberResult)
                                    .addClass(q.a.numberResult + "-has-data")
                                    .html(t);
                            }
                        },
                    },
                    {
                        key: "renderFull",
                        value: function () {
                            var t = this;
                            (this.$element = i()(this.compileTemplate())),
                                (this.$filterOptionsContainerElement = this.$element.find(this.selector.filterOptionsWrapper)),
                                this.filterOptions.forEach(function (e) {
                                    t.$filterOptionsContainerElement.append(e.$element);
                                });
                        },
                    },
                    {
                        key: "renderPartially",
                        value: function () {
                            var t = this;
                            this.$filterOptionsContainerElement = this.$element.find(this.selector.filterOptionsWrapper);
                            var e = !1;
                            this.clickedFilterOption.$element.siblings().remove(),
                                this.filterOptions.forEach(function (r) {
                                    if (r.$element) {
                                        if (r == t.clickedFilterOption) return void (e = !0);
                                        e ? t.$filterOptionsContainerElement.append(r.$element) : r.$element.insertBefore(t.clickedFilterOption.$element);
                                    }
                                });
                        },
                    },
                    {
                        key: "renderRefineBy",
                        value: function () {
                            o.a.getSettingValue("general.separateRefineByFromFilter") ? this.renderSeparateRefineBy() : this.renderAttachedRefineBy();
                        },
                    },
                    {
                        key: "renderAttachedRefineBy",
                        value: function () {
                            this.refineBy &&
                                this.$element &&
                                ((this.$refineByElementContainer = this.$element.find(this.selector.refineByWrapper)),
                                this.$refineByElementContainer.length > 0 && (this.$refineByElementContainer.first().html("").append(this.refineBy.$element), (this.$refineByElement = this.refineBy.$element)));
                        },
                    },
                    {
                        key: "renderSeparateRefineBy",
                        value: function () {
                            if (this.refineBy) {
                                var t = this.refineBy.filterTreeType == Ci.FilterTreeType.VERTICAL ? s.a.filterRefineByVertical : s.a.filterRefineByHorizontal;
                                i()(t).length > 0 && i()(t).first().html("").append(this.refineBy.$element);
                            }
                        },
                    },
                    {
                        key: "renderExtraElements",
                        value: function () {
                            0 == this.$element.find(this.selector.clearAllButton).length && this.$element.find(this.selector.clearAllButtonContainer).append(this.clearAllButton.$element),
                                0 == this.$element.find(this.selector.applyAllButton).length && this.$element.find(this.selector.applyAllButtonContainer).append(this.applyAllButton.$element),
                                u.a.isMobile() || "style-expand" != o.a.getSettingValue("general.filterTreeHorizontalStyle") || this.$element.find(this.selector.filterFooter).append(this.clearAllButton.$element);
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            (this.isMobileOnly || this.isDesktopOnly) &&
                                ((this.resizeTimer = null),
                                i()(window).on(
                                    "resize",
                                    function () {
                                        this.resizeTimer && clearTimeout(this.resizeTimer), (this.resizeTimer = setTimeout(this.onScreenResize.bind(this), 500));
                                    }.bind(this)
                                )),
                                this.$element &&
                                    (this.$element.find(this.selector.closeFilter).length > 0 &&
                                        (this.$element.find(this.selector.closeFilter).off("click"), this.$element.find(this.selector.closeFilter).on("click", this.onCloseFilterTree.bind(this))),
                                    i()(".boost-pfs-filter-overlay").length > 0 && i()(".boost-pfs-filter-overlay").off("click").on("click", this.onCloseFilterTree.bind(this)));
                        },
                    },
                    {
                        key: "onScreenResize",
                        value: function () {
                            var t = u.a.isMobile(),
                                e = (t && this.isMobileOnly) || (!t && this.isDesktopOnly);
                            this.isRenderOnDOM != e &&
                                ((this.isRenderOnDOM = e),
                                this.isRenderOnDOM ? ((this.isRenderPartially = !1), this.refresh(), i()(this.idSelector).first().html("").append(this.$element)) : this.$element && (this.$element.detach(), (this.$element = null)));
                        },
                    },
                    {
                        key: "onCloseFilterTree",
                        value: function () {
                            var t = i()(this.idSelector);
                            t &&
                                (this.mobileButton && (this.mobileButton.isCollapsed = !0),
                                this.desktopButton && (this.desktopButton.$element[0].click(), (this.desktopButton.isCollapsed = !0)),
                                t.removeClass(q.a.filterTreeMobileOpen),
                                i()("body").removeClass(q.a.filterTreeOpenBody).removeClass("boost-pfs-body-no-scroll"),
                                i()("html").removeClass(q.a.filterTreeOpenBody).removeClass("boost-pfs-body-no-scroll"));
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            var e = this;
                            o.a.getSettingValue("general.filterTreeEnableRenderPartially") && this.collectionId == l.a.collectionId
                                ? (this.clickedFilterOption = this.filterOptions.get(this.parent.clickedFilterOptionId))
                                : ((this.collectionId = l.a.collectionId), (this.clickedFilterOption = null)),
                                (this.isRenderPartially = !!(this.$element && this.clickedFilterOption && this.clickedFilterOption.$element)),
                                this.modifyOptionsData(t.options),
                                (this.children = []),
                                (this.filterOptions = new Map()),
                                t.options.forEach(function (t) {
                                    if (!(t.status != Kn.a.Status.ACTIVE || (Array.isArray(t.values) && 0 == t.values.length && Array.isArray(t.manualValues) && 0 == t.manualValues.length))) {
                                        var r = null;
                                        if ((e.clickedFilterOption && t.filterOptionId == e.clickedFilterOption.filterOptionId && (r = e.clickedFilterOption), null == r)) {
                                            switch (t.displayType) {
                                                case Kn.a.DisplayType.LIST:
                                                    r = new xl(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.BOX:
                                                    r = new Ul(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.RANGE:
                                                    r = new Ms(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.SWATCH:
                                                    r = new Jl(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.RATING:
                                                    r = new os(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.SUB_CATEGORY:
                                                    r = new ks(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                                                    r = new Gs(e.filterTreeType);
                                                    break;
                                                case Kn.a.DisplayType.MULTI_LEVEL_TAG:
                                                    r = new Zs(e.filterTreeType);
                                            }
                                            if (!r) return;
                                            r.setData(t);
                                        }
                                        e.addComponent(r), e.filterOptions.set(t.filterOptionId, r);
                                    }
                                }),
                                o.a.getSettingValue("general.showRefineBy") && ((this.refineBy = new vs(this.filterTreeType)), this.addComponent(this.refineBy), this.refineBy.setData()),
                                this.addComponent(this.clearAllButton),
                                this.addComponent(this.applyAllButton);
                        },
                    },
                    {
                        key: "modifyOptionsData",
                        value: function (t) {
                            var e = o.a.getSettingValue("general.advancedRangeSliders");
                            t.forEach(function (t) {
                                if ((Array.isArray(e) && e.includes(t.filterOptionId) && t.selectType == Kn.a.SelectType.MULTIPLE && (t.displayType = Kn.a.DisplayType.RANGE), t.filterType == Kn.a.FilterType.MULTI_LEVEL_TAG)) {
                                    switch (t.displayType) {
                                        case Kn.a.DisplayType.LIST:
                                            t.displayTypeItem = Kn.a.DisplayType.LIST;
                                            break;
                                        case Kn.a.DisplayType.BOX:
                                            t.displayTypeItem = Kn.a.DisplayType.BOX;
                                            break;
                                        case Kn.a.DisplayType.SWATCH:
                                            t.displayTypeItem = Kn.a.DisplayType.SWATCH;
                                            break;
                                        default:
                                            return;
                                    }
                                    t.displayType = Kn.a.DisplayType.MULTI_LEVEL_TAG;
                                }
                                ((u.a.isVendorPage() && t.filterType == Kn.a.FilterType.VENDOR) || (u.a.isTypePage() && t.filterType == Kn.a.FilterType.PRODUCT_TYPE)) && (t.status = Kn.a.Status.DISABLED),
                                    t.displayType == Kn.a.DisplayType.SUB_CATEGORY && (t.status = Kn.a.Status.DISABLED);
                            });
                        },
                    },
                ]) && ec(e.prototype, r),
                n && ec(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                p
            );
        })(d.a);
        function lc(t) {
            return (lc =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function sc(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== lc(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== lc(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === lc(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function cc() {
            return (cc =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = uc(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function uc(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = yc(t)); );
            return t;
        }
        function pc(t, e) {
            return (pc = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function fc(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = yc(t);
                if (e) {
                    var i = yc(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return hc(this, r);
            };
        }
        function hc(t, e) {
            if (e && ("object" === lc(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function yc(t) {
            return (yc = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var dc = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && pc(t, e);
            })(c, t);
            var e,
                r,
                n,
                s = fc(c);
            function c(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, c),
                    ((r = s.call(this, t, e)).style = "style2"),
                    (r.selector.clearAllButtonContainer = ".boost-pfs-filter-mobile-toolbar-right"),
                    (r.selector.backButton = ".boost-pfs-filter-back-btn"),
                    (r.selector.refineByOnTitle = ".boost-pfs-filter-selected-items-mobile"),
                    (r.selector.headerTitle = ".boost-pfs-filter-mobile-toolbar-middle"),
                    (r.style2ActiveFilterOption = null),
                    r
                );
            }
            return (
                (e = c),
                (n = [
                    {
                        key: "isActive",
                        value: function (t) {
                            return t == Ci.FilterTreeType.VERTICAL && "style2" == o.a.getSettingValue("general.filterTreeMobileStyle");
                        },
                    },
                ]),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            cc(yc(c.prototype), "init", this).call(this),
                                i()(this.idSelector).length > 0 &&
                                    (i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style2").addClass("boost-pfs-filter-tree-mobile-sticky"),
                                    o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"));
                        },
                    },
                    {
                        key: "getHeaderTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="boost-pfs-filter-mobile-toolbar">\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-top">\n\t\t\t\t\t<span class="{{class.closeFilterButton}}"><span>{{label.close}}</span></span>\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-items">\n\t\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-left">\n\t\t\t\t\t\t<span class="boost-pfs-filter-back-btn" aria-label="{{label.back}}"></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-middle">{{label.refineMobile}}</div>\n\t\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-right">\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            if ((cc(yc(c.prototype), "render", this).call(this), this.$element && u.a.isMobile())) {
                                var e = null;
                                this.filterOptions.forEach(function (r) {
                                    t.style2ActiveFilterOption && t.style2ActiveFilterOption.filterOptionId == r.filterOptionId && (e = r);
                                }),
                                    (this.style2ActiveFilterOption = e),
                                    this.renderFilterTreeHeader(),
                                    this.renderFilterTreeFooter(),
                                    this.renderFilterOptionCollapse(),
                                    this.renderFilterOptionClear(),
                                    this.renderRefineByOnTitle();
                            }
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            var t = this;
                            cc(yc(c.prototype), "bindEvents", this).call(this),
                                this.$element &&
                                    u.a.isMobile() &&
                                    (this.$element.find(this.selector.backButton).on("click", this.closeFilterOption.bind(this)),
                                    this.filterOptions.forEach(function (e) {
                                        e.$filterOptionTitleElement && (e.$filterOptionTitleElement.off("click"), e.$filterOptionTitleElement.on("click", t.openFilterOption.bind(t, e)));
                                    })),
                                this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "renderFilterTreeHeader",
                        value: function () {
                            this.style2ActiveFilterOption
                                ? (this.$element.find(this.selector.headerTitle).html(u.a.stripHtml(this.style2ActiveFilterOption.label)), this.$element.find(this.selector.backButton).show())
                                : (this.$element.find(this.selector.headerTitle).html(a.a.refineMobile), this.$element.find(this.selector.backButton).hide()),
                                this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "renderFilterTreeFooter",
                        value: function () {
                            var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
                            this.$element.find("." + q.a.showResultFilterButton).html(u.a.stripHtml(a.a.showResult + t));
                        },
                    },
                    {
                        key: "renderFilterOptionCollapse",
                        value: function () {
                            var t = this;
                            this.filterOptions.forEach(function (e) {
                                if (e.$filterOptionTitleElement && e.$filterOptionContentElement && e.collapse) {
                                    e.$element.removeClass("boost-pfs-filter-option-collapsed");
                                    var r = e.$element.find(".boost-pfs-filter-option-title"),
                                        n = e.$filterOptionContentElement;
                                    t.style2ActiveFilterOption
                                        ? e == t.style2ActiveFilterOption
                                            ? (r.hide(), n.show(), n.addClass("boost-pfs-filter-option-content-open"))
                                            : (r.hide(), n.hide(), n.removeClass("boost-pfs-filter-option-content-open"))
                                        : (r.show(), n.hide(), n.removeClass("boost-pfs-filter-option-content-open"));
                                }
                            });
                        },
                    },
                    {
                        key: "renderFilterOptionClear",
                        value: function () {
                            var t = this.clearAllButton.$element,
                                e = this.$element.find(this.selector.clearAllButtonContainer);
                            e &&
                                (t && (null == this.style2ActiveFilterOption && l.a.hasFilterOptionParam ? e.append(t) : t.detach()),
                                this.filterOptions.forEach(function (t) {
                                    t.clearButton && t.clearButton.$element && t.clearButton.$element.detach();
                                }),
                                this.style2ActiveFilterOption && this.style2ActiveFilterOption.clearButton && this.style2ActiveFilterOption.clearButton.$element && e.append(this.style2ActiveFilterOption.clearButton.$element));
                        },
                    },
                    {
                        key: "renderRefineByOnTitle",
                        value: function () {
                            var t = this;
                            this.filterOptions.forEach(function (e) {
                                if (e.$element) {
                                    var r = "";
                                    if (e.filterOptionId.startsWith(l.a.prefix + "_c_")) {
                                        var n = e.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS ? e.allNestedFilterItems : e.filterItems;
                                        if (n && n.size > 0) {
                                            var i = "",
                                                o = [];
                                            n.forEach(function (t) {
                                                t.isSelected && (2 == t.level || 3 == t.level ? o.push(u.a.stripHtml(t.label)) : (i = u.a.stripHtml(t.label)));
                                            }),
                                                (r = i && o.length > 0 ? i + ": " + o.join(", ") : i);
                                        }
                                    } else if (t.refineBy && t.refineBy.refineByItems) {
                                        var a = [];
                                        t.refineBy.refineByItems.forEach(function (t) {
                                            if (t.filterOptionId == e.filterOptionId) {
                                                var r = u.a.stripHtml(t.label);
                                                r && a.push(r);
                                            }
                                        }),
                                            (r = a.join(", "));
                                    }
                                    var s = r ? "<span>" + u.a.stripHtml(r) + "</span>" : "";
                                    e.$element.find(t.selector.refineByOnTitle).html(s);
                                }
                            });
                        },
                    },
                    {
                        key: "openFilterOption",
                        value: function (t) {
                            (this.style2ActiveFilterOption = t), this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear(), this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "closeFilterOption",
                        value: function () {
                            (this.style2ActiveFilterOption = null), this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear();
                        },
                    },
                    {
                        key: "onClickMobileButton",
                        value: function (t) {
                            t && (t.stopImmediatePropagation(), t.stopPropagation()), (this.style2ActiveFilterOption = null);
                            var e = i()(this.idSelector);
                            e &&
                                ((this.mobileButton.isCollapsed = !this.mobileButton.isCollapsed),
                                this.mobileButton.isCollapsed
                                    ? (e.removeClass(q.a.filterTreeMobileOpen), i()("body").removeClass(q.a.filterTreeOpenBody), i()("html").removeClass("boost-pfs-body-no-scroll"))
                                    : (this.closeFilterOption(), e.addClass(q.a.filterTreeMobileOpen), i()("body").addClass(q.a.filterTreeOpenBody), i()("html").addClass("boost-pfs-body-no-scroll"))),
                                this.mobileButton.afterToggleFilterTree(),
                                this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "mathHeightToolbarHeader",
                        value: function () {
                            var t = i()(".boost-pfs-filter-mobile-toolbar").height();
                            this.filterTreeType == Ci.FilterTreeType.VERTICAL && u.a.isMobile() && i()(".boost-pfs-filter-options-wrapper").css("top", t + "px");
                        },
                    },
                ]) && sc(e.prototype, r),
                n && sc(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                c
            );
        })(ac);
        function mc(t) {
            return (mc =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function gc(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== mc(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== mc(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === mc(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function bc() {
            return (bc =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = vc(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function vc(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Tc(t)); );
            return t;
        }
        function Sc(t, e) {
            return (Sc = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Oc(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Tc(t);
                if (e) {
                    var i = Tc(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Pc(this, r);
            };
        }
        function Pc(t, e) {
            if (e && ("object" === mc(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Tc(t) {
            return (Tc = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var wc = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Sc(t, e);
            })(l, t);
            var e,
                r,
                n,
                a = Oc(l);
            function l(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((r = a.call(this, t, e)).style = "style2-fullwidth"),
                    r
                );
            }
            return (
                (e = l),
                (n = [
                    {
                        key: "isActive",
                        value: function (t) {
                            return t == Ci.FilterTreeType.VERTICAL && "style2-fullwidth" == o.a.getSettingValue("general.filterTreeMobileStyle");
                        },
                    },
                ]),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            bc(Tc(l.prototype), "init", this).call(this),
                                i()(this.idSelector).length > 0 &&
                                    (i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style2").addClass("boost-pfs-filter-tree-mobile-sticky").addClass("boost-pfs-filter-tree-mobile-full-width-style"),
                                    o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"));
                        },
                    },
                ]) && gc(e.prototype, r),
                n && gc(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(dc);
        function _c(t) {
            return (_c =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Cc(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== _c(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== _c(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === _c(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function kc() {
            return (kc =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = Ec(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function Ec(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Lc(t)); );
            return t;
        }
        function Rc(t, e) {
            return (Rc = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ic(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Lc(t);
                if (e) {
                    var i = Lc(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return jc(this, r);
            };
        }
        function jc(t, e) {
            if (e && ("object" === _c(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Lc(t) {
            return (Lc = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Bc = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Rc(t, e);
            })(l, t);
            var e,
                r,
                n,
                a = Ic(l);
            function l(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((r = a.call(this, t, e)).style = "style3"),
                    (r.selector.refineByOnTitle = ".boost-pfs-filter-selected-items-mobile"),
                    (r.selector.clearAllButtonContainer = ".boost-pfs-filter-mobile-toolbar-bottom"),
                    r
                );
            }
            return (
                (e = l),
                (n = [
                    {
                        key: "isActive",
                        value: function (t) {
                            return t == Ci.FilterTreeType.VERTICAL && "style3" == o.a.getSettingValue("general.filterTreeMobileStyle");
                        },
                    },
                ]),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            kc(Lc(l.prototype), "init", this).call(this),
                                i()(this.idSelector).length > 0 &&
                                    (i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style3").addClass("boost-pfs-filter-tree-mobile-sticky"),
                                    o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"));
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            var t = this;
                            kc(Lc(l.prototype), "render", this).call(this),
                                this.$element &&
                                    u.a.isMobile() &&
                                    this.filterOptions.forEach(function (e) {
                                        if (e.$element && t.refineBy && t.refineBy.refineByItems) {
                                            var r = [];
                                            t.refineBy.refineByItems.forEach(function (t) {
                                                if (t.filterOptionId == e.filterOptionId) {
                                                    var n = t.buildLabel();
                                                    n && r.push(n);
                                                }
                                            }),
                                                e.$element.find(t.selector.refineByOnTitle).html(u.a.stripHtml(r.join(", ")));
                                        }
                                    });
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            kc(Lc(l.prototype), "bindEvents", this).call(this), this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "renderFilterTreeHeader",
                        value: function () {
                            this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "renderFilterTreeFooter",
                        value: function () {
                            var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
                            this.$element.find("." + q.a.showResultFilterButton).html(u.a.stripHtml(Labels.showResult + t));
                        },
                    },
                    {
                        key: "onClickMobileButton",
                        value: function (t) {
                            t && (t.stopImmediatePropagation(), t.stopPropagation());
                            var e = i()(this.idSelector);
                            e &&
                                ((this.mobileButton.isCollapsed = !this.mobileButton.isCollapsed),
                                this.mobileButton.isCollapsed
                                    ? (e.removeClass(q.a.filterTreeMobileOpen), i()("body").removeClass(q.a.filterTreeOpenBody), i()("html").removeClass("boost-pfs-body-no-scroll"))
                                    : (e.addClass(q.a.filterTreeMobileOpen), i()("body").addClass(q.a.filterTreeOpenBody), i()("html").addClass("boost-pfs-body-no-scroll"))),
                                this.mobileButton.afterToggleFilterTree(),
                                this.mathHeightToolbarHeader();
                        },
                    },
                    {
                        key: "mathHeightToolbarHeader",
                        value: function () {
                            var t = i()(".boost-pfs-filter-mobile-toolbar").height();
                            this.filterTreeType == Ci.FilterTreeType.VERTICAL && u.a.isMobile() && i()(".boost-pfs-filter-options-wrapper").css("top", t + "px");
                        },
                    },
                ]) && Cc(e.prototype, r),
                n && Cc(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(ac);
        function Ac(t) {
            return (Ac =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function xc(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Ac(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Ac(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Ac(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function Fc() {
            return (Fc =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = $c(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function $c(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Nc(t)); );
            return t;
        }
        function Dc(t, e) {
            return (Dc = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Mc(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Nc(t);
                if (e) {
                    var i = Nc(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Vc(this, r);
            };
        }
        function Vc(t, e) {
            if (e && ("object" === Ac(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Nc(t) {
            return (Nc = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Hc = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Dc(t, e);
            })(l, t);
            var e,
                r,
                n,
                a = Mc(l);
            function l(t, e) {
                var r;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, l),
                    ((r = a.call(this, t, e)).style = "style3-fullwidth"),
                    r
                );
            }
            return (
                (e = l),
                (n = [
                    {
                        key: "isActive",
                        value: function (t) {
                            return t == Ci.FilterTreeType.VERTICAL && "style3-fullwidth" == o.a.getSettingValue("general.filterTreeMobileStyle");
                        },
                    },
                ]),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            Fc(Nc(l.prototype), "init", this).call(this),
                                i()(this.idSelector).length > 0 &&
                                    (i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style3").addClass("boost-pfs-filter-tree-mobile-sticky").addClass("boost-pfs-filter-tree-mobile-full-width-style"),
                                    o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"));
                        },
                    },
                ]) && xc(e.prototype, r),
                n && xc(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                l
            );
        })(Bc);
        function Uc(t) {
            return (Uc =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Wc(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Uc(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Uc(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Uc(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function qc() {
            return (qc =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get.bind()
                    : function (t, e, r) {
                          var n = Gc(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }).apply(this, arguments);
        }
        function Gc(t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Qc(t)); );
            return t;
        }
        function zc(t, e) {
            return (zc = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Kc(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Qc(t);
                if (e) {
                    var i = Qc(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Yc(this, r);
            };
        }
        function Yc(t, e) {
            if (e && ("object" === Uc(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Qc(t) {
            return (Qc = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Jc = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && zc(t, e);
                })(c, t);
                var e,
                    r,
                    n,
                    s = Kc(c);
                function c(t, e) {
                    var r;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, c),
                        ((r = s.call(this, t, e)).style = "style4"),
                        (r.selector.clearAllButtonContainer = ".boost-pfs-filter-mobile-toolbar-right"),
                        (r.selector.backButton = ".boost-pfs-filter-back-btn"),
                        (r.selector.refineByOnTitle = ".boost-pfs-filter-selected-items-mobile"),
                        (r.selector.headerTitle = ".bc-sf-filter-mobile-toolbar-header"),
                        (r.selector.headerClose = ".boost-pfs-filter-close"),
                        (r.style4ActiveFilterOption = null),
                        (o.a.activeFilterScrollbarMobile = !1),
                        r
                    );
                }
                return (
                    (e = c),
                    (n = [
                        {
                            key: "isActive",
                            value: function (t) {
                                return t == Ci.FilterTreeType.VERTICAL && "style4" == o.a.getSettingValue("general.filterTreeMobileStyle");
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                qc(Qc(c.prototype), "init", this).call(this),
                                    i()(this.idSelector).length > 0 &&
                                        (i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style4").addClass("boost-pfs-filter-tree-mobile-sticky"),
                                        o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && i()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"));
                            },
                        },
                        {
                            key: "getHeaderTemplate",
                            value: function () {
                                return '\n        <div class="boost-pfs-filter-mobile-toolbar">\n            <div class="bc-sf-filter-mobile-toolbar-header">{{label.refineMobile}}</div>\n            <div class="boost-pfs-filter-mobile-toolbar-items">\n                <div class="boost-pfs-filter-mobile-toolbar-left">\n                    <span class="{{class.closeFilterButton}}"><span>{{label.close}}</span></span>\n                    <span class="boost-pfs-filter-back-btn">{{label.apply}}</span>\n                </div>\n                <div class="boost-pfs-filter-mobile-toolbar-right">\n                    {{clearButton}}\n                </div>\n            </div>\n        </div>\n    '.trim();
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                var t = this;
                                if ((qc(Qc(c.prototype), "render", this).call(this), this.$element && u.a.isMobile())) {
                                    var e = null;
                                    this.filterOptions.forEach(function (r) {
                                        t.style4ActiveFilterOption && t.style4ActiveFilterOption.filterOptionId == r.filterOptionId && (e = r);
                                    }),
                                        (this.style4ActiveFilterOption = e),
                                        this.renderFilterTreeHeader(),
                                        this.renderFilterTreeFooter(),
                                        this.renderFilterOptionCollapse(),
                                        this.renderFilterOptionClear(),
                                        this.renderRefineByOnTitle();
                                }
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                var t = this;
                                qc(Qc(c.prototype), "bindEvents", this).call(this),
                                    this.$element &&
                                        u.a.isMobile() &&
                                        (this.$element.find(this.selector.backButton).on("click", this.closeFilterOption.bind(this)),
                                        this.filterOptions.forEach(function (e) {
                                            e.$filterOptionTitleElement && (e.$filterOptionTitleElement.off("click"), e.$filterOptionTitleElement.on("click", t.openFilterOption.bind(t, e)));
                                        }));
                            },
                        },
                        {
                            key: "renderFilterTreeHeader",
                            value: function () {
                                this.style4ActiveFilterOption
                                    ? (this.$element.find(this.selector.headerTitle).html(u.a.stripHtml(this.style4ActiveFilterOption.label)),
                                      this.$element.find(this.selector.backButton).show(),
                                      this.$element.find(this.selector.headerClose).hide())
                                    : (this.$element.find(this.selector.headerTitle).html(a.a.refineMobile), this.$element.find(this.selector.backButton).hide(), this.$element.find(this.selector.headerClose).show());
                            },
                        },
                        {
                            key: "renderFilterTreeFooter",
                            value: function () {
                                var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
                                this.$element.find("." + q.a.showResultFilterButton).html(a.a.showResult + '<span class="boost-pfs-number-result">' + u.a.stripHtml(t) + "</span>");
                            },
                        },
                        {
                            key: "renderFilterOptionCollapse",
                            value: function () {
                                var t = this;
                                this.filterOptions.forEach(function (e) {
                                    if (e.$filterOptionTitleElement && e.$filterOptionContentElement && e.collapse) {
                                        e.$element.removeClass("boost-pfs-filter-option-collapsed");
                                        var r = e.$element.find(".boost-pfs-filter-option-title"),
                                            n = e.$filterOptionContentElement;
                                        t.style4ActiveFilterOption ? (e == t.style4ActiveFilterOption ? (r.hide(), n.show()) : (r.hide(), n.hide())) : (r.show(), n.hide());
                                    }
                                });
                            },
                        },
                        {
                            key: "renderFilterOptionClear",
                            value: function () {
                                var t = this.clearAllButton.$element,
                                    e = this.$element.find(this.selector.clearAllButtonContainer);
                                e &&
                                    (t && (null == this.style4ActiveFilterOption && l.a.hasFilterOptionParam ? e.append(t) : t.detach()),
                                    this.filterOptions.forEach(function (t) {
                                        t.clearButton && t.clearButton.$element && t.clearButton.$element.detach();
                                    }),
                                    this.style4ActiveFilterOption && this.style4ActiveFilterOption.clearButton && this.style4ActiveFilterOption.clearButton.$element && e.append(this.style4ActiveFilterOption.clearButton.$element));
                            },
                        },
                        {
                            key: "renderRefineByOnTitle",
                            value: function () {
                                var t = this;
                                this.filterOptions.forEach(function (e) {
                                    if (e.$element) {
                                        var r = "";
                                        if (e.filterOptionId.startsWith(l.a.prefix + "_c_")) {
                                            var n = e.displayType == Kn.a.DisplayType.MULTI_LEVEL_COLLECTIONS ? e.allNestedFilterItems : e.filterItems;
                                            if (n && n.size > 0) {
                                                var i = "",
                                                    o = [];
                                                n.forEach(function (t) {
                                                    t.isSelected && (2 == t.level || 3 == t.level ? o.push(u.a.stripHtml(t.label)) : (i = u.a.stripHtml(t.label)));
                                                }),
                                                    (r = i && o.length > 0 ? i + ": " + o.join(", ") : i);
                                            }
                                        } else if (t.refineBy && t.refineBy.refineByItems) {
                                            var a = [];
                                            t.refineBy.refineByItems.forEach(function (t) {
                                                if (t.filterOptionId == e.filterOptionId) {
                                                    var r = u.a.stripHtml(t.label);
                                                    r && a.push(r);
                                                }
                                            }),
                                                (r = a.join(", "));
                                        }
                                        var s = r ? "<span>" + u.a.stripHtml(r) + "</span>" : "";
                                        e.$element.find(t.selector.refineByOnTitle).html(s);
                                    }
                                });
                            },
                        },
                        {
                            key: "openFilterOption",
                            value: function (t) {
                                (this.style4ActiveFilterOption = t), this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear();
                                var e = i()(".boost-pfs-filter-mobile-toolbar").height();
                                i()(".boost-pfs-filter-options-wrapper").css("top", e + "px");
                            },
                        },
                        {
                            key: "closeFilterOption",
                            value: function () {
                                (this.style4ActiveFilterOption = null), this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear();
                            },
                        },
                        {
                            key: "onClickMobileButton",
                            value: function (t) {
                                t && (t.stopImmediatePropagation(), t.stopPropagation()), (this.style4ActiveFilterOption = null);
                                var e = i()(this.idSelector);
                                e &&
                                    ((this.mobileButton.isCollapsed = !this.mobileButton.isCollapsed),
                                    this.mobileButton.isCollapsed
                                        ? (e.removeClass(q.a.filterTreeMobileOpen), i()("body").removeClass(q.a.filterTreeOpenBody), i()("html").removeClass("boost-pfs-body-no-scroll"))
                                        : (e.addClass(q.a.filterTreeMobileOpen), i()("body").addClass(q.a.filterTreeOpenBody), i()("html").addClass("boost-pfs-body-no-scroll"))),
                                    this.mobileButton.afterToggleFilterTree();
                            },
                        },
                    ]) && Wc(e.prototype, r),
                    n && Wc(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    c
                );
            })(ac),
            Xc = {
                newFilterTree: function (t, e) {
                    return Bc.isActive(e) ? new Bc(t, e) : dc.isActive(e) ? new dc(t, e) : wc.isActive(e) ? new wc(t, e) : Hc.isActive(e) ? new Hc(t, e) : Jc.isActive(e) ? new Jc(t, e) : new ac(t, e);
                },
            };
        function Zc(t) {
            return (Zc =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function tu(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== Zc(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== Zc(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === Zc(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function eu(t, e) {
            return (eu = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function ru(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = iu(t);
                if (e) {
                    var i = iu(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return nu(this, r);
            };
        }
        function nu(t, e) {
            if (e && ("object" === Zc(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function iu(t) {
            return (iu = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var ou = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && eu(t, e);
                })(c, t);
                var e,
                    r,
                    n,
                    a = ru(c);
                function c() {
                    var t;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, c),
                        ((t = a.call(this)).filterTrees = []),
                        (t.filterMobileButton = null),
                        (t.filterDesktopButton = null),
                        (t.filterResult = null),
                        (t.filterLoadingIcon = null),
                        (t.filterScrollToTop = null),
                        (t.data = null),
                        (t.fromCache = !1),
                        (t.eventType = ""),
                        (t.error = ""),
                        (t.isFetchedFilterData = !1),
                        t
                    );
                }
                return (
                    (e = c),
                    (r = [
                        {
                            key: "beforeInit",
                            value: function () {
                                u.a.isBadUrl() && ((this.isInit = !0), u.a.setWindowLocation(window.location.pathname));
                            },
                        },
                        {
                            key: "init",
                            value: function () {
                                this.initInCollectionSearch(),
                                    this.initFilterTrees(),
                                    this.initFilterMobileButton(),
                                    this.initFilterDesktopButton(),
                                    (this.filterResult = new zn()),
                                    this.addComponent(this.filterResult),
                                    (this.filterLoadingIcon = new bi()),
                                    this.addComponent(this.filterLoadingIcon),
                                    (this.filterScrollToTop = new _i()),
                                    this.addComponent(this.filterScrollToTop),
                                    this.filterLoadingIcon.setShow(!0);
                            },
                        },
                        {
                            key: "afterInit",
                            value: function () {
                                Z.default.updateParamsFromUrl(), Z.default.getFilterData("init", this.afterGetFilterData.bind(this), this.errorFilterCallback.bind(this));
                            },
                        },
                        {
                            key: "initFilterTrees",
                            value: function () {
                                var t = this;
                                i()(s.a.filterTree).each(function (e, r) {
                                    var n = i()(r),
                                        a = "";
                                    if (
                                        (n.hasClass(q.a.filterTreeVertical)
                                            ? ((a = Ci.FilterTreeType.VERTICAL), i()("body").addClass(q.a.filterTree + "-vertical-" + o.a.getSettingValue("general.filterTreeVerticalStyle")))
                                            : n.hasClass(q.a.filterTreeHorizontal) && ((a = Ci.FilterTreeType.HORIZONTAL), i()("body").addClass(q.a.filterTree + "-horizontal-" + o.a.getSettingValue("general.filterTreeHorizontalStyle"))),
                                        a)
                                    ) {
                                        var l = q.a.filterTree + (0 == e ? "" : (e + 1).toString());
                                        n.attr("id", u.a.stripHtml(l));
                                        var s = Xc.newFilterTree(l, a);
                                        t.addComponent(s), t.filterTrees.push(s), t.renderFilterBackdrop(s);
                                    }
                                });
                            },
                        },
                        {
                            key: "initFilterMobileButton",
                            value: function () {
                                if (i()(s.a.filterTreeMobileButton).length > 0) {
                                    var t = i()(s.a.filterTreeMobileButton).first(),
                                        e = u.a.stripHtml(t.attr("data-filter-tree-id"));
                                    this.filterMobileButton = null;
                                    for (var r = this.filterTrees.length, n = 0; n < r; n++)
                                        this.filterMobileButton ||
                                            (0 != i()("#" + this.filterTrees[n].id).not("[data-is-desktop]").length &&
                                                ((e && this.filterTrees[n].id == e) || (!e && this.filterTrees[n].filterTreeType == Ci.FilterTreeType.VERTICAL)) &&
                                                ((this.filterMobileButton = new ri(this.filterTrees[n])), this.addComponent(this.filterMobileButton)));
                                }
                            },
                        },
                        {
                            key: "initFilterDesktopButton",
                            value: function () {
                                if (i()(s.a.filterTreeDesktopButton).length > 0) {
                                    var t = i()(s.a.filterTreeDesktopButton).first().attr("data-filter-tree-id");
                                    this.filterDesktopButton = null;
                                    for (var e = this.filterTrees.length, r = 0; r < e; r++)
                                        this.filterDesktopButton ||
                                            (0 != i()("#" + this.filterTrees[r].id).not("[data-is-mobile]").length &&
                                                ((t && this.filterTrees[r].id == t) || !t) &&
                                                ((this.filterDesktopButton = new ui(this.filterTrees[r])), this.addComponent(this.filterDesktopButton)));
                                }
                            },
                        },
                        {
                            key: "initInCollectionSearch",
                            value: function () {
                                var t = new ne();
                                this.addComponent(t);
                            },
                        },
                        {
                            key: "isRender",
                            value: function () {
                                return this.isFetchedFilterData || this.isFetchedProductData;
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                this.isFetchedFilterData &&
                                    (this.filterTrees.forEach(function (t) {
                                        i()(t.idSelector).length > 0 && !t.isRenderPartially && i()(t.idSelector).first().html("").append(t.$element);
                                    }),
                                    i()(s.a.filterTreeMobileButton).length > 0 && "init" == this.eventType && this.filterMobileButton && i()(s.a.filterTreeMobileButton).first().html("").append(this.filterMobileButton.$element),
                                    i()(s.a.filterTreeDesktopButton).length > 0 &&
                                        "init" == this.eventType &&
                                        this.filterDesktopButton &&
                                        (i()("body").addClass(q.a.filterTreeDesktopButton + "-body"), i()(s.a.filterTreeDesktopButton).first().html("").append(this.filterDesktopButton.$element)));
                            },
                        },
                        {
                            key: "renderFilterBackdrop",
                            value: function (t) {
                                (!u.a.isMobile() && "style-off-canvas" != o.a.getSettingValue("general.filterTreeVerticalStyle")) ||
                                    t.filterTreeType != Ci.FilterTreeType.VERTICAL ||
                                    i()("body").hasClass("boost-pfs-filter-overlay") ||
                                    i()(t.idSelector).before('<div class="boost-pfs-filter-overlay" role="button" tabindex="0" aria-label="Background overlay"></div>'),
                                    u.a.isMobile() &&
                                        (i()(t.idSelector).addClass("boost-pfs-filter-mobile-" + o.a.getSettingValue("general.filterTreeMobileStyle")),
                                        i()("body").addClass("boost-pfs-filter-mobile-" + o.a.getSettingValue("general.filterTreeMobileStyle") + "-body"));
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                u.a.isMobile() && o.a.getSettingValue("general.stickyFilterOnMobile") ? this.stickyFilterMobile() : !u.a.isMobile() && o.a.getSettingValue("general.stickyFilterOnDesktop") && this.stickyFilterDesktop();
                            },
                        },
                        {
                            key: "stickyFilterMobile",
                            value: function () {
                                (i()(s.a.stickyFilterTreeMobileButtonWrapper).length > 0 ? i()(s.a.stickyFilterTreeMobileButtonWrapper) : i()(s.a.stickyElementMobile)).each(function (t, e) {
                                    u.a.sticky(i()(e), s.a.endStickyMobile, s.a.avoidStickyHeader);
                                });
                            },
                        },
                        {
                            key: "stickyFilterDesktop",
                            value: function () {
                                var t = i()(s.a.stickyElementDesktop),
                                    e = o.a.getSettingValue("general.filterTreeVerticalStyle"),
                                    r = i()(s.a.stickyFilterTreeDesktopButtonWrapper),
                                    n = i()(s.a.filterTreeHorizontalWrapper),
                                    a = s.a.avoidStickyHeader,
                                    l = i()(s.a.filterTreeWrapper).length > 0 ? s.a.filterTreeWrapper : s.a.endStickyDesktop;
                                r.length > 0 && (a = i()(s.a.avoidStickyHeader).length > 0 ? s.a.avoidStickyHeader + "," + s.a.stickyFilterTreeDesktopButtonWrapper : s.a.stickyFilterTreeDesktopButtonWrapper);
                                var c = r.attr("data-offset-top"),
                                    p = n.attr("data-offset-top");
                                r.length > 0 && n.length > 0 && void 0 !== c && c > 0 && ((p = p > c ? c : p), n.attr("data-offset-top", p));
                                var f = !!t.hasClass(q.a.filterTreeHorizontal);
                                ("style-off-canvas" === e || "style-expand" === e || f) &&
                                    (r.each(function (t, e) {
                                        u.a.sticky(i()(e), s.a.endStickyDesktop, s.a.avoidStickyHeader), r.css({ maxWidth: i()(l).width() + "px" });
                                    }),
                                    n.each(function (e, r) {
                                        u.a.sticky(i()(r), "body", a), t.css({ maxWidth: i()(l).width() + "px" });
                                    })),
                                    t.each(function (n, o) {
                                        (r.length < 1 || "style-expand" === e) && (u.a.sticky(i()(o), s.a.endStickyDesktop, a), f && t.css({ maxWidth: i()(l).width() + "px" }));
                                    });
                            },
                        },
                        {
                            key: "afterGetFilterData",
                            value: function (t, e, r) {
                                !t ||
                                !Array.isArray(t.products) ||
                                0 != t.products.length ||
                                void 0 === boostPFSAppConfig.general.collection_product_count ||
                                t.products.length == boostPFSAppConfig.general.collection_product_count ||
                                o.a.getSettingValue("general.productAndVariantAvailable") ||
                                !o.a.getSettingValue("general.enableBackToOriginal") ||
                                "init" != e ||
                                l.a.hasFilterOptionParam ||
                                l.a.collectionTags ||
                                "function" == typeof Z.default.beforeCall ||
                                "function" == typeof Z.default.beforeCallAsync
                                    ? this.setData(t, e, r)
                                    : this.errorFilterCallback();
                            },
                        },
                        {
                            key: "setData",
                            value: function (t, e, r) {
                                (this.isFetchedFilterData = !1), (this.isFetchedProductData = !1), (this.data = JSON.parse(JSON.stringify(t))), (this.fromCache = t.from_cache), (this.error = t.error);
                                var n = JSON.parse(JSON.stringify(l.a.queryParams));
                                (l.a.queryParams = n),
                                    void 0 !== l.a.activeCurrencyPrices && i.a.extend(l.a.queryParams, l.a.activeCurrencyPrices),
                                    (this.eventType = e || t.event_type),
                                    (this.clickedFilterOptionId = r && r.filterOptionId && "clear" != e ? r.filterOptionId : ""),
                                    (t = this.modifyData(t)).filter &&
                                        t.filter.options &&
                                        -1 == l.a.imutableFilterTree.indexOf(this.eventType) &&
                                        ((this.isFetchedFilterData = !0),
                                        this.filterTrees.forEach(function (e) {
                                            e.setData(t.filter);
                                        })),
                                    (t.products || t.collections || t.pages) && ((this.isFetchedProductData = !0), this.filterResult.setData(t)),
                                    this.refresh(),
                                    this.filterLoadingIcon.setShow(!1);
                            },
                        },
                        {
                            key: "modifyData",
                            value: function (t) {
                                return t;
                            },
                        },
                        {
                            key: "errorFilterCallback",
                            value: function () {
                                if (!(u.a.isiOS() || u.a.isSafari() || u.a.isBackButton() || u.a.getWindowLocation().href.includes("view=boost-pfs-original"))) {
                                    var t = u.a.getWindowLocation().href.split("?")[0] + "?view=boost-pfs-original" + (u.a.isSearchPage() && l.a.queryParams.hasOwnProperty("q") ? "&q=" + l.a.queryParams.q : "");
                                    u.a.isBadUrl(t) || (window.location.href = t);
                                }
                            },
                        },
                    ]) && tu(e.prototype, r),
                    n && tu(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    c
                );
            })(d.a),
            au = [
                {
                    name: "getSettingValue",
                    mapToFunction: function (t, e) {
                        return o.a.getSettingValue(t, e);
                    },
                },
                {
                    name: "getSortingList",
                    mapToFunction: function () {
                        return u.a.FilterResult.getSortingList();
                    },
                },
                {
                    name: "buildToolbarLink",
                    mapToFunction: function (t, e, r) {
                        return u.a.buildToolbarLink(t, e, r);
                    },
                },
                {
                    name: "optimizeImage",
                    mapToFunction: function (t, e) {
                        return u.a.optimizeImage(t, e);
                    },
                },
                {
                    name: "buildProductItemUrl",
                    mapToFunction: function (t, e) {
                        return u.a.buildProductItemUrl(t, e);
                    },
                },
                {
                    name: "refreshProperties",
                    mapToFunction: function () {
                        (BoostPFS.prototype.selector = s.a), (BoostPFS.prototype.queryParams = l.a.queryParams);
                    },
                },
            ],
            lu = [
                { name: "beforeBuildSearchBox", mapToFunction: "beforeBindEvents", mapArguments: ["id"], component: p.a },
                { name: "afterBuildSearchBox", mapToFunction: "afterBindEvents", mapArguments: ["id"], component: p.a },
                { name: "customizeSuggestion", mapToFunction: "customizeAutoCompleteResizeMenu", mapArguments: ["$uiMenuElement", "$element", "id"], component: p.a },
                { name: "afterShowSearchBoxMobile", mapToFunction: "afterShowSearchBoxMobile", mapArguments: ["inputMobileId"], component: f.a },
                { name: "afterCloseSuggestionMobile", mapToFunction: "afterCloseInstantSearchMobile", mapArguments: ["inputMobileId", "@0"], component: f.a },
                { name: "afterShowSearchBoxStyle3", mapToFunction: "afterShowSearchBoxStyle3", mapArguments: ["inputStyle3Id"], component: h.a },
                { name: "afterCloseInstantSearchStyle3", mapToFunction: "afterCloseInstantSearchStyle3", mapArguments: ["inputStyle3Id", "@0"], component: h.a },
                { name: "customizeSuggetionProductTitle", mapToFunction: "customizeProductTitle", mapArguments: ["title", "currentTerm", "data"], component: y.a },
                { name: "buildProductGridItem", mapToFunction: "compileTemplate", mapArguments: ["data", "index", "totalProduct"], component: I },
                { name: "buildProductListItem", mapToFunction: "compileTemplate", mapArguments: ["data", "index", "totalProduct"], component: $ },
                { name: "buildProductCollageItem", mapToFunction: "compileTemplate", mapArguments: ["data", "index", "totalProduct"], component: W },
                { name: "prepareProductData", mapToFunction: "prepareProductData", mapArguments: ["data"], component: Pt },
                { name: "buildExtrasProductList", mapToFunction: "afterRender", mapArguments: ["data", "eventType"], component: Pt },
                { name: "buildAdditionalElements", mapToFunction: "afterRender", mapArguments: ["data", "totalProduct", "eventType"], component: ou },
                { name: "buildPagination", mapToFunction: "render", mapArguments: ["totalProduct", "paginationType"], component: Rt },
                { name: "buildFilterDisplayType", mapToFunction: "render", mapArguments: [], component: Ft },
                { name: "buildFilterSorting", mapToFunction: "compileTemplate", mapArguments: [], component: Ut },
                { name: "buildFilterShowLimit", mapToFunction: "compileTemplate", mapArguments: [], component: Qt },
                { name: "buildBreadcrumb", mapToFunction: "buildBreadcrumb", mapArguments: ["collectionData", "data"], component: _e },
            ],
            su = function (t, e) {
                BoostPFS.prototype.hasOwnProperty(t) || (BoostPFS.prototype[t] = e);
            },
            cu = function (t, e, r, n) {
                if (BoostPFS.prototype.hasOwnProperty(t)) {
                    n.prototype[e] = function () {
                        var e,
                            n = [];
                        if (r && r.length > 0)
                            for (var i = 0; i < r.length; i++) {
                                var o = r[i];
                                if (this.hasOwnProperty(o)) n.push(this[o]);
                                else if (0 == o.indexOf("@")) {
                                    var a = parseInt(o.substr(1));
                                    void 0 !== arguments[a] ? n.push(arguments[a]) : n.push(null);
                                } else n.push(null);
                            }
                        return (e = BoostPFS.prototype[t]).call.apply(e, [BoostPFS.instance].concat(n));
                    };
                }
            },
            uu = {
                mapLegacyFunctions: function () {
                    au.forEach(function (t) {
                        su(t.name, t.mapToFunction);
                    }),
                        lu.forEach(function (t) {
                            cu(t.name, t.mapToFunction, t.mapArguments, t.component);
                        });
                },
                mapLegacyFunctionCall: su,
                mapLegacyFunctionOverride: cu,
            },
            pu = r(74),
            fu = r(42),
            hu = r(89),
            yu = r(23),
            du = r(132),
            mu = r(80);
        function gu(t) {
            return (gu =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function bu(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== gu(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== gu(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === gu(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function vu(t, e) {
            return (vu = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Su(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Pu(t);
                if (e) {
                    var i = Pu(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Ou(this, r);
            };
        }
        function Ou(t, e) {
            if (e && ("object" === gu(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function Pu(t) {
            return (Pu = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Tu = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && vu(t, e);
                })(l, t);
                var e,
                    r,
                    n,
                    a = Su(l);
                function l() {
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, l),
                        a.call(this)
                    );
                }
                return (
                    (e = l),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                var t = this;
                                if (
                                    (i()('input[name="' + o.a.getSettingValue("search.termKey") + '"]:not([data-disable-instant-search]):not([data-already-init])').each(function (e, r) {
                                        var n = "boost-pfs-search-box-" + e,
                                            o = new p.a(n, i()(r));
                                        t.addComponent(o);
                                    }),
                                    u.a.isMobile() && o.a.getSettingValue("search.suggestionMobileStyle") !== yu.a.Mobile.SuggestionType.STYLE_2)
                                ) {
                                    var e = mu.a.instantSearchMobile();
                                    this.addComponent(e);
                                }
                                if ((!u.a.isMobile() && "style3" === o.a.getSettingValue("search.suggestionStyle")) || "2-overlay-fullwidth" === o.a.getSettingValue("search.suggestionColumn")) {
                                    var r = mu.a.instantSearchStyle3();
                                    this.addComponent(r);
                                }
                            },
                        },
                    ]) && bu(e.prototype, r),
                    n && bu(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    l
                );
            })(d.a),
            wu = r(90),
            _u = r(131),
            Cu = r(75),
            ku = r(46),
            Eu = r(123),
            Ru = r(127),
            Iu = r(130),
            ju = r(129),
            Lu = r(128),
            Bu = r(62),
            Au = r(125),
            xu = r(126),
            Fu = r(124),
            $u = r(103),
            Du = {
                inject: function (t) {
                    (t.jQ = i.a),
                        (t.noUiSlider = Rs.a),
                        (t.Analytics = pu.a),
                        (t.Class = q.a),
                        (t.Globals = l.a),
                        (t.Labels = a.a),
                        (t.Navigation = c.a),
                        (t.Selector = s.a),
                        (t.Settings = o.a),
                        (t.Utils = u.a),
                        (t.FunctionMapper = uu),
                        (t.Integration = m.a),
                        (t.Api = fu.a),
                        (t.FilterApi = Z.default),
                        (t.InstantSearchApi = hu.default),
                        (t.FilterTreeEnum = Ci),
                        (t.FilterOptionEnum = Kn.a),
                        (t.InstantSearchEnum = yu.a),
                        (t.Filter = ou),
                        (t.FilterTree = ac),
                        (t.FilterStyle = Xc),
                        (t.FilterTreeStyle2 = dc),
                        (t.FilterTreeStyle2Fullwidth = wc),
                        (t.FilterTreeStyle3 = Bc),
                        (t.FilterTreeStyle3Fullwidth = Hc),
                        (t.FilterTreeStyle4 = Jc),
                        (t.FilterOption = _l),
                        (t.FilterOptionList = xl),
                        (t.FilterOptionBox = Ul),
                        (t.FilterOptionSwatch = Jl),
                        (t.FilterOptionMultiLevelCollections = Gs),
                        (t.FilterOptionMultiLevelTag = Zs),
                        (t.FilterOptionRangeSlider = Ms),
                        (t.FilterOptionRating = os),
                        (t.FilterOptionSubCategory = ks),
                        (t.FilterApplyButton = Vi),
                        (t.FilterClearButton = Bi),
                        (t.FilterCollapse = bl),
                        (t.FilterScrollbar = ja),
                        (t.FilterSearchBox = da),
                        (t.FilterTooltip = Pa),
                        (t.FilterViewMore = sa),
                        (t.FilterOptionItem = zi),
                        (t.FilterOptionItemList = to),
                        (t.FilterOptionItemBox = uo),
                        (t.FilterOptionItemSwatch = Oo),
                        (t.FilterOptionItemMultiLevelCollections = za),
                        (t.FilterOptionItemSecondLevelCollections = Wa),
                        (t.FilterOptionItemThirdLevelCollections = qa),
                        (t.FilterOptionItemMultiLevelTag = ll),
                        (t.FilterOptionItemSecondLevelTag = il),
                        (t.FilterOptionItemThirdLevelTag = ol),
                        (t.FilterOptionItemRangeSlider = Jo),
                        (t.FilterOptionItemRating = jo),
                        (t.FilterOptionItemSubCategory = No),
                        (t.FilterRefineBy = vs),
                        (t.FilterRefineByItem = fs),
                        (t.FilterLoadingIcon = bi),
                        (t.FilterMobileButton = ri),
                        (t.FilterDesktopButton = ui),
                        (t.FilterScrollToTop = _i),
                        (t.FilterResult = zn),
                        (t.ProductList = Pt),
                        (t.ProductListPlaceholder = hr),
                        (t.ProductListNoSearchResult = Vn),
                        (t.ProductItem = T),
                        (t.ProductGridItem = I),
                        (t.ProductListItem = $),
                        (t.ProductCollageItem = W),
                        (t.Breadcrumb = be),
                        (t.PageInfoCollection = _e),
                        (t.PageInfoSearch = ue),
                        (t.ProductDisplayType = Ft),
                        (t.ProductLimit = Qt),
                        (t.ProductSorting = Ut),
                        (t.RobotsMeta = Le),
                        (t.InCollectionSearch = ne),
                        (t.SearchResultPanels = X),
                        (t.SearchResultPanelItem = at),
                        (t.SearchResultTotal = cn),
                        (t.CollectionItem = Ar),
                        (t.CollectionItemList = Nr),
                        (t.CollectionList = Kr),
                        (t.PageItem = Sr),
                        (t.PageItemList = kr),
                        (t.PageList = en),
                        (t.MostPopular = Bn),
                        (t.ProductSlider = wn),
                        (t.ProductSliderItem = mn),
                        (t.ProductPagination = ht),
                        (t.ProductPaginationDefault = Rt),
                        (t.ProductPaginationInfinite = Ge),
                        (t.ProductPaginationLoadMore = Me),
                        (t.ProductPaginationLoadPrevious = Ze),
                        (t.SearchDisplayPagination = ar),
                        (t.SearchInput = p.a),
                        (t.InstantSearch = Tu),
                        (t.InstantSearchMobile = f.a),
                        (t.InstantSearchResult = wu.a),
                        (t.InstantSearchStyle = mu.a),
                        (t.InstantSearchResultStyle2 = _u.a),
                        (t.InstantSearchStyle3 = h.a),
                        (t.InstantSearchNoResult = Cu.a),
                        (t.InstantSearchOnclick = ku.a),
                        (t.InstantSearchResultBlock = Eu.a),
                        (t.InstantSearchResultBlockDym = Ru.a),
                        (t.InstantSearchResultBlockEmpty = Iu.a),
                        (t.InstantSearchResultBlockLoading = ju.a),
                        (t.InstantSearchResultBlockViewAll = Lu.a),
                        (t.InstantSearchResultItem = Bu.a),
                        (t.InstantSearchResultItemCollection = Au.a),
                        (t.InstantSearchResultItemPage = xu.a),
                        (t.InstantSearchResultItemPopular = Fu.a),
                        (t.InstantSearchResultItemProduct = y.a),
                        (t.InstantSearchResultRedirect = $u.a),
                        (t.SearchAutoComplete = du.a);
                },
            };
        function Mu(t) {
            return (Mu =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        var Vu = function () {
                i.a.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, e) {
                    i.a.fn[e] = function (t, r) {
                        return arguments.length > 0 ? this.on(e, null, t, r) : this.trigger(e);
                    };
                }),
                    (i.a.fn.hover = function (t, e) {
                        return this.mouseenter(t).mouseleave(e || t);
                    });
            },
            Nu = function () {
                i.a.ajax = function (t) {
                    var e = t.type,
                        r = void 0 === e ? "GET" : e,
                        n = t.url,
                        o = void 0 === n ? "" : n,
                        a = t.data,
                        l = t.dataType,
                        s = t.success,
                        c = t.error,
                        u = new XMLHttpRequest(),
                        p = "application/json";
                    l || (p = "text/html"),
                        "object" === Mu(a) && "string" == typeof r && "get" === r.toLowerCase() && (o += "?" + i.a.param(a)),
                        u.open(r, o),
                        u.setRequestHeader("Content-Type", "".concat(p, ";charset=UTF-8")),
                        "json" === l && u.setRequestHeader("Accept", "application/json, text/javascript"),
                        (u.onload = function () {
                            var t;
                            (t = "json" === l ? JSON.parse(u.responseText) : u.responseText), u.readyState > 3 && (200 == u.status ? "function" == typeof s && s(t) : "function" == typeof c && c(t));
                        }),
                        a && "string" == typeof r && "get" !== r.toLowerCase() ? u.send(JSON.stringify(a)) : u.send();
                };
            },
            Hu = function () {
                i.a.fn.serializeArray = function () {
                    var t = [],
                        e = this.length > 0 ? this[0] : {};
                    return (
                        Array.prototype.slice.call(e).forEach(function (e) {
                            !e.name ||
                                e.disabled ||
                                ["file", "reset", "submit", "button"].indexOf(e.type) > -1 ||
                                ("select-multiple" !== e.type
                                    ? (["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked) || t.push({ name: e.name, value: e.value })
                                    : Array.prototype.slice.call(e.options).forEach(function (r) {
                                          r.selected && t.push({ name: e.name, value: r.value });
                                      }));
                        }),
                        t
                    );
                };
            },
            Uu = function () {
                i.a.param = function (t) {
                    return Object.keys(t)
                        .map(function (e) {
                            if (Array.isArray(t[e])) {
                                for (var r = [], n = 0; n < t[e].length; n++) r.push(encodeURIComponent(e + "[]") + "=" + encodeURIComponent(t[e][n]));
                                return r.join("&");
                            }
                            return encodeURIComponent(e) + "=" + encodeURIComponent(null === t[e] ? "" : t[e]);
                        })
                        .join("&");
                };
            },
            Wu = {
                init: function () {
                    Vu(), Nu(), Hu(), Uu();
                },
            };
        function qu(t) {
            return (qu =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function Gu(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== qu(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== qu(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === qu(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function zu(t, e) {
            return (zu = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function Ku(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = Ju(t);
                if (e) {
                    var i = Ju(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return Yu(this, r);
            };
        }
        function Yu(t, e) {
            if (e && ("object" === qu(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return Qu(t);
        }
        function Qu(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        }
        function Ju(t) {
            return (Ju = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var Xu = (function (t) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && zu(t, e);
                })(h, t);
                var e,
                    r,
                    n,
                    f = Ku(h);
                function h() {
                    var t;
                    return (
                        (function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, h),
                        ((t = f.call(this)).search = null),
                        (t.filter = null),
                        (Zu = Qu(t)),
                        t
                    );
                }
                return (
                    (e = h),
                    (n = [
                        {
                            key: "instance",
                            get: function () {
                                return Zu;
                            },
                        },
                        {
                            key: "jQ",
                            get: function () {
                                return i.a;
                            },
                        },
                        {
                            key: "Globals",
                            get: function () {
                                return l.a;
                            },
                        },
                        {
                            key: "Labels",
                            get: function () {
                                return a.a;
                            },
                        },
                        {
                            key: "Selector",
                            get: function () {
                                return s.a;
                            },
                        },
                        {
                            key: "Settings",
                            get: function () {
                                return o.a;
                            },
                        },
                        {
                            key: "Utils",
                            get: function () {
                                return u.a;
                            },
                        },
                        {
                            key: "inject",
                            value: function (t) {
                                Du.inject(t);
                            },
                        },
                    ]),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                Wu.init(), uu.mapLegacyFunctions(), o.a.init(), a.a.init(), s.a.init(), l.a.init(), c.a.init(), this.initApp(), this.initOTP(), this.initADA(), this.initVariantsDisplay();
                            },
                        },
                        {
                            key: "initApp",
                            value: function () {
                                u.a.addClassToBody("enableApp");
                            },
                        },
                        {
                            key: "initSearchBox",
                            value: function (t) {
                                if (o.a.getSettingValue("search.enableSuggestion") && !u.a.isGLHMobile()) {
                                    if ((u.a.addClassToBody("enableInstantSearch"), (this.search = new Tu()), this.addComponent(this.search), t)) {
                                        var e = new p.a(t);
                                        this.search.addComponent(e);
                                    }
                                    this.search.refresh();
                                }
                            },
                        },
                        {
                            key: "initFilter",
                            value: function () {
                                o.a.getSettingValue("general.enableFilter") && !u.a.isGLHMobile() && (u.a.addClassToBody("enableFilter"), (this.filter = new ou()), this.addComponent(this.filter), this.filter.refresh());
                            },
                        },
                        {
                            key: "initAnalytics",
                            value: function () {
                                o.a.getSettingValue("general.enableTrackingOrderRevenue") && !u.a.isGLHMobile() && pu.a.init();
                            },
                        },
                        {
                            key: "initOTP",
                            value: function () {
                                window.BoostOTP &&
                                    "function" == typeof window.BoostOTP.init &&
                                    i()(window).on("load", function () {
                                        BoostOTP.init();
                                    });
                            },
                        },
                        {
                            key: "initADA",
                            value: function () {
                                i()("body").on("keyup", function (t) {
                                    t && 9 == t.keyCode && i()("body").addClass(Class.adaWrapper);
                                }),
                                    i()("body").on("click", function (t) {
                                        (!t || !t.originalEvent || (t.originalEvent.screenX && t.originalEvent.screenY)) && i()("body").removeClass(Class.adaWrapper);
                                    });
                            },
                        },
                        {
                            key: "initVariantsDisplay",
                            value: function () {
                                o.a.getSettingValue("general.enableVariantsDisplay") && u.a.addClassToBody("variantsDisplay");
                            },
                        },
                    ]) && Gu(e.prototype, r),
                    n && Gu(e, n),
                    Object.defineProperty(e, "prototype", { writable: !1 }),
                    h
                );
            })(d.a),
            Zu = null,
            tp = (e.default = Xu);
    },
    7: function (t, e, r) {
        "use strict";
        var n = r(0),
            i = r(2),
            o = {
                productFilter: "Product filter",
                refine: "Refine By",
                refineMobile: "Refine By",
                refineMobileCollapse: "Hide Filter",
                refineDesktop: "Filter",
                refineDesktopCollapse: "Hide Filter",
                clear: "Clear",
                clearAll: "Clear All",
                apply: "Apply",
                applyAll: "Apply All",
                close: "Close",
                back: "Back",
                loadMore: "Load more {{ amountProduct }} Products",
                loadMoreTotal: "{{ from }} - {{ to }} of {{ total }} Products",
                loadPreviousPage: "Load Previous Page",
                searchOptions: "Search options",
                collectionAll: "All",
                viewMore: "View More",
                viewLess: "View Less",
                under: "Under",
                above: "Above",
                ratingStar: "Star",
                ratingStars: "Stars",
                ratingUp: "& Up",
                showResult: "Show Results",
                showLimit: "Show",
                sorting: "Sort By",
                sortingList: {
                    "best-selling": "Best Selling",
                    manual: "Featured",
                    "price-ascending": "Lowest Price",
                    "price-descending": "Highest Price",
                    "title-ascending": "Alphabetically, A-Z",
                    "title-descending": "Alphabetically, Z-A",
                    "created-descending": "Date, New to Old",
                    "created-ascending": "Date, Old to New",
                    "published-descending": "Date, New to Old",
                    "published-ascending": "Date, Old to New",
                    "sale-descending": "% Off",
                    "sale-ascending": "% Off, Low to High",
                    relevance: "Relevance",
                    "review-ratings-ascending": "Total reviews, Low to High",
                    "review-ratings-descending": "Total reviews, High to Low",
                },
                listView: "List View",
                gridView: "Grid View",
                gridViewColumns: "Grid view {{ count }} Columns",
                inCollectionSearch: "Search for products in this collection",
                search: {
                    generalTitle: "Search",
                    resultHeader: 'Search Results for "{{ terms }}"',
                    resultEmpty: "We are sorry! We couldn't find results for \"{{ terms }}\".{{ breakline }}But don't give up – check the spelling or try less specific search terms.",
                    resultEmptyWithSuggestion: 'Sorry, nothing found for "{{ terms }}". Check out these items instead?',
                    resultNumber: 'Showing {{ count }} results for "{{ terms }}"',
                    searchTotalResult: "Showing {{ count }} result",
                    searchTotalResults: "Showing {{ count }} results",
                    seeAllProducts: "See all products →",
                    searchPanelCollection: "Collections",
                    searchPanelPage: "Pages",
                    searchPanelProduct: "Products",
                },
                suggestion: {
                    instantSearchSuggestionsLabel: "Popular suggestions",
                    instantSearchCollectionsLabel: "Collections",
                    instantSearchProductsLabel: "Products",
                    instantSearchPagesLabel: "Pages",
                    viewAll: "View all {{ count }} products",
                    suggestQuery: 'Showing {{ count }} results for "{{ terms }}".',
                    didYouMean: "Did you mean: {{ terms }}",
                    searchBoxPlaceholder: "Search",
                    searchBoxOnclickRecentSearchLabel: "Recent searches",
                    searchBoxOnclickSearchTermLabel: "Popular searches",
                    searchBoxOnclickProductsLabel: "Trending products",
                    noSearchResultSearchTermLabel: "Popular searches",
                    noSearchResultProductsLabel: "Trending products",
                },
                error: {
                    noFilterResult: "Sorry, no products matched your selection",
                    noSearchResult: "Sorry, no products matched the keyword",
                    noProducts: "No products found in this collection",
                    noSuggestionProducts: 'Sorry, nothing found for "{{ terms }}".',
                    noSuggestionResult: 'Sorry, nothing found for "{{ terms }}".',
                },
                action_list: {
                    qvBtnLabel: "Quick View",
                    qvAddToCartBtnLabel: "Add To Cart",
                    qvSoldOutLabel: "Sold Out",
                    qvSaleLabel: "Sale",
                    qvQtyLeftLabel: "Hurry, there are only {{item}} item(s) left!",
                    qvNotifyMeSuccessfullyLabel: "Thanks! We will notify you when this product becomes available!",
                    qvNotifyMeErrorLabel: "Please provide a valid email address.",
                    qvNotifyMeMessageLabel: "Notify me when {{item}} becomes available",
                    qvNotifyMeFormBodyLabel: "Please notify me when {{item}} becomes available.",
                    atcAvailableLabel: "Add To Cart",
                    atcSelectOptionsLabel: "Select Options",
                    atcSoldOutLabel: "Sold Out",
                    atcAddingToCartBtnLabel: "Adding...",
                    atcAddedToCartBtnLabel: "Added!",
                    atcPopupAddedToCartLabel: "has been added to shopping cart",
                    atcPopupSubtotalLabel: "Cart Subtotal",
                    atcPopupCheckoutLabel: "Checkout",
                    atcPopupGoToCartLabel: "Your Cart",
                    atcPopupTotalItemsLabel: "items",
                    atcPopupCrossSellHeadingLabel: "Frequently bought with",
                    atcMiniCartCountItemLabel: "item",
                    atcMiniCartCountItemLabelPlural: "items",
                    atcMiniCartTotalItemsLabel: "Total Items",
                    atcMiniCartSubtotalLabel: "Subtotal",
                    atcMiniCartCheckoutLabel: "Checkout",
                    atcMiniCartViewCartLabel: "View cart",
                    atcMiniCartEmptyCartLabel: "Your Cart Is Currently Empty",
                    atcMiniCartRemoveItemLabel: "Remove This Item",
                    atcMiniCartShopingCartLabel: "Your cart",
                },
                mostPopular: { popularProductsHeading: "Popular products" },
                recentlyViewed: { recentProductHeading: "Recently viewed products" },
                ada: {
                    searchAutoComplete: "When autocomplete results are available use up and down arrows to review and enter to select",
                    toggleMultiLevel: "Expand/Collapse {{filterItem}}",
                    filterOption: "Filter by {{filterOption}}",
                    clearFilterOption: "Clear filter by {{filterOption}}",
                    clearFilterItem: "Clear filter by {{filterOption}} {{filterItem}}",
                    clearAllFilterItems: "Clear all filters",
                    filterOptionTitle: "Filter by {{filterOption}}",
                    minValue: "Min value",
                    maxValue: "Max value",
                    productCount: "Number of products: {{count}}",
                    closeQuickViewSelectOption: "Close select option",
                },
                init: function () {
                    var t = {};
                    void 0 !== i.a.label && (t = n.a.mergeObject(o, i.a.label)), (o = t), n.a.iterateObject(o, n.a.stripHtml);
                },
            };
        e.a = o;
    },
    74: function (t, e, r) {
        "use strict";
        r(27), r(9), r(28), r(25), r(26), r(48), r(43), r(51), r(49), r(154), r(30);
        var n = r(1),
            i = r.n(n),
            o = r(42),
            a = { UserAction: { VIEW_PRODUCT: "view_product", QUICK_VIEW: "quick_view", ADD_TO_CART: "add_to_cart", BUY_NOW: "buy_now" }, Action: { FILTER: "filter", SEARCH: "search", SUGGEST: "suggest" } },
            l = r(3),
            s = r(5),
            c = r(0),
            u = r(2),
            p = r(4),
            f = "boostPFSAnalytics",
            h = "",
            y = "",
            d = null,
            m = function () {
                u.a.getSettingValue("search.enableSuggestion") &&
                    i()("." + p.a.searchSuggestionWrapper).length > 0 &&
                    i()("." + p.a.searchSuggestionWrapper).each(function (t, e) {
                        e.addEventListener("click", O, !0), document.addEventListener("keydown", O, !0);
                    });
            },
            g = function () {
                s.a.trackingProduct && i()(s.a.products).length > 0 && document.addEventListener("click", S, !0);
            },
            b = function () {
                var t = C(f);
                Array.isArray(t) &&
                    (t.forEach(function (t) {
                        E(t), t.pid == boostPFSAppConfig.general.product_id && (d = t);
                    }),
                    c.a.isProductPage() &&
                        (s.a.trackingAddToCart && i()(s.a.trackingAddToCart).length > 0 && document.addEventListener("click", P, !0), s.a.trackingBuyNow && i()(s.a.trackingBuyNow).length > 0 && document.addEventListener("click", T, !0)));
            },
            v = function () {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
                    var e = (16 * Math.random()) | 0;
                    return ("x" == t ? e : (3 & e) | 8).toString(16);
                });
            },
            S = function (t) {
                if (t && t.target) {
                    var e = i()(t.target),
                        r = c.a.isSearchPage() ? a.Action.SEARCH : a.Action.FILTER,
                        n = a.UserAction.VIEW_PRODUCT;
                    s.a.trackingQuickView && e.closest(s.a.trackingQuickView).length > 0 && (n = a.UserAction.QUICK_VIEW),
                        s.a.trackingAddToCart && e.closest(s.a.trackingAddToCart).length > 0 && (n = a.UserAction.ADD_TO_CART),
                        s.a.trackingBuyNow && e.closest(s.a.trackingBuyNow).length > 0 && (n = a.UserAction.BUY_NOW);
                    var o = "",
                        l = e.closest(s.a.trackingProduct);
                    if ((l.length > 0 ? (o = l.attr("data-id")) : d && ((n != a.UserAction.ADD_TO_CART && n != a.UserAction.BUY_NOW) || (o = d.pid)), o)) {
                        var u = w(o, n, r);
                        _(u), E(u), (d = n == a.UserAction.QUICK_VIEW ? u : null);
                    }
                }
            },
            O = function (t) {
                if (t && t.target && ("keydown" != t.type || 13 == t.keyCode)) {
                    var e = i()(t.target).closest("." + p.a.searchSuggestionItem + "-product");
                    if (e) {
                        var r = e.attr("data-id");
                        if (r) {
                            var n = w(r, a.UserAction.VIEW_PRODUCT, a.Action.SUGGEST);
                            _(n);
                        }
                    }
                }
            },
            P = function (t) {
                if (t && t.target && i()(t.target).closest(s.a.trackingAddToCart).length > 0) {
                    var e = { tid: l.a.shopDomain, pid: boostPFSAppConfig.general.product_id.toString(), u: a.UserAction.ADD_TO_CART, ct: h };
                    _(e), E(e);
                }
            },
            T = function (t) {
                if (t && t.target && i()(t.target).closest(s.a.trackingBuyNow).length > 0) {
                    var e = { tid: l.a.shopDomain, pid: boostPFSAppConfig.general.product_id.toString(), u: a.UserAction.BUY_NOW };
                    _(e), E(e);
                }
            },
            w = function (t, e, r) {
                var n = new Date(),
                    i = h,
                    o = e == a.UserAction.QUICK_VIEW ? a.UserAction.VIEW_PRODUCT : e,
                    s = "";
                if ((r == a.Action.FILTER ? (s += "collection_scope=" + l.a.collectionId) : (s += "q=" + l.a.currentTerm), r == a.Action.FILTER || r == a.Action.SEARCH)) {
                    var c = Object.keys(l.a.queryParams).filter(function (t) {
                        return t.startsWith(l.a.prefix);
                    });
                    c &&
                        c.length > 0 &&
                        c.forEach(function (t) {
                            var e = l.a.queryParams[t];
                            Array.isArray(e)
                                ? e.forEach(function (e) {
                                      s += "&" + t + "=" + encodeURIComponent(e);
                                  })
                                : (s += "&" + t + "=" + encodeURIComponent(e));
                        });
                }
                return { tid: l.a.shopDomain, ct: i, pid: t, t: n.toISOString(), u: o, a: r, qs: s, r: document.referrer };
            },
            _ = function (t) {
                var e = C(f);
                Array.isArray(e) || (e = []);
                var r = e.filter(function (e) {
                    return e.pid != t.productId;
                });
                r.push(t), k(f, r);
            },
            C = function (t) {
                try {
                    return JSON.parse(localStorage.getItem(t));
                } catch (t) {
                    return null;
                }
            },
            k = function (t, e) {
                try {
                    null != e ? localStorage.setItem(t, JSON.stringify(e)) : localStorage.setItem(t, "");
                } catch (t) {}
            },
            E = function (t, e) {
                if (e || t.ct) {
                    t.sid = y;
                    var r = new XMLHttpRequest();
                    r.open("POST", o.a.getApiUrl("analytics")),
                        r.setRequestHeader("Content-Type", "application/json;charset=UTF-8"),
                        (r.onload = function () {
                            r.readyState > 3 &&
                                200 == r.status &&
                                (function (t) {
                                    var e = C(f);
                                    if (Array.isArray(e)) {
                                        var r = e.filter(function (e) {
                                            return e.pid != t;
                                        });
                                        k(f, r);
                                    }
                                })(t.pid);
                        }),
                        r.send(JSON.stringify(t));
                } else
                    setTimeout(function () {
                        !(function (t) {
                            var e = new XMLHttpRequest();
                            e.open("GET", "/cart.js"),
                                (e.onload = function () {
                                    if (e.readyState > 3 && 200 == e.status) {
                                        var r = JSON.parse(e.responseText),
                                            n = r.item_count <= 0 ? "" : r.token;
                                        (h = n), t && ((t.ct = n), E(t, !0));
                                    }
                                }),
                                e.send();
                        })(t);
                    }, 1e3);
            },
            R = {
                init: function () {
                    window.XMLHttpRequest && ((h = ""), (y = C("boostPFSSessionId")) || ((y = v()), k("boostPFSSessionId", y)), m(), g(), b());
                },
                getSessionId: function () {
                    return y || ((y = C("boostPFSSessionId")) || ((y = v()), k("boostPFSSessionId", y)), y);
                },
            };
        e.a = R;
    },
    75: function (t, e, r) {
        "use strict";
        r(27), r(9), r(28);
        var n = r(1),
            i = r.n(n),
            o = r(2),
            a = r(5),
            l = r(23),
            s = (r(0), r(7)),
            c = null,
            u = {
                getNoResultBlockSettings: function () {
                    var t = u.getNoResultData().no_result_suggestions,
                        e = {
                            type: l.a.ResultType.NO_RESULT_SUGGESTIONS,
                            label: s.a.suggestion.noSearchResultSearchTermLabel,
                            status: o.a.getSettingValue("search.suggestionNoResult.search_terms.status") ? "active" : "inactive",
                            number: t && t.length ? t.length : 0,
                        },
                        r = o.a.getSettingValue("search.suggestionNoResult.products.data");
                    return [
                        e,
                        {
                            type: l.a.ResultType.NO_RESULT_PRODUCTS,
                            label: s.a.suggestion.noSearchResultProductsLabel,
                            status: o.a.getSettingValue("search.suggestionNoResult.products.status") ? "active" : "inactive",
                            number: r && r.length ? r.length : 0,
                        },
                    ];
                },
                getNoResultData: function () {
                    if (c) return c;
                    var t = {},
                        e = i()(a.a.searchNoResultJson);
                    if (e.length)
                        try {
                            t = JSON.parse(e.html());
                        } catch (t) {
                            console.log("Failed to parse notFoundJson.");
                        }
                    var r = { isAllEmpty: !0 },
                        n = o.a.getSettingValue("search.suggestionNoResult.search_terms.status");
                    t.search_terms && n && ((r[l.a.ResultType.NO_RESULT_SUGGESTIONS] = t.search_terms), t.search_terms.length > 0 && (r.isAllEmpty = !1));
                    var s = o.a.getSettingValue("search.suggestionNoResult.products.status");
                    return t.products && s && ((r[l.a.ResultType.NO_RESULT_PRODUCTS] = u.prepareProducts(t.products)), t.products.length > 0 && (r.isAllEmpty = !1)), (c = r);
                },
                prepareProducts: function (t) {
                    return Array.isArray(t)
                        ? (t.forEach(function (t) {
                              var e = [];
                              Array.isArray(t.media) || (t.media = []),
                                  t.media.forEach(function (t) {
                                      "image" == t.media_type && e.push({ id: t.id, position: t.position, src: t.src, width: t.width, height: t.height });
                                  }),
                                  (t.images_info = e),
                                  (t.price /= 100),
                                  (t.price_min /= 100),
                                  (t.price_max /= 100),
                                  (t.compare_at_price /= 100),
                                  (t.compare_at_price_min /= 100),
                                  (t.compare_at_price_max /= 100);
                          }),
                          t)
                        : [];
                },
                noResultData: c,
            };
        e.a = u;
    },
    8: function (t, e, r) {
        "use strict";
        r.r(e);
        r(27),
            r(9),
            r(28),
            r(51),
            r(43),
            r(33),
            r(37),
            r(44),
            r(25),
            r(41),
            r(102),
            r(70),
            r(73),
            r(121),
            r(49),
            r(30),
            r(185),
            r(87),
            r(58),
            r(11),
            r(13),
            r(12),
            r(72),
            r(153),
            r(48),
            r(211),
            r(26),
            r(154),
            r(14),
            r(15),
            r(16),
            r(155),
            r(69),
            r(71);
        var n = r(1),
            i = r.n(n),
            o = r(3),
            a = r(2),
            l = r(0),
            s = r(42),
            c = r(39),
            u = r(65),
            p = r(6),
            f = r(74);
        function h(t) {
            return (
                (function (t) {
                    if (Array.isArray(t)) return y(t);
                })(t) ||
                (function (t) {
                    if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
                })(t) ||
                (function (t, e) {
                    if (!t) return;
                    if ("string" == typeof t) return y(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    "Object" === r && t.constructor && (r = t.constructor.name);
                    if ("Map" === r || "Set" === r) return Array.from(t);
                    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return y(t, e);
                })(t) ||
                (function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                })()
            );
        }
        function y(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
        }
        var d = null,
            m = { eventType: "init", eventInfo: {} },
            g = function (t, e, r) {
                if (
                    (P(t),
                    S &&
                        S.forEach(function (e) {
                            "function" == typeof e && e(t);
                        }),
                    "function" == typeof E.beforeCall && E.beforeCall(t, m.eventInfo),
                    "function" != typeof E.beforeCallAsync)
                )
                    b(t, e, r);
                else {
                    E.beforeCallAsync(
                        function () {
                            b(t, e, r);
                        },
                        t,
                        m.eventInfo
                    );
                }
            },
            b = function t(e, r, n, a) {
                (a = void 0 !== a ? a : 0), (d = r), (o.a.queryParams.callback = "BoostPFSFilterCallback"), (o.a.queryParams.event_type = e);
                var c = s.a.getApiUrl("filter"),
                    u = l.a.isCollectionPage() && o.a.queryParams.q;
                (l.a.isSearchPage() || u) && ((c = s.a.getApiUrl("search")), o.a.hasOwnProperty("searchDisplay") && o.a.searchDisplay && "products" !== o.a.searchDisplay && (c += "/" + o.a.searchDisplay));
                var p = document.createElement("script");
                p.type = "text/javascript";
                var f = new Date().getTime(),
                    h = JSON.parse(JSON.stringify(o.a.queryParams));
                (o.a.queryParams = h), (p.src = c + "?t=" + f + "&" + i.a.param(o.a.queryParams)), (p.id = "boost-pfs-filter-script"), (p.async = !0);
                var y;
                p.addEventListener("error", function (e) {
                    "function" == typeof document.getElementById(p.id).remove ? document.getElementById(p.id).remove() : (document.getElementById(p.id).outerHTML = ""),
                        a < 2 ? (a++, y && clearTimeout(y), (y = setTimeout(t("resend", r, n, a), 2e3))) : "function" == typeof n && n();
                }),
                    document.getElementsByTagName("head")[0].appendChild(p),
                    p.addEventListener("load", function (t) {
                        "function" == typeof document.getElementById(p.id).remove ? document.getElementById(p.id).remove() : (document.getElementById(p.id).outerHTML = "");
                    });
            },
            v = function (t) {
                O &&
                    O.forEach(function (e) {
                        "function" == typeof e && e(t, m.eventType, m.eventInfo);
                    }),
                    "function" == typeof d && d(t, m.eventType, m.eventInfo);
            },
            S = [],
            O = [],
            P = function (t) {
                var e = l.a.mergeObject({}, o.a.queryParams);
                (e = w(e, t)),
                    (e = _(e, t)),
                    (e = s.a.setApiLocaleParams(e)),
                    l.a.isEnableShopifyMultipleCurrencies() &&
                        (l.a.isConvertCurrenciesOnFrontEnd() ? ((e = T(e, t)).hasOwnProperty("currency") && delete e.currency, e.hasOwnProperty("country") && delete e.country) : (e = s.a.setShopifyMultiCurrencyParams(e))),
                    (e.sid = f.a.getSessionId()),
                    (o.a.queryParams = e);
            },
            T = function (t, e) {
                var r = Object.keys(t);
                return (
                    (r = r.filter(function (t) {
                        return (0 == t.indexOf("pf_p_") || 0 == t.indexOf("pf_vp_")) && !t.includes("_exclude_from_value");
                    })),
                    (o.a.activeCurrencyPrices = []),
                    r.length &&
                        r.forEach(function (e) {
                            var r = [];
                            Array.isArray(t[e]) &&
                                t[e].forEach(function (t) {
                                    var e = t.split(":");
                                    (e = e.map(function (t, e) {
                                        var r = 0 == e;
                                        return 0 == t.length ? "" : l.a.revertPriceToDefaultCurrency(t, r);
                                    })),
                                        r.push(e.join(":"));
                                }),
                                (o.a.activeCurrencyPrices[e] = t[e]),
                                (t[e] = r);
                        }),
                    t
                );
            },
            w = function (t, e) {
                var r = c.a.getHistoryState(),
                    n = 0;
                "history" == e
                    ? (n = r && r.param && r.param.hasOwnProperty("collection_scope") ? parseInt(r.param.collection_scope) : parseInt(boostPFSConfig.general.collection_id))
                    : null != o.a.collectionId
                    ? (n = parseInt(o.a.collectionId))
                    : boostPFSConfig.general.collection_id
                    ? (n = parseInt(boostPFSConfig.general.collection_id))
                    : l.a.isCollectionPage() || l.a.isSearchPage() || (n = a.a.getSettingValue("general.filterEverywhereCollectionId")),
                    (o.a.collectionId = n),
                    (t.collection_scope = n);
                var i = null;
                "history" == e
                    ? (i = r && r.param && r.param.tag ? r.param.tag : boostPFSConfig.general.collection_tags)
                    : o.a.collectionTags
                    ? (i = o.a.collectionTags)
                    : boostPFSConfig.general.collectionTags && (i = boostPFSConfig.general.collectionTags),
                    (o.a.collectionTags = i),
                    (t.tag = i),
                    a.a.getSettingValue("general.loadProductFromLiquid") &&
                        "sync" == a.a.getSettingValue("general.loadProductFromLiquidType") &&
                        a.a.getSettingValue("general.theme_id") &&
                        (t.theme_id = a.a.getSettingValue("general.theme_id")),
                    1 == a.a.getSettingValue("general.availableAfterFiltering")
                        ? ((t.product_available = !0 === l.a.checkExistFilterOptionParam() || o.a.productAvailable), (t.variant_available = !0 === l.a.checkExistFilterOptionParam() || o.a.variantAvailable))
                        : ((t.product_available = o.a.productAvailable), (t.variant_available = o.a.variantAvailable));
                var s = Object.keys(t).some(function (t) {
                        return t.startsWith(o.a.prefix + "_l_") || t.startsWith(o.a.prefix + "_vl_");
                    }),
                    u = Object.keys(t).find(function (t) {
                        return t.endsWith("ibsl");
                    });
                (s && (o.a.inventoryBaseSelectedLocations || u) ? (t.inventory_base_selected_locations = !0) : delete t.inventory_base_selected_locations,
                a.a.getSettingValue("general.showOutOfStockOption") && (t.zero_options = !0),
                (t.build_filter_tree = !(void 0 !== e && o.a.imutableFilterTree.indexOf(e) > -1)),
                (t.check_cache = !(
                    !1 !== l.a.checkExistFilterOptionParam() ||
                    1 != t.page ||
                    t.sort != o.a.defaultSorting ||
                    t.limit != a.a.getSettingValue("general.limit") ||
                    l.a.isSearchPage() ||
                    l.a.isVendorPage() ||
                    l.a.isTypePage() ||
                    t.q
                )),
                l.a.isCollectionPage() && t.q && (t.incollection_search = !0),
                a.a.getSettingValue("general.showVariantsAsProduct") && (t.variants_as_products = !0),
                "" != a.a.getSettingValue("general.priceMode") && (t.price_mode = a.a.getSettingValue("general.priceMode")),
                "" != a.a.getSettingValue("general.tagMode") && (t.tag_mode = a.a.getSettingValue("general.tagMode")),
                a.a.getSettingValue("general.sortingAvailableFirst") && (t.sort_first = "available"),
                l.a.isVendorPage() && t.hasOwnProperty("q")) && ((t[a.a.getSettingValue("general.vendorParam")] = [t.q]), delete t.q);
                l.a.isTypePage() && t.hasOwnProperty("q") && ((t[a.a.getSettingValue("general.typeParam")] = [t.q]), delete t.q);
                return t;
            },
            _ = function (t, e) {
                if (l.a.isSearchPage()) {
                    (t.q = l.a.stripHtml(l.a.getSearchTerm())), "q" != o.a.searchTermKey && delete t[o.a.searchTermKey];
                    var r = a.a.getSettingValue("search.enableFuzzy");
                    !0 !== r && (t.fuzzy = r),
                        !1 !== a.a.getSettingValue("search.reduceMinMatch") && (t.reduce_min_match = a.a.getSettingValue("search.reduceMinMatch")),
                        a.a.getSettingValue("search.fullMinMatch") && (t.full_min_match = !0),
                        a.a.getSettingValue("general.sortingAvailableFirst") && (t.sort_first = "available"),
                        a.a.getSettingValue("search.enablePlusCharacterSearch") && (t.enable_plus_character_search = !0);
                }
                return t;
            },
            C = function (t) {
                var e = "";
                e = t ? ("string" == typeof t && 2 == t.split("?").length ? t.split("?")[1] : "") : l.a.getWindowLocation().search;
                var r = new URLSearchParams(e),
                    n = {},
                    i = l.a.isCollectionPage() || l.a.isSearchPage() ? a.a.getSettingValue("general.urlScheme") : 0;
                return (
                    r.forEach(function (t, e) {
                        var r = c.a.longParamMap.get(e);
                        r || (r = e);
                        var s =
                                o.a.imutableFilterTree.includes(r) ||
                                r == o.a.searchTermKey ||
                                (r.startsWith(o.a.prefix) && r.includes("_and_condition")) ||
                                (r.startsWith(o.a.prefix) && r.includes("_show_exact_rating")) ||
                                (r.startsWith(o.a.prefix) && r.includes("_exclude_from_value")),
                            u = r.startsWith(o.a.prefix);
                        if (s) (n[r] = t), (o.a.hasFilterOptionParam = !0);
                        else if (u) {
                            var f = r.startsWith(o.a.prefix + "_c_"),
                                h = r.startsWith(o.a.prefix + "_ct_"),
                                y = new RegExp(o.a.prefix + "_v?li_[a-z_]+?_ibsl$").test(r);
                            if (f) {
                                if (l.a.isCollectionPage()) return;
                                n.collection_scope = t;
                            } else if (h) {
                                var d = a.a.getSettingValue("general.multiLevelCollectionSelectType");
                                (n.tag_mode = d == p.a.SelectType.MULTIPLE ? "2" : "1"), n.hasOwnProperty("tag") ? n.tag.push(t) : (n.tag = [t]);
                            } else if (y) return (n.inventory_base_selected_locations = t), (o.a.inventoryBaseSelectedLocations = t), void delete n[r];
                            switch (i) {
                                case 2:
                                    n[r] = t.split(",");
                                    break;
                                case 1:
                                default:
                                    n.hasOwnProperty(r) ? n[r].push(t) : (n[r] = [t]);
                            }
                            f ? (o.a.collectionId = n.collection_scope) : h && (o.a.collectionTags = n.tag), (o.a.hasFilterOptionParam = !0);
                        }
                    }),
                    n
                );
            },
            k = function (t) {
                (t._ = o.a.prefix), (t.shop = t.hasOwnProperty("shop") ? t.shop : o.a.shopDomain), (t.page = t.hasOwnProperty("page") ? parseInt(t.page) : 1);
                var e = a.a.getSettingValue("general.limit");
                (e <= 0 || e > 70) && (e = 24),
                    "default" == a.a.getSettingValue("general.paginationType") || a.a.getSettingValue("general.paginationTypeAdvanced")
                        ? (t.limit = t.hasOwnProperty("limit") ? t.limit : e)
                        : (t.limit = (t.hasOwnProperty("limit") ? t.limit : e) * t.page);
                var r = l.a.getDefaultSorting();
                "" != r ? (o.a.defaultSorting = r) : l.a.isCollectionPage() || (o.a.defaultSorting = a.a.getSettingValue("general.filterEverywhereDefaultSorting")),
                    (t.sort = t.hasOwnProperty("sort") ? t.sort : o.a.defaultSorting),
                    (t.display = t.hasOwnProperty("display") ? t.display : a.a.getSettingValue("general.defaultDisplay")),
                    (t = s.a.setShopifyMultiCurrencyParams(t));
                var n = a.a.getSettingValue("general.location");
                return n && "string" == typeof n && (t.location = n), t;
            },
            E = {
                BoostPFSFilterCallback: function (t) {
                    E.setDefaultValueForExcludedFields(t), "function" == typeof E.afterCall && E.afterCall(t, m.eventType, m.eventInfo), "function" != typeof E.afterCallAsync ? v(t) : E.afterCallAsync(t, v, m.eventType, m.eventInfo);
                },
                getFilterData: g,
                updateParamsFromUrl: function (t) {
                    var e = C(t);
                    (e = k(e)),
                        l.a.isEnableShopifyMultipleCurrencies() &&
                            (e = l.a.isConvertCurrenciesOnFrontEnd()
                                ? (function (t) {
                                      var e = Object.keys(t);
                                      return (
                                          (e = e.filter(function (t) {
                                              return (0 == t.indexOf("pf_p_") || 0 == t.indexOf("pf_vp_")) && !t.includes("_exclude_from_value");
                                          })).length &&
                                              e.forEach(function (e) {
                                                  var r = [];
                                                  Array.isArray(t[e]) &&
                                                      t[e].forEach(function (t) {
                                                          var e = t.split(":");
                                                          (e = e.map(function (t, e) {
                                                              return 0 == t.length ? "" : l.a.convertPriceBasedOnActiveCurrency(t);
                                                          })),
                                                              r.push(e.join(":"));
                                                      }),
                                                      (t[e] = r);
                                              }),
                                          t
                                      );
                                  })(e)
                                : s.a.setShopifyMultiCurrencyParams(e)),
                        (o.a.queryParams = e);
                },
                setParam: function (t, e) {
                    null == e || (Array.isArray(e) && 0 == e.length) ? delete o.a.queryParams[t] : Array.isArray(e) ? (o.a.queryParams[t] = h(new Set(e))) : (o.a.queryParams[t] = e);
                    var r = t.startsWith(o.a.prefix + "_c_"),
                        n = t.startsWith(o.a.prefix + "_ct_"),
                        i = new RegExp(o.a.prefix + "_v?li_[a-z_]+?_ibsl$").test(t),
                        a = o.a.queryParams[t];
                    if ((r || "collection_scope" == t) && ((o.a.queryParams.collection_scope = a), (o.a.collectionId = a), !a)) {
                        var l = t.replace(o.a.prefix + "_c_", o.a.prefix + "_ct_");
                        delete o.a.queryParams[l], (o.a.queryParams.tag = null), (o.a.collectionTags = null);
                    }
                    n && ((o.a.queryParams.tag = a), (o.a.collectionTags = a)), i && (o.a.inventoryBaseSelectedLocations = a);
                },
                setDefaultValueForExcludedFields: function (t) {
                    if (Array.isArray(t.products)) {
                        var e = new Date().toISOString();
                        t.products.forEach(function (t) {
                            t.hasOwnProperty("variants") || (t.variants = []),
                                t.hasOwnProperty("images_info") || (t.images_info = []),
                                t.hasOwnProperty("collections") || (t.collections = []),
                                t.hasOwnProperty("tags") || (t.tags = []),
                                t.hasOwnProperty("skus") || (t.skus = []),
                                t.hasOwnProperty("options_with_values") || (t.options_with_values = []),
                                t.hasOwnProperty("barcodes") || (t.barcodes = []),
                                t.hasOwnProperty("created_at") || (t.created_at = e),
                                t.hasOwnProperty("updated_at") || (t.updated_at = e),
                                t.hasOwnProperty("published_at") || (t.published_at = e);
                        });
                    }
                },
                addBeforeApplyFilter: function (t) {
                    S.push(t);
                },
                addAfterApplyFilter: function (t) {
                    O.push(t);
                },
                applyFilter: function (t, e) {
                    (m.eventType = t),
                        (m.eventInfo = e),
                        u.default.instance.filter.filterLoadingIcon.setShow(!0),
                        g(t, u.default.instance.filter.setData.bind(u.default.instance.filter), u.default.instance.filter.errorFilterCallback.bind(u.default.instance.filter)),
                        c.a.updateAddressBar();
                },
                callFilterApi: b,
                callbackFilterApi: v,
                beforeCall: null,
                afterCall: null,
                beforeCallAsync: null,
                afterCallAsync: null,
            };
        e.default = E;
    },
    80: function (t, e, r) {
        "use strict";
        var n = r(2),
            i = r(0),
            o = r(90),
            a = r(131),
            l = r(81),
            s = r(64),
            c = { InstantSearchResult: o.a, InstantSearchResultStyle2: a.a, InstantSearchStyle3: l.a, InstantSearchMobile: s.a },
            u = {
                instantSearchResult: function (t, e) {
                    var r = n.a.getSettingValue("search.suggestionStyle"),
                        o = "InstantSearchResult" + i.a.capitalize(r, !0, !0);
                    return (c[o] && c[o].isActive()) || (o = "InstantSearchResult"), new c[o](t, e);
                },
                instantSearchMobile: function () {
                    var t = n.a.getSettingValue("search.suggestionMobileStyle");
                    "style1" == t && (t = "");
                    var e = "InstantSearchMobile" + i.a.capitalize(t, !0, !0);
                    return (c[e] && c[e].isActive()) || (e = "InstantSearchMobile"), new c[e]();
                },
                instantSearchStyle3: function () {
                    var t = "InstantSearchStyle3";
                    return (c[t] && c[t].isActive()) || (t = "InstantSearchStyle3"), new c[t]();
                },
            };
        e.a = u;
    },
    81: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = (r(10), r(45)),
            a = r(4),
            l = r(2),
            s = r(7),
            c = r(5),
            u = r(0),
            p = r(3);
        function f(t) {
            return (f =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function h(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== f(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== f(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === f(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function y(t, e) {
            return (y = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function d(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = g(t);
                if (e) {
                    var i = g(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return m(this, r);
            };
        }
        function m(t, e) {
            if (e && ("object" === f(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function g(t) {
            return (g = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var b = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && y(t, e);
            })(m, t);
            var e,
                r,
                n,
                f = d(m);
            function m() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, m),
                    ((t = f.call(this)).data = ""),
                    (t.isBoundEvents = !1),
                    (t.isOpen = !1),
                    (t.inputStyle3Id = c.a.searchBoxStyle3.substr(1)),
                    (t.searchBox = null),
                    (t.selector = {
                        searchInput: c.a.searchBoxStyle3,
                        clearButton: "." + a.a.searchSuggestionBtnClearStyle3,
                        closebutton: "." + a.a.searchSuggestionBtnCloseStyle3,
                        submitButton: "." + a.a.searchSuggestionBtnSubmitStyle3,
                        topPanel: "." + a.a.searchSuggestion + "-style3-top-panel",
                        overlay: "." + a.a.searchSuggestion + "-style3-overlay",
                        searchInputs: 'input[name="' + l.a.getSettingValue("search.termKey") + '"]',
                    }),
                    t
                );
            }
            return (
                (e = m),
                (n = [
                    {
                        key: "tempType",
                        get: function () {
                            return { SEARCH_BTN: "search_btn", DEFAULT: "default" };
                        },
                    },
                    {
                        key: "isActive",
                        value: function () {
                            return !0;
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case m.tempType.SEARCH_BTN:
                                    return '\n\t\t\t\t\t<button class="{{class.searchSuggestionBtnSubmitStyle3}}" type="submit"><span>Submit</span></button>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-style3-overlay"></div>\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-style3-top-panel">\n\t\t\t\t\t\t<form action="/search" method="get">\n            \t\t\t\t<div class="{{class.searchSuggestion}}-style3-top-panel-input-group">\n            \t\t\t\t\t{{btnSearch}}\n\t\t\t\t\t\t\t\t<input role="textbox" type="text" name="{{searchTermKey}}" placeholder="{{searchBoxPlaceholder}}" id="{{searchId}}" />\n            \t\t\t\t\t<button type="button" class="{{class.searchSuggestionBtnClearStyle3}}"><span>X</span></button>\n            \t\t\t\t</div>\n            \t\t\t\t<button type="button" class="{{class.searchSuggestionBtnCloseStyle3}}"><span><-</span></button>\n\t\t\t\t\t\t</form>\n\t\t\t\t\t</div>\n\t\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = "";
                            return (
                                l.a.getSettingValue("search.showSearchBtnStyle3") && (t = this.getTemplate(m.tempType.SEARCH_BTN)),
                                this.getTemplate()
                                    .replace(/{{btnSearch}}/g, t)
                                    .replace(/{{searchTermKey}}/g, l.a.getSettingValue("search.termKey"))
                                    .replace(/{{searchBoxPlaceholder}}/g, s.a.suggestion.searchBoxPlaceholder)
                                    .replace(/{{searchId}}/g, this.inputStyle3Id)
                                    .replace(/{{class.searchSuggestion}}/g, a.a.searchSuggestion)
                                    .replace(/{{class.searchSuggestionBtnSubmitStyle3}}/g, a.a.searchSuggestionBtnSubmitStyle3)
                                    .replace(/{{class.searchSuggestionBtnCloseStyle3}}/g, a.a.searchSuggestionBtnCloseStyle3)
                                    .replace(/{{class.searchSuggestionBtnClearStyle3}}/g, a.a.searchSuggestionBtnClearStyle3)
                            );
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            i()("body").append(this.compileTemplate());
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvents;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            (this.$searchInput = i()(this.selector.searchInput)),
                                (this.$clearButtonElement = i()(this.selector.clearButton)),
                                (this.$closebuttonElement = i()(this.selector.closebutton)),
                                (this.$submitButtonElement = i()(this.selector.submitButton)),
                                (this.$topPanelElement = i()(this.selector.topPanel)),
                                (this.$overlayElement = i()(this.selector.overlay)),
                                (this.searchBox = new o.a(this.inputStyle3Id, this.$searchInput)),
                                this.searchBox.refresh(),
                                this.$closebuttonElement.on("click", this.closeInstantSearchStyle3.bind(this, !0)),
                                this.$clearButtonElement.on("click", this.clearInstantSearchStyle3.bind(this)),
                                (this.$searchInputs = i()(this.selector.searchInputs)),
                                this.$searchInputs.on("click", this._onClickSearchBox.bind(this)).on("focus", this._onFocusSearchBox.bind(this)).on("keyup", this._onTypeSearchBoxEvent.bind(this)),
                                this.$searchInput.on("focus", this._onFocusStyle3Input.bind(this)),
                                this.$searchInput.on("keyup", this._onKeyupSearchBox.bind(this)),
                                (this.$targetInput = null),
                                (this.isBoundEvents = !0);
                        },
                    },
                    {
                        key: "_onClickSearchBox",
                        value: function (t) {
                            if (u.a.InstantSearch.isStyle3()) {
                                var e = this.$targetInput && u.a.stripHtml(this.$targetInput.val());
                                e && this.$searchInputs.val(e),
                                    this.$searchInput &&
                                        (this.$searchInput.length > 0 && "" != u.a.stripHtml(this.$searchInput.val())
                                            ? this.openSuggestionStyle3()
                                            : this.searchBox &&
                                              this.searchBox.searchAutoComplete &&
                                              this.searchBox.searchAutoComplete.enableOnClickSearchBox &&
                                              (this.openSuggestionStyle3(), this.searchBox.searchAutoComplete.showOnClickSuggestion()));
                            }
                        },
                    },
                    {
                        key: "_onKeyupSearchBox",
                        value: function (t) {
                            var e;
                            this.$targetInput.val(u.a.stripHtml(null == t || null === (e = t.currentTarget) || void 0 === e ? void 0 : e.value));
                        },
                    },
                    {
                        key: "_onFocusSearchBox",
                        value: function (t) {
                            if (u.a.InstantSearch.isStyle3()) {
                                var e = t && t.target ? t.target.id : "",
                                    r = this.$searchInput ? this.$searchInput.attr("id") : "";
                                "" != e && "" != r && e != r && ((this.$targetInput = i()("#" + e)), this.showSearchBoxStyle3()), this.$searchInput.trigger("click");
                            }
                        },
                    },
                    {
                        key: "_onFocusStyle3Input",
                        value: function (t) {
                            var e = this;
                            this.isReFocus
                                ? (t && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault()), (this.isReFocus = !1), this._onFocusSearchBox(t))
                                : setTimeout(function () {
                                      (document.activeElement && document.activeElement.id ? "#" + document.activeElement.id : "") != c.a.searchBoxStyle3 && ((e.isReFocus = !0), e.$searchInput.focus());
                                  }, 0);
                        },
                    },
                    {
                        key: "_onTypeSearchBoxEvent",
                        value: function (t) {
                            u.a.InstantSearch.isStyle3() &&
                                (this.searchBox.instantSearchResult.$wrapper.show(),
                                "" == u.a.stripHtml(t.target.value)
                                    ? (this.searchBox && this.searchBox.searchAutoComplete && this.searchBox.searchAutoComplete.enableOnClickSearchBox
                                          ? this.searchBox.searchAutoComplete.showOnClickSuggestion()
                                          : this.closeInstantSearchStyle3(),
                                      this.$clearButtonElement.hide())
                                    : this.$clearButtonElement.show());
                        },
                    },
                    {
                        key: "showSearchBoxStyle3",
                        value: function () {
                            var t = this;
                            (this.isOpen = !0),
                                this.onClickOutsideSuggestionStyle3Event(),
                                this.scrollSuggestionStyle3Event(),
                                "" == u.a.stripHtml(this.$searchInput.val()) ? this.$clearButtonElement.hide() : this.$clearButtonElement.show(),
                                this.$searchInput.is(":focus") ||
                                    (this.$topPanelElement.show(),
                                    this.$overlayElement.show(),
                                    i()('[tabindex="-1"]').removeAttr("tabindex").addClass(a.a.searchSuggestionNoTabIndex),
                                    u.a.InstantSearch.isStyle3() && i()("[data-open=true]").length > 0 && i()("[data-open=true]").attr("data-open", !1),
                                    setTimeout(function () {
                                        t.$searchInput.focus();
                                    }, 100),
                                    this.afterShowSearchBoxStyle3());
                        },
                    },
                    {
                        key: "closeInstantSearchStyle3",
                        value: function (t) {
                            i()(".js-drawer-close, .search-modal__close-button, .fancybox-close-small, .drawer__close > button").trigger("click"),
                                this.searchBox.instantSearchResult.$wrapper.hide(),
                                (t = void 0 !== t && t) && (this.$topPanelElement.hide(), this.$overlayElement.hide()),
                                this._setValueAllSearchBoxes(),
                                i()("." + a.a.searchSuggestionNoTabIndex).attr("tabindex", -1),
                                i()("body").hasClass(a.a.searchSuggestionStyle3Open) && i()("body").removeClass(a.a.searchSuggestionStyle3Open),
                                this.searchBox.instantSearchResult.$wrapper.hasClass(a.a.searchSuggestionOpen) && this.searchBox.instantSearchResult.$wrapper.removeClass(a.a.searchSuggestionOpen),
                                this.afterCloseInstantSearchStyle3(t);
                        },
                    },
                    {
                        key: "clearInstantSearchStyle3",
                        value: function () {
                            this.$clearButtonElement.hide(),
                                (p.a.currentTerm = ""),
                                this._setValueAllSearchBoxes(""),
                                this.searchBox && this.searchBox.searchAutoComplete && this.searchBox.searchAutoComplete.enableOnClickSearchBox ? this.searchBox.searchAutoComplete.showOnClickSuggestion() : this.closeInstantSearchStyle3(),
                                this.$searchInput.focus();
                        },
                    },
                    { key: "afterCloseInstantSearchStyle3", value: function (t) {} },
                    {
                        key: "_setValueAllSearchBoxes",
                        value: function (t) {
                            void 0 === t && (t = u.a.stripHtml(p.a.currentTerm)), (p.a.currentTerm = u.a.stripHtml(t)), this.$searchInputs.val(u.a.stripHtml(t));
                        },
                    },
                    {
                        key: "onClickOutsideSuggestionStyle3Event",
                        value: function () {
                            var t = this;
                            i()(document).on("touchstart", function (e) {
                                if (e.target) {
                                    var r = i()(e.target),
                                        n = r.closest("." + a.a.searchSuggestion + "-style3-top-panel").length > 0,
                                        o = r.closest("." + a.a.searchSuggestionWrapper + " div").length > 0;
                                    n || o || t.closeInstantSearchStyle3(!0);
                                }
                            });
                        },
                    },
                    {
                        key: "scrollSuggestionStyle3Event",
                        value: function () {
                            var t = this;
                            i()(document).on("touchmove", function (e) {
                                t.$searchInput.is(":focus") && t.$searchInput.blur();
                            });
                        },
                    },
                    { key: "afterShowSearchBoxStyle3", value: function () {} },
                    {
                        key: "openSuggestionStyle3",
                        value: function () {
                            this.beforeOpenSuggestionStyle3(),
                                i()("body").hasClass(a.a.searchSuggestionStyle3Open) || i()("body").addClass(a.a.searchSuggestionStyle3Open),
                                this.showSearchBoxStyle3(),
                                this.searchBox.instantSearchResult.$wrapper.show(),
                                this.afterOpenSuggestionStyle3();
                        },
                    },
                    { key: "beforeOpenSuggestionStyle3", value: function () {} },
                    { key: "afterOpenSuggestionStyle3", value: function () {} },
                ]) && h(e.prototype, r),
                n && h(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                m
            );
        })(r(64).a);
        e.a = b;
    },
    89: function (t, e, r) {
        "use strict";
        r.r(e);
        r(11), r(9), r(12), r(102), r(51), r(69), r(214), r(154), r(27), r(28);
        var n = r(1),
            i = r.n(n),
            o = r(3),
            a = r(2),
            l = r(0),
            s = r(42),
            c = r(74),
            u = r(45),
            p = function t(e, r, n, o) {
                (r = void 0 !== r ? r : 0), (o = void 0 !== o ? o : "");
                var a = h(e, n);
                a.q && ((e = a.q), delete a.q), "" != o && (a.prev_query = o);
                var l = document.createElement("script");
                (l.type = "text/javascript"),
                    (l.src = s.a.getApiUrl("suggestion") + "?q=" + e + "&" + i.a.param(a)),
                    (l.async = !0),
                    l.addEventListener("error", function (e) {
                        i()(this).remove(), r < 3 ? (r++, t(a.q, n, o, r)) : u.a.disableInstantSearch();
                    }),
                    document.getElementsByTagName("head")[0].appendChild(l),
                    l.addEventListener("load", function (t) {
                        i()(this).remove();
                    });
            },
            f = function (t) {
                var e = o.a.suggestionCache;
                if (t.hasOwnProperty("prev_query")) {
                    var r = t.prev_query;
                    if (e.hasOwnProperty(r)) {
                        var n,
                            i = e[r],
                            a = ["collections", "did_you_mean", "pages", "suggest_query"],
                            s = a.length;
                        for (n = 0; n < s; n++) t[a[n]] = l.a.getValueInObjectArray(a[n], i);
                        (t.prev_total_product = l.a.getValueInObjectArray("total_product", i)),
                            (i[l.a.findIndexArray("products", i, "key")].values = t.products),
                            (i[l.a.findIndexArray("suggestions", i, "key")].values = t.suggestions),
                            i.push({ key: "local_cache", values: !0 }),
                            i.push({ key: "suggest_total_product", values: t.total_product }),
                            (o.a.suggestionCache[r] = i);
                    }
                }
                window.suggestionCallback(
                    Object.keys(t).map(function (e) {
                        return { key: e, values: t[e] };
                    })
                );
            },
            h = function (t, e) {
                var r = {};
                (r.shop = o.a.shopDomain), (r.t = new Date().getTime()), a.a.getSettingValue("search.enableDefaultResult") || (r.enable_default_result = !1);
                var n = a.a.getSettingValue("search.enableFuzzy");
                !0 !== n && (r.fuzzy = n),
                    a.a.getSettingValue("search.fullMinMatch") && (r.full_min_match = !0),
                    !1 !== a.a.getSettingValue("search.reduceMinMatch") && (r.reduce_min_match = a.a.getSettingValue("search.reduceMinMatch")),
                    a.a.getSettingValue("general.showVariantsAsProduct") && (r.variants_as_products = !0),
                    a.a.getSettingValue("search.enablePlusCharacterSearch") && (r.enable_plus_character_search = !0),
                    1 == a.a.getSettingValue("search.productAvailable") && (r.product_available = !0);
                var i,
                    l = a.a.getSettingValue("search.suggestionBlocks"),
                    u = l.length;
                for (i = 0; i < u; i++) {
                    r[l[i].type.slice(0, -1) + "_limit"] = l[i].number;
                }
                r.dym_limit = a.a.getSettingValue("search.suggestionDymLimit");
                var p = a.a.getSettingValue("search.skipFields");
                p.length > 0 && (param.skipFields = p), (r.callback = "BoostPFSInstantSearchCallback"), (r.event_type = e);
                var f = "suggest_dym" == e ? ["products", "suggestions"] : [];
                return (r.suggest_types = f), (r = s.a.setApiLocaleParams(r)), ((r = s.a.setShopifyMultiCurrencyParams(r)).sid = c.a.getSessionId()), Object.assign(r, o.a.instantSearchQueryParams);
            },
            y = {
                BoostPFSInstantSearchCallback: function (t) {
                    y.setDefaultValueForExcludedFields(t), "function" == typeof y.afterCall && y.afterCall(t), "function" != typeof y.afterCallAsync ? f(t) : y.afterCallAsync(t, f);
                },
                getSuggestionData: function (t, e, r, n) {
                    if (("function" == typeof y.beforeCall && y.beforeCall(t), "function" != typeof y.beforeCallAsync)) p(t, 0, r, n);
                    else {
                        y.beforeCallAsync(t, function () {
                            p(t, 0, r, n);
                        });
                    }
                },
                prepareSuggestionParams: h,
                setDefaultValueForExcludedFields: function (t) {
                    if (Array.isArray(t.products)) {
                        var e = new Date().toISOString();
                        t.products.forEach(function (t) {
                            t.hasOwnProperty("variants") || (t.variant = []),
                                t.hasOwnProperty("images_info") || (t.images_info = []),
                                t.hasOwnProperty("collections") || (t.collections = []),
                                t.hasOwnProperty("tags") || (t.tags = []),
                                t.hasOwnProperty("skus") || (t.skus = []),
                                t.hasOwnProperty("options_with_values") || (t.options_with_values = []),
                                t.hasOwnProperty("barcodes") || (t.barcodes = []),
                                t.hasOwnProperty("created_at") || (t.created_at = e),
                                t.hasOwnProperty("updated_at") || (t.updated_at = e),
                                t.hasOwnProperty("published_at") || (t.published_at = e);
                        });
                    }
                },
                callInstantSearchApi: p,
                callbackInstantSearchApi: f,
                beforeCall: null,
                afterCall: null,
                beforeCallAsync: null,
                afterCallAsync: null,
            };
        e.default = y;
    },
    90: function (t, e, r) {
        "use strict";
        r(86), r(27), r(9), r(28), r(24), r(25), r(26), r(30), r(49), r(37), r(44), r(20), r(21), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(2),
            a = r(0),
            l = r(4),
            s = r(23),
            c = r(75),
            u = r(46),
            p = r(10),
            f = r(123),
            h = r(128),
            y = r(129),
            d = r(130);
        function m(t) {
            return (m =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function g(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== m(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== m(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === m(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function b(t, e) {
            return (b = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function v(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = O(t);
                if (e) {
                    var i = O(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return S(this, r);
            };
        }
        function S(t, e) {
            if (e && ("object" === m(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function O(t) {
            return (O = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var P = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && b(t, e);
            })(m, t);
            var e,
                r,
                n,
                p = v(m);
            function m(t, e) {
                var r;
                !(function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, m),
                    ((r = p.call(this)).searchInputId = t),
                    (r.isLoading = !1),
                    (r.isFirstLoad = !0),
                    (r.blocks = []),
                    (r.onClickBlocks = []),
                    (r.loadingBlock = null);
                var n = "." + l.a.searchSuggestionWrapper + '[data-search-box-id="' + r.searchInputId + '"]';
                return (
                    (r.selector = { wrapper: n, popover: n + " ." + l.a.searchSuggestion + "-popover", loading: n + " ." + l.a.searchSuggestion + "-loading" }),
                    (r.$searchInputElement = e),
                    (r.$instantSearchResult = null),
                    (r.$wrapper = null),
                    (r.$popoverElement = null),
                    (r.$loadingElement = null),
                    (r.suggestionDirection = r._getSuggestionDirection()),
                    (r.position = ""),
                    r
                );
            }
            return (
                (e = m),
                (n = [
                    {
                        key: "isActive",
                        value: function () {
                            return !0;
                        },
                    },
                ]),
                (r = [
                    {
                        key: "init",
                        value: function () {
                            var t = this;
                            (this.loadingBlock = new y.a()),
                                this.addComponent(this.loadingBlock),
                                (this.blockSettings = o.a.getSettingValue("search.suggestionBlocks")),
                                (this.onClickBlocks = u.a.getOnClickBlockSettings()),
                                (this.blockSettings = this.onClickBlocks.concat(this.blockSettings)),
                                (this.noResultBlocks = c.a.getNoResultBlockSettings()),
                                (this.blockSettings = this.blockSettings.concat(this.noResultBlocks)),
                                this._applyFilterBlockSettings(),
                                (this.hasProductBlock = !1),
                                this.blockSettings.forEach(function (e) {
                                    var r = new f.a(e);
                                    t.addComponent(r), t.blocks.push(r), e.type == s.a.ResultType.PRODUCTS && "active" == e.status && (t.hasProductBlock = !0);
                                });
                            var e = new h.a();
                            this.addComponent(e), (this.blockViewAll = e);
                            var r = new d.a();
                            this.addComponent(r), (this.blockEmpty = r), c.a.getNoResultData(), u.a.getOnClickData();
                        },
                    },
                    {
                        key: "getTemplate",
                        value: function () {
                            return '\n\t\t\t<div class="{{class.searchSuggestionWrapper}}" id="{{searchSuggestionId}}" data-search-box-id="{{searchInputId}}" role="listbox">\n\t\t\t\t<div class="{{class.searchSuggestion}}-popover" data-direction="{{suggestionDirection}}"></div>\n\t\t\t</div>\n\t\t'.trim();
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            var t = this._getSuggestionWrapperClass();
                            return this.getTemplate()
                                .replace(/{{searchSuggestionId}}/g, this.searchInputId.replace(l.a.searchBox, l.a.searchSuggestion))
                                .replace(/{{searchInputId}}/g, this.searchInputId)
                                .replace(/{{suggestionDirection}}/g, this.suggestionDirection)
                                .replace(/{{class.searchSuggestionWrapper}}/g, t)
                                .replace(/{{class.searchSuggestion}}/g, l.a.searchSuggestion);
                        },
                    },
                    {
                        key: "_getSuggestionWrapperClass",
                        value: function () {
                            var t = "",
                                e = l.a.searchSuggestion + "-mobile-" + o.a.getSettingValue("search.suggestionMobileStyle");
                            switch (o.a.getSettingValue("search.suggestionStyle")) {
                                case "style1":
                                    var r = "grid" === o.a.getSettingValue("search.suggestionStyle1ProductItemType") ? 3 : 1;
                                    t =
                                        l.a.searchSuggestionWrapper +
                                        " " +
                                        e +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-column-1 " +
                                        l.a.searchSuggestion +
                                        "-product-position-none " +
                                        l.a.searchSuggestion +
                                        "-product-item-type-" +
                                        o.a.getSettingValue("search.suggestionStyle1ProductItemType") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-products-per-row-" +
                                        r;
                                    break;
                                case "style2":
                                    var n = "grid" === o.a.getSettingValue("search.suggestionStyle2ProductItemType") ? 3 : o.a.getSettingValue("search.suggestionStyle2ProductPerRow");
                                    t =
                                        l.a.searchSuggestionWrapper +
                                        " " +
                                        e +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-column-2-non-fullwidth " +
                                        l.a.searchSuggestion +
                                        "-product-position-" +
                                        o.a.getSettingValue("search.suggestionStyle2ProductPosition") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-product-item-type-" +
                                        o.a.getSettingValue("search.suggestionStyle2ProductItemType") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-products-per-row-" +
                                        n;
                                    break;
                                case "style3":
                                    var i = "grid" === o.a.getSettingValue("search.suggestionStyle3ProductItemType") ? 4 : o.a.getSettingValue("search.suggestionStyle3ProductPerRow");
                                    t =
                                        l.a.searchSuggestionWrapper +
                                        " " +
                                        e +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-column-2-overlay-fullwidth " +
                                        l.a.searchSuggestion +
                                        "-product-position-" +
                                        o.a.getSettingValue("search.suggestionStyle3ProductPosition") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-product-item-type-" +
                                        o.a.getSettingValue("search.suggestionStyle3ProductItemType") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-products-per-row-" +
                                        i;
                                    break;
                                default:
                                    var a = o.a.getSettingValue("search.suggestionProductItemPerRow");
                                    t =
                                        l.a.searchSuggestionWrapper +
                                        " " +
                                        e +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-column-" +
                                        o.a.getSettingValue("search.suggestionColumn") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-product-position-" +
                                        o.a.getSettingValue("search.suggestionProductPosition") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-product-item-type-" +
                                        o.a.getSettingValue("search.suggestionProductItemType") +
                                        " " +
                                        l.a.searchSuggestion +
                                        "-products-per-row-" +
                                        a;
                            }
                            return t;
                        },
                    },
                    { key: "_applyFilterBlockSettings", value: function () {} },
                    {
                        key: "render",
                        value: function () {
                            if (this.isFirstLoad) {
                                var t = this.compileTemplate();
                                (this.appendToSelector = "body"),
                                    this._applyFilterAutocompleteAppendElement(),
                                    i()(this.appendToSelector).append(t),
                                    (this.$wrapper = i()(this.selector.wrapper)),
                                    (this.$popoverElement = i()(this.selector.popover)),
                                    (this.isFirstLoad = !1);
                            } else this.$instantSearchResult.show(), this.$instantSearchResult.siblings().show(), this.isLoading ? (this._renderSuggestionLoading(), this._renderWrapper()) : (this._renderWrapper(), this._renderSuggestion());
                        },
                    },
                    {
                        key: "isBindEvents",
                        value: function () {
                            return !this.isBoundEvent;
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            window.addEventListener("resize", this._setSuggestionPosition.bind(this));
                            for (var t = 0; t < this.$searchInputElement.length; t++) this.$searchInputElement[t].addEventListener("click", this._setSuggestionPosition.bind(this));
                        },
                    },
                    { key: "_applyFilterAutocompleteAppendElement", value: function () {} },
                    {
                        key: "_renderWrapper",
                        value: function () {
                            var t = a.a.InstantSearch.isFullWidthMobile() ? l.a.searchSuggestionMobile : "";
                            "" !== t && this.$wrapper.addClass(t);
                            var e = this._setSuggestionPosition();
                            e.setSuggetionPosition(), e.setSuggetionPopoverPosition();
                            var r = "";
                            (r = "auto" == o.a.getSettingValue("search.suggestionWidth") || a.a.isMobile() ? this.$searchInputElement[0].getBoundingClientRect().width : o.a.getSettingValue("search.suggestionWidth")),
                                this.$wrapper.css({ width: r });
                        },
                    },
                    {
                        key: "_setSuggestionPosition",
                        value: function () {
                            var t = this,
                                e = this,
                                r = this.$searchInputElement[0].getBoundingClientRect(),
                                n = a.a.InstantSearch.isFullWidthMobile() ? r.bottom : r.bottom + 12,
                                o = e._getSuggestionDirection(),
                                l = e._maxWidth();
                            window.addEventListener("scroll", function () {
                                if (!a.a.isMobile()) {
                                    var t = e.$searchInputElement[0].getBoundingClientRect();
                                    (n = a.a.InstantSearch.isFullWidthMobile() ? t.bottom : t.bottom + 12),
                                        "left" == o ? e.$wrapper.css({ top: n + "px", left: t.left + "px" }) : e.$wrapper.css({ top: n + "px", right: window.innerWidth - t.right + "px" });
                                }
                            });
                            var s = "",
                                c = "",
                                u = "";
                            if ("left" == o) {
                                (s = n + "px"), (c = r.left + "px");
                                var p = i()(window).width() - r.left,
                                    f = l;
                                p < l && (f = i()("#" + this.$wrapper[0].id).width()), a.a.isMobile() ? this.$wrapper.css({ top: s, right: "10px", left: "10px" }) : this.$wrapper.css({ top: s, left: c });
                                var h = function () {
                                        p < f ? t.$instantSearchResult.css({ top: "0px", left: "-" + (f - p + 20) + "px" }) : t.$instantSearchResult.css({ top: "0px", left: "0px" });
                                    },
                                    y = function () {
                                        t.$popoverElement.css({ top: "-20px", left: "20px" });
                                    };
                            } else
                                (s = n + "px"),
                                    (u = window.innerWidth - r.right + "px"),
                                    a.a.isMobile() ? this.$wrapper.css({ top: s, right: "10px", left: "10px" }) : this.$wrapper.css({ top: s, right: u }),
                                    (h = function () {
                                        t.$instantSearchResult.css({ top: "0px", right: "0px" });
                                    }),
                                    (y = function () {
                                        t.$popoverElement.css({ top: "-20px", right: "20px" });
                                    });
                            return { setSuggetionPosition: h, setSuggetionPopoverPosition: y };
                        },
                    },
                    {
                        key: "_renderSuggestion",
                        value: function () {
                            if ((this.$instantSearchResult && this.$instantSearchResult.attr("data-search-box", a.a.stripHtml(this.id)), this.data)) {
                                var t = this._getSuggestionBlockElements(),
                                    e = this._isTwoColumn();
                                e ? this._renderSuggestionTwoColumn(t) : this._renderSuggestionOneColumn(t);
                                var r = a.a.getValueInObjectArray(s.a.ResultType.ALL_EMPTY, this.data) && !this.hasRedirectData;
                                if ((this.$wrapper.show(), r))
                                    if (this.blockEmpty.$element)
                                        if (this.blockEmpty.isEmptyWithSuggestion && !a.a.isMobile() && e) {
                                            var n = this.$instantSearchResult.find("[data-group=no_result_products]"),
                                                i = this.$instantSearchResult.find("[data-group=no_result_suggestions]");
                                            n.length > 0
                                                ? n.find("." + l.a.searchSuggestionHeader).before(this.blockEmpty.$element)
                                                : i.length > 0
                                                ? i.find("." + l.a.searchSuggestionHeader).before(this.blockEmpty.$element)
                                                : this.$instantSearchResult.prepend(this.blockEmpty.$element);
                                        } else this.$instantSearchResult.prepend(this.blockEmpty.$element);
                                    else this.$wrapper.hide(), this.$wrapper.removeClass(l.a.searchSuggestionOpen);
                            }
                        },
                    },
                    {
                        key: "_getSuggestionBlockElements",
                        value: function () {
                            var t = [],
                                e = a.a.getValueInObjectArray(s.a.ResultType.ALL_EMPTY, this.data) && !this.hasRedirectData,
                                r = a.a.getValueInObjectArray(s.a.ResultType.SUGGEST_QUERY, this.data),
                                n = a.a.getValueInObjectArray(s.a.ResultType.DID_YOU_MEAN, this.data);
                            return (
                                !e || r || (n && 0 != n.length)
                                    ? (this.blocks.forEach(function (e) {
                                          t.push(e.$element);
                                      }),
                                      this.hasProductBlock && t.push(this.blockViewAll.$element))
                                    : this.blockEmpty.$element &&
                                      ((!a.a.isMobile() && this.blockEmpty.isEmptyWithSuggestion) || t.push(this.blockEmpty.$element),
                                      this.blocks.forEach(function (e) {
                                          t.push(e.$element);
                                      })),
                                t
                            );
                        },
                    },
                    {
                        key: "_isTwoColumn",
                        value: function () {
                            var t = !1;
                            if (!a.a.isMobile() && this.hasProductBlock)
                                switch (o.a.getSettingValue("search.suggestionStyle")) {
                                    case "style1":
                                        t = !1;
                                        break;
                                    case "style2":
                                    case "style3":
                                        t = !0;
                                        break;
                                    default:
                                        o.a.getSettingValue("search.suggestionColumn").startsWith("1") || (t = !0);
                                }
                            else t = !1;
                            return t;
                        },
                    },
                    {
                        key: "_maxHeight",
                        value: function () {
                            var t = "",
                                e = o.a.getSettingValue("search.suggestionMaxHeight"),
                                r = o.a.getSettingValue("search.suggestionStyle"),
                                n = o.a.getSettingValue("search.suggestionStyle2ProductItemType"),
                                i = this.$searchInputElement[0].getBoundingClientRect(),
                                l = a.a.InstantSearch.isFullWidthMobile() ? i.bottom : i.bottom + 12;
                            return (t = "" == e ? ("style2" == r && "list" == n ? 564 : 640) : e) + l > window.innerHeight - 30 && (t = window.innerHeight - l - 30), t;
                        },
                    },
                    {
                        key: "_maxWidth",
                        value: function () {
                            var t = o.a.getSettingValue("search.suggestionMaxWidth"),
                                e = o.a.getSettingValue("search.suggestionStyle"),
                                r = o.a.getSettingValue("search.suggestionStyle2ProductItemType"),
                                n = o.a.getSettingValue("search.suggestionStyle2ProductPerRow");
                            return "" == t ? ("style2" == e && "grid" == r ? 850 : "style2" == e && "list" == r && "2" == n ? 800 : "style2" == e && "list" == r && "1" == n ? 526 : "") : t;
                        },
                    },
                    {
                        key: "_renderSuggestionOneColumn",
                        value: function (t) {
                            var e = this._maxHeight() + "px";
                            this.$instantSearchResult.css("maxHeight", e);
                            var r = i()('<div class="boost-pfs-search-suggestion-scroll-groups-element-wrapper"></div>');
                            t.forEach(function (t) {
                                r.append(t);
                            }),
                                this.$instantSearchResult.append(r),
                                this.$instantSearchResult.append(this.blockViewAll.$element);
                        },
                    },
                    {
                        key: "_renderSuggestionTwoColumn",
                        value: function (t) {
                            var e = this,
                                r = this._maxHeight() + "px";
                            this.$instantSearchResult.css("maxHeight", r);
                            var n = i()('<div class="' + l.a.searchSuggestion + '-groups-pro"></div>'),
                                o = i()('<div class="' + l.a.searchSuggestion + '-groups-others"></div>');
                            t.forEach(function (t) {
                                e.$instantSearchResult.append(o).append(n);
                                var r = void 0 !== t.data ? t.data("group") : "";
                                void 0 === r && (r = ""), r.includes("products") || "view-all" == r || "empty" == r ? n.append(t) : o.append(t);
                            }),
                                "" == n.html().trim() ? o.addClass(l.a.searchSuggestion + "-no-products") : o.removeClass(l.a.searchSuggestion + "-no-products"),
                                "" == o.html().trim()
                                    ? (n.addClass(l.a.searchSuggestion + "-no-others"), this.$instantSearchResult.parent().addClass(l.a.searchSuggestion + "-no-others-wrapper"))
                                    : (n.removeClass(l.a.searchSuggestion + "-no-others"), this.$instantSearchResult.parent().removeClass(l.a.searchSuggestion + "-no-others-wrapper")),
                                this.$instantSearchResult.append(o).append(n);
                        },
                    },
                    {
                        key: "_renderSuggestionLoading",
                        value: function () {
                            this.loadingBlock.$element &&
                                !i()(this.selector.loading).length &&
                                (this.$instantSearchResult.children().hide(),
                                this.$instantSearchResult.prepend(this.loadingBlock.$element),
                                (this.$loadingElement = i()(this.selector.loading)),
                                this.$wrapper.addClass(l.a.searchSuggestionOpen),
                                i()("body").addClass(l.a.searchSuggestionOpenBody),
                                this.$instantSearchResult.show(),
                                this.$loadingElement.show());
                        },
                    },
                    {
                        key: "_getSuggestionDirection",
                        value: function () {
                            var t = o.a.getSettingValue("search.suggestionPosition");
                            if ("" != t) return t;
                            var e = i()(window).width() / 2;
                            return this.$searchInputElement.offset().left < e ? "left" : "right";
                        },
                    },
                    {
                        key: "setData",
                        value: function (t, e, r) {
                            var n = this;
                            if (((this.$instantSearchResult = t), (this.data = e), (this.isLoading = r), this.data)) {
                                this.setRedirectData();
                                var i = a.a.getValueInObjectArray(s.a.ResultType.ALL_EMPTY, this.data) && !this.hasRedirectData,
                                    o = a.a.getValueInObjectArray(s.a.ResultType.SUGGEST_QUERY, this.data),
                                    l = a.a.getValueInObjectArray(s.a.ResultType.DID_YOU_MEAN, this.data);
                                this.blocks.forEach(function (t) {
                                    var e = a.a.getValueInObjectArray(t.type, n.data);
                                    if (i && !o && (!l || 0 == l.length)) {
                                        var r = c.a.getNoResultData()[t.type];
                                        r && (e = r);
                                    }
                                    t.setData(e, i);
                                }),
                                    this.blockEmpty.setData(this.data),
                                    this.blockViewAll.setData(this.data);
                            }
                        },
                    },
                    {
                        key: "setRedirectData",
                        value: function () {
                            if (
                                ((this.redirectData = a.a.getValueInObjectArray(s.a.ResultType.REDIRECT, this.data)),
                                (this.searchQuery = a.a.getValueInObjectArray(s.a.ResultType.QUERY, this.data)),
                                (this.hasRedirectData = !1),
                                this.redirectData && this.searchQuery)
                            ) {
                                var t = a.a.getValueInObjectArray(s.a.ResultType.SUGGESTIONS, this.data);
                                Array.isArray(t) && (t.includes(this.searchQuery) || t.unshift(this.searchQuery), (this.hasRedirectData = !0));
                            }
                        },
                    },
                ]) && g(e.prototype, r),
                n && g(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                m
            );
        })(p.a);
        e.a = P;
    },
    91: function (t, e, r) {
        "use strict";
        r(24), r(25), r(26), r(20), r(21), r(9), r(22), r(18), r(19), r(14), r(15), r(17), r(16), r(11), r(13), r(12);
        var n = r(1),
            i = r.n(n),
            o = r(0),
            a = r(4),
            l = r(2),
            s = r(3);
        function c(t) {
            return (c =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      })(t);
        }
        function u(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(
                        t,
                        ((i = n.key),
                        (o = void 0),
                        (o = (function (t, e) {
                            if ("object" !== c(t) || null === t) return t;
                            var r = t[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t, e || "default");
                                if ("object" !== c(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        })(i, "string")),
                        "symbol" === c(o) ? o : String(o)),
                        n
                    );
            }
            var i, o;
        }
        function p(t, e) {
            return (p = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  })(t, e);
        }
        function f(t) {
            var e = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            })();
            return function () {
                var r,
                    n = y(t);
                if (e) {
                    var i = y(this).constructor;
                    r = Reflect.construct(n, arguments, i);
                } else r = n.apply(this, arguments);
                return h(this, r);
            };
        }
        function h(t, e) {
            if (e && ("object" === c(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            })(t);
        }
        function y(t) {
            return (y = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  })(t);
        }
        var d = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && p(t, e);
            })(h, t);
            var e,
                r,
                n,
                c = f(h);
            function h() {
                var t;
                return (
                    (function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, h),
                    ((t = c.call(this)).id = ""),
                    (t.title = ""),
                    (t.imageUrl = ""),
                    (t.url = ""),
                    (t.sku = ""),
                    (t.label = ""),
                    (t.vendor = ""),
                    (t.isShow = !1),
                    t
                );
            }
            return (
                (e = h),
                (n = [
                    {
                        key: "tempType",
                        get: function () {
                            return { SKU: "sku", VENDOR: "vendor", IMAGE: "thumb", PRICE: "regular_price", PRICE_SALE: "sale_price" };
                        },
                    },
                ]),
                (r = [
                    {
                        key: "getTemplate",
                        value: function (t) {
                            switch (t) {
                                case h.tempType.IMAGE:
                                    return '\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-left">\n\t\t\t\t\t\t<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">\n\t\t\t\t\t</div>\n\t\t\t\t'.trim();
                                case h.tempType.SKU:
                                    return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>\n\t\t\t\t'.trim();
                                case h.tempType.VENDOR:
                                    return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>\n\t\t\t\t'.trim();
                                case h.tempType.PRICE:
                                    return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-price">\n\t\t\t\t\t\t<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t'.trim();
                                case h.tempType.PRICE_SALE:
                                    return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-price">\n            <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;\n\t\t\t\t\t\t<s>{{compareAtPrice}}</s>\n\t\t\t\t\t\t\n\t\t\t\t\t</p>\n\t\t\t\t'.trim();
                                default:
                                    return '\n\t\t\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">\n\t\t\t\t\t\t<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>\n\t\t\t\t\t\t\t{{itemProductImage}}\n\t\t\t\t\t\t\t<div class="{{class.searchSuggestion}}-right">\n\t\t\t\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>\n\t\t\t\t\t\t\t\t{{itemProductSku}}\n\t\t\t\t\t\t\t\t{{itemProductVendor}}\n\t\t\t\t\t\t\t\t{{itemProductPrice}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t'.trim();
                            }
                        },
                    },
                    {
                        key: "compileTemplate",
                        value: function () {
                            if (this.isShow) {
                                var t = o.a.stripHtml(s.a.currentTerm),
                                    e = "";
                                l.a.getSettingValue("search.showSuggestionProductImage") && this.imageUrl.length && (e = (e = this.getTemplate(h.tempType.IMAGE)).replace(/{{imageUrl}}/g, this.imageUrl));
                                var r = this.customizeProductTitle();
                                r = this._highlightSuggestionResult(r, t);
                                var n = "";
                                l.a.getSettingValue("search.showSuggestionProductSku") && this.sku.length && (n = (n = this.getTemplate(h.tempType.SKU)).replace(/{{sku}}/g, this.sku));
                                var i = "";
                                l.a.getSettingValue("search.showSuggestionProductVendor") && this.vendor.length && (i = (i = this.getTemplate(h.tempType.VENDOR)).replace(/{{vendor}}/g, this.vendor));
                                var c = this.compileSuggestionProductPrice(),
                                    u = l.a.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";
                                return this.getTemplate()
                                    .replace(/{{id}}/g, this.id)
                                    .replace(/{{escapedBlockType}}/g, o.a.stripHtml(this.parent.type))
                                    .replace(/{{url}}/g, this.url)
                                    .replace(/{{newTabAttribute}}/g, u)
                                    .replace(/{{itemProductImage}}/g, e)
                                    .replace(/{{title}}/g, r)
                                    .replace(/{{escapedTitle}}/g, o.a.stripHtml(r))
                                    .replace(/{{itemProductSku}}/g, n)
                                    .replace(/{{itemProductVendor}}/g, i)
                                    .replace(/{{itemProductPrice}}/, c)
                                    .replace(/{{class.searchSuggestion}}/g, a.a.searchSuggestion)
                                    .replace(/{{class.searchSuggestionItem}}/g, a.a.searchSuggestionItem)
                                    .replace(/{{class.searchUiAutocompleteItem}}/g, a.a.searchUiAutocompleteItem);
                            }
                            return "";
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.isShow ? ((this.$element = i()(this.compileTemplate())), this.$element.attr("data-title", o.a.stripHtml(this.title))) : (this.$element = null);
                        },
                    },
                    {
                        key: "setData",
                        value: function (t) {
                            t
                                ? ((this.data = t),
                                  (this.id = t.id),
                                  (this.title = o.a.stripHtml(t.title)),
                                  (this.imageUrl = t.images_info.length > 0 ? o.a.optimizeImage(t.images_info[0].src, "200x") : boostPFSConfig.general.no_image_url),
                                  (this.url = o.a.buildProductItemUrlWithVariant(t)),
                                  (this.sku = o.a.stripHtml(t.skus && t.skus.length > 0 ? t.skus[0] : "")),
                                  (this.label = o.a.stripHtml(t.label)),
                                  (this.vendor = o.a.stripHtml(t.vendor)),
                                  (this.isShow = !0))
                                : ((this.data = null), (this.id = ""), (this.title = ""), (this.imageUrl = ""), (this.url = ""), (this.sku = ""), (this.label = ""), (this.vendor = ""), (this.isShow = !1));
                        },
                    },
                    {
                        key: "compileSuggestionProductPrice",
                        value: function () {
                            this.prepareSuggestionProductPriceData();
                            var t = this.data.compare_at_price_min > this.data.price_min,
                                e = o.a.formatMoney(this.data.price_min),
                                r = "";
                            this.data &&
                                this.data.compare_at_price_min &&
                                ((r = o.a.formatMoney(this.data.compare_at_price_min)), l.a.getSettingValue("search.removePriceDecimal") && ((e = o.a.removeDecimal(e)), (r = o.a.removeDecimal(r))));
                            var n = "";
                            return (
                                l.a.getSettingValue("search.showSuggestionProductPrice") &&
                                    (n = t && l.a.getSettingValue("search.showSuggestionProductSalePrice") ? this.getTemplate(h.tempType.PRICE_SALE) : this.getTemplate(h.tempType.PRICE)),
                                n.replace(/{{regularPrice}}/g, e).replace(/{{compareAtPrice}}/g, r)
                            );
                        },
                    },
                    {
                        key: "customizeProductTitle",
                        value: function () {
                            return this.title;
                        },
                    },
                    {
                        key: "prepareSuggestionProductPriceData",
                        value: function () {
                            var t = this.data;
                            o.a.isEnableShopifyMultipleCurrencies() &&
                                (!t.isConvertedPrice && o.a.isConvertCurrenciesOnFrontEnd()
                                    ? ((t.price_min = o.a.convertPriceBasedOnActiveCurrency(t.price_min, !0)),
                                      (t.price_max = o.a.convertPriceBasedOnActiveCurrency(t.price_max, !0)),
                                      (t.compare_at_price_min = o.a.convertPriceBasedOnActiveCurrency(t.compare_at_price_min, !0)),
                                      (t.compare_at_price_max = o.a.convertPriceBasedOnActiveCurrency(t.compare_at_price_max, !0)),
                                      (t.isConvertedPrice = !0))
                                    : o.a.convertPriceBasedOnPresentmentPrice(t));
                        },
                    },
                ]) && u(e.prototype, r),
                n && u(e, n),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                h
            );
        })(r(62).a);
        e.a = d;
    },
});
